/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 45);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(52);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(60)();
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADD_COLOR_SCHEME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CHANGE_COLOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CHANGE_COLORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_COLOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SELECT_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SELECT_TILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SELECT_SAMPLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SELECT_COLOR; });
/* unused harmony export DEFAULT_COLORS */
var ADD_COLOR_SCHEME='ADD_COLOR_SCHEME';var CHANGE_COLOR='CHANGE_COLOR';var CHANGE_COLORS='CHANGE_COLORS';var ADD_COLOR='ADD_COLOR';var SELECT_PATH='SELECT_PATH';var SELECT_TILE='SELECT_TILE';var SELECT_SAMPLE='SELECT_SAMPLE';var SELECT_COLOR='SELECT_COLOR';var DEFAULT_COLORS=' DEFAULT_COLORS';

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Context__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__connect_connect__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hooks_useDispatch__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hooks_useSelector__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hooks_useStore__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_batch__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_reactBatchedUpdates__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_shallowEqual__ = __webpack_require__(27);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport connectAdvanced */
/* unused harmony reexport ReactReduxContext */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__connect_connect__["a"]; });
/* unused harmony reexport batch */
/* unused harmony reexport useDispatch */
/* unused harmony reexport useSelector */
/* unused harmony reexport useStore */
/* unused harmony reexport shallowEqual */










Object(__WEBPACK_IMPORTED_MODULE_7__utils_batch__["b" /* setBatch */])(__WEBPACK_IMPORTED_MODULE_8__utils_reactBatchedUpdates__["a" /* unstable_batchedUpdates */]);


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addColorScheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return selectPath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return changeColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return changeColors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return selectTile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return selectSample; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return selectColor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(3);
var addColorScheme=function addColorScheme(id,colors){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["b" /* ADD_COLOR_SCHEME */],selectedTile:id,colorScheme:colors};};var selectPath=function selectPath(id){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["f" /* SELECT_PATH */],id:id};};var changeColor=function changeColor(id,color){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["c" /* CHANGE_COLOR */],id:id,color:color};};var changeColors=function changeColors(colors){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["d" /* CHANGE_COLORS */],colors:colors};};var selectTile=function selectTile(id){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["h" /* SELECT_TILE */],id:id};};var addColor=function addColor(color){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["a" /* ADD_COLOR */],color:color};};var selectSample=function selectSample(id){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["g" /* SELECT_SAMPLE */],id:id};};var selectColor=function selectColor(id){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["e" /* SELECT_COLOR */],id:id};};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(53);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return locationsAreEqual; });
/* unused harmony export parsePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(82);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_2_value_equal__["a" /* default */])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');
  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    return '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var Figure=function Figure(_ref){var id=_ref.id,d=_ref.d,fill=_ref.fill,transform=_ref.transform,selected=_ref.selected,stroke=_ref.stroke,strokeWidth=_ref.strokeWidth,width=_ref.width,height=_ref.height,independent=_ref.independent,_onClick=_ref.onClick;return independent===false?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:d,fill:fill,stroke:stroke,strokeWidth:strokeWidth,transform:transform,width:width,height:height}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:selected===false?"figure":"figure selected-figure",onClick:function onClick(){return _onClick(id);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{key:'svg1',version:'1.1',width:width,height:height,viewBox:'0 0 200 200',xmlns:'http://www.w3.org/2000/svg',xmlSpace:'preserve'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:d,fill:fill,stroke:stroke,strokeWidth:strokeWidth,transform:transform})));};Figure.defaultProps={angle:0,independent:false,selected:false,strokeWidth:0,stroke:"#000"};/* harmony default export */ __webpack_exports__["a"] = (Figure);

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.String = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var camelize = exports.camelize = function camelize(str) {
    return str.split(' ').map(function (word) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    }).join('');
  };
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var Tile=function Tile(_ref){var children=_ref.children,width=_ref.width,height=_ref.height,selected=_ref.selected,onSelectTile=_ref.onSelectTile;var styledSvg={border:selected?'2px solid black':'1px dotted #666666'};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{style:styledSvg,width:width,height:height,viewBox:'0 0 200 200',onClick:function onClick(){return onSelectTile();}},children);};Tile.defaultProps={width:100,height:100};/* harmony default export */ __webpack_exports__["a"] = (Tile);

/***/ }),
/* 12 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReactReduxContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var ReactReduxContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(null);
/* unused harmony default export */ var _unused_webpack_default_export = (ReactReduxContext);

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(78);
/* unused harmony reexport BrowserRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(83);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__HashRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(33);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(84);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(86);
/* unused harmony reexport NavLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(88);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(90);
/* unused harmony reexport Redirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(34);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(20);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(92);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(94);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generatePath__ = __webpack_require__(96);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__matchPath__ = __webpack_require__(97);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withRouter__ = __webpack_require__(98);
/* unused harmony reexport withRouter */





























/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__batch__ = __webpack_require__(24);
 // encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  var batch = Object(__WEBPACK_IMPORTED_MODULE_0__batch__["a" /* getBatch */])(); // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?

  var current = [];
  var next = [];
  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      batch(function () {
        for (var i = 0; i < listeners.length; i++) {
          listeners[i]();
        }
      });
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);
      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;
        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(store, parentSub) {
    this.store = store;
    this.parentSub = parentSub;
    this.unsubscribe = null;
    this.listeners = nullListeners;
    this.handleChangeWrapper = this.handleChangeWrapper.bind(this);
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.handleChangeWrapper = function handleChangeWrapper() {
    if (this.onStateChange) {
      this.onStateChange();
    }
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.handleChangeWrapper) : this.store.subscribe(this.handleChangeWrapper);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export __DO_NOT_USE__ActionTypes */
/* unused harmony export applyMiddleware */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bindActionCreators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return combineReducers; });
/* unused harmony export compose */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_symbol_observable__ = __webpack_require__(66);


/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error('It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function.');
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected the listener to be a function.');
    }

    if (isDispatching) {
      throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionDescription = actionType && "action \"" + String(actionType) + "\"" || 'an action';
  return "Given " + actionDescription + ", reducer \"" + key + "\" returned undefined. " + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.";
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined during initialization. " + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
    }

    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined when probed with a random type. " + ("Don't try to handle " + ActionTypes.INIT + " or other actions in \"redux/*\" ") + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */


function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning("No reducer provided for key \"" + key + "\"");
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
  // keys multiple times.

  var unexpectedKeyCache;

  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);

      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error("bindActionCreators expected an object or a function, instead received " + (actionCreators === null ? 'null' : typeof actionCreators) + ". " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
  }

  var boundActionCreators = {};

  for (var key in actionCreators) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error('Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return _objectSpread2({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */

function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === "production". ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or setting mode to production in webpack (https://webpack.js.org/concepts/mode/) ' + 'to ensure you have the correct code for your production build.');
}




/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(21);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(48);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setBatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getBatch; });
// Default to a dummy "batch" implementation that just runs the callback
function defaultNoopBatch(callback) {
  callback();
}

var batch = defaultNoopBatch; // Allow injecting another batching function later

var setBatch = function setBatch(newBatch) {
  return batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings

var getBatch = function getBatch() {
  return batch;
};

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_is__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_Subscription__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Context__ = __webpack_require__(14);







 // Define some constant arrays just to avoid re-creating these

var EMPTY_ARRAY = [];
var NO_SUBSCRIPTION_ARRAY = [null, null];

var stringifyComponent = function stringifyComponent(Comp) {
  try {
    return JSON.stringify(Comp);
  } catch (err) {
    return String(Comp);
  }
};

function storeStateUpdatesReducer(state, action) {
  var updateCount = state[1];
  return [action.payload, updateCount + 1];
}

var initStateUpdates = function initStateUpdates() {
  return [null, 0];
}; // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser. We need useLayoutEffect because we want
// `connect` to perform sync updates to a ref to save the latest props after
// a render is actually committed to the DOM.


var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_4_react__["useLayoutEffect"] : __WEBPACK_IMPORTED_MODULE_4_react__["useEffect"];
function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      _ref2$forwardRef = _ref2.forwardRef,
      forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef,
      _ref2$context = _ref2.context,
      context = _ref2$context === void 0 ? __WEBPACK_IMPORTED_MODULE_7__Context__["a" /* ReactReduxContext */] : _ref2$context,
      connectOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"]);

  __WEBPACK_IMPORTED_MODULE_3_invariant___default()(renderCountProp === undefined, "renderCountProp is removed. render counting is built into the latest React Dev Tools profiling extension");
  __WEBPACK_IMPORTED_MODULE_3_invariant___default()(!withRef, 'withRef is removed. To access the wrapped instance, use a ref on the connected component');
  var customStoreWarningMessage = 'To use a custom Redux store for specific components, create a custom React context with ' + "React.createContext(), and pass the context object to React Redux's Provider and specific components" + ' like: <Provider context={MyContext}><ConnectedComponent context={MyContext} /></Provider>. ' + 'You may also pass a {context : MyContext} option to connect';
  __WEBPACK_IMPORTED_MODULE_3_invariant___default()(storeKey === 'store', 'storeKey has been removed and does not do anything. ' + customStoreWarningMessage);
  var Context = context;
  return function wrapWithConnect(WrappedComponent) {
    if (false) {
      invariant(isValidElementType(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + stringifyComponent(WrappedComponent)));
    }

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var pure = connectOptions.pure;

    function createChildSelector(store) {
      return selectorFactory(store.dispatch, selectorFactoryOptions);
    } // If we aren't running in "pure" mode, we don't want to memoize values.
    // To avoid conditionally calling hooks, we fall back to a tiny wrapper
    // that just executes the given callback immediately.


    var usePureOnlyMemo = pure ? __WEBPACK_IMPORTED_MODULE_4_react__["useMemo"] : function (callback) {
      return callback();
    };

    function ConnectFunction(props) {
      var _useMemo = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useMemo"])(function () {
        // Distinguish between actual "data" props that were passed to the wrapper component,
        // and values needed to control behavior (forwarded refs, alternate context instances).
        // To maintain the wrapperProps object reference, memoize this destructuring.
        var forwardedRef = props.forwardedRef,
            wrapperProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["forwardedRef"]);

        return [props.context, forwardedRef, wrapperProps];
      }, [props]),
          propsContext = _useMemo[0],
          forwardedRef = _useMemo[1],
          wrapperProps = _useMemo[2];

      var ContextToUse = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useMemo"])(function () {
        // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
        // Memoize the check that determines which context instance we should use.
        return propsContext && propsContext.Consumer && Object(__WEBPACK_IMPORTED_MODULE_5_react_is__["isContextConsumer"])(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(propsContext.Consumer, null)) ? propsContext : Context;
      }, [propsContext, Context]); // Retrieve the store and ancestor subscription via context, if available

      var contextValue = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useContext"])(ContextToUse); // The store _must_ exist as either a prop or in context

      var didStoreComeFromProps = Boolean(props.store);
      var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
      __WEBPACK_IMPORTED_MODULE_3_invariant___default()(didStoreComeFromProps || didStoreComeFromContext, "Could not find \"store\" in the context of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + "or pass a custom React context provider to <Provider> and the corresponding " + ("React context consumer to " + displayName + " in connect options."));
      var store = props.store || contextValue.store;
      var childPropsSelector = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useMemo"])(function () {
        // The child props selector needs the store reference as an input.
        // Re-create this selector whenever the store changes.
        return createChildSelector(store);
      }, [store]);

      var _useMemo2 = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useMemo"])(function () {
        if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var subscription = new __WEBPACK_IMPORTED_MODULE_6__utils_Subscription__["a" /* default */](store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `subscription` will then be null. This can
        // probably be avoided if Subscription's listeners logic is changed to not call listeners
        // that have been unsubscribed in the  middle of the notification loop.

        var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
        return [subscription, notifyNestedSubs];
      }, [store, didStoreComeFromProps, contextValue]),
          subscription = _useMemo2[0],
          notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
      // and memoize that value to avoid unnecessary context updates.


      var overriddenContextValue = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useMemo"])(function () {
        if (didStoreComeFromProps) {
          // This component is directly subscribed to a store from props.
          // We don't want descendants reading from this store - pass down whatever
          // the existing context value is from the nearest connected ancestor.
          return contextValue;
        } // Otherwise, put this component's subscription instance into context, so that
        // connected descendants won't update until after this component is done


        return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, contextValue, {
          subscription: subscription
        });
      }, [didStoreComeFromProps, contextValue, subscription]); // We need to force this wrapper component to re-render whenever a Redux store update
      // causes a change to the calculated child component props (or we caught an error in mapState)

      var _useReducer = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useReducer"])(storeStateUpdatesReducer, EMPTY_ARRAY, initStateUpdates),
          _useReducer$ = _useReducer[0],
          previousStateUpdateResult = _useReducer$[0],
          forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards


      if (previousStateUpdateResult && previousStateUpdateResult.error) {
        throw previousStateUpdateResult.error;
      } // Set up refs to coordinate values between the subscription effect and the render logic


      var lastChildProps = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])();
      var lastWrapperProps = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])(wrapperProps);
      var childPropsFromStoreUpdate = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])();
      var renderIsScheduled = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useRef"])(false);
      var actualChildProps = usePureOnlyMemo(function () {
        // Tricky logic here:
        // - This render may have been triggered by a Redux store update that produced new child props
        // - However, we may have gotten new wrapper props after that
        // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
        // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
        // So, we'll use the child props from store update only if the wrapper props are the same as last time.
        if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) {
          return childPropsFromStoreUpdate.current;
        } // TODO We're reading the store directly in render() here. Bad idea?
        // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
        // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
        // to determine what the child props should be.


        return childPropsSelector(store.getState(), wrapperProps);
      }, [store, previousStateUpdateResult, wrapperProps]); // We need this to execute synchronously every time we re-render. However, React warns
      // about useLayoutEffect in SSR, so we try to detect environment and fall back to
      // just useEffect instead to avoid the warning, since neither will run anyway.

      useIsomorphicLayoutEffect(function () {
        // We want to capture the wrapper props and child props we used for later comparisons
        lastWrapperProps.current = wrapperProps;
        lastChildProps.current = actualChildProps;
        renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update

        if (childPropsFromStoreUpdate.current) {
          childPropsFromStoreUpdate.current = null;
          notifyNestedSubs();
        }
      }); // Our re-subscribe logic only runs when the store/subscription setup changes

      useIsomorphicLayoutEffect(function () {
        // If we're not subscribed to the store, nothing to do here
        if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts

        var didUnsubscribe = false;
        var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component

        var checkForUpdates = function checkForUpdates() {
          if (didUnsubscribe) {
            // Don't run stale listeners.
            // Redux doesn't guarantee unsubscriptions happen until next dispatch.
            return;
          }

          var latestStoreState = store.getState();
          var newChildProps, error;

          try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
          } catch (e) {
            error = e;
            lastThrownError = e;
          }

          if (!error) {
            lastThrownError = null;
          } // If the child props haven't changed, nothing to do here - cascade the subscription update


          if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) {
              notifyNestedSubs();
            }
          } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render

            forceComponentUpdateDispatch({
              type: 'STORE_UPDATED',
              payload: {
                latestStoreState: latestStoreState,
                error: error
              }
            });
          }
        }; // Actually subscribe to the nearest connected ancestor (or store)


        subscription.onStateChange = checkForUpdates;
        subscription.trySubscribe(); // Pull data from the store after first render in case the store has
        // changed since we began.

        checkForUpdates();

        var unsubscribeWrapper = function unsubscribeWrapper() {
          didUnsubscribe = true;
          subscription.tryUnsubscribe();

          if (lastThrownError) {
            // It's possible that we caught an error due to a bad mapState function, but the
            // parent re-rendered without this component and we're about to unmount.
            // This shouldn't happen as long as we do top-down subscriptions correctly, but
            // if we ever do those wrong, this throw will surface the error in our tests.
            // In that case, throw the error from here so it doesn't get lost.
            throw lastThrownError;
          }
        };

        return unsubscribeWrapper;
      }, [store, subscription, childPropsSelector]); // Now that all that's done, we can finally try to actually render the child component.
      // We memoize the elements for the rendered child component as an optimization.

      var renderedWrappedComponent = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useMemo"])(function () {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(WrappedComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, actualChildProps, {
          ref: forwardedRef
        }));
      }, [forwardedRef, WrappedComponent, actualChildProps]); // If React sees the exact same element reference as last time, it bails out of re-rendering
      // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.

      var renderedChild = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useMemo"])(function () {
        if (shouldHandleStateChanges) {
          // If this component is subscribed to store updates, we need to pass its own
          // subscription instance down to our descendants. That means rendering the same
          // Context instance, and putting a different value into the context.
          return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ContextToUse.Provider, {
            value: overriddenContextValue
          }, renderedWrappedComponent);
        }

        return renderedWrappedComponent;
      }, [ContextToUse, renderedWrappedComponent, overriddenContextValue]);
      return renderedChild;
    } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.


    var Connect = pure ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.memo(ConnectFunction) : ConnectFunction;
    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;

    if (forwardRef) {
      var forwarded = __WEBPACK_IMPORTED_MODULE_4_react___default.a.forwardRef(function forwardConnectRef(props, ref) {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Connect, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
          forwardedRef: ref
        }));
      });
      forwarded.displayName = displayName;
      forwarded.WrappedComponent = WrappedComponent;
      return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(forwarded, WrappedComponent);
    }

    return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(63);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(29);

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
//
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
//
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(30);


function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__useReduxContext__ = __webpack_require__(32);

/**
 * A hook to access the redux store.
 *
 * @returns {any} the redux store
 *
 * @example
 *
 * import React from 'react'
 * import { useStore } from 'react-redux'
 *
 * export const ExampleComponent = () => {
 *   const store = useStore()
 *   return <div>{store.getState()}</div>
 * }
 */

function useStore() {
  var _useReduxContext = Object(__WEBPACK_IMPORTED_MODULE_0__useReduxContext__["a" /* useReduxContext */])(),
      store = _useReduxContext.store;

  return store;
}

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useReduxContext;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Context__ = __webpack_require__(14);



/**
 * A hook to access the value of the `ReactReduxContext`. This is a low-level
 * hook that you should usually not need to call directly.
 *
 * @returns {any} the value of the `ReactReduxContext`
 *
 * @example
 *
 * import React from 'react'
 * import { useReduxContext } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const { store } = useReduxContext()
 *   return <div>{store.getState()}</div>
 * }
 */

function useReduxContext() {
  var contextValue = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__components_Context__["a" /* ReactReduxContext */]);
  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(contextValue, 'could not find react-redux context value; please ensure the component is wrapped in a <Provider>');
  return contextValue;
}

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(8);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Link> outside a <Router>");

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(35);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(22);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(87)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Slide__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__slider_css__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__slider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__slider_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Slider=function(_Component){_inherits(Slider,_Component);function Slider(props){_classCallCheck(this,Slider);var _this=_possibleConstructorReturn(this,(Slider.__proto__||Object.getPrototypeOf(Slider)).call(this,props));_this.goToPrevSlide=function(){if(_this.state.currentIndex===0){_this.setState({currentIndex:_this.state.image.length-1});}_this.setState({currentIndex:_this.state.currentIndex-1});};_this.goToNextSlide=function(){if(_this.state.currentIndex===_this.state.images.length-1){return _this.setState({currentIndex:0});}_this.setState({currentIndex:_this.state.currentIndex+1});};_this.slideWidth=function(){return document.querySelector('.slide').clientWidth;};_this.state={images:['grano-1200','mosaicos'],descriptions:['Baldosas en Grano','Mosaicos'],links:['/galeria','/mosaicos'],currentIndex:0,translateValue:0};_this.goToNextSlide=_this.goToNextSlide.bind(_this);_this.goToPrevSlide=_this.goToPrevSlide.bind(_this);_this.Interval=setInterval(function(){_this.goToNextSlide();},4000);return _this;}_createClass(Slider,[{key:'componentWillUnmount',value:function componentWillUnmount(){clearInterval(this.interval);}},{key:'render',value:function render(){var _state=this.state,currentIndex=_state.currentIndex,descriptions=_state.descriptions,links=_state.links;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slider'},this.state.images.map(function(image,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Slide__["a" /* default */],{key:index,image:image,description:descriptions[index],url:links[index],visible:index==currentIndex?"block":"none"});}));}}]);return Slider;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Slider);

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__card_css__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__card_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__card_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Card=function(_Component){_inherits(Card,_Component);function Card(props){_classCallCheck(this,Card);return _possibleConstructorReturn(this,(Card.__proto__||Object.getPrototypeOf(Card)).call(this,props));}_createClass(Card,[{key:'render',value:function render(){var title=this.props.title;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},title),this.props.children));}}]);return Card;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Card);

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MapContainer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_google_maps_react__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_google_maps_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_google_maps_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MapContainer=function(_Component){_inherits(MapContainer,_Component);function MapContainer(props){_classCallCheck(this,MapContainer);return _possibleConstructorReturn(this,(MapContainer.__proto__||Object.getPrototypeOf(MapContainer)).call(this,props));}_createClass(MapContainer,[{key:'render',value:function render(){var _props=this.props,lat=_props.lat,lng=_props.lng,zoom=_props.zoom;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_google_maps_react__["Map"],{google:this.props.google,zoom:zoom,initialCenter:{lat:lat,lng:lng},style:{width:'80%',height:'600px',margin:'0 auto 0 auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_google_maps_react__["Marker"],{title:'TodoPisos S.A.S.',name:'TodoPisos',position:{lat:lat,lng:lng}}));}}]);return MapContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_google_maps_react__["GoogleApiWrapper"])({apiKey:"AIzaSyAndX6gHhGauGLHaLuYHjFs5mTuLNPsvG4"})(MapContainer));

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.arePathsEqual = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };

  /**
   * Compares two path arrays of LatLng objects.
   */

  var arePathsEqual = exports.arePathsEqual = function arePathsEqual(pathA, pathB) {
    if (pathA === pathB) {
      return true;
    }
    if (!Array.isArray(pathA) || !Array.isArray(pathB)) {
      return false;
    }
    if (pathA.length !== pathB.length) {
      return false;
    }
    for (var i = 0; i < pathA.length; ++i) {
      if (pathA[i] === pathB[i]) {
        continue;
      }
      if (!isValidLatLng(pathA[i]) || !isValidLatLng(pathB[i])) {
        return false;
      }
      if (pathB[i].lat !== pathA[i].lat || pathB[i].lng !== pathA[i].lng) {
        return false;
      }
    }
    return true;
  };

  /**
   * Helper that checks whether an array consists of objects
   * with lat and lng properties
   * @param {object} elem the element to check
   * @returns {boolean} whether or not it's valid
   */
  var isValidLatLng = function isValidLatLng(elem) {
    return elem !== null && (typeof elem === 'undefined' ? 'undefined' : _typeof(elem)) === 'object' && elem.hasOwnProperty('lat') && elem.hasOwnProperty('lng');
  };
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__site_css__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__site_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__site_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Site=function(_React$Component){_inherits(Site,_React$Component);function Site(props){_classCallCheck(this,Site);return _possibleConstructorReturn(this,(Site.__proto__||Object.getPrototypeOf(Site)).call(this,props));}_createClass(Site,[{key:'render',value:function render(){var _props=this.props,tel=_props.tel,dir=_props.dir,dep=_props.dep,mun=_props.mun;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'site'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,mun,' - ',dep),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,dir),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Tel\xE9fono: ',tel));}}]);return Site;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Site);

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__colorElement_css__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__colorElement_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__colorElement_css__);
var ColorElement=function ColorElement(_ref){var id=_ref.id,color=_ref.color,selected=_ref.selected,selectedPath=_ref.selectedPath,_onClick=_ref.onClick;var className='color';if(selected)className+=' selected';var divStyle={backgroundColor:color,width:'20px',height:'20px',cursor:'pointer',paddingLeft:'2px',marginLeft:'5px',marginBottom:'5px',border:selected?'2px solid #000':''};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:divStyle,onClick:function onClick(){return _onClick(selectedPath,color,id);}});};/* harmony default export */ __webpack_exports__["a"] = (ColorElement);

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tile__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__figure__ = __webpack_require__(9);
var DrawTile=function DrawTile(tile,color,selectedSample,colorSchemeIndex,onSelectedSample){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__tile__["a" /* default */],{selected:selectedSample===colorSchemeIndex,onSelectTile:function onSelectTile(){return onSelectedSample(colorSchemeIndex,tile.colorScheme[colorSchemeIndex]);}},tile.paths.map(function(path,pathIndex){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__figure__["a" /* default */],{key:pathIndex,transform:path.transform,d:path.d,fill:color[pathIndex]});}));};var SampleMenu=function SampleMenu(_ref){var tile=_ref.tile,selectedTileIndex=_ref.selectedTileIndex,selectedSample=_ref.selectedSample,onSelectedSample=_ref.onSelectedSample;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,tile.colorScheme.map(function(color,colorSchemeIndex){return DrawTile(tile,color,selectedSample,colorSchemeIndex,onSelectedSample);}));};/* harmony default export */ __webpack_exports__["a"] = (SampleMenu);

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(46);
module.exports = __webpack_require__(51);


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(47).enable();
  window.Promise = __webpack_require__(49);
}

// fetch() polyfill for making API calls.
__webpack_require__(50);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(13);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(23);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12)))

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(23);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 50 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__registerServiceWorker__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_app_App__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__reducers_index__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__node_modules_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__node_modules_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__node_modules_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__index_css__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__index_css__);
//New
var initialState={tiles:[{paths:[{d:"m144.26 0c-70.02 19.495-125.09 74.777-144.26 144.93v55.07h92.684c-0.6473-4.8673 0.8277-8.0939 2.2344-12.338 2.4626-3.8157 1.2758-5.5517 11.99-7.4961 3.6198-1.9507 9.6735-3.2948 12.752-1.3066l6.2363-8.3242c0.78764-1.949 5.2005-4.4296 9.3027-4.3457 3.0027-1.6929 7.7723 2.5379 10.51 3.0547 1.8678 0.34899 3.1162 2.1106 3.3047 3.5644l0.97461 6.9707c-0.81449 2.1384 1.642 3.8358 2.3301 5.3555 0 0 0.86616 0.51971 1.4316 0.75781l10.928-2.2324-8.25-13.035-7.1426-9.3574-10.139-8.5176-4.7226-2.6562-12.469-0.62109-3.1465 0.77343-3.3301 0.69141 0.92382 1.7188 1.2754 11.184-7.875 9.9902-4.6445 2.0859-5.3789 0.5625-7.7383 0.32812-1.9629 3.3262-1.3926 2.5234c-2.0914 4.2436-3.4921 3.064-6.4531 3.668-2.6441 0.50878-6.1678-0.0227-10.26-0.19336l-7.2832-8.5059-8.2246 6.4277-15.66 4.6641-11.197-4.4961c9.1845-5.875 10.373-9.3071 19.979-15.918 0.88393-2.3542 8.3251-11.521 10.146-13.25 9.6994-5.8958 11.648-7.8542 18.035-10.75 4.1786-1.0536 7.3566-1.7316 11.66-2.9102l9.8945-0.82031 5.1953 0.30273 14.08 0.23633 8.0098 1.5664 6.127 1.6035 1.5273-1.5469-3.084-2.6719-3.0371-3.4844-1.5898-1.5469-4.9277-3.8223-4.8496-2.0332-5.8125 4.5625-7.6875 1.6875c-3.6509-0.88646-6.9898-2.4612-9.6406-4.9102l-2.0352-4.7051c-0.97836-2.3886-0.97301-4.6126-0.73633-7.7969-2.6415 0.5809-4.6573 0.59879-7.1738-0.13281-3.3016-2.2761-5.215-4.382-6.916-8.9453-0.92047-1.5207-0.65374-2.9168-0.51172-4.5625l2.6328-7.123c-6.0822-5.1096-4.1535-6.5435-4.627-10.193-0.14852-3.025 2.3282-6.4242 3.3047-9.3242 2.9-0.97648 6.2992-3.4532 9.3242-3.3047 3.6498 0.47344 5.0857-1.4572 10.195 4.625l7.1211-2.6309c1.6457-0.14203 3.0418-0.40876 4.5625 0.51172 4.5633 1.701 6.6711 3.6125 8.9473 6.9141 0.7316 2.5165 0.71176 4.5343 0.13086 7.1758 3.1843-0.23669 5.4083-0.24397 7.7969 0.73437l4.707 2.0371c2.449 2.6508 4.0217 5.9898 4.9082 9.6406l-1.6875 7.6875-4.5625 5.8125 2.0332 4.8476 3.8223 4.9277 1.5469 1.5918 3.4863 3.0371 2.6699 3.082 1.5469-1.5254-1.6016-6.127-1.5684-8.0098-0.23633-14.08-0.30273-5.1973 0.82031-9.8926c1.1786-4.3036 1.8585-7.4816 2.9121-11.66 2.8958-6.3869 4.8542-8.3358 10.75-18.035 1.7292-1.8214 10.896-9.2626 13.25-10.146 6.6109-9.6055 10.043-10.794 15.918-19.979l4.4961 11.195-4.6641 15.66-6.4297 8.2246 8.5059 7.2852c0.17066 4.092 0.70214 7.6157 0.19336 10.26-0.60399 2.961 0.57563 4.3617-3.668 6.4531l-2.5234 1.3926-3.3262 1.9609-0.32812 7.7383-0.5625 5.3809-2.0859 4.6445-9.9902 7.875-11.184-1.2773-1.7188-0.92383-0.69141 3.3301-0.77148 3.1484 0.61914 12.469 2.6562 4.7226 8.5176 10.139 9.3574 7.1426 13.037 8.25 2.2305-10.928c-0.2381-0.56548-0.75781-1.4316-0.75781-1.4316-1.5196-0.68812-3.2152-3.1446-5.3535-2.3301l-6.9707-0.97461c-1.4538-0.18844-3.2174-1.4369-3.5664-3.3047-0.5168-2.7375-4.7456-7.5091-3.0527-10.512-0.0839-4.1022 2.3947-8.5132 4.3438-9.3008l8.3242-6.2363c-1.9882-3.0785-0.64408-9.1321 1.3066-12.752 1.9444-10.714 3.6823-9.5277 7.498-11.99 4.2911-1.4223 7.539-2.9198 12.498-2.2168v-82.541l-0.0391 6.4121 0.0117 7.4863c-96.918 0-175.49 78.568-175.49 175.49l-7.4863-0.0117-16.672 0.10157v-31.062c3.7083 0.26471 7.3725 1.0163 11.125 0.79492 1.4583-0.0616 2.7917-0.40523 4.1875-0.60742 1.7765-1.2941 3.5962-2.4573 4.8027-4.6719 14.256-72.612 71.46-129.82 144.07-144.07 2.2146-1.2065 3.3778-3.0262 4.6719-4.8027 0.20223-1.3958 0.54582-2.7292 0.60742-4.1875 0.22141-3.7525-0.53019-7.4167-0.79492-11.125h31v-0.06252zm-45.457 0.99219c0.22807 0.34129 0.3846 0.66163 0.4707 0.88086-0.09064-0.34008-0.25522-0.62603-0.4707-0.88086zm0.52734 1.2305c0.0047 0.12842 0.0086 0.25825-0.0039 0.41211 0.0097-0.14371 0.01588-0.28481 0.0039-0.41211zm-0.01172 0.54102c-0.01517 0.13621-0.05795 0.30859-0.08789 0.46484 0.0396-0.16283 0.07178-0.32026 0.08789-0.46484zm-1.6523 1.8184c-0.37387 0.23163-0.74722 0.46506-1.1211 0.69141 0.37645-0.21507 0.74799-0.4585 1.1211-0.69141zm-10.811 4.2148c-0.44515 0.085157-0.8926 0.14814-1.3398 0.20312 0.44766-0.056055 0.89427-0.12434 1.3398-0.20312zm-1.9238 0.27344c-1.5569 0.15114-3.1126 0.15062-4.6406 0.10352 1.559 0.082237 3.1061 0.055311 4.6406-0.10352zm-71.293 4.0176a19 19 0 0 1-0.14648 0.15625h0.08398zm51.361 0.07813c0.15807 1.9784 0.0093 3.8709-0.35547 5.7988 0.36787-1.8475 0.54812-3.7639 0.35547-5.7988zm-51.723 0.30859a19 19 0 0 1-0.0293 0.0293l0.03516-0.01367zm-13.279 5.4258v98.609l0.041016-19.863zm64.584 0.39648c-0.02645 0.13142-0.05953 0.26459-0.08789 0.39648 0.02983-0.1321 0.0598-0.26374 0.08789-0.39648zm-44.15 0.77148c-0.09304 0.07398-0.18642 0.13852-0.2793 0.21484-0.28569 0.35662-0.55103 0.71378-0.80274 1.0723a15 15 0 0 1 1.082-1.2871zm-3.8125 7.2812c-0.79652 3.5231-0.20695 6.9041 1.2871 9.7695a15 15 0 0 1-1.2871-9.7695zm38.189 4.4766c-0.54169 0.16822-1.0891 0.30897-1.6387 0.44336 0.54725-0.12683 1.0945-0.27405 1.6387-0.44336zm-13.285 9.5215a15 15 0 0 1-0.12109 0.10938l5.6211 5.5059zm-15.609 3.0215c0.05022 0.02004 0.09997 0.04106 0.15039 0.06055a15 15 0 0 1-0.15039-0.06055zm0.74023 0.26758c1.317 0.44545 2.6928 0.70175 4.0918 0.73633a15 15 0 0 1-4.0918-0.73633zm7.1133 0.54102a15 15 0 0 1-1.6582 0.17578c0.01914 0.04607 0.02723 0.08393 0.04492 0.12891 0.56843-0.08059 1.1046-0.18241 1.6133-0.30469zm-2.1055 0.18359a15 15 0 0 1-0.85742 0.01367c0.28515 0.0058 0.57093-7.65e-4 0.85742-0.01367zm0.92969 6.4453c-0.29438 1.6511-0.80092 3.2348-1.3672 4.8281 0.63284-1.6 1.099-3.2036 1.3672-4.8281zm-3.7578 7.252c-1.6102 1.5081-3.319 2.8933-5.1484 4.293 1.9777-1.4342 3.6238-2.835 5.1484-4.293zm-20.035 4.834c-0.26385-0.01503-0.47966 0.01724-0.67578 0.06641 0.20173-0.04467 0.445-0.05788 0.70898-0.05664zm12.869 0.04297c-3.3175 0.90052-6.3668 1.3314-9.7383 0.8418 3.5399 0.6087 6.6953 0.0108 9.7383-0.8418zm-13.863 0.12109c-0.00829 0.0039-0.013347 0.0097-0.021484 0.01367 0.00912-4e-3 0.016116-0.0098 0.025391-0.01367-0.00104 4.81e-4 -0.00287-4.83e-4 -0.00391 0zm-0.67969 0.62891c-0.1626 0.27543-0.20898 0.51758-0.20898 0.51758 0.050707-0.19796 0.12446-0.36449 0.20898-0.51758zm2.0664 14.752c0.095506 2.4505 0.12109 5-0.38086 7.5 0.00116 0.04882-0.0023 0.09767-0.00195 0.14648 0.4742-2.5156 0.58086-5.0643 0.38281-7.6465zm-3.3711 16.168c-0.67505 1.1515-1.3968 2.3036-2.1094 3.4551 0.78829-1.1382 1.4901-2.2871 2.1094-3.4551zm-2.1094 3.4551c-0.68119 0.17597-1.1873 0.2168-1.5801 0.18555 0.42535 0.07129 0.92787 0.03702 1.5801-0.18555zm-2.6914-0.35156c0.27783 0.24185 0.59307 0.4236 0.97461 0.51367-0.21223-0.074579-0.59116-0.25578-0.97461-0.51367zm198.98 50.691-0.16602 20.605a30 30 0 0 1 0.16602-6e-3zm-20.82 29.008c-0.16636 0.14229-0.33884 0.27322-0.50391 0.41797-0.28217 0.32159-0.54178 0.65575-0.81445 0.98242a30 30 0 0 1 1.3184-1.4004zm-9.084 19.682c-0.0474 0.62203-0.0828 1.2543-0.0976 1.9043l-0.72662 6e-3h0.72852a30 30 0 0 1 0.0957-1.9102z",transform:"rotate(0 0 0)"},{d:"m0.47071-0.062486v17.752a17.75 17.751 0 0 0 17.75-17.752zm117.1 0c-52.966 22.004-95.271 64.458-117.1 117.52v27.422c19.175-70.155 74.242-125.44 144.26-144.94zm51.898 0.0625c0.26473 3.7085 1.0163 7.3743 0.79492 11.127-0.0616 1.4584-0.40519 2.7916-0.60742 4.1875-1.2941 1.7766-2.4573 3.5962-4.6719 4.8027-72.612 14.257-129.82 71.462-144.07 144.08-1.2065 2.2147-3.0262 3.3777-4.8027 4.6719-1.3958 0.20223-2.7292 0.54581-4.1875 0.60742-3.7525 0.22142-7.4167-0.53019-11.125-0.79492v31.064l16.672-0.10157 7.4863 0.0117c6e-6 -96.923 78.568-175.49 175.49-175.49l-0.0117-7.4863 0.10156-16.674zm31 169.95a30 30.001 0 0 0-0.12695 6e-3 30 30 0 0 1 0.12695-4e-3zm-2.5508 0.1289a30 30.001 0 0 0-1.4941 0.17969 30 30 0 0 1 1.4941-0.17969zm-2.9805 0.40625a30 30.001 0 0 0-1.4883 0.33399 30 30 0 0 1 1.4883-0.33399zm-2.8828 0.68946a30 30.001 0 0 0-1.498 0.49804 30 30 0 0 1 1.498-0.49804zm-2.8457 0.99023a30 30.001 0 0 0-1.3984 0.625 30 30 0 0 1 1.3984-0.625zm-2.7188 1.2637a30 30.001 0 0 0-1.3379 0.76758 30 30 0 0 1 1.3379-0.76758zm-2.5723 1.5234a30 30.001 0 0 0-1.2539 0.89648 30 30 0 0 1 1.2539-0.89648zm-2.4277 1.791a30 30.001 0 0 0-1.1309 0.99218 30 30 0 0 1 1.1309-0.99218zm-2.209 1.9961a30 30.001 0 0 0-1.0586 1.1367 30 30 0 0 1 1.0586-1.1367zm-2.0176 2.2285a30 30.001 0 0 0-0.91797 1.207 30 30 0 0 1 0.91797-1.207zm-1.7832 2.418a30 30.001 0 0 0-0.7832 1.2774 30 30 0 0 1 0.7832-1.2774zm-1.5273 2.5742a30 30.001 0 0 0-0.66993 1.3867 30 30 0 0 1 0.66993-1.3867zm-1.2598 2.707a30 30.001 0 0 0-0.52344 1.4316 30 30 0 0 1 0.52344-1.4316zm-0.99414 2.8496a30 30.001 0 0 0-0.36914 1.4395 30 30 0 0 1 0.36914-1.4395zm-0.69727 2.9004a30 30.001 0 0 0-0.23047 1.5332 30 30 0 0 1 0.23047-1.5332zm-0.40429 2.957a30 30.001 0 0 0-0.12891 2.5781 30 30 0 0 1 0.12891-2.5781z",transform:"rotate(0 0 0)"},{d:"m117.57-0.0625-19.863 0.041016c1.0339 0.91094 2.1301 1.5734 1.4141 3.6719-2.9391 2.0356-5.9417 3.5073-9.1934 4.418-3.4141 1.0411-6.8906 1.332-10.43 1.0605-4.4784-1.0017-6.3308-1.1581-13.184-2.1602l-1.0508-0.11328c-0.90502 0.23181-1.3411 0.77598-1.3086 2.0078l0.88281 3.0059c0.74378 4.3254-0.29455 8.0867-1.4258 11.756-2.2076 3.0442-4.3217 5.3386-6.7168 7.5391-2.7204 1.076-5.4514 1.6844-8.2773 1.623-0.67838-0.30325-1.0877-0.27793-2.2129-0.74414a15 15 0 0 0-4.2988-12.256 15 15 0 0 0-21.213 0 15 15 0 0 0 0 21.213 15 15 0 0 0 11.412 4.3438v0.14648c-0.08963 0.01239-0.17187 0.03008-0.26367 0.04102 0.79349 1.6713 0.64987 2.0298 1.0059 2.8262 0.06131 2.826-0.54708 5.5569-1.623 8.2773-2.2005 2.3951-4.4948 4.5092-7.5391 6.7168-3.6691 1.1312-7.4305 2.1696-11.756 1.4258l-3.0059-0.88282c-1.2318-0.03248-1.776 0.40357-2.0078 1.3086l0.11328 1.0508c1.002 6.8527 1.1604 8.7053 2.1621 13.184 0.27145 3.5391-0.021447 7.0156-1.0625 10.43-0.91064 3.2516-2.3823 6.2542-4.418 9.1934-2.0984 0.71609-2.7609-0.38015-3.6719-1.4141l-0.041016 19.863c11.007-26.392 25.125-47.257 47.062-70.51 23.253-21.938 44.118-36.056 70.51-47.062zm66.488 29.832c-5.875 9.1845-9.3071 10.373-15.918 19.979-2.3542 0.88393-11.521 8.3251-13.25 10.146-5.8958 9.6994-7.8542 11.648-10.75 18.035-1.0536 4.1786-1.7335 7.3566-2.9121 11.66l-0.82031 9.8926 0.30273 5.1973 0.23633 14.08 1.5684 8.0098 1.6016 6.127-1.5469 1.5254-2.6699-3.082-3.4863-3.0371-1.5469-1.5918-3.8223-4.9277-2.0332-4.8476 4.5625-5.8125 1.6875-7.6875c-0.88646-3.6508-2.4592-6.9898-4.9082-9.6406l-4.707-2.0371c-2.3886-0.97835-4.6126-0.97106-7.7969-0.73437 0.5809-2.6415 0.60074-4.6593-0.13086-7.1758-2.2761-3.3016-4.3839-5.2131-8.9473-6.9141-1.5207-0.92048-2.9168-0.65375-4.5625-0.51172l-7.1211 2.6309c-5.1096-6.0822-6.5455-4.1516-10.195-4.625-3.025-0.14852-6.4242 2.3282-9.3242 3.3047-0.97648 2.9-3.4532 6.2992-3.3047 9.3242 0.47344 3.6498-1.4553 5.0838 4.627 10.193l-2.6328 7.123c-0.14203 1.6457-0.40876 3.0418 0.51172 4.5625 1.701 4.5633 3.6144 6.6692 6.916 8.9453 2.5165 0.7316 4.5323 0.71371 7.1738 0.13281-0.23668 3.1843-0.24203 5.4083 0.73633 7.7969l2.0352 4.7051c2.6508 2.449 5.9898 4.0237 9.6406 4.9102l7.6875-1.6875 5.8125-4.5625 4.8496 2.0332 4.9277 3.8223 1.5898 1.5469 3.0371 3.4844 3.084 2.6719-1.5273 1.5469-6.127-1.6035-8.0098-1.5664-14.08-0.23633-5.1953-0.30273-9.8945 0.82031c-4.3036 1.1786-7.4816 1.8566-11.66 2.9102-6.3869 2.8958-8.3358 4.8542-18.035 10.75-1.8214 1.7292-9.2626 10.896-10.146 13.25-9.6055 6.6109-10.794 10.043-19.979 15.918l11.197 4.4961 15.66-4.6641 8.2246-6.4277 7.2832 8.5059c4.092 0.17068 7.6157 0.70214 10.26 0.19336 2.961-0.60399 4.3617 0.57563 6.4531-3.668l1.3926-2.5234 1.9629-3.3262 7.7383-0.32812 5.3789-0.5625 4.6445-2.0859 7.875-9.9902-1.2754-11.184-0.92382-1.7188 3.3301-0.69141 3.1465-0.77343 12.469 0.62109 4.7226 2.6562 10.139 8.5176 7.1426 9.3574 8.25 13.035-10.928 2.2324c-0.56548-0.2381-1.4316-0.75781-1.4316-0.75781-0.68812-1.5196-3.1446-3.2171-2.3301-5.3555l-0.97461-6.9707c-0.18844-1.4538-1.4369-3.2155-3.3047-3.5644-2.7375-0.5168-7.5071-4.7476-10.51-3.0547-4.1022-0.0839-8.5151 2.3967-9.3027 4.3457l-6.2363 8.3242c-3.0785-1.9882-9.1321-0.64408-12.752 1.3066-10.714 1.9444-9.5277 3.6804-11.99 7.4961-1.467 4.4258-3.0353 7.7257-2.1641 12.955l77.244-0.62305c0.21358-9.2182 3.7485-15.55 8.6777-21.168 5.615-4.9239 11.944-8.4526 21.156-8.666l0.625-77.244c-5.2294-0.87127-8.5292 0.6971-12.955 2.1641-3.8157 2.4626-5.5536 1.2758-7.498 11.99-1.9507 3.6198-3.2948 9.6735-1.3066 12.752l-8.3242 6.2363c-1.949 0.78764-4.4276 5.1986-4.3438 9.3008-1.6929 3.0026 2.5359 7.7742 3.0527 10.512 0.34899 1.8678 2.1126 3.1162 3.5664 3.3047l6.9707 0.97461c2.1384-0.81449 3.8339 1.642 5.3535 2.3301 0 0 0.51971 0.86616 0.75781 1.4316l-2.2305 10.928-13.037-8.25-9.3574-7.1426-8.5176-10.139-2.6562-4.7226-0.61914-12.469 0.77148-3.1484 0.69141-3.3301 1.7188 0.92383 11.184 1.2773 9.9902-7.875 2.0859-4.6445 0.5625-5.3809 0.32812-7.7383 3.3262-1.9609 2.5234-1.3926c4.2436-2.0914 3.064-3.4921 3.668-6.4531 0.50878-2.6441-0.0227-6.1678-0.19336-10.26l-8.5059-7.2852 6.4297-8.2246 4.6641-15.66z",transform:"rotate(0 0 0)"},{d:"m18.988-0.041016-5.4102 13.285h-0.3867l0.09373 0.24609-13.285 5.4102 0.041016 78.746c0.26392 0.78327 1.6004 1.47 2.0098 1.5996 0.40084 0.0432 0.93921 0.0012 1.6621-0.18555 2.5006-4.041 5.1956-8.082 5.0996-12.123 0.50195-2.5 0.47637-5.0495 0.38086-7.5-0.31445-4.1875-1.3789-8.375-2.0684-12.562l-0.20703-1.6719s0.22417-1.405 1.8828-1.3105l3.1309 0.88477c4.0436 0.58724 7.6185-0.13802 11.756-1.4258 2.763-2.1139 5.276-4.1654 7.5391-6.7168 0.94727-2.6654 1.7383-5.2995 1.623-8.2773-0.2474-1.0046-0.24479-1.8216-0.74219-3.0137-11.15 0.88471-21.81-12.757-11.953-25.061 12.36-10.157 26.167 0.56812 25.277 11.783 1.1921 0.4974 2.0091 0.4948 3.0137 0.74219 2.9779 0.11524 5.612-0.67578 8.2773-1.623 2.5514-2.263 4.6029-4.776 6.7168-7.5391 1.2878-4.1374 2.013-7.7122 1.4258-11.756l-0.88476-3.1309c-0.09449-1.6586 1.3105-1.8828 1.3105-1.8828l1.6719 0.20703c4.1875 0.68946 8.375 1.7539 12.562 2.0684 2.4505 0.09551 5 0.1211 7.5-0.38086 4.041 0.09597 8.082-2.599 12.123-5.0996 0.18675-0.72289 0.22875-1.2613 0.18555-1.6621-0.12958-0.40935-0.81634-1.7458-1.5996-2.0098z",transform:"rotate(0 0 0)"},{d:"m0-0.099609v19a19 19 0 0 0 19-19zm185 0.099609v15h15v-15zm15.041 170a30 30 0 0 0-30 30h30zm-200.04 15v15h15v-15z",transform:"rotate(0 0 0)"}],colorScheme:[['#efffe8','#59f',"#d8ba31","#4cb3a0","#d40000"],['#C6BDBE','#9EA9E1','#fff','#C6BDBE','#C6BDBE'],['#7d7d7d','#59f',"#d8ba31","#4cb3a0","#d40000"]],rotations:[0,90,0,90,270,180,270,180,0,90,0,90,270,180,270,180],translations:[0]},{paths:[{d:"m99.496 21.451c-2.218 0-4.4549 1.0578-6.6504 3.1738-4.403 3.589-5.0477 7.8204-1.4727 13.025-7.321 1.958-11.397 5.8772-11.883 11.41s2.6045 9.4367 9.4395 12.053c3.588 2.603 5.703 6.1899 5.375 10.422-0.316 2.602-1.9456 4.5611-4.3906 5.2051-3.418 1.302-7.3336 0.65822-10.266-1.3008-13.512-9.766-18.402-28.009-11.24-43.65-16.286 2.616-32.899-0.64262-46.74-9.7656 9.123 13.683 12.54 30.612 9.9375 46.91 15.312-7.177 33.386-2.6146 43.152 11.068 2.444 2.932 3.101 6.8348 1.957 10.424-0.972 1.958-3.0882 3.9015-5.5332 4.2305-4.232 0.328-7.9786-1.6291-10.266-5.2051-2.761-6.848-6.8351-10.108-12.369-9.4512-5.376 0.329-9.1212 4.5606-11.408 11.725-4.876-3.576-9.2803-2.9312-13.027 1.3008-4.075 4.561-4.075 9.1235 0 13.355 3.746 4.246 8.1513 4.8899 13.027 1.6309 2.287 7.163 6.0322 11.079 11.408 11.723 5.534 0.65698 9.6081-2.6026 12.369-9.7656 2.287-3.589 5.7046-5.2168 10.266-5.2168 2.603 0.657 4.3892 1.9576 5.5332 4.5606 1.145 3.917 0.48797 7.1749-1.957 10.422-11.067 15.642-25.566 19.547-43.152 11.082 2.772 16.942-0.6575 32.569-9.9375 46.896 14.341-9.767 29.968-12.699 46.74-10.096-8.307-17.586-4.5607-31.912 11.238-43.32 3.103-2.274 6.5196-2.9338 10.266-1.6328 2.603 0.986 4.0766 2.9328 4.3926 5.5488 0.328 4.561-1.46 7.8087-5.377 10.096-6.835 2.931-9.9235 6.8349-9.4375 12.381 0.486 5.534 4.5599 9.1095 11.881 11.396-3.575 4.889-2.9303 9.1204 1.4727 13.023 4.391 3.918 8.9516 3.918 13.184 0 4.403-3.903 5.0609-8.1334 1.6309-13.023 7.334-2.287 11.238-5.8625 11.738-11.396 0.485-5.546-2.618-9.4499-9.623-12.381-3.417-2.287-5.5329-6.1927-5.0469-10.096 0.172-2.616 1.9593-4.8128 4.4043-5.5488 3.574-1.301 7.0048-0.64019 10.094 1.6328 15.641 11.408 19.546 25.734 11.238 43.32 16.943-2.602 32.569 0.3287 46.91 10.096-9.779-14.327-12.709-29.954-10.107-46.896-17.586 8.465-31.914 4.56-43.152-11.082-2.444-3.247-3.1021-6.5049-1.7871-10.422 0.803-2.603 2.7612-3.9046 5.5352-4.5606 4.389 0 7.8208 1.6278 10.094 5.2168 2.774 7.163 7.0068 10.423 12.383 9.7656 5.535-0.64401 9.1235-4.5597 11.396-11.723 4.561 3.259 9.1234 2.6151 13.025-1.6309 3.918-4.233 3.918-8.7945 0-13.355-3.902-4.232-8.4634-4.8768-13.025-1.3008-2.274-7.163-5.8625-11.396-11.396-11.725-5.376-0.657-9.6098 2.6032-12.383 9.4512-2.274 3.576-5.7048 5.5331-10.094 5.2051-2.774-0.328-4.7322-1.6275-5.5352-4.2305-1.315-3.904-0.65494-7.1638 1.7891-10.424 11.238-15.628 25.564-19.546 43.15-11.068-2.602-16.942 0.32843-32.582 10.107-46.91-14.341 9.122-29.967 12.697-46.91 9.7656 8.308 17.6 4.4037 31.926-11.238 43.65-3.089 2.287-6.5198 2.6018-10.094 1.3008-2.603-0.643-4.2323-2.6021-4.4043-5.2051-0.486-4.561 1.3028-7.8189 5.0488-10.422 7.005-2.615 10.106-6.5187 9.6211-12.053-0.5-5.534-4.4043-9.4522-11.738-11.41 3.43-5.205 2.7741-9.4364-1.6289-13.025-2.1165-2.116-4.3152-3.1738-6.5332-3.1738zm-23.666 54.646c13.512 12.369 33.873 12.369 47.385 0-12.211 13.683-12.211 33.872 0 47.555-13.512-12.381-33.873-12.381-47.385 0 12.211-13.683 12.211-33.872 0-47.555z",transform:"rotate(0 0 0)"},{d:"m-0.478-0.125v200h200v-200zm124.59 119.86c11.238 15.642 25.565 19.546 43.151 11.081-2.602 16.942 0.329 32.57 10.108 46.897-14.341-9.767-29.968-12.697-46.911-10.095 8.308-17.586 4.403-31.914-11.238-43.322-3.089-2.273-6.52-2.932-10.094-1.631-2.445 0.736-4.232 2.932-4.404 5.548-0.486 3.903 1.631 7.808 5.048 10.095 7.005 2.931 10.107 6.835 9.622 12.381-0.5 5.534-4.404 9.109-11.738 11.396 3.43 4.89 2.773 9.122-1.63 13.025-4.232 3.918-8.793 3.918-13.184 0-4.403-3.903-5.047-8.136-1.472-13.025-7.321-2.287-11.396-5.862-11.882-11.396-0.486-5.546 2.603-9.45 9.438-12.381 3.917-2.287 5.704-5.534 5.376-10.095-0.316-2.616-1.788-4.562-4.391-5.548-3.746-1.301-7.163-0.643-10.266 1.631-15.799 11.408-19.545 25.736-11.238 43.322-16.772-2.603-32.4 0.328-46.741 10.095 9.28-14.327 12.71-29.955 9.938-46.897 17.586 8.465 32.084 4.561 43.151-11.081 2.445-3.247 3.103-6.506 1.958-10.423-1.144-2.603-2.931-3.904-5.534-4.561-4.561 0-7.978 1.629-10.265 5.218-2.761 7.163-6.835 10.423-12.369 9.766-5.376-0.644-9.122-4.561-11.409-11.724-4.876 3.259-9.28 2.615-13.026-1.631-4.075-4.232-4.075-8.793 0-13.354 3.747-4.232 8.15-4.877 13.026-1.301 2.287-7.164 6.033-11.396 11.409-11.725 5.534-0.657 9.608 2.603 12.369 9.451 2.287 3.576 6.033 5.534 10.265 5.206 2.445-0.329 4.562-2.274 5.534-4.232 1.144-3.589 0.486-7.492-1.958-10.424-9.766-13.683-27.839-18.244-43.151-11.067 2.603-16.298-0.815-33.228-9.938-46.911 13.841 9.123 30.455 12.382 46.741 9.766-7.162 15.641-2.273 33.885 11.239 43.651 2.932 1.959 6.848 2.603 10.266 1.301 2.445-0.644 4.075-2.603 4.391-5.205 0.328-4.232-1.788-7.82-5.376-10.423-6.835-2.616-9.924-6.52-9.438-12.053s4.561-9.451 11.882-11.409c-3.575-5.205-2.931-9.437 1.472-13.026 4.391-4.232 8.951-4.232 13.184 0 4.403 3.589 5.06 7.821 1.63 13.026 7.334 1.958 11.238 5.875 11.738 11.409 0.485 5.534-2.617 9.438-9.622 12.053-3.746 2.603-5.534 5.862-5.048 10.423 0.172 2.603 1.801 4.562 4.404 5.205 3.574 1.301 7.005 0.986 10.094-1.301 15.642-11.724 19.546-26.051 11.238-43.651 16.943 2.931 32.57-0.644 46.911-9.766-9.779 14.328-12.71 29.969-10.108 46.911-17.586-8.478-31.913-4.561-43.151 11.067-2.444 3.26-3.103 6.52-1.788 10.424 0.803 2.603 2.761 3.904 5.535 4.232 4.389 0.328 7.82-1.63 10.094-5.206 2.773-6.848 7.006-10.108 12.382-9.451 5.534 0.329 9.122 4.562 11.396 11.725 4.562-3.576 9.123-2.931 13.025 1.301 3.918 4.561 3.918 9.121 0 13.354-3.902 4.246-8.464 4.89-13.025 1.631-2.273 7.163-5.861 11.08-11.396 11.724-5.376 0.657-9.608-2.603-12.382-9.766-2.273-3.589-5.705-5.218-10.094-5.218-2.774 0.656-4.732 1.958-5.535 4.561-1.315 3.917-0.657 7.176 1.787 10.423z",transform:"rotate(0 0 0)"},{d:"m75.83 123.65c12.211-13.683 12.211-33.872 0-47.555 13.512 12.369 33.872 12.369 47.384 0-12.211 13.683-12.211 33.872 0 47.555-13.512-12.381-33.872-12.381-47.384 0z",transform:"rotate(0 0 0)"}],colorScheme:[["#000","#ededed","#bc444a"],["#ededed","#c6bdbe","#B0CDEE"]],rotations:[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{paths:[{d:'m100 100.02 100 100h-200z',transform:'rotate(0 0 0)'},{d:'m100.01 100 100-100v200z',transform:'rotate(0 0 0)'},{d:'m100 99.992-100-100h200z',transform:'rotate(0 0 0)'},{d:'m99.992 100-100 100v-200z',transform:'rotate(0 0 0)'}],colorScheme:[['#afe9c6','#B0CDEE','#c6bdbe','#fff'],['#afe9c6','#2a7fff','#000','#fff']],rotations:[0,180,0,180,180,0,180,0,0,180,0,180,180,0,180,0]},{paths:[{d:'m43.6 0c0 9.9917 3.1505 17.685 8.1133 26.883-9.1138 4.318-17.762 12.819-23.426 22.234-9.9256-4.1687-18.163-6.1131-28.287-5.5176v16.51c12.18 0.0893 23.059 5.6339 30.318 14.314a74.144 75.442 0 0 1 43.033-44.736c-8.1317-7.3042-13.25-17.897-13.25-29.688zm41.439 0c4.9e-4 8.2625 6.6984 14.96 14.961 14.961 8.2625-4.9e-4 14.96-6.6984 14.961-14.961zm54.859 0c7e-5 11.761-5.0917 22.331-13.188 29.633a74.144 75.442 0 0 1 42.979 44.887c7.3177-8.5465 18.177-13.971 30.311-13.971v-16.949c-10.124-0.59553-18.362 1.3489-28.287 5.5176-5.6638-9.4153-14.312-17.916-23.426-22.234 4.9628-9.1977 8.1133-16.891 8.1133-26.883zm-39.898 85.039a14.962 14.962 0 0 1 1.2715 0.0625 14.962 14.962 0 0 0-1.2715-0.0625zm-100 0.0156v29.891c8.124-0.16029 14.664-6.7831 14.664-14.945-4.9e-4 -8.1622-6.5401-14.785-14.664-14.945zm98.725 0.0469a14.962 14.962 0 0 0-0.72461 0.0879 14.962 14.962 0 0 1 0.72461-0.0879zm3.3066 0.0918a14.962 14.962 0 0 1 0.71289 0.10742 14.962 14.962 0 0 0-0.71289-0.10742zm-4.8047 0.11328a14.962 14.962 0 0 0-0.68946 0.15625 14.962 14.962 0 0 1 0.68946-0.15625zm6.291 0.16992a14.962 14.962 0 0 1 0.68164 0.17383 14.962 14.962 0 0 0-0.68164-0.17383zm96.482 0.01c-8.2625 4.9e-4 -14.96 6.6984-14.961 14.961 4.9e-4 8.2625 6.6984 14.96 14.961 14.961zm-104.21 0.16797a14.962 14.962 0 0 0-0.68164 0.22461 14.962 14.962 0 0 1 0.68164-0.22461zm9.1445 0.23828a14.962 14.962 0 0 1 0.67774 0.24805 14.962 14.962 0 0 0-0.67774-0.24805zm-10.576 0.26172a14.962 14.962 0 0 0-0.61524 0.27539 14.962 14.962 0 0 1 0.61524-0.27539zm11.98 0.3125a14.962 14.962 0 0 1 0.61719 0.29687 14.962 14.962 0 0 0-0.61719-0.29687zm-13.328 0.31445a14.962 14.962 0 0 0-0.60742 0.34961 14.962 14.962 0 0 1 0.60742-0.34961zm14.646 0.38477a14.962 14.962 0 0 1 0.59961 0.36914 14.962 14.962 0 0 0-0.59961-0.36914zm-15.932 0.38086a14.962 14.962 0 0 0-0.54492 0.38867 14.962 14.962 0 0 1 0.54492-0.38867zm17.17 0.44531a14.962 14.962 0 0 1 0.55078 0.41797 14.962 14.962 0 0 0-0.55078-0.41797zm-18.383 0.45117a14.962 14.962 0 0 0-0.49609 0.4375 14.962 14.962 0 0 1 0.49609-0.4375zm19.555 0.51172a14.962 14.962 0 0 1 0.49218 0.45898 14.962 14.962 0 0 0-0.49218-0.45898zm-20.652 0.48633a14.962 14.962 0 0 0-0.45899 0.49219 14.962 14.962 0 0 1 0.45899-0.49219zm21.705 0.57422a14.962 14.962 0 0 1 0.4375 0.49609 14.962 14.962 0 0 0-0.4375-0.49609zm-22.709 0.53906a14.962 14.962 0 0 0-0.41797 0.55078 14.962 14.962 0 0 1 0.41797-0.55078zm23.654 0.625a14.962 14.962 0 0 1 0.38867 0.54492 14.962 14.962 0 0 0-0.38867-0.54492zm-24.529 0.56445a14.962 14.962 0 0 0-0.36914 0.59961 14.962 14.962 0 0 1 0.36914-0.59961zm25.334 0.65821a14.962 14.962 0 0 1 0.34961 0.60742 14.962 14.962 0 0 0-0.34961-0.60742zm-26.105 0.64257a14.962 14.962 0 0 0-0.29688 0.61719 14.962 14.962 0 0 1 0.29688-0.61719zm26.807 0.69727a14.962 14.962 0 0 1 0.27539 0.61523 14.962 14.962 0 0 0-0.27539-0.61523zm-27.43 0.64648a14.962 14.962 0 0 0-0.24805 0.67774 14.962 14.962 0 0 1 0.24805-0.67774zm27.98 0.71875a14.962 14.962 0 0 1 0.22461 0.68164 14.962 14.962 0 0 0-0.22461-0.68164zm-28.471 0.69336a14.962 14.962 0 0 0-0.17383 0.68164 14.962 14.962 0 0 1 0.17383-0.68164zm28.887 0.73633a14.962 14.962 0 0 1 0.15625 0.68945 14.962 14.962 0 0 0-0.15625-0.68945zm-29.236 0.71875a14.962 14.962 0 0 0-0.10743 0.71289 14.962 14.962 0 0 1 0.10743-0.71289zm29.51 0.74414a14.962 14.962 0 0 1 0.0879 0.72461 14.962 14.962 0 0 0-0.0879-0.72461zm-29.709 0.72852a14.962 14.962 0 0 0-0.0625 1.2715 14.962 14.962 0 0 1 0.0625-1.2715zm29.859 1.2715a14.962 14.962 0 0 1-0.0625 1.2715 14.962 14.962 0 0 0 0.0625-1.2715zm-29.859 1.2754a14.962 14.962 0 0 0 0.0879 0.72461 14.962 14.962 0 0 1-0.0879-0.72461zm29.705 0.75586a14.962 14.962 0 0 1-0.10742 0.71289 14.962 14.962 0 0 0 0.10742-0.71289zm-29.5 0.74219a14.962 14.962 0 0 0 0.15625 0.68945 14.962 14.962 0 0 1-0.15625-0.68945zm29.217 0.74414a14.962 14.962 0 0 1-0.17383 0.68164 14.962 14.962 0 0 0 0.17383-0.68164zm-28.869 0.69336a14.962 14.962 0 0 0 0.22461 0.68164 14.962 14.962 0 0 1-0.22461-0.68164zm28.453 0.72265a14.962 14.962 0 0 1-0.24804 0.67774 14.962 14.962 0 0 0 0.24804-0.67774zm-27.953 0.70899a14.962 14.962 0 0 0 0.27539 0.61523 14.962 14.962 0 0 1-0.27539-0.61523zm27.379 0.69531a14.962 14.962 0 0 1-0.29687 0.61719 14.962 14.962 0 0 0 0.29687-0.61719zm-26.752 0.65234a14.962 14.962 0 0 0 0.34961 0.60743 14.962 14.962 0 0 1-0.34961-0.60743zm26.053 0.66602a14.962 14.962 0 0 1-0.36914 0.59961 14.962 14.962 0 0 0 0.36914-0.59961zm-25.287 0.61891a14.962 14.962 0 0 0 0.38867 0.54492 14.962 14.962 0 0 1-0.38867-0.54492zm24.461 0.61914a14.962 14.962 0 0 1-0.41797 0.55078 14.962 14.962 0 0 0 0.41797-0.55078zm-23.564 0.59375a14.962 14.962 0 0 0 0.4375 0.4961 14.962 14.962 0 0 1-0.4375-0.4961zm22.602 0.57813a14.962 14.962 0 0 1-0.45898 0.49218 14.962 14.962 0 0 0 0.45898-0.49218zm-21.604 0.51953a14.962 14.962 0 0 0 0.49219 0.45898 14.962 14.962 0 0 1-0.49219-0.45898zm20.543 0.5332a14.962 14.962 0 0 1-0.4961 0.4375 14.962 14.962 0 0 0 0.4961-0.4375zm-19.43 0.4707a14.962 14.962 0 0 0 0.55078 0.41797 14.962 14.962 0 0 1-0.55078-0.41797zm18.266 0.47461a14.962 14.962 0 0 1-0.54492 0.38867 14.962 14.962 0 0 0 0.54492-0.38867zm-17.076 0.40039a14.962 14.962 0 0 0 0.59961 0.36914 14.962 14.962 0 0 1-0.59961-0.36914zm15.854 0.4043a14.962 14.962 0 0 1-0.60743 0.34961 14.962 14.962 0 0 0 0.60743-0.34961zm-14.553 0.36719a14.962 14.962 0 0 0 0.61718 0.29687 14.962 14.962 0 0 1-0.61718-0.29687zm13.213 0.33398a14.962 14.962 0 0 1-0.61523 0.27539 14.962 14.962 0 0 0 0.61523-0.27539zm-11.869 0.28907a14.962 14.962 0 0 0 0.67773 0.24804 14.962 14.962 0 0 1-0.67773-0.24804zm10.504 0.26171a14.962 14.962 0 0 1-0.68164 0.22461 14.962 14.962 0 0 0 0.68164-0.22461zm-9.0918 0.22852a14.962 14.962 0 0 0 0.68164 0.17383 14.962 14.962 0 0 1-0.68164-0.17383zm7.6621 0.1875a14.962 14.962 0 0 1-0.68945 0.15625 14.962 14.962 0 0 0 0.68945-0.15625zm-6.207 0.16211a14.962 14.962 0 0 0 0.7129 0.10742 14.962 14.962 0 0 1-0.7129-0.10742zm4.7441 0.11133a14.962 14.962 0 0 1-0.72461 0.0879 14.962 14.962 0 0 0 0.72461-0.0879zm-3.2715 0.0879a14.962 14.962 0 0 0 1.2715 0.0625 14.962 14.962 0 0 1-1.2715-0.0625zm-68.391 10.656c-7.2596 8.6934-18.147 14.247-30.338 14.336v16.51c10.124 0.59553 18.362-1.3489 28.287-5.5176 5.6638 9.4153 14.312 17.916 23.426 22.234-4.9628 9.1977-8.1133 16.891-8.1133 26.883h16.484c-7e-5 -11.763 5.0932-22.334 13.191-29.637a74.144 75.442 0 0 1-42.938-44.809zm139.16 0.5957a74.144 75.442 0 0 1-42.857 44.166c8.1292 7.304 13.244 17.895 13.244 29.684h16.52c0-9.9917-3.1505-17.685-8.1133-26.883 9.1138-4.318 17.762-12.819 23.426-22.234 9.9256 4.1687 18.163 6.1131 28.287 5.5176v-16.055c-12.241 8e-5 -23.187-5.5177-30.506-14.195zm-69.512 58.889c-8.2625 4.9e-4 -14.96 6.6984-14.961 14.961h29.922c-4.9e-4 -8.2625-6.6984-14.96-14.961-14.961z',transform:"rotate(0 0 0)"},{d:'m100 43.645a56.356 56.356 0 0 0-56.355 56.355 56.356 56.356 0 0 0 56.355 56.355 56.356 56.356 0 0 0 56.355-56.355 56.356 56.356 0 0 0-56.355-56.355zm0 8.4336c9.0895 0 16.459 7.3675 16.459 16.457v15.006h14.959c9.0895 0 16.457 7.3695 16.457 16.459s-7.3675 16.459-16.457 16.459h-14.959v15.006c0 9.0895-7.3695 16.457-16.459 16.457s-16.459-7.3675-16.459-16.457v-15.006h-15.047c-9.0895 0-16.459-7.3695-16.459-16.459 1e-6 -9.0895 7.3695-16.459 16.459-16.459h15.047v-15.006c1e-6 -9.0895 7.3695-16.457 16.459-16.457z',transform:"rotate(0 0 0)"},{d:'m0 0v43.6c10.124-0.59553 18.362 1.3489 28.287 5.5176 5.6638-9.4153 14.312-17.916 23.426-22.234-4.9628-9.1977-8.1133-16.891-8.1133-26.883zm156.4 0c0 9.9917-3.1505 17.685-8.1133 26.883 9.1138 4.318 17.762 12.819 23.426 22.234 9.9256-4.1687 18.163-6.1131 28.287-5.5176v-43.6zm-56.4 52.078c-9.0895 0-16.459 7.3675-16.459 16.457v15.006h-15.047c-9.0895 0-16.459 7.3695-16.459 16.459-4e-6 9.0895 7.3695 16.459 16.459 16.459h15.047v15.006c1e-6 9.0895 7.3695 16.457 16.459 16.457s16.459-7.3675 16.459-16.457v-15.006h14.959c9.0895 0 16.457-7.3695 16.457-16.459s-7.3675-16.459-16.457-16.459h-14.959v-15.006c0-9.0895-7.3695-16.457-16.459-16.457zm0 32.961a14.962 14.962 0 0 1 14.961 14.961 14.962 14.962 0 0 1-14.961 14.961 14.962 14.962 0 0 1-14.961-14.961 14.962 14.962 0 0 1 14.961-14.961zm-71.713 65.844c-9.9256 4.1687-18.163 6.1131-28.287 5.5176v43.6h43.6c0-9.9917 3.1505-17.685 8.1133-26.883-9.1138-4.318-17.762-12.819-23.426-22.234zm143.43 0c-5.6638 9.4153-14.312 17.916-23.426 22.234 4.9628 9.1977 8.1133 16.891 8.1133 26.883h43.6v-43.6c-10.124 0.59553-18.362-1.3489-28.287-5.5176z',transform:"rotate(0 0 0)"},{d:'m60.102 0c-6.7e-5 11.791 5.1183 22.383 13.25 29.688a74.144 75.442 0 0 0-43.033 44.736c-7.3189-8.7514-18.314-14.322-30.615-14.322v24.938c8.2625 4.9e-4 14.96 6.6984 14.961 14.961-4.89e-4 8.2625-6.6984 14.96-14.961 14.961v24.938c12.311 7e-5 23.316-5.5795 30.635-14.344a74.144 75.442 0 0 0 42.938 44.809c-8.0982 7.3024-13.191 17.874-13.191 29.637h24.938c4.91e-4 -8.2625 6.6984-14.96 14.961-14.961 8.2625 4.9e-4 14.96 6.6984 14.961 14.961h24.938c7e-5 -11.789-5.1149-22.38-13.244-29.684a74.144 75.442 0 0 0 42.857-44.166c7.3189 8.6776 18.265 14.195 30.506 14.195v-24.938c-8.2625-4.9e-4 -14.96-6.6984-14.961-14.961 4.9e-4 -8.2625 6.6984-14.96 14.961-14.961v-24.938c-12.134-7e-5 -22.993 5.4242-30.311 13.971a74.144 75.442 0 0 0-42.979-44.887c8.0958-7.3023 13.188-17.872 13.188-29.633h-24.938c-4.9e-4 8.2625-6.6984 14.96-14.961 14.961-8.2625-4.9e-4 -14.96-6.6984-14.961-14.961zm39.898 43.645a56.356 56.356 0 0 1 56.355 56.355 56.356 56.356 0 0 1-56.355 56.355 56.356 56.356 0 0 1-56.355-56.355 56.356 56.356 0 0 1 56.355-56.355zm0 41.395a14.962 14.962 0 0 1 1.2715 0.0625 14.962 14.962 0 0 0-1.2715-0.0625zm-1.2754 0.0625a14.962 14.962 0 0 0-0.72461 0.0879 14.962 14.962 0 0 1 0.72461-0.0879zm3.3066 0.0918a14.962 14.962 0 0 1 0.71289 0.10742 14.962 14.962 0 0 0-0.71289-0.10742zm-4.8047 0.11328a14.962 14.962 0 0 0-0.68945 0.15625 14.962 14.962 0 0 1 0.68945-0.15625zm6.291 0.16993a14.962 14.962 0 0 1 0.68164 0.17382 14.962 14.962 0 0 0-0.68164-0.17382zm-7.7285 0.17773a14.962 14.962 0 0 0-0.68164 0.22461 14.962 14.962 0 0 1 0.68164-0.22461zm9.1445 0.23828a14.962 14.962 0 0 1 0.67774 0.24805 14.962 14.962 0 0 0-0.67774-0.24805zm-10.576 0.26172a14.962 14.962 0 0 0-0.61523 0.27539 14.962 14.962 0 0 1 0.61523-0.27539zm11.98 0.3125a14.962 14.962 0 0 1 0.61719 0.29687 14.962 14.962 0 0 0-0.61719-0.29687zm-13.328 0.31445a14.962 14.962 0 0 0-0.60742 0.34961 14.962 14.962 0 0 1 0.60742-0.34961zm14.646 0.38477a14.962 14.962 0 0 1 0.59961 0.36914 14.962 14.962 0 0 0-0.59961-0.36914zm-15.932 0.38086a14.962 14.962 0 0 0-0.54492 0.38867 14.962 14.962 0 0 1 0.54492-0.38867zm17.17 0.44531a14.962 14.962 0 0 1 0.55078 0.41797 14.962 14.962 0 0 0-0.55078-0.41797zm-18.383 0.45117a14.962 14.962 0 0 0-0.49609 0.4375 14.962 14.962 0 0 1 0.49609-0.4375zm19.555 0.51172a14.962 14.962 0 0 1 0.49218 0.45898 14.962 14.962 0 0 0-0.49218-0.45898zm-20.652 0.48633a14.962 14.962 0 0 0-0.45898 0.49218 14.962 14.962 0 0 1 0.45898-0.49218zm21.705 0.57422a14.962 14.962 0 0 1 0.4375 0.49609 14.962 14.962 0 0 0-0.4375-0.49609zm-22.709 0.53906a14.962 14.962 0 0 0-0.41797 0.55078 14.962 14.962 0 0 1 0.41797-0.55078zm23.654 0.625a14.962 14.962 0 0 1 0.38867 0.54492 14.962 14.962 0 0 0-0.38867-0.54492zm-24.529 0.56445a14.962 14.962 0 0 0-0.36914 0.59961 14.962 14.962 0 0 1 0.36914-0.59961zm25.334 0.6582a14.962 14.962 0 0 1 0.34961 0.60743 14.962 14.962 0 0 0-0.34961-0.60743zm-26.105 0.64258a14.962 14.962 0 0 0-0.29688 0.61719 14.962 14.962 0 0 1 0.29688-0.61719zm26.807 0.69727a14.962 14.962 0 0 1 0.27539 0.61523 14.962 14.962 0 0 0-0.27539-0.61523zm-27.43 0.64648a14.962 14.962 0 0 0-0.24805 0.67774 14.962 14.962 0 0 1 0.24805-0.67774zm27.98 0.71875a14.962 14.962 0 0 1 0.22461 0.68164 14.962 14.962 0 0 0-0.22461-0.68164zm-28.471 0.69336a14.962 14.962 0 0 0-0.17383 0.68164 14.962 14.962 0 0 1 0.17383-0.68164zm28.887 0.73633a14.962 14.962 0 0 1 0.15625 0.68945 14.962 14.962 0 0 0-0.15625-0.68945zm-29.236 0.71875a14.962 14.962 0 0 0-0.10742 0.71289 14.962 14.962 0 0 1 0.10742-0.71289zm29.51 0.74414a14.962 14.962 0 0 1 0.0879 0.72461 14.962 14.962 0 0 0-0.0879-0.72461zm-29.709 0.72852a14.962 14.962 0 0 0-0.0625 1.2715 14.962 14.962 0 0 1 0.0625-1.2715zm29.859 1.2715a14.962 14.962 0 0 1-0.0625 1.2715 14.962 14.962 0 0 0 0.0625-1.2715zm-29.859 1.2754a14.962 14.962 0 0 0 0.08789 0.72461 14.962 14.962 0 0 1-0.08789-0.72461zm29.705 0.75586a14.962 14.962 0 0 1-0.10742 0.71289 14.962 14.962 0 0 0 0.10742-0.71289zm-29.5 0.74219a14.962 14.962 0 0 0 0.15625 0.68945 14.962 14.962 0 0 1-0.15625-0.68945zm29.217 0.74414a14.962 14.962 0 0 1-0.17383 0.68164 14.962 14.962 0 0 0 0.17383-0.68164zm-28.869 0.69336a14.962 14.962 0 0 0 0.22461 0.68164 14.962 14.962 0 0 1-0.22461-0.68164zm28.453 0.72265a14.962 14.962 0 0 1-0.24804 0.67774 14.962 14.962 0 0 0 0.24804-0.67774zm-27.953 0.70899a14.962 14.962 0 0 0 0.27539 0.61523 14.962 14.962 0 0 1-0.27539-0.61523zm27.379 0.69531a14.962 14.962 0 0 1-0.29687 0.61719 14.962 14.962 0 0 0 0.29687-0.61719zm-26.752 0.65234a14.962 14.962 0 0 0 0.34961 0.60743 14.962 14.962 0 0 1-0.34961-0.60743zm26.053 0.66602a14.962 14.962 0 0 1-0.36914 0.59961 14.962 14.962 0 0 0 0.36914-0.59961zm-25.287 0.61914a14.962 14.962 0 0 0 0.38867 0.54492 14.962 14.962 0 0 1-0.38867-0.54492zm24.461 0.61914a14.962 14.962 0 0 1-0.41797 0.55078 14.962 14.962 0 0 0 0.41797-0.55078zm-23.564 0.59375a14.962 14.962 0 0 0 0.4375 0.4961 14.962 14.962 0 0 1-0.4375-0.4961zm22.602 0.57813a14.962 14.962 0 0 1-0.45898 0.49218 14.962 14.962 0 0 0 0.45898-0.49218zm-21.604 0.51953a14.962 14.962 0 0 0 0.49219 0.45898 14.962 14.962 0 0 1-0.49219-0.45898zm20.543 0.5332a14.962 14.962 0 0 1-0.4961 0.4375 14.962 14.962 0 0 0 0.4961-0.4375zm-19.43 0.4707a14.962 14.962 0 0 0 0.55078 0.41797 14.962 14.962 0 0 1-0.55078-0.41797zm18.266 0.47461a14.962 14.962 0 0 1-0.54492 0.38867 14.962 14.962 0 0 0 0.54492-0.38867zm-17.076 0.40039a14.962 14.962 0 0 0 0.59961 0.36914 14.962 14.962 0 0 1-0.59961-0.36914zm15.854 0.4043a14.962 14.962 0 0 1-0.60743 0.34961 14.962 14.962 0 0 0 0.60743-0.34961zm-14.553 0.36719a14.962 14.962 0 0 0 0.61719 0.29687 14.962 14.962 0 0 1-0.61719-0.29687zm13.213 0.33398a14.962 14.962 0 0 1-0.61523 0.27539 14.962 14.962 0 0 0 0.61523-0.27539zm-11.869 0.28907a14.962 14.962 0 0 0 0.67773 0.24804 14.962 14.962 0 0 1-0.67773-0.24804zm10.504 0.26171a14.962 14.962 0 0 1-0.68164 0.22461 14.962 14.962 0 0 0 0.68164-0.22461zm-9.0918 0.22852a14.962 14.962 0 0 0 0.68164 0.17383 14.962 14.962 0 0 1-0.68164-0.17383zm7.6621 0.1875a14.962 14.962 0 0 1-0.68945 0.15625 14.962 14.962 0 0 0 0.68945-0.15625zm-6.207 0.16211a14.962 14.962 0 0 0 0.71289 0.10742 14.962 14.962 0 0 1-0.71289-0.10742zm4.7441 0.11133a14.962 14.962 0 0 1-0.72461 0.0879 14.962 14.962 0 0 0 0.72461-0.0879zm-3.2715 0.0879a14.962 14.962 0 0 0 1.2715 0.0625 14.962 14.962 0 0 1-1.2715-0.0625z',transform:"rotate(0 0 0)"},{d:'m85.039 0a14.962 14.962 0 0 0 14.961 14.961 14.962 14.962 0 0 0 14.961-14.961zm-85.039 85.039v29.922a14.962 14.962 0 0 0 14.961-14.961 14.962 14.962 0 0 0-14.961-14.961zm200 0.44727a14.962 14.962 0 0 0-14.961 14.961 14.962 14.962 0 0 0 14.961 14.961zm-100.02 99.553a14.962 14.962 0 0 0-14.961 14.961h29.922a14.962 14.962 0 0 0-14.961-14.961z',transform:"rotate(0 0 0)"},{d:'m114.96 100a14.962 14.962 0 0 1-14.962 14.962 14.962 14.962 0 0 1-14.962-14.962 14.962 14.962 0 0 1 14.962-14.962 14.962 14.962 0 0 1 14.962 14.962z',transform:"rotate(0 0 0)"}],colorScheme:[['#c7bdbd','#ABCEF2','#ededed','#ededed','#ABCEF2','#7E7D7B'],['#c7bdbd','#ededed','#ededed','#c7bdbd','#ABCEF2','#7E7D7B'],['#c7bdbd','#ededed','#ededed','#fd5','#ABCEF2','#7E7D7B'],['#06f','#c8b7b7','#ff7f2a','#fd5','#8d4fd3','#8d5fd3']],rotations:[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{paths:[{d:'m105.42 0.43889-13.372 11.147-33.786-0.58238 31.951 12.209 7.77 17.813-17.057 5.3143-30.991-13.468 24.847 23.509 0.36258 19.43-17.793-1.6197-23.48-24.303 13.963 31.228-7.1 18.092-15.82-8.3052-12.392-31.441 0.9493 34.195-13.26 13.767v73.568h18.85v18.861h0.12965l7.401-8.0262 15.589-0.11428 7.5065 8.1407h0.04175l6.823-9.9227 7.2845 9.5712 7.159-7.7647 15.587-0.11428 7.5305 8.1667 13.728-11.439 33.783 0.58238-31.951-12.211-7.77-17.81 17.059-5.3163 30.991 13.468-24.847-23.507-0.36258-19.356-3.1028 3.1032-9.704-9.7052 5.344-5.3448 9.704 9.7052-2.1733 2.1736 17.725 1.611 23.478 24.305-13.96-31.23 7.0975-18.09 15.822 8.3052 12.392 31.439-0.9493-34.193 13.42-13.936v-0.11429l-7.8975-7.0063-0.10988-14.613 7.957-7.0593 0.0505 13.218v-13.334l-9.26-6.7558 9.26-6.7558v-0.26154l-8.0075-7.3868-0.11426-15.591 8.1215-7.4922v-0.03955h-18.957v-18.712zm-11.304 199.35-17.092 0.0637h48.671zm30.439-184.87 13.024 5.4153 4.4982 9.9362 4.496-9.9362 13.024-5.4153 5.3725 13.044-4.496 9.9362 10.205-3.8461 13.038 5.3823-5.421 13.024-10.174 3.8351 9.9325 4.4966 5.4145 13.026-13.042 5.3733-9.9345-4.4966 3.8455 10.206-5.3815 13.039-13.022-5.4238-3.8455-10.202-5e-3 0.01105 2e-3 0.0025-4.4982 9.9362-13.024 5.4153-5.3725-13.044 4.4872-9.9187 5e-3 -0.0132-10.205 3.8461-13.038-5.3823 5.421-13.024 10.19-3.8417-9.8795-4.4724-5.4145-13.026 13.042-5.3733 9.8795 4.4702-4.496-9.9362zm-0.8768 22.98 0.0549 0.0264 5e-3 0.01105 12.954 5.3868 5e-3 -0.01105zm36.814 36.795-5.4125-13.024-0.022 0.0088 5.4145 13.007zm-0.0176-36.795-9e-3 0.0045-5.4125 13.02zm-18.397-7.6282-9e-3 0.0198 5.377 13.029 4.4542-1.8549-4.4498 1.8505zm26.005 26.03-6.8295 2.8197 6.836-2.8153zm-22.377 3.6087 1.714 9.2352 2e-3 0.0045zm-3.6478 1.523-5.318 7.7407v0.0045zm5.397 7.8547-4.7574 11.549 4.764-11.547zm-69.575 4.1208 9.704 9.7052-5.344 5.3448-9.704-9.7052zm14.883 18.927 12.242 0.0087-9e-3 12.244-12.242-9e-3zm-47.832 5.3648 13.024 5.4153 4.496 9.9362 4.496-9.9362 13.027-5.4153 5.3725 13.044-4.4916 9.9252-0.0045 0.0113 10.205-3.8461 13.038 5.3823-5.423 13.024-10.174 3.8351 9.9345 4.4966 5.4145 13.026-13.042 5.3733-9.937-4.4966 3.8455 10.206-5.3815 13.039-13.02-5.4218-3.8411-10.195-0.0045-0.0112-5.377-13.028 5.3725 13.044-4.496 9.9362-13.027 5.4153-5.3725-13.044 4.496-9.9362 0.0088-5e-3 5.41-13.015-5.4235 13.024-10.205 3.8461-13.038-5.3823 5.4235-13.024 10.188-3.8395-9.8795-4.4724-5.4125-13.029 13.042-5.3733 9.8795 4.4702-4.4982-9.9362zm35.935 59.773-5.4125-13.026-0.0088 2e-3zm-5.4125-13.026 13.042-5.3733-0.03075 0.0113-0.0132-5e-3zm124.39-22.764-0.0857 42.476 0.0857 3.0703z',transform:'rotate(0 0 0)'},{d:'m33.91 0-3.0762 0.048828-6.9414 4.7539 4.5977 7.0469-8.2324 1.7344 1.5508 8.2715-8.2695-1.5488-1.7324 8.2344-7.0469-4.5957-4.75 6.9453 0.13477 4.8828 12.387 23.689 0.84375-26.721 20.506 17.146-9.4453-25.008 25.508 7.9922-18.297-19.49 26.625-2.3789zm146.97 0.43945-30.65 0.11328 7.5312 8.166 15.588-0.11328zm-45.051 0.12305-30.648 0.11328 7.5293 8.168 15.59-0.11523zm64.051 18.588-8.166 7.5332 0.11328 15.59 8.166 7.5312zm-57.809 11.131-5.3711 13.045-13.025-5.416 5.4219 13.023-13.037 5.3828 13.041 5.373-5.4141 13.029 13.021-5.4258 5.3828 13.041 5.3711-13.045 13.025 5.416-5.4219-13.023 13.037-5.3828-13.041-5.373 5.4141-13.027-13.021 5.4219zm5.2852 13.076-1.6621 9.25 9.2383-1.7148-7.7168 5.3613 7.7441 5.3223-9.2461-1.6641 1.7148 9.2383-5.3633-7.7168-5.3184 7.7461 1.6641-9.248-9.2383 1.7168 7.7148-5.3652-7.7461-5.3184 9.25 1.6641-1.7168-9.2402 5.3613 7.7168zm52.434 20.193-7.957 7.0586 0.10938 14.613 7.959 7.0605zm-121.91 9.8555-5.3438 5.3457 9.7031 9.7051 5.3457-5.3438zm-77.658 34.014 0.11328 30.648 8.166-7.5293-0.11328-15.588zm117.07 4.834-5.3457 5.3438 9.7051 9.707 5.3438-5.3457zm-54.838 0.80078-5.3711 13.043-13.025-5.4141 5.4219 13.023-13.037 5.3828 13.041 5.373-5.4141 13.027 13.021-5.4238 5.3809 13.041 5.373-13.045 13.025 5.416-5.4219-13.025 13.037-5.3808-13.041-5.375 5.4141-13.025-13.021 5.4219zm5.2852 13.076-1.6621 9.25 9.2383-1.7168-7.7168 5.3633 7.7441 5.3203-9.2461-1.6621 1.7148 9.2383-5.3633-7.7168-5.3184 7.7461 1.6641-9.248-9.2383 1.7148 7.7148-5.3633-7.7461-5.3184 9.25 1.6621-1.7168-9.2383 5.3613 7.7168zm119.63 14.346-0.84375 26.721-20.506-17.146 9.4453 25.01-25.508-7.9922 18.297 19.488-26.625 2.3789 24.361 11.004 3.0762-0.0488 6.9414-4.7539-4.5977-7.0469 8.2324-1.7344-1.5508-8.2695 8.2695 1.5469 1.7305-8.2344 7.0488 4.5957 4.75-6.9453-0.13672-4.8809zm-187.26 9.873 0.11523 30.648 8.166-7.5312-0.11328-15.586zm86.486 41.273-15.588 0.11328-7.5312 8.166 30.65-0.11328zm-44.404 0.0898-15.588 0.11328-7.5312 8.168 30.65-0.11523z',transform:'rotate(0 0 0)'},{d:'m30.834 0.048828-30.811 0.023438-0.013672 30.818 4.75-6.9453 7.0469 4.5957 1.7324-8.2344 8.2695 1.5488-1.5508-8.2695 8.2324-1.7363-4.5977-7.0469zm150.06 0.099609v19.002h19v-19.002zm-30.658 0.4043-14.404 0.009766 7.5625 9.9395zm-2.877 42.807-5.3203 7.7461-5.3613-7.7148 1.7148 9.2383-9.248-1.6641 7.7441 5.3203-7.7148 5.3633 9.2383-1.7148-1.6641 9.248 5.3203-7.7461 5.3613 7.7168-1.7148-9.2402 9.248 1.6641-7.7461-5.3203 7.7168-5.3613-9.2383 1.7148zm52.643 6.4473-9.416 6.873 9.416 6.873zm-107.23 42.535-0.0078 12.242 12.24 0.01 0.01-12.244zm-25.029 33.791-5.3184 7.7461-5.3633-7.7168 1.7148 9.2383-9.2461-1.6641 7.7441 5.3203-7.7148 5.3633 9.2383-1.7148-1.6641 9.248 5.3184-7.7461 5.3633 7.7168-1.7148-9.2383 9.2461 1.6641-7.7441-5.3203 7.7148-5.3633-9.2383 1.7148zm-67.643 9.8086 0.0097656 14.406 9.9414-7.5645zm199.8 33.104-4.752 6.9434-7.0469-4.5938-1.7305 8.2344-8.2695-1.5469 1.5508 8.2695-8.2324 1.7344 4.5977 7.0469-6.9414 4.7539 30.811-0.0234zm-199.82 11.953v19.002h18.998v-19.002zm56.49 8.9375-6.8418 9.9512 14.406-0.0117z',transform:'rotate(0 0 0)'},{d:'m33.91 0 24.361 11.004 33.783 0.58203 13.727-11.439zm24.361 11.004-26.625 2.3789 18.297 19.488 30.99 13.469 17.059-5.3145-7.7695-17.812zm66.287 3.918-5.373 13.045 4.4961 9.9355-9.8789-4.4707-13.043 5.373 5.4141 13.027 9.8828 4.4746-10.186 3.8398-5.4219 13.023 13.039 5.3828 10.203-3.8477-4.4941 9.9316 5.373 13.043 13.025-5.4141 4.4961-9.9355-5.373-13.045-13.025 5.4141 5.4219-13.018-12.984-5.3594 13.021-5.3672-5.4141-13.027-0.0508-0.02344 13.02 5.4141 5.373-13.045-4.4961-9.9375zm35.049 0-13.025 5.4141-4.4961 9.9375 5.373 13.045 13.025-5.416 4.4961-9.9355zm0.87696 22.98-5.4219 13.023 13.033 5.3809-13.016 5.3633 5.4102 13.02-13.01-5.416-5.3809 13.039 3.8457 10.207 13.021 5.4238 5.3828-13.041-3.8438-10.199 9.9238 4.4902 13.043-5.373-5.4141-13.027-9.9297-4.4941 10.176-3.8359 5.4238-13.023-13.039-5.3828zm-136.05-13.021 9.4453 25.008 23.479 24.303 17.793 1.6191-0.36328-19.43-24.846-23.508zm9.4453 25.008-20.508-17.146-0.8418 26.721 12.393 31.439 15.818 8.3047 7.0996-18.09zm-21.35 9.5742-12.387-23.689-0.14453 71.881 13.48-13.996zm187.38 32.818-13.48 13.996 0.94922 34.197 12.387 23.689zm-154.97 5.4219-5.373 13.045 4.4961 9.9336-9.8809-4.4727-13.041 5.373 5.4141 13.027 9.8848 4.4766-10.195 3.8418-5.4219 13.023 13.039 5.3828 10.205-3.8457-4.4922 9.9277 5.373 13.045 13.025-5.416 4.4961-9.9355-5.373-13.045-13.025 5.416 5.418-13.016-12.988-5.3613 13.031-5.3711-5.4141-13.025 12.971 5.3906 5.373-13.043-4.4961-9.9375zm17.521 15.352 5.373 13.043 13.025-5.4141 4.4961-9.9355-5.373-13.045-13.025 5.4141zm96.703-12.33-7.0996 18.09 13.963 31.23 20.506 17.146 0.84375-26.721-12.393-31.439zm6.8633 49.32-23.479-24.301-17.793-1.6191 0.36328 19.432 24.848 23.508 25.508 7.9922-9.4473-25.01zm-74.965-33.205-10.205 3.8477-5.4219 13.023 13.035 5.3809-13.01 5.3613 5.4141 13.027 9.9355 4.4961 13.043-5.373-5.4141-13.027-9.9297-4.4961 10.17-3.834 5.4219-13.023zm-10.188 40.641-13.021-5.4238-5.3809 13.041 3.8457 10.207 13.021 5.4219 5.3809-13.039zm38.1-3.8809-17.059 5.3144 7.7695 17.812 31.939 12.205-33.77-0.58008-13.727 11.439 71.871 0.14453-24.354-11 26.615-2.3789-18.297-19.49z',transform:'rotate(0 0 0)'}],colorScheme:[['#fff','#87cdde','#ffffe0','#fd5'],['#ff2a2a','#87cdde','#ffffe0','#fd5'],['#fff','#87cdde','#ffffe0','#c6bdbe']],rotations:[0,90,0,90,90,0,90,0,0,90,0,90,90,0,90,0]},{paths:[{d:'m-0.58002-0.01771v10.637c0.049248 0.0344 0.098679 0.0703 0.14844 0.10742v-10.479c0.66181 0.33189 1.1947 0.86112 2.3555 2.043 2.1274 2.166 6.3824 6.4983 10.926 10.697 4.5434 4.199 9.3766 8.2648 12.941 12.301 3.5649 4.0362 5.8622 8.0437 6.8789 11.402 1.0167 3.3586 0.75177 6.067 0.23633 7.8945s-1.2819 2.7694-0.25 3.0352c1.0319 0.26577 3.8603-0.14703 7.7344 1.2969s8.7924 4.7441 11.709 7.7637 3.8304 5.7596 3.9043 8.7793c0.07389 3.0196-0.6925 6.3196-1.1641 8.6035-0.47153 2.2838-0.64793 3.5496 0.01563 4.4199 0.66352 0.87029 2.1658 1.3416 3.6836 1.5625 1.5177 0.22087 3.0492 0.19105 4.4629 0.95703 1.4137 0.76599 2.7094 2.3276 4.0059 3.6094 1.2965 1.2817 2.5936 2.2837 3.5664 2.6074 0.97279 0.32371 1.6207-0.031 1.7969-1.9609 0.17613-1.9299-0.11721-5.435 0.17773-7.0254s1.1804-1.2671 2.1797-0.82618 2.1213 1.0028 3.4766 1.7246c1.3553 0.72184 2.9461 1.6056 3.6973 2.5625 0.75118 0.9569 0.66293 1.9867 0.86914 3.4902s0.70602 3.4772 1.502 4.7891c0.79594 1.3119 1.8857 1.9602 3.0352 2.1367 1.1495 0.17655 2.3578-0.11953 3.3594-0.8418 1.0015-0.72226 1.7978-1.8709 1.9004-3.3438 0.10262-1.4729-0.48658-3.2705 0.13281-4.3457s2.445-1.4288 4.2422-1.6055c1.7972-0.17667 3.5653-0.17525 5.834-0.26367 2.2686-0.0884 5.038-0.26502 7.5273-0.54492s4.7003-0.66427 6.0996-0.82618c1.3994-0.1619 1.9883-0.10232 2.2969 0.38282 0.30866 0.48514 0.33845 1.3977 0.0879 4.9805-0.25061 3.5828-0.78007 9.8246-1.1777 13.566-0.39769 3.7418-0.66236 4.9774-1.5762 5.6562-0.91381 0.67883-2.4746 0.79638-4.2578 1.0469-1.7832 0.25051-3.7854 0.63322-4.8613 1.4434-1.0759 0.81015-1.2217 2.0463-1.0449 3.2559 0.17679 1.2095 0.67561 2.3854 1.877 3.4394s3.102 1.9833 4.7891 2.3809 3.1595 0.26503 4.0801 0.83203c0.92061 0.56701 1.2878 1.8321 1.8184 3.0039 0.53056 1.1719 1.2229 2.2462 2.2832 3.2774 1.0603 1.0311 2.4884 2.0176 2.1562 2.4824-0.33208 0.46477-2.4211 0.40614-4.8008 0.33984s-5.0426-0.14065-6.3984 0.17579c-1.3559 0.31643-1.4006 1.0217-0.0508 2.8516 1.3499 1.8299 4.0863 4.7722 5.5742 7.4824s1.7224 5.1852 2.1133 6.5195c0.39092 1.3348 0.93657 1.5241 3.6035 1.3398 2.667-0.18435 7.4527-0.74305 10.869-0.48047 3.4165 0.26259 5.4634 1.3462 7.2246 2.6582s3.2376 2.8528 4.4023 4.666c1.1648 1.8133 2.0188 3.8989 2.8281 6.2774s1.5742 5.0479 2.3398 7.7168l0.79492 2.166c2.53-0.10861 5.062-0.21673 8.5996 0.64453 3.5376 0.86127 8.083 2.6906 12.168 5.8125 4.085 3.1218 7.7084 7.5365 11.264 11.949 3.5553 4.4127 7.0423 8.8248 9.6582 12.051 0.54407 0.67097 1.0204 1.2787 1.3945 1.8496h5.6191v-15.457c-0.43051-0.72511-0.89292-1.0562-1.2715-1.3281-0.73948-0.53117-1.1562-0.86454-2.2812-1.9375-1.1251-1.073-2.9572-2.8843-4.457-4.2695s-2.6666-2.3437-4.4062-3.9375-4.0522-3.823-7.0625-5.9375-6.7194-4.1146-9.2715-5.4688-3.945-2.0611-4.3828-2.4473c-0.43784-0.3862 0.082-0.44928 0.66601-0.68945 0.58403-0.24017 1.228-0.65652 2.041-1.2402 0.81299-0.58372 1.7897-1.3316 2.373-2.3848 0.58336-1.0531 0.77182-2.4064 1.1992-3.709s1.0934-2.5506 2.1465-3.8223 2.4882-2.5623 3.8125-3.584 2.5293-1.7681 3.416-2.3106 1.4484-0.87635 1.5938-1.293-0.12667-0.91637-1.2305-1.5723-3.042-1.4695-5.125-2.2715c-2.083-0.80198-4.3125-1.5933-6.1035-2.166s-3.1478-0.92789-4.1465-1.084c-0.9987-0.15608-1.6443-0.11404-2.4668-0.041-0.82252 0.0729-1.8242 0.17667-2.5312 0.42578s-1.1262 0.64741-1.6152 0.7832c-0.48904 0.1358-1.0502 0.01-0.99804-0.50195 0.0522-0.51188 0.71711-1.4069 1.0918-2.084 0.37469-0.67709 0.45806-1.1335 0.99024-1.832 0.53217-0.69851 1.5084-1.6344 2.5195-2.8125 1.0111-1.178 2.052-2.5917 2.9492-3.6348 0.89724-1.0431 1.6457-1.7103 1.4785-2.3867-0.16722-0.67639-1.2498-1.3631-2.9473-1.582-1.6975-0.21889-4.0122 0.0307-6.2617 0.35352s-4.4361 0.71997-6.207 0.94921c-1.7709 0.22929-3.125 0.29168-4.0215 0.0625-0.89652-0.22919-1.3336-0.75084-2.1875-1.3965s-2.1255-1.4162-3.4375-1.9785c-1.312-0.56231-2.6667-0.91796-5-1.5117-2.3333-0.59376-5.6462-1.427-8.1465-2.5625s-4.1875-2.5719-5.334-4.2188c-1.1464-1.6468-1.7494-3.4997-2.041-5.8652s-0.27023-5.2391-0.13477-8.0938 0.38409-5.6871 0.55079-8.5527c0.16669-2.8656 0.25099-5.7546 0.38671-7.6113 0.13573-1.8568 0.32316-2.6698-0.50976-2.9922-0.83293-0.32237-2.6877-0.15565-6.375-0.25976-3.6873-0.10412-9.2084-0.47837-13.281-0.38477-4.0726 0.0936-6.6977 0.65542-8.8125 0.72852s-3.7188-0.34341-5.2402-1.625-2.958-3.4255-3.9375-5.6035-1.5011-4.3861-2.1055-6.793-1.2905-5.0094-2.3633-7.0508c-1.0728-2.0413-2.5314-3.5195-3.2402-4.625s-0.66583-1.8348-0.30078-3.2109c0.36505-1.3762 1.0501-3.3934 1.4355-5.6445 0.38544-2.2511 0.46877-4.7272 0.46875-6.7383s-0.08198-3.5538-0.62305-4.2305c-0.54107-0.67673-1.5419-0.48847-2.875 0.49024-1.3331 0.9787-3.0006 2.7498-4.5 4.1348-1.4994 1.3849-2.8327 2.3864-3.8223 2.9492-0.98957 0.56281-1.6353 0.68722-1.959-0.17773-0.32364-0.86494-0.32422-2.7193-0.32422-5.043s-4.42e-4 -5.1133-1.1777-8.1758c-1.1773-3.0625-3.53-6.3959-4.707-8.0625s-1.1774-1.6661-1.4375-1.125c-0.26013 0.54107-0.78215 1.6246-1.6465 3.041s-2.0721 3.1682-3.6543 4.2617-3.5423 1.5315-5.5215 2.5-3.9788 2.4676-5.0938 3.5508c-1.1149 1.0832-1.3456 1.7507-1.627 1.9492-0.2814 0.19857-0.61379-0.0721-1.0098-0.57227-0.39597-0.50018-0.85401-1.23-1.2188-1.9805-0.36474-0.75044-0.63542-1.5209-1.4375-2.8438s-2.1348-3.1967-4.2285-5.8945c-2.0937-2.698-4.9492-6.2201-7.6992-9.6367-2.75-3.4167-5.3954-6.728-6.541-9.166-0.14601-0.31071-0.26695-0.60733-0.37109-0.89258zm190.86 0.1836c0.053 0.26373 0.0352 0.72307 0.0645 0.81445 0.19757 0.61653 0.35527 0.33962 0.46874 0.8125 0.11351 0.47287 0.53692 0.61296-0.52148 1.7812-1.0584 1.1683-2.8256 2.9873-4.0586 4.0703s-2.1725 1.8934-2.3848 1.7188c-0.21225-0.17461-0.27059-0.80251-0.98633-1.5781-0.36642-0.39708-0.90614-0.83383-1.4863-1.2832a19.53 19.53 0 0 0 11.791 12c-6e-3 -7e-3 -0.0118-0.0142-0.0176-0.0215-0.14708-0.18425-0.29126-0.3597-0.43359-0.52539-0.18085-0.20801-0.35856-0.40481-0.52735-0.56054-0.38718-0.3573-0.73811-0.55106-1.0137-0.68164h-2e-3c-0.27576-0.13058-0.47519-0.19857-0.5625-0.30469-0.0218-0.0265-0.029-0.0649-0.0215-0.11328 0.0226-0.14527 0.17127-0.38556 0.4082-0.69727 0.31591-0.41562 0.78857-0.95775 1.3301-1.5742s1.2677-1.3675 2.0039-2.0957c0.7362-0.72838 1.4823-1.4337 2.0664-1.9629 1.1683-1.0584 1.3103-0.63499 1.7832-0.52149 0.47288 0.1135 0.19597 0.27117 0.8125 0.46875 0.0932 0.0298 0.5656 0.0114 0.82617 0.0684v-9.8144zm-190.18 12.99c-0.079786-8e-3 -0.15014-4e-4 -0.22266 4e-3v48.84c0.25321 0.2215 0.53404 0.41884 0.86914 0.64648 1.656 1.125 4.3852 3.207 7.625 5.0195 3.2398 1.8125 6.9893 3.3549 11.469 4.1465 4.4794 0.79156 9.6863 0.8339 13.301-0.5 3.6145-1.3339 5.6359-4.0419 6.4062-6.4062s0.2924-4.3858-1.207-5.4375-4.0208-1.1349-6.1562-0.21875-3.8845 2.831-5.7812 4.1758-3.9357 2.1145-5.5625 1.9375c-1.6268-0.17697-2.8337-1.3008-2.75-2.8848 0.0837-1.5839 1.4575-3.626 1.832-5.2402 0.37452-1.6142-0.25052-2.8022-0.875-3.7285-0.62448-0.92626-1.2504-1.5937-1.8027-2.9277s-1.0304-3.3324-0.30078-5.916c0.72961-2.5836 2.6665-5.7501 4.2812-7.9375s2.9075-3.3961 3.1152-5-0.66902-3.6032-1.7832-4.832c-1.1142-1.2288-2.4677-1.6878-3.9473-1.3965-1.4796 0.29133-3.0807 1.3308-4.1133 3.1133s-1.4909 4.3018-2.0117 6.3125-1.1045 3.511-2.2715 4.8555c-1.167 1.3444-2.9129 2.5286-3.6016 2.1426s-0.31379-2.3424 0.11328-4.707 0.90639-5.1342 1.0312-7.9258c0.12486-2.7916-0.10476-5.6052-0.77148-8.0528-0.66673-2.4476-1.7718-4.5309-3.084-5.916s-2.8322-2.0717-3.8008-2.166zm140.42 6.2656c-0.14583 0.20832-0.28945 0.41498-2.6797 4.6758-1.3224 2.3573-3.3276 5.9792-5.248 10.215-4.196 1.89-7.7935 3.823-10.111 5.0742-4.3719 2.3601-4.3709 2.3457-1.9668 7.0371 1.3972 2.7265 3.4225 6.6441 6.127 10.717-0.37088 4.5357-0.36494 8.5404-0.34375 11.115 0.0384 4.6665 0.0765 4.6975 0.0977 4.7129s0.0222 0.0157 3.7812 0.28906c2.2485 0.16354 7.5957 0.53748 13.418 0.29688 3.6171 2.2485 6.9687 3.9138 9.1699 5 4.2299 2.0873 4.23 2.0857 6.6191-2.0293 1.0976-1.8904 2.7028-4.6745 4.3516-7.9551 5.5148-2.8158 10.711-6.5676 15.906-10.326l-2.4844-4.6504c-1.3971-2.6129-3.4049-6.3271-6.0312-10.223 0.41279-4.3573 0.47112-8.1952 0.49414-10.691 0.043-4.6665 8e-3 -4.6972-0.0137-4.7129-0.0209-0.0157-0.0222-0.0154-3.4102-0.0879-2.0026-0.0428-6.7016-0.13143-12.057 0.27539-4.8814-3.3005-10.247-6.0198-15.619-8.7324zm8.3281 18.562a13.245 13.245 0 0 1 13.244 13.246 13.245 13.245 0 0 1-13.244 13.244 13.245 13.245 0 0 1-13.246-13.244 13.245 13.245 0 0 1 13.246-13.246zm-139.04 36.104c-2.1288-0.0254-3.9935 0.0197-5.5859 0.0645-1.7992 0.0507-3.1791 0.10119-4.3437 0.15625v9.1953c0.046823 0.0321 0.086543 0.0513 0.13867 0.0918v-0.39648c63.873 1.1839 115.01 50.351 115.06 110.63-0.048 2.0578-0.15673 4.1139-0.32618 6.166 0.0338 2e-3 -0.0989 2e-3 -0.0996 4e-3v0.0312c2.4861 0.0133 4.5579 0.0432 5.8516 0.0293 1.5-0.0161 2.2015 0.18379 3.0781 0.11133-0.53503-13.927-0.89556-28.127-6.8984-44.76-6.0029-16.633-17.474-35.971-32.496-50.055s-33.595-22.914-48.238-27.238c-10.982-3.2432-19.754-3.9512-26.141-4.0273zm6.9121 21.391c-1.0792-0.0346-1.683 0.19213-2.2383 0.61718-0.74044 0.56675-1.3967 1.4875-1.9453 2.4336-0.54859 0.94606-0.99028 1.919-1.377 2.7402s-0.71657 1.4915-1.3535 1.8125c-0.63695 0.32102-1.5802 0.29181-2.5879 0.35547-1.0077 0.0637-2.0813 0.22059-3.1465 0.40039s-2.1225 0.38145-2.7949 0.68945c-0.67242 0.308-0.95967 0.72198-1.1035 0.92969-0.072822 0.10516-0.11385 0.16149-0.25 0.29297v5.6758c0.032655 7e-3 0.054739 0.013 0.087891 0.0195v-3.252a90.603 87.044 0 0 1 88.822 86.959 90.603 87.044 0 0 1-0.25 4.8457h-2.4199c0.25633 0.29845 0.56952 0.48122 0.98047 0.59179 1.3456 0.36208 3.6277 0.13099 4.8105-0.0293 1.1829-0.16026 1.1999-0.24197 1.209-0.5918s0.01037-0.96625 0.1582-1.623c0.14783-0.6568 0.44186-1.349 0.64062-2.248 0.19877-0.89901 0.30081-1.9987 0.4043-2.9668s0.20512-1.7872 0.38281-2.4082c0.17769-0.62096 0.42822-1.0316 1.0332-1.459s1.5587-0.86895 2.3477-1.3262c0.78895-0.45722 1.4072-0.92716 1.916-1.2441 0.50885-0.31698 0.90543-0.47892 1.2891-0.82617 0.38362-0.34725 0.75017-0.87541 0.97851-1.4434 0.22836-0.56795 0.31695-1.1713-0.0957-3.123-0.41264-1.9518-1.3265-5.2511-2.2031-8.5957-0.87667-3.3446-1.7159-6.7314-2.4961-8.4473s-1.5022-1.76-2.9531-1.5098c-1.4509 0.25025-3.6361 0.79596-4.9863 1.1094s-1.8743 0.39512-2.3145 0.01c-0.44013-0.38604-0.79371-1.2394-1.916-3.8223-1.1223-2.5828-3.014-6.8928-4.9316-10.646-1.9177-3.7536-3.8756-6.9726-4.9883-8.7363-1.1126-1.7637-1.4065-2.1166-1.377-2.5742 0.02957-0.45758 0.38373-1.0178 0.95117-1.7988s1.3474-1.7805 2.4238-2.8125c1.0765-1.032 2.4431-2.0912 2.9512-2.791s0.15473-1.0391-1.0312-2.2324c-1.186-1.1933-3.2034-3.2409-4.9785-5.0234s-3.3067-3.2989-4.2715-4.168-1.3627-1.0906-1.959-0.75977c-0.59632 0.33084-1.3921 1.2163-2.4082 2.2324s-2.2534 2.1646-2.9902 3.041c-0.73685 0.87639-0.9741 1.4807-1.416 1.6582-0.44191 0.17749-1.0889-0.0738-3.6523-1.709s-7.0419-4.6557-10.887-6.9316c-3.8448-2.276-7.0395-3.7987-8.7656-4.873-1.7261-1.0744-1.9451-1.675-1.9375-2.4277 0.0076-0.75271 0.24283-1.6502 0.41211-3.127s0.27335-3.5309 0.20703-4.6758c-0.06632-1.1448-0.30212-1.3812-2.1211-1.9336s-5.2224-1.4214-8.4375-2.25-6.2421-1.6168-8.168-1.9043c-0.48147-0.0719-0.89417-0.1115-1.2539-0.12304zm-16.398 24.215c-0.14921-3e-3 -0.29622 2e-3 -0.44336 0.0137v40.379c0.007176 2e-3 0.020145 5e-3 0.027344 8e-3v-0.45898c0.25636-0.0218 0.54635-0.1073 1.2539-0.33399 1.2059-0.38635 3.6165-1.1573 6.4629-1.2793 2.8464-0.12195 6.1298 0.40591 9.3945 1.9883 3.2647 1.5824 6.512 4.218 8.4004 5.3711 1.7669 1.0789 2.4079 0.77565 4.7051-1.5449 5e-3 -0.30787-5e-3 -0.61054-0.04102-0.88867-0.20466-1.5819-0.92769-2.4555-2.3242-3.6504-1.3965-1.1949-3.4663-2.7108-5.6836-3.7676-2.2172-1.0568-4.5804-1.6527-5.4883-2.4668-0.90789-0.81407-0.35816-1.8415 0.5332-3.3789s2.1224-3.5806 4.3633-5.1309 5.4812-2.6033 7.6113-3.4043c2.1301-0.80096 3.1373-1.3454 3.1953-2.2031s-0.83346-2.0272-3.1836-3.252c-2.3501-1.2248-6.1593-2.5048-9.0098-2.7773-2.8504-0.27244-4.7415 0.46344-5.8438 0.0781-1.1022-0.38525-1.4133-1.8914-2.3027-3.6445s-2.3529-3.747-4.5313-5.7812c-2.0422-1.9071-4.6898-3.828-7.0957-3.875zm135.06 40.555c-0.59685 0.0241-1.2354 0.14273-1.9004 0.35937-2.3644 0.77033-5.0724 2.7918-6.4062 6.4062-1.3339 3.6145-1.2916 8.8214-0.5 13.301 0.79157 4.4794 2.3339 8.229 4.1465 11.469 1.8126 3.2398 3.8946 5.969 5.0195 7.625 0.22764 0.3351 0.42498 0.61594 0.64648 0.86914h48.84c4e-3 -0.0725 0.0118-0.14285 4e-3 -0.22265-0.0943-0.96863-0.78088-2.4886-2.166-3.8008-1.3851-1.3122-3.4684-2.4173-5.916-3.084s-5.2612-0.89635-8.0527-0.77148c-2.7916 0.12486-5.5612 0.60417-7.9258 1.0312-2.3646 0.42707-4.321 0.80193-4.707 0.11328s0.79814-2.4345 2.1426-3.6016c1.3444-1.167 2.8448-1.7507 4.8555-2.2715s4.53-0.97916 6.3125-2.0117c1.7825-1.0326 2.822-2.6337 3.1133-4.1133 0.29132-1.4796-0.16765-2.8331-1.3965-3.9473-1.2288-1.1142-3.2281-1.9909-4.832-1.7832-1.6039 0.20772-2.8126 1.5005-5 3.1152s-5.354 3.5516-7.9375 4.2812c-2.5836 0.72961-4.582 0.25151-5.916-0.30078-1.334-0.5523-2.0015-1.1783-2.9277-1.8027-0.92627-0.62448-2.1143-1.2495-3.7285-0.875-1.6142 0.37452-3.6563 1.7483-5.2402 1.832s-2.7078-1.1232-2.8848-2.75c-0.17698-1.6268 0.59272-3.6658 1.9375-5.5625 1.3448-1.8967 3.2596-3.6458 4.1758-5.7812 0.91613-2.1354 0.83295-4.6568-0.21875-6.1562-0.65732-0.93714-1.6932-1.4749-2.9551-1.5586-0.18928-0.0126-0.38308-0.0159-0.58203-8e-3zm-75.043 7.1211c-0.53105 0.0921-0.97195 0.8308-1.5312 2-0.73051 1.5271-1.6569 3.7766-2.4453 5.5156s-1.436 2.962-2.1875 3.9863-1.6057 1.8488-2.6191 2.6172c-1.0134 0.76843-2.1819 1.4768-3.1719 1.8144-0.98993 0.33769-1.7925 0.30088-2.125-0.20703-0.33247-0.50791-0.19007-1.4815-1.459-4.1309-1.2689-2.6494-3.9505-6.9727-6.0527-8.6191-0.80168-0.62788-1.4274-0.92399-1.9609-0.98437-2.9189 2.8431-2.8565 3.4906-1.7852 5.3047s3.1414 4.7756 4.5566 7.5644 2.1698 5.3959 2.1895 8.3457c0.01961 2.9498-0.69652 6.2382-1.0547 7.8848-0.27655 1.2713-0.36216 1.5569-1.2168 1.6211 0.0018 5.5e-4 0.0041 3e-3 0.0059 4e-3 0.08344 0.0241 0.10468 0.0113 5.8262 2e-3 5.7215-9e-3 18.514-0.0171 25.027-4e-3 6.5131 0.0132 7.4385 0.0482 7.6543-0.82421 0.21576-0.87246-0.27195-2.6772-1.3418-4.6973-1.0698-2.0201-2.7264-4.2711-4.1895-5.6719-1.4631-1.4007-2.7318-1.9515-3.8711-2.3144-1.1393-0.36299-2.1457-0.53641-2.4336-1.9062s0.14331-3.9322-0.13672-6.3789-1.2709-4.7771-2.293-6.7637c-1.022-1.9866-2.0747-3.6304-2.8652-4.0547-0.09882-0.053-0.19359-0.0876-0.28516-0.10352-0.08012-0.0139-0.15851-0.0131-0.23438 0zm-55.693 7.7285c-1.4207 0.0348-2.6923 0.30841-3.4746 0.47656-0.74201 0.15948-1.0395 0.21849-1.1641 0.041v24.383h24.227c-0.05582-0.13765 0.02514-0.43347 0.20898-1.082 0.34269-1.209 1.0228-3.6059 0.50781-5.8691-0.51502-2.2633-2.2282-4.3843-4.3965-5.2148-2.1683-0.83059-4.7748-0.37528-6.0859-0.22656-1.3112 0.14871-1.2906-0.0144-1.127-1.4277 0.16364-1.4133 0.47015-4.0763-0.49219-6.2754s-3.1931-3.9356-5.5586-4.5352c-0.88707-0.22483-1.7921-0.29044-2.6445-0.26953z',transform:'rotate(0 0 0)'},{d:'m104.82-0.00771c0.0578 0.11122 0.1473 0.29371 0.24219 0.4707 0.22831 0.42583 0.68517 1.2775 2.1582 2.0801 1.473 0.80258 3.9618 1.556 6.2363 1.8359s4.3353 0.088 6.7559-0.30273c2.4206-0.39082 5.2013-0.98174 7.1777-1.3027 1.9765-0.32101 3.1488-0.37376 3.9551-0.43945 0.80625-0.0657 1.245-0.14287 1.6387-0.0312 0.39364 0.11158 0.7433 0.41196 0.85547 1.2402 0.11215 0.82828-0.0123 2.182-0.6875 3.543-0.67513 1.361-1.8999 2.7232-2.6758 3.6211-0.7759 0.89787-1.1008 1.328-0.95312 1.6289 0.14767 0.30092 0.76648 0.4685 1.3223 0.55859 0.55578 0.0901 1.0474 0.1028 1.9512-0.01 0.90377-0.11202 2.2199-0.34706 3.3848-0.5664 1.1648-0.21935 2.1769-0.42273 3.4238-1.0527 1.2469-0.63001 2.7289-1.6866 3.9512-2.5976s2.1858-1.6777 3.0469-2.4746c0.86104-0.79691 1.6194-1.6256 1.998-2.0391s0.37897-0.41189 0.7168-0.4043c0.33783 8e-3 1.0124 0.0214 1.5625 0.55664 0.55014 0.53527 0.97686 1.5917 1.6816 2.5586 0.70477 0.96691 1.6854 1.8409 2.7441 2.4883 1.0587 0.64737 2.1939 1.0666 3.1426 1.4551 0.94869 0.3885 1.7112 0.7455 2.9707 1.1152 1.2595 0.36975 3.0165 0.75194 4.6133 1.0605 1.5968 0.30861 3.032 0.54403 4 0.47852 0.96796-0.0655 1.4674-0.42984 1.543-0.98438 0.0755-0.55455-0.27122-1.2984-0.46875-2.291-0.19752-0.99263-0.24532-2.2338 2e-3 -3.3496 0.24721-1.1158 0.78884-2.1075 1.3203-2.7715 0.53148-0.66403 1.0516-1.0018 1.8457-1.1855 0.79411-0.18372 1.8635-0.21407 2.7617 0.1914 0.89822 0.40546 1.6257 1.2465 2.6777 2.1289 1.052 0.88236 2.4268 1.8064 3.1426 2.582 0.71574 0.77561 0.77408 1.4035 0.98633 1.5781 0.21225 0.17462 1.1518-0.63573 2.3848-1.7188s3.0002-2.902 4.0586-4.0703 0.635-1.3084 0.52148-1.7812c-0.11349-0.47288-0.27117-0.19597-0.46874-0.8125-0.0377-0.1178 7e-3 -0.86028-0.12891-0.98632zm-105.26 0.25391v77.387c0.10401 0.0509 0.20377 0.11562 0.30859 0.16406v-3.4902c1.1646-0.0551 2.5446-0.10557 4.3437-0.15625 1.5924-0.0449 3.4571-0.0897 5.5859-0.0645 6.3864 0.0761 15.158 0.78419 26.141 4.0274 14.643 4.3242 33.216 13.155 48.238 27.238 15.022 14.084 26.493 33.422 32.496 50.055 6.0029 16.633 6.3634 30.835 6.8984 44.762-0.87661 0.0725-1.5781-0.12938-3.0781-0.11328-0.3748 4e-3 -1.1987-6e-3 -1.6953-8e-3 5e-3 0.048 0.0125 0.0912 0.0176 0.13867h17.5c-0.1947-0.23245-0.37591-0.47876-0.58007-0.7793-1.125-1.656-3.207-4.3852-5.0195-7.625s-3.3549-6.9893-4.1465-11.469c-0.79156-4.4794-0.8339-9.6863 0.5-13.301 1.3339-3.6145 4.0419-5.6359 6.4062-6.4062 0.66498-0.21665 1.3035-0.33527 1.9004-0.35937 0.19895-8e-3 0.39275-5e-3 0.58203 8e-3 1.2619 0.0837 2.2978 0.62145 2.9551 1.5586 1.0517 1.4994 1.1349 4.0208 0.21875 6.1562-0.91613 2.1354-2.831 3.8845-4.1758 5.7812s-2.1145 3.9357-1.9375 5.5625c0.17697 1.6268 1.3008 2.8337 2.8848 2.75s3.626-1.4575 5.2402-1.832c1.6142-0.37451 2.8022 0.25052 3.7285 0.875 0.92626 0.62448 1.5937 1.2504 2.9277 1.8027 1.334 0.55229 3.3324 1.0304 5.916 0.30078 2.5836-0.72961 5.7501-2.6665 7.9375-4.2812s3.3961-2.9075 5-3.1152c1.6039-0.20771 3.6032 0.66902 4.832 1.7832 1.2288 1.1142 1.6878 2.4677 1.3965 3.9473-0.29133 1.4796-1.3308 3.0807-3.1133 4.1133s-4.3018 1.4909-6.3125 2.0117-3.511 1.1045-4.8555 2.2715c-1.3444 1.167-2.5286 2.9129-2.1426 3.6016s2.3424 0.31379 4.707-0.11328c2.3646-0.42708 5.1342-0.90639 7.9258-1.0312 2.7916-0.12487 5.6051 0.10475 8.0527 0.77148s4.5309 1.7718 5.916 3.084 2.0717 2.8322 2.166 3.8008c5e-3 0.0476 5.2e-4 0.0895-2e-3 0.13281h9.2832c-0.3807-0.59308-0.88246-1.2283-1.4512-1.9297-2.6159-3.226-6.1029-7.6381-9.6582-12.051-3.5553-4.4127-7.1787-8.8274-11.264-11.949-4.085-3.1218-8.6304-4.9512-12.168-5.8125-3.5376-0.86126-6.0696-0.75314-8.5996-0.64453l-0.79492-2.166c-0.7656-2.6689-1.5305-5.3383-2.3398-7.7168s-1.6634-4.4641-2.8281-6.2774c-1.1648-1.8132-2.6411-3.354-4.4023-4.666s-3.8081-2.3956-7.2246-2.6582c-3.4165-0.26258-8.2022 0.29611-10.869 0.48047-2.667 0.18432-3.2126-5e-3 -3.6035-1.3398-0.3909-1.3344-0.6254-3.8093-2.1133-6.5195s-4.2243-5.6525-5.5742-7.4824-1.3051-2.5351 0.0508-2.8516c1.3559-0.31644 4.0188-0.24209 6.3984-0.17579s4.4687 0.12493 4.8008-0.33984-1.0959-1.4513-2.1562-2.4824-1.7526-2.1055-2.2832-3.2774c-0.53055-1.1718-0.89775-2.4369-1.8184-3.0039-0.92062-0.567-2.393-0.43443-4.0801-0.83203s-3.5877-1.3268-4.7891-2.3809-1.7002-2.23-1.877-3.4394c-0.17679-1.2095-0.031-2.4457 1.0449-3.2559 1.0759-0.81014 3.0782-1.1928 4.8613-1.4434 1.7832-0.2505 3.344-0.36805 4.2578-1.0469 0.91382-0.67883 1.1785-1.9144 1.5762-5.6562 0.39769-3.7418 0.92715-9.9836 1.1777-13.566 0.25058-3.5828 0.22078-4.4953-0.0879-4.9805-0.3086-0.48514-0.89752-0.54471-2.2969-0.38281-1.3994 0.16191-3.6103 0.54627-6.0996 0.82617s-5.2587 0.45652-7.5273 0.54492-4.0368 0.087-5.834 0.26367c-1.7972 0.17666-3.6228 0.53027-4.2422 1.6055-0.61939 1.0752-0.03019 2.8728-0.13281 4.3457s-0.89885 2.6215-1.9004 3.3438c-1.0015 0.72227-2.2099 1.0184-3.3594 0.8418-1.1495-0.17654-2.2392-0.82486-3.0352-2.1367-0.79593-1.3119-1.2957-3.2855-1.502-4.7891s-0.11796-2.5333-0.86914-3.4902c-0.75118-0.95688-2.342-1.8407-3.6973-2.5625-1.3553-0.72183-2.4773-1.2837-3.4766-1.7246s-1.8847-0.76426-2.1797 0.82617c-0.29494 1.5904-0.0016 5.0954-0.17773 7.0254-0.17614 1.93-0.82408 2.2846-1.7969 1.9609-0.97279-0.32371-2.2699-1.3257-3.5664-2.6074s-2.5922-2.8434-4.0059-3.6094c-1.4137-0.76598-2.9452-0.73614-4.4629-0.95703-1.5177-0.2209-3.0201-0.6922-3.6836-1.5625-0.66352-0.87029-0.48715-2.1361-0.01563-4.4199 0.47156-2.2839 1.238-5.5839 1.1641-8.6035s-0.9877-5.7597-3.9043-8.7793-7.8349-6.3198-11.709-7.7637-6.7025-1.0311-7.7344-1.2969c-1.0319-0.26578-0.26544-1.2076 0.25-3.0352 0.51544-1.8275 0.78037-4.5359-0.23633-7.8945s-3.314-7.3661-6.8789-11.402c-3.5647-4.036-8.398-8.1018-12.941-12.301-4.5434-4.199-8.7984-8.5312-10.926-10.697-1.1608-1.1818-1.6937-1.7111-2.3555-2.043zm197.98 9.0156c-0.24046 0.0121-0.5682 0.17197-1.1523 0.70117-1.1683 1.0584-2.9873 2.8257-4.0703 4.0586s-1.8914 2.1725-1.7168 2.3848c0.17461 0.21225 0.80251 0.27059 1.5781 0.98633 0.77563 0.71573 1.6997 2.0906 2.582 3.1426 0.88237 1.052 1.7234 1.7795 2.1289 2.6777 0.40547 0.89823 0.37513 1.9676 0.19141 2.7617-0.18371 0.7941-0.52152 1.3142-1.1856 1.8457-0.66402 0.53147-1.6557 1.0731-2.7715 1.3203-1.1158 0.24724-2.357 0.19942-3.3496 2e-3 -0.99262-0.19753-1.7365-0.54425-2.291-0.46875-0.55454 0.0755-0.91887 0.57501-0.98437 1.543s0.1699 2.4032 0.47851 4c0.3086 1.5968 0.6908 3.3538 1.0606 4.6133 0.36974 1.2595 0.72673 2.022 1.1152 2.9707 0.38851 0.9487 0.80771 2.0839 1.4551 3.1426 0.64736 1.0587 1.5214 2.0394 2.4883 2.7441 0.96691 0.70478 2.0233 1.1315 2.5586 1.6816 0.53524 0.55013 0.54864 1.2247 0.55664 1.5625s9e-3 0.33814-0.4043 0.7168c-0.41344 0.37866-1.2422 1.137-2.0391 1.998-0.7969 0.86104-1.5636 1.8246-2.4746 3.0469s-1.9676 2.7042-2.5977 3.9512c-0.63001 1.2469-0.83338 2.259-1.0527 3.4238-0.21934 1.1648-0.45439 2.481-0.56641 3.3848-0.11253 0.90378-0.0997 1.3954-0.01 1.9512 0.0901 0.55578 0.25767 1.1746 0.55859 1.3223 0.30093 0.14767 0.73104-0.17722 1.6289-0.95312 0.89788-0.7759 2.2601-2.0006 3.6211-2.6758s2.7147-0.79965 3.543-0.6875c0.82827 0.11216 1.1286 0.46183 1.2402 0.85547 0.11162 0.39364 0.0343 0.83242-0.0312 1.6387-0.0657 0.80625-0.11844 1.9786-0.43945 3.9551-0.321 1.9765-0.91191 4.7571-1.3027 7.1777-0.39073 2.4206-0.58264 4.4813-0.30274 6.7559 0.2799 2.2745 1.0334 4.7633 1.8359 6.2363 0.80258 1.473 1.6542 1.9299 2.0801 2.1582 0.17699 0.0949 0.35948 0.18439 0.4707 0.24219v-85.391c-0.12604-0.13574-0.86853-0.0912-0.98633-0.12891-0.61653-0.19758-0.33962-0.35525-0.8125-0.46875-0.23643-0.0567-0.39039-0.19181-0.63086-0.17969zm-197.45 3.8926c0.96863 0.0943 2.4886 0.78088 3.8008 2.166 1.3122 1.3851 2.4173 3.4684 3.084 5.916 0.66673 2.4476 0.89635 5.2612 0.77148 8.0527-0.12486 2.7916-0.60418 5.5612-1.0312 7.9258-0.42707 2.3646-0.80193 4.321-0.11328 4.707s2.4345-0.79814 3.6016-2.1426c1.167-1.3444 1.7507-2.8448 2.2715-4.8555s0.97916-4.53 2.0117-6.3125c1.0326-1.7825 2.6337-2.822 4.1133-3.1133 1.4796-0.29132 2.8331 0.16765 3.9473 1.3965 1.1142 1.2288 1.9909 3.2281 1.7832 4.832s-1.5005 2.8126-3.1152 5-3.5516 5.354-4.2812 7.9375c-0.72961 2.5836-0.25151 4.582 0.30078 5.916 0.5523 1.334 1.1783 2.0015 1.8027 2.9277 0.62448 0.92627 1.2495 2.1143 0.875 3.7285-0.37452 1.6142-1.7483 3.6563-1.832 5.2402s1.1232 2.7078 2.75 2.8848c1.6268 0.17698 3.6658-0.59272 5.5625-1.9375 1.8967-1.3448 3.6458-3.2596 5.7812-4.1758s4.6568-0.83295 6.1562 0.21875 1.9774 3.0731 1.207 5.4375-2.7917 5.0724-6.4062 6.4062c-3.6145 1.3339-8.8214 1.2916-13.301 0.5-4.4794-0.79157-8.229-2.3339-11.469-4.1465-3.2398-1.8126-5.969-3.8946-7.625-5.0195-0.3351-0.22764-0.61593-0.42498-0.86914-0.64648v-48.84c0.072521-4e-3 0.14287-0.0116 0.22266-4e-3zm159.21 3.6035c-0.37282 0.0854-1.0339 0.86945-2.166 1.8887-1.2938 1.1648-3.196 2.6309-4.1484 3.3652s-0.95235 0.7346-1.3457 1.3398c-0.39336 0.60524-1.1803 1.8148-1.6289 3.3047s-0.55851 3.257 0.62305 4.7441c1.1816 1.4872 3.6527 2.6954 5.791 2.4902 2.1383-0.20517 3.9446-1.8207 4.4453-4.5059 0.50074-2.6851-0.30292-6.4425-0.70117-8.8906-0.39824-2.4481-0.39045-3.5873-0.72656-3.7285-0.042-0.0176-0.0893-0.02-0.14258-8e-3zm-34.059 7.8086c-0.0592 3e-3 -0.10609 0.0196-0.14258 0.0469-0.29192 0.2184 0.1036 1.2359 0.45312 2.9414s0.6511 4.089 1.125 5.9277c0.47392 1.8388 1.12 3.1303 2.1777 4.2715 1.0578 1.1412 2.5256 2.1294 4.4062 1.8633 1.8807-0.26609 4.1725-1.7865 5.0781-3.7344 0.90559-1.9479 0.42541-4.3221-1.6367-6.1133s-5.7067-3.0006-8.0195-3.8965c-2.0237-0.78393-3.0268-1.3291-3.4414-1.3066zm48.127 14.111c-0.11935 3e-3 -0.25569 0.0145-0.43555 0.0293-0.71942 0.059-2.1582 0.17799-3.6113 0.73437s-2.9173 1.5502-3.3711 3.3945c-0.45384 1.8444 0.10205 4.5373 1.5723 6.1035 1.4702 1.5662 3.8546 2.006 6.2852 0.75977s4.9084-4.1778 6.6016-5.9902c1.6932-1.8125 2.5998-2.5052 2.5059-2.8574-0.0939-0.35227-1.1875-0.36466-2.9004-0.67578s-4.0357-0.9183-5.1992-1.2227c-0.87264-0.22827-1.0892-0.286-1.4473-0.27539zm-45.959 11.738c-0.59783 0.022-1.2263 0.13643-1.873 0.35547-2.5871 0.87617-5.4694 3.4145-7.4102 4.959-1.9407 1.5445-2.9396 2.0948-2.8984 2.457 0.0412 0.36223 1.1208 0.53472 2.7695 1.0938 1.6487 0.55904 3.8586 1.5009 4.9648 1.9727 1.1063 0.47175 1.1059 0.47236 1.8262 0.51953 0.72029 0.0472 2.1606 0.14188 3.6797-0.19531 1.519-0.33718 3.1145-1.1054 3.834-2.8633s0.56245-4.5046-0.6621-6.2695c-0.91842-1.3237-2.437-2.0954-4.2305-2.0293zm38.684 11.18c-0.42422-0.0258-0.86642 0.0121-1.3262 0.13086-1.839 0.47517-3.9454 2.2441-4.627 4.2812-0.68158 2.0371 0.0606 4.3418 2.3105 5.8906s6.0076 2.3416 8.4062 2.9727c2.3987 0.63106 3.4375 1.1013 3.7031 0.85156s-0.2428-1.2194-0.78125-2.875c-0.53846-1.6556-1.1048-3.9876-1.3887-5.1562-0.28386-1.1687-0.28265-1.1681-0.67579-1.7734s-1.1804-1.8166-2.3594-2.832c-0.88425-0.76159-1.9891-1.4129-3.2617-1.4902zm-23.285 5.5879c-0.27464 0.0143-0.54579 0.0484-0.80859 0.10351-2.1024 0.44072-3.7177 2.2447-3.918 4.9688s1.0147 6.3689 1.6816 8.7578c0.66693 2.389 0.78508 3.5219 1.1348 3.625 0.34969 0.10307 0.93102-0.82405 2.0879-2.125s2.8828-2.9674 3.748-3.8027c0.86527-0.8353 0.86554-0.83538 1.1894-1.4805 0.3239-0.64509 0.97302-1.9364 1.2539-3.4668s0.19445-3.2993-1.1445-4.6465c-1.1716-1.1788-3.3021-2.0333-5.2246-1.9336zm-128.58 23.596c-1.3505 0.0295-1.9707 0.46827-2.4297 1.0508-0.61194 0.77667-0.93558 1.8116-1.4512 2.8281-0.51559 1.0165-1.2259 2.0172-1.9961 2.6211-0.77015 0.60388-1.6041 0.81367-3.0625 0.73047s-3.5399-0.45879-4.998-0.52149c-0.10748-5e-3 -0.19568-8e-3 -0.28906-0.0117v8.1621c0.051797-0.058 0.11067-0.11776 0.15625-0.18359 0.14384-0.20771 0.43109-0.62169 1.1035-0.92969 0.67242-0.308 1.7298-0.50965 2.7949-0.68945s2.1388-0.33669 3.1465-0.40039 1.9509-0.0345 2.5879-0.35547c0.63695-0.32102 0.96684-0.99123 1.3535-1.8125s0.82836-1.7942 1.377-2.7402c0.54859-0.94606 1.2049-1.8669 1.9453-2.4336 0.55533-0.42506 1.1591-0.65184 2.2383-0.61719 0.35974 0.0115 0.77244 0.0512 1.2539 0.12305 1.9259 0.28751 4.9528 1.0757 8.168 1.9043s6.6185 1.6977 8.4375 2.25 2.0548 0.78875 2.1211 1.9336c0.06632 1.1448-0.03775 3.199-0.20703 4.6758s-0.40451 2.3742-0.41211 3.127c-0.0076 0.7527 0.21137 1.3534 1.9375 2.4277 1.7261 1.0744 4.9208 2.5971 8.7656 4.873 3.8448 2.276 8.3233 5.2964 10.887 6.9316 2.5634 1.6352 3.2104 1.8865 3.6523 1.709 0.44191-0.17748 0.67916-0.78181 1.416-1.6582 0.73685-0.87639 1.9742-2.0249 2.9902-3.041 1.0161-1.0161 1.8119-1.9016 2.4082-2.2324 0.59632-0.33083 0.99424-0.10929 1.959 0.75977s2.4964 2.3855 4.2715 4.168 3.7925 3.8301 4.9785 5.0234c1.186 1.1934 1.5393 1.5326 1.0312 2.2324s-1.8747 1.759-2.9512 2.791-1.8564 2.0314-2.4238 2.8125-0.9216 1.3412-0.95117 1.7988 0.26432 0.81053 1.377 2.5742c1.1126 1.7637 3.0706 4.9827 4.9883 8.7363s3.8093 8.0636 4.9316 10.646c1.1223 2.5828 1.4759 3.4362 1.916 3.8223 0.44013 0.38558 0.96421 0.3041 2.3145-0.01 1.3502-0.31341 3.5354-0.85912 4.9863-1.1094 1.4509-0.25026 2.1729-0.20607 2.9531 1.5098s1.6194 5.1027 2.4961 8.4473c0.87666 3.3446 1.7905 6.644 2.2031 8.5957 0.41265 1.9518 0.32408 2.5551 0.0957 3.123-0.22834 0.56795-0.59489 1.0961-0.97851 1.4434-0.38363 0.34725-0.78021 0.50919-1.2891 0.82617-0.50886 0.31698-1.1271 0.78692-1.916 1.2441-0.78895 0.45722-1.7427 0.89874-2.3477 1.3262s-0.85551 0.83803-1.0332 1.459c-0.17769 0.62095-0.27933 1.4401-0.38281 2.4082s-0.20553 2.0678-0.4043 2.9668-0.4928 1.5912-0.64062 2.248c-0.1234 0.54824-0.13948 1.0322-0.14844 1.3926h8.4668c-0.36716-0.32366-0.36749-0.85192-0.55469-2.0898-0.19728-1.3046-0.61377-3.3825-0.69727-4.6562s0.16665-1.732 0.71485-2.0898 1.3927-0.61516 2.2773-1.043c0.88466-0.4278 1.8091-1.0257 2.5117-1.8106 0.70262-0.78483 1.182-1.7536 0.85937-4.3887-0.32262-2.6351-1.4467-6.9331-2.6406-11.748-1.1939-4.815-2.4564-10.145-3.2891-12.666-0.8327-2.521-1.2385-2.2324-2.5215-1.8359-1.283 0.39645-3.4446 0.90077-4.7734 0.88867s-1.8232-0.54083-2.7383-2.2285c-0.91506-1.6877-2.2506-4.5322-3.9434-7.4785-1.6927-2.9464-3.739-5.9897-4.748-8.0274s-0.97493-3.0616-0.10352-4.377c0.87142-1.3153 2.5767-2.9168 3.2051-4.2168 0.62839-1.3 0.17971-2.2964-1.1562-3.8164-1.336-1.52-3.5608-3.5649-6.0352-6.2207s-5.1981-5.9232-7.1426-7.7129c-1.9445-1.7896-3.1096-2.1015-4.457-1.1934-1.3474 0.90812-2.8787 3.0373-4.1602 3.7676-1.2815 0.73024-2.313 0.0616-4.0078-1.0156s-4.0514-2.5632-6.3262-3.9004-4.4662-2.5252-6.1348-3.5137-2.8118-1.7746-3.5254-2.4629c-0.71362-0.68832-0.99206-1.2746-0.9668-2.4902s0.3547-3.0528 0.49219-4.2246 0.08121-1.6764-2.459-2.4707c-2.5402-0.79429-7.565-1.8795-12.162-3.0449-4.5971-1.1654-8.7652-2.4102-11.299-2.7734-0.6334-0.0908-1.1651-0.12701-1.6152-0.11719zm-14.232 24.158v4.7637c0.10316-5e-3 0.20603-0.0113 0.31055-0.01 2.4059 0.047 5.0535 1.9679 7.0957 3.875 2.1784 2.0342 3.6418 4.0281 4.5313 5.7812s1.2005 3.2593 2.3027 3.6445c1.1022 0.3853 2.9933-0.35062 5.8438-0.0781 2.8504 0.2725 6.6596 1.5526 9.0098 2.7773 2.3501 1.2248 3.2416 2.3942 3.1836 3.252s-1.0652 1.4022-3.1953 2.2031c-2.1301 0.80096-5.3704 1.854-7.6113 3.4043s-3.4719 3.5934-4.3633 5.1309c-0.89136 1.5374-1.4411 2.5648-0.5332 3.3789 0.90789 0.81408 3.271 1.41 5.4883 2.4668 2.2172 1.0568 4.2871 2.5727 5.6836 3.7676 1.3965 1.1948 2.1196 2.0685 2.3242 3.6504 0.03602 0.27813 0.04602 0.5808 0.04102 0.88867 0.15784-0.15945 0.25856-0.24427 0.43359-0.42383 2.7225-2.7928 7.6396-8.049 10.266-10.541 1.6412-1.5575 2.3891-2.0369 2.793-2.0137 0.24232 0.0139 0.35981 0.20848 0.47461 0.45899 0.02978 0.065 0.05856 0.16255 0.08789 0.23437a5.2152 5.1534 0 0 1-0.06055-0.74805 5.2152 5.1534 0 0 1 5.2148-5.1523 5.2152 5.1534 0 0 1 5.2168 5.1523 5.2152 5.1534 0 0 1-5.2168 5.1543 5.2152 5.1534 0 0 1-0.51172-0.0254c0.8665 0.21651 1.7631 0.37378-0.72656 2.9629-2.4976 2.5974-8.3839 7.6237-11.303 10.467 0.53349 0.0604 1.1593 0.35649 1.9609 0.98437 2.1022 1.6465 4.7838 5.9698 6.0527 8.6191 1.2689 2.6494 1.1265 3.623 1.459 4.1309 0.33246 0.50791 1.1351 0.54472 2.125 0.20703 0.98993-0.33769 2.1585-1.046 3.1719-1.8144 1.0134-0.76843 1.8676-1.5929 2.6191-2.6172s1.3991-2.2473 2.1875-3.9863 1.7148-3.9885 2.4453-5.5156c0.5593-1.1692 1.0002-1.9079 1.5312-2 0.07587-0.0131 0.15426-0.0139 0.23438 0 0.09157 0.0159 0.18634 0.0505 0.28516 0.10352 0.79058 0.42425 1.8432 2.0681 2.8652 4.0547s2.0129 4.317 2.293 6.7637-0.15115 5.0091 0.13672 6.3789 1.2943 1.5433 2.4336 1.9062c1.1393 0.36299 2.408 0.91372 3.8711 2.3144 1.4631 1.4008 3.1196 3.6518 4.1895 5.6719 1.0698 2.0201 1.5576 3.8248 1.3418 4.6973-0.10622 0.42949-0.39159 0.63776-1.4238 0.73828h6.0332a84.486 80.647 0 0 0 0.23437-4.49 84.486 80.647 0 0 0-82.826-80.568zm44.977 38.711c0.01602 0.0333 0.03052 0.0736 0.04687 0.10547 0.36145 0.70357 0.80775 1.0429 1.4434 1.3555a5.2152 5.1534 0 0 1-1.4902-1.4609zm-36.277 4.3555c-0.36856-6e-3 -0.73209 4.2e-4 -1.0879 0.0156 0.71159-0.0305 1.4499-0.0199 2.209 0.0371-0.37955-0.0285-0.75253-0.0469-1.1211-0.0527zm-7.5508 1.2949c-0.62581 0.2005-0.91029 0.27929-1.1484 0.3125 0.23815-0.0332 0.52263-0.112 1.1484-0.3125zm25.275 6.5781c0.3056 0.097 0.58623 0.12221 0.87109 0.0703-0.28426 0.0516-0.56558 0.0262-0.87109-0.0703zm-22.408 3.9629c-1.2281-3e-3 -2.2012 0.0422-2.8496 0.0723-1.2968 0.06-1.2961 0.0586-1.2891 1.0371l0.027344 3.9141c0.0038596 0.5344 0.014311 0.76952 0.21875 0.83594 0.007295 2e-3 0.015616 4e-3 0.023438 6e-3 0.051618 0.0127 0.1158 0.0186 0.19336 0.0137 0.006635 0 0.012684-9.5e-4 0.019531-2e-3 0.18371-0.0143 0.43548-0.0652 0.80469-0.14453 1.2518-0.26903 3.7536-0.80657 6.1191-0.20703 2.3655 0.59955 4.5963 2.336 5.5586 4.5352 0.96234 2.1991 0.65582 4.8621 0.49219 6.2754-0.16364 1.4133-0.18423 1.5764 1.127 1.4277 1.3112-0.14872 3.9176-0.60403 6.0859 0.22656s3.8815 2.9516 4.3965 5.2148c0.51502 2.2632-0.16512 4.6602-0.50781 5.8691-0.08989 0.31712-0.15363 0.54442-0.19141 0.71679-0.0062 0.0291-0.0013 0.0407-0.0059 0.0664-0.07251 0.3986 0.04585 0.42365 0.47266 0.41601 0.61744-0.0111 1.9773-0.0357 2.8828-0.0293 0.90551 6e-3 1.4189 0.0412 1.7441 8e-3 0.32523-0.0337 0.46338-0.1347 0.53125-0.18555 0.06787-0.0509 0.06697-0.0507 0.25977-2.5234 0.1928-2.4728 0.57796-7.4181-1.0898-12.074-1.6678-4.6565-5.3877-9.0255-9.2949-11.594-3.9072-2.5686-8.0018-3.3364-11.346-3.6605-1.6719-0.16204-3.1547-0.21184-4.3828-0.21484zm36.67 28.619c-0.06821 0.31356-0.1224 0.51913-0.17969 0.72461 0.0581-0.19817 0.11502-0.42734 0.17969-0.72461z',transform:'rotate(0 0 0)'},{d:'m162.09 51.232a13.245 13.245 0 0 1-13.245 13.245 13.245 13.245 0 0 1-13.245-13.245 13.245 13.245 0 0 1 13.245-13.245 13.245 13.245 0 0 1 13.245 13.245z',transform:'rotate(0 0 0)'},{d:'m18.578 0.20385c0.08487 0.21856 0.16967 0.43662 0.2793 0.66992 1.1457 2.438 3.791 5.7494 6.541 9.166 2.75 3.4167 5.6055 6.9387 7.6992 9.6367 2.0937 2.6979 3.4264 4.5717 4.2285 5.8945s1.0728 2.0933 1.4375 2.8438c0.36474 0.75043 0.82278 1.4803 1.2188 1.9805s0.72837 0.77084 1.0098 0.57227c0.2814-0.19856 0.51201-0.86606 1.627-1.9492 1.1149-1.0832 3.1146-2.5823 5.0938-3.5508s3.9393-1.4065 5.5215-2.5 2.79-2.8453 3.6543-4.2617 1.3864-2.4999 1.6465-3.041c0.26013-0.54106 0.26049-0.54157 1.4375 1.125 1.177 1.6666 3.5297 5 4.707 8.0625s1.1777 5.8521 1.1777 8.1758 5.78e-4 4.178 0.32422 5.043c0.32364 0.86495 0.96941 0.74054 1.959 0.17773 0.98957-0.56282 2.3229-1.5643 3.8223-2.9492s3.1669-3.1561 4.5-4.1348c1.3331-0.97871 2.3339-1.167 2.875-0.49024 0.54107 0.67672 0.62303 2.2194 0.62305 4.2305s-0.08331 4.4872-0.46875 6.7383c-0.38543 2.2511-1.0705 4.2684-1.4355 5.6445-0.36505 1.3762-0.40802 2.1055 0.30078 3.2109 0.7088 1.1055 2.1674 2.5837 3.2402 4.625s1.759 4.6439 2.3633 7.0508 1.126 4.6149 2.1055 6.793c0.9795 2.178 2.4161 4.3219 3.9375 5.6035s3.1254 1.6981 5.2402 1.625 4.7397-0.63493 8.8125-0.72852c4.0728-0.0936 9.594 0.28065 13.281 0.38477 3.6873 0.10411 5.5421-0.0626 6.375 0.25976 0.83292 0.32238 0.64549 1.1354 0.50976 2.9922-0.13572 1.8568-0.22002 4.7457-0.38671 7.6113-0.1667 2.8656-0.41533 5.698-0.55079 8.5527s-0.15689 5.7282 0.13477 8.0938 0.89458 4.2184 2.041 5.8652c1.1464 1.6469 2.8338 3.0833 5.334 4.2188s5.8132 1.9687 8.1465 2.5625c2.3333 0.59375 3.688 0.9494 5 1.5117s2.5836 1.3329 3.4375 1.9785 1.291 1.1673 2.1875 1.3965c0.89651 0.22918 2.2506 0.16679 4.0215-0.0625 1.7709-0.22924 3.9576-0.62639 6.207-0.94921s4.5642-0.57241 6.2617-0.35352 2.78 0.90564 2.9473 1.582c0.16721 0.6764-0.58127 1.3436-1.4785 2.3867-0.89725 1.0431-1.9381 2.4567-2.9492 3.6348-1.0111 1.178-1.9874 2.114-2.5195 2.8125-0.53218 0.69851-0.61555 1.1549-0.99024 1.832-0.37468 0.67709-1.0396 1.5721-1.0918 2.084-0.0522 0.51195 0.509 0.63775 0.99804 0.50195 0.48904-0.13579 0.90817-0.53409 1.6152-0.7832s1.7087-0.35288 2.5312-0.42578c0.82252-0.073 1.4681-0.11496 2.4668 0.041 0.9987 0.15609 2.3554 0.51125 4.1465 1.084s4.0205 1.364 6.1035 2.166c2.083 0.80198 4.0212 1.6156 5.125 2.2715s1.3758 1.1557 1.2305 1.5723-0.70706 0.75052-1.5938 1.293-2.0917 1.2888-3.416 2.3106c-1.3243 1.0217-2.7594 2.3124-3.8125 3.584s-1.7191 2.5196-2.1465 3.8223-0.61585 2.6559-1.1992 3.709c-0.58337 1.0531-1.5601 1.801-2.373 2.3848-0.813 0.58372-1.457 1.0001-2.041 1.2402-0.58401 0.24017-1.1038 0.30325-0.66601 0.68945 0.43784 0.38619 1.8307 1.0931 4.3828 2.4473s6.2612 3.3542 9.2715 5.4688 5.3229 4.3437 7.0625 5.9375 2.9064 2.5522 4.4062 3.9375 3.332 3.1966 4.457 4.2695c1.125 1.073 1.5418 1.4063 2.2812 1.9375 0.29175 0.20956 0.63427 0.45943 0.97265 0.89257v-88.885c-0.0911-0.0461-0.16926-0.0858-0.27148-0.14063-0.42583-0.22831-1.2775-0.68517-2.0801-2.1582-0.80258-1.473-1.556-3.9618-1.8359-6.2363s-0.088-4.3353 0.30274-6.7559c0.39082-2.4206 0.98173-5.2013 1.3027-7.1777 0.32101-1.9765 0.37376-3.1488 0.43945-3.9551 0.0657-0.80625 0.14362-1.245 0.0312-1.6387-0.11158-0.39364-0.41196-0.74331-1.2402-0.85547-0.82828-0.11215-2.182 0.0123-3.543 0.6875-1.361 0.67513-2.7232 1.8999-3.6211 2.6758-0.89787 0.7759-1.328 1.1008-1.6289 0.95313-0.30092-0.14767-0.4685-0.76649-0.55859-1.3223-0.0901-0.55578-0.10637-1.0474 0.01-1.9512 0.11202-0.90377 0.34707-2.22 0.56641-3.3848 0.21935-1.1648 0.42272-2.1769 1.0527-3.4238 0.63001-1.2469 1.6866-2.7289 2.5977-3.9512 0.91105-1.2222 1.6777-2.1858 2.4746-3.0469 0.79691-0.86104 1.6256-1.6194 2.0391-1.998s0.41189-0.37897 0.4043-0.7168c-8e-3 -0.33783-0.0214-1.0124-0.55664-1.5625-0.53527-0.55014-1.5917-0.97686-2.5586-1.6816-0.96691-0.70477-1.8409-1.6854-2.4883-2.7441-0.64737-1.0587-1.0666-2.1939-1.4551-3.1426-0.3885-0.94869-0.74549-1.7112-1.1152-2.9707-0.36975-1.2595-0.75195-3.0165-1.0606-4.6133-0.30861-1.5968-0.54402-3.032-0.47851-4 0.0655-0.96796 0.42983-1.4674 0.98437-1.543 0.55455-0.0755 1.2984 0.27122 2.291 0.46875 0.99263 0.19752 2.2338 0.246 3.3496-2e-3 1.1158-0.24721 2.1075-0.78884 2.7715-1.3203 0.66403-0.53148 1.0018-1.0516 1.1856-1.8457 0.18372-0.7941 0.21406-1.8635-0.19141-2.7617-0.40546-0.89822-1.2465-1.6257-2.1289-2.6777-0.5342-0.6369-1.081-1.3795-1.6035-2.0352a19.53 19.53 0 0 1-11.791-12c-0.55305-0.42839-1.1428-0.86818-1.6562-1.2988-1.0521-0.88238-1.7795-1.7234-2.6777-2.1289-0.89823-0.40547-1.9676-0.37513-2.7617-0.19141-0.7941 0.18371-1.3142 0.52152-1.8457 1.1856-0.53147 0.66402-1.0731 1.6557-1.3203 2.7715-0.24724 1.1158-0.19892 2.357-2e-3 3.3496 0.19753 0.99262 0.54425 1.7365 0.46875 2.291-0.0755 0.55454-0.57501 0.91887-1.543 0.98437s-2.4032-0.1699-4-0.47851c-1.5968-0.3086-3.3538-0.6908-4.6133-1.0606-1.2595-0.36974-2.022-0.72673-2.9707-1.1152-0.9487-0.38851-2.0839-0.80771-3.1426-1.4551-1.0587-0.64736-2.0394-1.5214-2.7441-2.4883-0.70478-0.96691-1.1315-2.0233-1.6816-2.5586-0.55013-0.53524-1.2247-0.54864-1.5625-0.55664s-0.33814-9e-3 -0.7168 0.4043c-0.37866 0.41344-1.137 1.2422-1.998 2.0391-0.86104 0.7969-1.8246 1.5636-3.0469 2.4746s-2.7042 1.9676-3.9512 2.5977c-1.2469 0.63001-2.259 0.83338-3.4238 1.0527-1.1648 0.21934-2.481 0.45439-3.3848 0.56641-0.90378 0.11232-1.3954 0.0993-1.9512 0.01-0.55578-0.0901-1.1746-0.25767-1.3223-0.55859-0.14767-0.30093 0.17722-0.73104 0.95312-1.6289 0.7759-0.89788 2.0006-2.2601 2.6758-3.6211 0.67518-1.361 0.79964-2.7147 0.6875-3.543-0.11217-0.82827-0.46183-1.1287-0.85547-1.2402-0.39365-0.11157-0.83243-0.0343-1.6387 0.0312-0.80625 0.0657-1.9786 0.11845-3.9551 0.43946-1.9765 0.321-4.7571 0.91191-7.1777 1.3027-2.4206 0.39077-4.4813 0.58263-6.7559 0.30273-2.2745-0.2799-4.7633-1.0334-6.2363-1.8359-1.473-0.80258-1.9299-1.6542-2.1582-2.0801-0.0523-0.0975-0.0882-0.17173-0.13281-0.25977zm-17.855 0.9082c0.33177 0.30591 0.68923 0.65849 1.1992 1.1777-0.50086-0.50996-0.87158-0.87468-1.1992-1.1777zm181.47 6.0508c0.25326 0.215 0.4789 0.42256 0.66211 0.6211-0.18281-0.19811-0.40966-0.40679-0.66211-0.6211zm8.7969 8.4336c-0.14171 0.18644-0.23797 0.33651-0.3086 0.46679 0.0705-0.12997 0.16733-0.28093 0.3086-0.46679zm-31.686 1.1621c0.0533-0.0122 0.10057-0.0102 0.14258 8e-3 0.33611 0.14117 0.32832 1.2804 0.72656 3.7285 0.32963 2.0263 0.92621 4.9423 0.8418 7.4121 3.1822-0.0959 5.8179-0.0582 7.1699-0.0293 3.388 0.0725 3.3893 0.0722 3.4102 0.0879 0.0217 0.0157 0.0567 0.0464 0.0137 4.7129-0.0146 1.5857-0.0548 3.7512-0.17969 6.209 0.61887-0.10319 1.1536-0.15064 1.5078-0.17969 0.17986-0.0147 0.3162-0.0258 0.43555-0.0293 0.35804-0.0106 0.57463 0.0471 1.4473 0.27539 1.1635 0.30436 3.4863 0.91153 5.1992 1.2226 1.7129 0.31112 2.8065 0.32352 2.9004 0.67579 0.0939 0.35226-0.81268 1.045-2.5059 2.8574-1.4852 1.5898-3.5739 4.0398-5.7051 5.459 0.95052 1.6562 1.7682 3.172 2.4375 4.4238l2.4844 4.6504c-2.9603 2.1416-5.9238 4.2749-8.9434 6.2402 0.46092 0.57247 0.81296 1.0994 1.0312 1.4355 0.39314 0.60538 0.39193 0.60475 0.67579 1.7734 0.28386 1.1687 0.85021 3.5007 1.3887 5.1562 0.53845 1.6556 1.0468 2.6253 0.78125 2.875-0.2656 0.24973-1.3045-0.2205-3.7031-0.85156-2.3987-0.63107-6.1564-1.4239-8.4062-2.9727-0.12158-0.0837-0.22119-0.17767-0.33398-0.26562-1.0474 1.9409-2.0152 3.6283-2.748 4.8906-2.3891 4.115-2.3892 4.1166-6.6191 2.0293-1.1773-0.58096-2.6984-1.341-4.3984-2.2539-0.154 0.34212-0.3201 0.71729-0.42773 0.93164-0.32391 0.64509-0.32418 0.64517-1.1894 1.4805-0.86528 0.8353-2.5912 2.5018-3.748 3.8027s-1.7382 2.2281-2.0879 2.125c-0.34969-0.1031-0.46784-1.2361-1.1348-3.625-0.56191-2.0128-1.5022-4.9123-1.668-7.4062-3.4865-0.0511-6.4312-0.24229-7.9336-0.35157-3.759-0.27338-3.76-0.27366-3.7812-0.28906s-0.0593-0.0464-0.0977-4.7129c-0.0134-1.6331-9e-3 -3.8813 0.082-6.4356-0.65443 0.0145-1.2098-0.0209-1.5762-0.0449-0.7203-0.0472-0.71989-0.0478-1.8262-0.51953-1.1063-0.47176-3.3161-1.4136-4.9648-1.9727-1.6487-0.55903-2.7283-0.73152-2.7695-1.0938-0.0412-0.36224 0.95769-0.91257 2.8984-2.457 1.4121-1.1238 3.3232-2.7669 5.2559-3.9199-1.1482-2.0342-2.1187-3.8975-2.8828-5.3887-2.4041-4.6914-2.4051-4.677 1.9668-7.0371 1.3955-0.75335 3.2942-1.7641 5.4688-2.8535-0.53857-0.85601-0.94236-1.825-1.2578-3.0488-0.4739-1.8388-0.77546-4.2223-1.125-5.9277-0.3495-1.7055-0.74504-2.723-0.45312-2.9414 0.0365-0.0273 0.0833-0.0437 0.14258-0.0469 0.41459-0.0224 1.4177 0.52271 3.4414 1.3066 1.8505 0.71684 4.5425 1.6408 6.6055 2.8965 0.95859-1.8384 1.8435-3.4374 2.5371-4.6738 2.3902-4.2608 2.5339-4.4674 2.6797-4.6758 3.4678 1.7512 6.9197 3.5223 10.254 5.4336 0.33218-0.6432 0.66484-1.1696 0.88086-1.502 0.39335-0.60525 0.39324-0.6055 1.3457-1.3398s2.8546-2.2004 4.1484-3.3652c1.1321-1.0192 1.7932-1.8033 2.166-1.8887zm33.41 1.2012c0.13804 0.16087 0.27742 0.33144 0.41992 0.50976-0.14208-0.17767-0.28279-0.35179-0.41992-0.50976zm-192.71 65.238v14.279c0.17577 5e-3 0.33496 0.0129 0.5332 0.0215 1.4581 0.0627 3.5397 0.43832 4.998 0.52148 1.4584 0.0832 2.2924-0.12659 3.0625-0.73047 0.77015-0.60389 1.4805-1.6046 1.9961-2.6211s0.83923-2.0515 1.4512-2.8281c0.61194-0.77668 1.5113-1.2968 4.0449-0.93359 2.5336 0.36323 6.7018 1.6081 11.299 2.7734 4.5971 1.1654 9.6219 2.2506 12.162 3.0449 2.5402 0.79428 2.5965 1.2989 2.459 2.4707-0.13749 1.1718-0.46693 3.009-0.49219 4.2246s0.25318 1.8019 0.9668 2.4902c0.71362 0.68831 1.8568 1.4744 3.5254 2.4629s3.86 2.1765 6.1348 3.5137 4.6314 2.8232 6.3262 3.9004 2.7263 1.7459 4.0078 1.0156c1.2815-0.73025 2.8127-2.8595 4.1602-3.7676 1.3474-0.90812 2.5125-0.59629 4.457 1.1934 1.9445 1.7896 4.6682 5.0571 7.1426 7.7129s4.6992 4.7008 6.0352 6.2207c1.336 1.52 1.7846 2.5164 1.1562 3.8164-0.62839 1.3-2.3337 2.9015-3.2051 4.2168-0.87142 1.3153-0.90555 2.3393 0.10352 4.377s3.0553 5.081 4.748 8.0273c1.6927 2.9464 3.0283 5.7908 3.9434 7.4785 0.91506 1.6877 1.4094 2.2164 2.7383 2.2285s3.4904-0.49222 4.7734-0.88867c1.283-0.39644 1.6888-0.68494 2.5215 1.8359s2.0952 7.851 3.2891 12.666 2.318 9.113 2.6406 11.748c0.32262 2.6351-0.15676 3.6038-0.85938 4.3887-0.70261 0.78483-1.6271 1.3828-2.5117 1.8106-0.88467 0.4278-1.7291 0.68513-2.2773 1.043s-0.79832 0.81609-0.71485 2.0898c0.0835 1.2738 0.49999 3.3517 0.69727 4.6562s0.1738 1.83 0.60547 2.1484c0.0997 0.0735 0.2341 0.13252 0.4043 0.18555h12.412a117.37 110.73 0 0 0 0.32618-6.166 117.37 110.73 0 0 0-115.06-110.63zm-0.0058594 24.994v6.7461a84.486 80.647 0 0 1 82.826 80.568 84.486 80.647 0 0 1-0.23437 4.4902h5.9805a90.603 87.044 0 0 0 0.25-4.8457 90.603 87.044 0 0 0-88.822-86.959zm43.604 42.664c-0.40387-0.0232-1.1517 0.45613-2.793 2.0137-2.626 2.4921-7.5431 7.7482-10.266 10.541-2.7225 2.7928-3.2503 3.1218-5.1387 1.9688-1.8883-1.153-5.1356-3.7887-8.4004-5.3711-3.2647-1.5824-6.5482-2.1102-9.3945-1.9883-2.8464 0.12196-5.257 0.89295-6.4629 1.2793-0.70756 0.22669-0.99754 0.31219-1.2539 0.33399v10.928c0.029843-0.5442 0.20776-0.59919 1.2715-0.64844 1.2968-0.06 3.8885-0.1815 7.2324 0.14258 3.3439 0.32408 7.4385 1.0919 11.346 3.6602 3.9072 2.5682 7.6271 6.9376 9.2949 11.594 1.6678 4.6561 1.2826 9.6014 1.0898 12.074-0.1928 2.4728-0.1919 2.4726-0.25977 2.5234-0.03318 0.0249-0.08396 0.0622-0.16406 0.0977 0.31199 0.0768 0.75553 0.0807 1.4258 0.082 1.8985 4e-3 5.5453 0.0119 7.3711 0.0156 1.8258 4e-3 1.8254 4e-3 2.1836-1.6426 0.35817-1.6466 1.0743-4.935 1.0547-7.8848-0.01961-2.9498-0.77426-5.5568-2.1895-8.3457s-3.4853-5.7504-4.5566-7.5644c-1.0713-1.8141-1.1337-2.4616 1.7852-5.3047s8.8051-7.8694 11.303-10.467c2.4976-2.5973 1.5878-2.7472 0.71875-2.9648-0.86903-0.21761-1.6951-0.5035-2.332-0.81641-0.63694-0.31291-1.0834-0.65293-1.4453-1.3574s-0.63917-1.7714-0.94531-2.4394c-0.1148-0.25051-0.23228-0.44509-0.47461-0.45899zm140.2 46.201c0.0471 0.0578 0.0979 0.11585 0.14258 0.17383-0.0446-0.0581-0.0955-0.11587-0.14258-0.17383zm0.51758 0.74414c0.0882 0.13833 0.19289 0.27824 0.26758 0.41407-0.074-0.1357-0.1799-0.2758-0.26758-0.41407zm0.62695 1.2109c0.0137 0.0362 0.0361 0.0757 0.0488 0.11133-0.0125-0.0357-0.0352-0.0751-0.0488-0.11133z',transform:'rotate(0 0 0)'},{d:'m54.546 150.8a5.2152 5.1534 0 0 1-5.2152 5.1534 5.2152 5.1534 0 0 1-5.2152-5.1534 5.2152 5.1534 0 0 1 5.2152-5.1534 5.2152 5.1534 0 0 1 5.2152 5.1534z',transform:'rotate(0 0 0)'}],colorScheme:[['#ededed','#c5bcbd','#accef2','#f9f9f9','#accef2'],['#ededed','#59f','#accef2','#f9f9f9','#accef2'],['#ffe680','#59f','#ff7f2a','#f9f9f9','#ff7f2a']],rotations:[-90,0,-90,0,180,90,180,90,-90,0,-90,0,180,90,180,90]},{paths:[{d:'m0.042969 0.044922-0.042969 99.955 50-50-49.957-49.955zm149.91 149.91-49.955 49.957 99.955 0.04297-50-50z',transform:'rotate(0 0 0)'},{d:'m50 50 99.955 99.955-49.955 49.957-100-99.912 50-50',transform:'rotate(0 0 0)'},{d:'m0.042969 100.04v99.912h199.91l-99.955-0.04297z',transform:'rotate(0 0 0)'},{d:'m99.955 0.04297 99.955 99.955-49.955 49.957-100-99.912 50-50',transform:'rotate(0 0 0)'},{d:'m99.955 0.042969-99.912 0.0019531 49.912 49.998 50-50zm99.955 99.955-49.955 49.957 50 50-0.04492-99.957z',transform:'rotate(0 0 0)'},{d:"M 199.91,99.998 99.955,0.043 199.995,3e-5 l -0.0898,99.998",transform:'rotate(0 0 0)'}],colorScheme:[['#f55','#fff','#c6bdbe','#4d4d4d','#fff','#fff'],['#f55','#fff','#c6bdbe','#4d4d4d','#fff','#c6bdbe'],['#accef3','#fff','#c6bdbe','#4d4d4d','#fff','#c6bdbe'],['#87a581','#fff','#8d5fd3','#4d4d4d','#fff','#8d5fd3']],rotations:[-90,0,-90,0,180,90,180,90,-90,0,-90,0,180,90,180,90]},{paths:[{d:'m152.85 0.0019531a47.301 47.292 0 0 0 47.301 47.291v-12.189c-0.11645 0.08786-0.24073 0.12373-0.38281 0.14258-0.65145 0.08643-1.6129 0.06153-2.8223-0.28125-1.2094-0.34278-2.6671-1.0022-3.709-1.9258-1.0419-0.92353-1.6653-2.1089-1.8418-3.209-0.17644-1.1001 0.0957-2.1119 0.67579-3.4434 0.5801-1.3315 1.4645-2.9753 2.4102-4.5352 0.94561-1.5599 1.9468-3.0279 2.2461-4.2891s-0.10404-2.3122-1.0176-3.9746c-0.91354-1.6624-2.3362-3.9346-4.1524-5.8926-1.8162-1.958-4.0268-3.6015-5.668-4.1387-1.6412-0.5372-2.7146 0.032121-3.8633 0.68555-1.1487 0.65343-2.3727 1.3899-3.9394 2.3574-1.5668 0.96751-3.4756 2.1654-5.3047 2.6152-1.8291 0.44987-3.5776 0.15142-4.6894-0.7168s-1.5858-2.302-1.748-3.7578c-0.16227-1.4558-0.0123-2.928 0.0625-3.6641 0.0716-0.70356 0.0797-0.74519 0.1836-1.0742z',transform:'rotate(0 0 0)'},{d:'m166.59 0.0019531c-0.10387 0.32902-0.11205 0.37066-0.1836 1.0742-0.0748 0.73602-0.22477 2.2082-0.0625 3.6641 0.16228 1.4558 0.6362 2.8896 1.748 3.7578s2.8603 1.1667 4.6894 0.7168c1.8291-0.44987 3.7379-1.6477 5.3047-2.6152 1.5668-0.96751 2.7907-1.704 3.9394-2.3574s2.2221-1.2227 3.8633-0.68555c1.6412 0.5372 3.8518 2.1807 5.668 4.1387 1.8162 1.958 3.2388 4.2302 4.1524 5.8926 0.91354 1.6624 1.3168 2.7135 1.0176 3.9746s-1.3005 2.7292-2.2461 4.2891c-0.94561 1.5599-1.83 3.2037-2.4102 4.5352-0.58011 1.3315-0.85224 2.3432-0.67579 3.4434 0.17646 1.1001 0.79992 2.2855 1.8418 3.209 1.0419 0.92353 2.4996 1.583 3.709 1.9258s2.1708 0.36768 2.8223 0.28125c0.14208-0.01885 0.26636-0.05472 0.38281-0.14258v-35.102z',transform:'rotate(0 0 0)'},{d:'m12.77-0.0625c2.5351 0.062128 4.9288 0.10843 6.5117 0.19531 3.69 0.20254 3.2489 0.64394 7.5566 2.4277 4.3077 1.7838 13.363 4.9087 21.635 9.0488 8.2714 4.1402 15.759 9.294 22.326 15.332s12.216 12.96 16.807 20.463c4.5903 7.5034 8.1208 15.59 10.416 24.152 2.2952 8.5627 3.355 17.603 3.8848 22.123 0.32196 2.7474 0.44562 3.7456 0.54492 4.1719 0.42628 0.0993 1.4245 0.22296 4.1719 0.54492 4.5202 0.52971 13.56 1.5895 22.123 3.8848 8.5627 2.2952 16.649 5.8257 24.152 10.416 7.5034 4.5903 14.425 10.239 20.463 16.807 6.038 6.5676 11.192 14.055 15.332 22.326 4.1402 8.2714 7.265 17.327 9.0488 21.635 1.7838 4.3077 2.2252 3.8667 2.4277 7.5566 0.0818 1.4899 0.12678 3.7185 0.1836 6.0859l-0.20704-187.11v47.291h-4e-3v6.7891c-0.52554 0.11661-1.0037 0.10134-2.2617 0.01172-2.014-0.14348-6.0431-0.43056-9.3223-0.98828-3.2792-0.55772-5.8062-1.3856-8.418-2.3457-2.6117-0.96011-5.3056-2.0516-7.3789-3.3672s-3.5237-2.8551-5.1328-2.916c-1.6091-0.06096-3.3765 1.3568-5.8047 3.0625-2.4282 1.7057-5.5095 3.6934-8.1856 6.3828-2.676 2.6894-4.9399 6.0741-6.2539 9.0957-1.314 3.0216-1.6747 5.6751-1.7422 8.1445-0.0675 2.4694 0.15996 4.746 0.42773 6.123 0.26773 1.3771 0.57452 1.8501 0.33203 2.3203-0.24248 0.47016-1.0351 0.9374-2.1953 1.1035-1.1602 0.16612-2.6793 0.02877-4.3086-0.28906-1.6293-0.31784-3.3647-0.81632-4.5566-1.2754s-1.8413-0.87765-2.5703-0.70703c-0.72897 0.17062-1.5365 0.93048-2.2207 1.6816-0.68419 0.75116-1.2395 1.4898-2.0918 2.1367-0.85232 0.64694-1.9948 1.196-3.1855 1.6309s-2.4255 0.75291-3.5781 0.94726c-1.1526 0.19436-2.2186 0.26451-3.0976 0.17969s-1.5667-0.32521-2.0254-0.96875c-0.45866-0.64354-0.68765-1.6875-0.68165-2.8926 6e-3 -1.205 0.24726-2.5702 1.0469-4.1328 0.79962-1.5626 2.157-3.3227 3.5059-4.7871s2.6896-2.6332 3.1797-3.6426 0.13155-1.8618-0.5293-2.8262c-0.66085-0.9644-1.6258-2.0423-2.0918-3.3398-0.46591-1.2975-0.43353-2.8139-0.082-4.3242 0.3515-1.5103 1.0218-3.0138 1.8457-3.4375 0.82395-0.42366 1.8014 0.23226 2.5039 0.58398 0.70247 0.35173 1.1295 0.39935 2.4785 0.54297 1.349 0.14363 3.621 0.38304 5.8008 0.09766 2.1798-0.28538 4.2639-1.0934 6.3555-2.4629 2.0916-1.3695 4.1864-3.2984 6.5234-5.8516 2.3371-2.5532 4.9155-5.7296 6.8223-8.166s3.1412-4.1329 3.1055-5.5801-1.341-2.6472-2.2695-3.6953c-0.92853-1.0481-1.4794-1.9424-2.3418-3.8262-0.86245-1.8838-2.0345-4.7531-2.9629-7.7598s-1.6122-6.1502-2.0742-8.7871c-0.46204-2.637-0.70234-4.7665-0.64844-6.2852 0.0539-1.5187 0.41024-2.45 0.69141-3.4062 8e-3 -0.02737 0.0167-0.05473 0.0254-0.082031l-5.5703-0.0019531c-0.54342 0.84331-0.97561 1.7012-1.5977 2.959-0.68208 1.3792-1.607 3.2268-2.9551 4.8125-1.348 1.5857-3.1206 2.9098-5.8047 3.834-2.6841 0.92417-6.279 1.4487-9.625 1.1992-3.346-0.2495-6.4418-1.2733-9.2383-2.3594-2.7966-1.0861-5.2946-2.2349-7.2422-3.2773-1.9476-1.0425-3.3445-1.9791-4.3555-1.9922-1.011-0.013134-1.6359 0.89757-2.0605 1.7402s-0.64888 1.6179-0.79883 2.5293c-0.14995 0.91141-0.22478 1.9589-0.125 3.3574 0.09978 1.3985 0.37429 3.1455 1.2363 4.2949 0.86204 1.1494 2.3089 1.6996 3.5703 2.1367 1.2614 0.4371 2.3336 0.76014 3.1699 1.0723 0.83637 0.31212 1.4359 0.61255 1.4609 1.3359 0.0251 0.72339-0.52312 1.8721-1.1348 2.9707s-1.2856 2.1462-2.1094 2.8457c-0.82372 0.69948-1.798 1.0505-2.7344 1.2754-0.93639 0.22487-1.8359 0.32359-2.0488 0.74805-0.21289 0.42445 0.26227 1.1732 0.88672 1.8477 0.62445 0.67446 1.3987 1.2736 2.2481 1.9355 0.84934 0.66199 1.7708 1.3844 2.8594 1.6094 1.0885 0.22492 2.3332-0.04938 3.0566 0.25 0.72342 0.29938 0.92372 1.173 0.88672 1.8594-0.037 0.6864-0.31205 1.1858-0.67383 1.5605-0.36177 0.37479-0.81045 0.62488-1.5469 1.2363-0.73643 0.61145-1.7621 1.5863-2.3613 2.6719-0.5992 1.0856-0.77441 2.2842-0.72461 3.2207s0.32469 1.611 0.69922 2.5723c0.37453 0.96127 0.84886 2.2092 1.2109 3.5449 0.36206 1.3357 0.61326 2.7593 0.41406 3.8203s-0.84879 1.7605-1.4356 2.3848c-0.58676 0.62422-1.1115 1.1741-1.748 1.6113-0.63658 0.4372-1.3826 0.7595-1.709 0.75976-0.32643 2.62e-4 -0.22624-0.32448-0.0391-1.498 0.18718-1.1736 0.46025-3.1944 0.47265-5.1172s-0.23627-3.7445-0.58593-5.9922c-0.34966-2.2477-0.79829-4.9192-1.6348-7.291-0.83648-2.3718-2.0605-4.4436-3.7207-6.291-1.6602-1.8475-3.7576-3.4709-5.7051-4.8691-1.9475-1.3982-3.7457-2.5715-5.4004-4.2012-1.6547-1.6297-3.1641-3.7142-4.1289-6.0625-0.96479-2.3483-1.3824-4.9556-0.58594-8.1152 0.7965-3.1596 2.8062-6.8657 4.0703-9.0254 0.52214-0.89203 0.88477-1.4573 1.1973-1.9238l-13.154-0.0039063c0.60668 0.98963-0.02457 1.6973-0.47461 2.6289-0.50456 1.0445-0.75649 2.3759-0.82422 3.9824s0.04866 3.4875-0.15625 4.2363c-0.20491 0.74885-0.73039 0.3648-1.5234-0.22656-0.79294-0.59137-1.8531-1.3902-3.3847-2.3359s-3.5353-2.0393-6.1895-3.3301-5.9605-2.7774-7.2148-3.9395c-0.39947-0.37007-0.56934-0.7054-0.5918-1.0234zm187.38 0.064453-43.461-0.015625c4e-3 0.0051994 8e-3 0.010093 0.0117 0.015625h9.8887zm-47.1 4.0254c0.075 0.78022 0.16947 1.5585 0.2832 2.334-0.11373-0.77553-0.20816-1.5538-0.2832-2.334zm-144.82 4.207 0.00586 0.00586c1.4649 0.040819 3.0913 0.1464 4.873 0.33984-1.7904-0.19744-3.4148-0.30461-4.8789-0.3457zm4.9512 0.35156c0.77255 0.084751 1.5886 0.19538 2.4199 0.31641-0.83464-0.12245-1.6432-0.22988-2.4199-0.31641zm140.51 0.14453c0.14981 0.75071 0.31783 1.4977 0.50391 2.2402-0.18608-0.74256-0.3541-1.4895-0.50391-2.2402zm-137.62 0.23633c0.95878 0.14615 1.9519 0.31504 2.9863 0.51562-1.0332-0.20034-2.0249-0.36814-2.9863-0.51562zm138.73 4.3594c0.22607 0.74026 0.47028 1.4749 0.73242 2.2031-0.26214-0.72827-0.50635-1.4629-0.73242-2.2031zm1.5508 4.4473c0.30253 0.72203 0.62294 1.4364 0.96094 2.1426-0.338-0.70613-0.65841-1.4205-0.96094-2.1426zm1.9961 4.2852c0.37181 0.68726 0.76061 1.3652 1.166 2.0332-0.40541-0.668-0.79421-1.3459-1.166-2.0332zm2.4062 4.0566c0.44284 0.65331 0.90197 1.2954 1.377 1.9258-0.47499-0.63034-0.93412-1.2725-1.377-1.9258zm2.8008 3.7988c0.5096 0.61014 1.0345 1.2073 1.5742 1.791-0.53971-0.58368-1.0646-1.1809-1.5742-1.791zm3.1719 3.5059c0.5633 0.55144 1.1403 1.0887 1.7305 1.6113-0.59016-0.52261-1.1672-1.0599-1.7305-1.6113zm3.5059 3.1699c0.62058 0.497 1.2536 0.97827 1.8984 1.4434-0.64485-0.46509-1.2779-0.94636-1.8984-1.4434zm3.793 2.7988c0.66779 0.43241 1.3464 0.84791 2.0352 1.2461-0.68876-0.39819-1.3674-0.81368-2.0352-1.2461zm4.0762 2.418c0.69716 0.35798 1.4031 0.69858 2.1172 1.0215-0.71409-0.32291-1.42-0.66351-2.1172-1.0215zm4.2852 1.9922c0.72953 0.28714 1.4661 0.55611 2.209 0.80664-0.7429-0.25054-1.4794-0.5195-2.209-0.80664zm4.4629 1.5547c0.7516 0.21206 1.5084 0.40548 2.2695 0.58008-0.76118-0.1746-1.5179-0.36802-2.2695-0.58008zm4.5976 1.1016c0.76978 0.13567 1.5428 0.25224 2.3184 0.34961-0.77556-0.09737-1.5486-0.21394-2.3184-0.34961zm8.6758 13.014v56.396c-0.47876 0.32343-1.0966 0.71833-2.0449 1.2734-2.1597 1.2642-5.8658 3.2738-9.0254 4.0703-3.1596 0.7965-5.7669 0.37887-8.1152-0.58593-2.3483-0.96479-4.4328-2.4742-6.0625-4.1289s-2.803-3.4529-4.2012-5.4004-3.0217-4.0448-4.8691-5.7051c-1.8475-1.6602-3.9192-2.8842-6.291-3.7207-2.3718-0.83648-5.0433-1.2851-7.291-1.6348-2.2477-0.34964-4.0694-0.59833-5.9922-0.58593s-3.9436 0.28548-5.1172 0.47266c-1.1736 0.18718-1.4983 0.28737-1.498-0.03906 2.6e-4 -0.32638 0.32257-1.0724 0.75977-1.709 0.4372-0.63659 0.9871-1.1613 1.6113-1.748 0.62422-0.58676 1.3237-1.2363 2.3848-1.4355s2.4846 0.052 3.8203 0.41406c1.3357 0.36208 2.5837 0.83641 3.5449 1.2109s1.6358 0.64945 2.5723 0.69922c0.93651 0.0498 2.1351-0.12541 3.2207-0.72461 1.0856-0.59919 2.0604-1.6249 2.6719-2.3613 0.61145-0.73642 0.86154-1.1851 1.2363-1.5469 0.37479-0.36178 0.87414-0.63679 1.5605-0.67383 0.6864-0.037 1.56 0.1633 1.8594 0.88672 0.2994 0.72342 0.0251 1.9681 0.25 3.0566 0.22493 1.0885 0.94738 2.01 1.6094 2.8594 0.66199 0.84935 1.2611 1.6236 1.9356 2.248 0.67446 0.62445 1.4232 1.0996 1.8477 0.88672 0.42446-0.2129 0.52317-1.1125 0.74804-2.0488 0.22487-0.93636 0.57593-1.9107 1.2754-2.7344 0.69949-0.82373 1.7471-1.4977 2.8457-2.1094 1.0986-0.61164 2.2473-1.1598 2.9707-1.1348 0.72339 0.025 1.0238 0.62457 1.3359 1.4609 0.31212 0.83637 0.63516 1.9085 1.0723 3.1699 0.43711 1.2614 0.98727 2.7083 2.1367 3.5703 1.1494 0.86204 2.8964 1.1365 4.2949 1.2363 1.3985 0.0998 2.446 0.025 3.3574-0.125 0.91141-0.14994 1.6866-0.37414 2.5293-0.79883 0.84266-0.42468 1.7533-1.0496 1.7402-2.0606-0.0131-1.0109-0.94974-2.4078-1.9922-4.3555-1.0425-1.9476-2.1912-4.4456-3.2773-7.2422-1.0861-2.7965-2.1099-5.8923-2.3594-9.2383s0.27505-6.9409 1.1992-9.625 2.2483-4.4567 3.834-5.8047c1.5857-1.348 3.4333-2.273 4.8125-2.9551 1.325-0.65525 2.2124-1.0931 3.0996-1.6797zm-0.85351 69.67c0.22153 0.0208 0.45359 0.098 0.70312 0.25391v20.354c-0.32034-0.0202-0.65816-0.19102-1.0312-0.59375-1.162-1.2544-2.6487-4.5607-3.9394-7.2148-1.2908-2.6542-2.3843-4.6579-3.3301-6.1894-0.94576-1.5315-1.7446-2.5917-2.3359-3.3848-0.59136-0.79305-0.97541-1.3185-0.22656-1.5234 0.74885-0.20495 2.6298-0.0885 4.2363-0.15625 1.6065-0.0677 2.9379-0.31964 3.9824-0.82421 0.70254-0.33938 1.2768-0.78321 1.9414-0.72071zm-7.2344 61.793c9e-3 0.18931 0.0205 0.38385 0.0273 0.56836-7e-3 -0.18582-0.0179-0.37747-0.0273-0.56836z',transform:'rotate(0 0 0)'},{d:'m146.79-0.058594c-0.0121 0.041853-0.0268 0.083258-0.0391 0.125-0.28117 0.95622-0.63748 1.8876-0.69141 3.4062-0.0539 1.5187 0.1864 3.6482 0.64844 6.2852 0.46204 2.637 1.1458 5.7804 2.0742 8.7871s2.1004 5.876 2.9629 7.7598c0.86245 1.8838 1.4133 2.7781 2.3418 3.8262 0.92853 1.0481 2.2338 2.2482 2.2695 3.6953s-1.1987 3.1436-3.1055 5.5801-4.4852 5.6129-6.8223 8.166c-2.3371 2.5532-4.4318 4.482-6.5234 5.8516-2.0916 1.3695-4.1757 2.1775-6.3555 2.4629-2.1798 0.28538-4.4518 0.04597-5.8008-0.09766-1.349-0.14363-1.776-0.19124-2.4785-0.54297-0.70247-0.35173-1.68-1.0076-2.5039-0.58398-0.82392 0.42366-1.4942 1.9272-1.8457 3.4375s-0.38391 3.0267 0.082 4.3242c0.46595 1.2975 1.431 2.3754 2.0918 3.3398 0.66085 0.9644 1.0194 1.8168 0.5293 2.8262s-1.8308 2.1782-3.1797 3.6426-2.7062 3.2245-3.5059 4.7871c-0.79962 1.5626-1.0406 2.9278-1.0469 4.1328-6e-3 1.205 0.22299 2.249 0.68165 2.8926 0.45865 0.64354 1.1463 0.88394 2.0254 0.96875 0.87909 0.08482 1.9451 0.01467 3.0976-0.17969 1.1526-0.19436 2.3874-0.5124 3.5781-0.94726s2.3332-0.98392 3.1855-1.6309c0.85232-0.64694 1.4076-1.3856 2.0918-2.1367 0.68419-0.75116 1.4917-1.511 2.2207-1.6816 0.72898-0.17062 1.3783 0.24796 2.5703 0.70703s2.9273 0.95756 4.5566 1.2754 3.1484 0.45518 4.3086 0.28906c1.1602-0.16611 1.9528-0.63335 2.1953-1.1035 0.24249-0.47017-0.0643-0.94323-0.33203-2.3203-0.26777-1.3771-0.49523-3.6536-0.42773-6.123 0.0675-2.4694 0.42818-5.1229 1.7422-8.1445 1.314-3.0216 3.5779-6.4063 6.2539-9.0957 2.676-2.6894 5.7573-4.6771 8.1856-6.3828 2.4282-1.7057 4.1956-3.1235 5.8047-3.0625 1.6091 0.06096 3.0596 1.6004 5.1328 2.916s4.7672 2.4071 7.3789 3.3672c2.6117 0.96011 5.1388 1.788 8.418 2.3457 3.2792 0.55772 7.3082 0.8448 9.3223 0.98828 1.258 0.08962 1.7362 0.10489 2.2617-0.01172v-6.7891a47.301 47.292 0 0 1-47.297-47.291h3.8516c-0.0147-0.021353-0.0302-0.039401-0.0449-0.060547z',transform:'rotate(0 0 0)'},{d:'m84.891-0.1582c-0.32342 0.47876-0.71833 1.0966-1.2734 2.0449-1.2642 2.1597-3.2738 5.8658-4.0703 9.0254-0.7965 3.1596-0.37885 5.7669 0.58594 8.1152 0.96479 2.3483 2.4742 4.4328 4.1289 6.0625 1.6547 1.6297 3.4529 2.803 5.4004 4.2012 1.9475 1.3982 4.0448 3.0217 5.7051 4.8691 1.6602 1.8475 2.8842 3.9192 3.7207 6.291 0.83648 2.3718 1.2851 5.0433 1.6348 7.291 0.34966 2.2477 0.59833 4.0694 0.58593 5.9922s-0.28547 3.9436-0.47265 5.1172c-0.18718 1.1736-0.28733 1.4983 0.0391 1.498 0.32639-2.61e-4 1.0724-0.32256 1.709-0.75976 0.63659-0.4372 1.1613-0.9871 1.748-1.6113 0.58676-0.62422 1.2364-1.3237 1.4356-2.3848s-0.052-2.4846-0.41406-3.8203c-0.36208-1.3357-0.83641-2.5837-1.2109-3.5449-0.37453-0.96127-0.64945-1.6358-0.69922-2.5723-0.0498-0.93651 0.12541-2.1351 0.72461-3.2207 0.59919-1.0856 1.6249-2.0604 2.3613-2.6719 0.73642-0.61145 1.1851-0.86154 1.5469-1.2363 0.36178-0.37479 0.63679-0.87415 0.67383-1.5605 0.037-0.6864-0.1633-1.56-0.88672-1.8594s-1.9681-0.02508-3.0566-0.25c-1.0885-0.22492-2.01-0.94738-2.8594-1.6094-0.84935-0.66199-1.6236-1.2611-2.2481-1.9355-0.62445-0.67446-1.0996-1.4232-0.88672-1.8477 0.21289-0.42446 1.1125-0.52318 2.0488-0.74805 0.93637-0.22487 1.9106-0.57591 2.7344-1.2754 0.82373-0.69948 1.4977-1.7471 2.1094-2.8457s1.1598-2.2473 1.1348-2.9707c-0.025-0.72339-0.62456-1.0238-1.4609-1.3359-0.83637-0.31212-1.9085-0.63516-3.1699-1.0723-1.2614-0.43711-2.7083-0.98727-3.5703-2.1367-0.86204-1.1494-1.1365-2.8964-1.2363-4.2949-0.09978-1.3985-0.02495-2.446 0.125-3.3574 0.14994-0.91141 0.37414-1.6866 0.79883-2.5293s1.0496-1.7534 2.0605-1.7402 2.4078 0.94973 4.3555 1.9922c1.9476 1.0425 4.4456 2.1912 7.2422 3.2773 2.7965 1.0861 5.8922 2.1099 9.2383 2.3594 3.346 0.2495 6.9409-0.27505 9.625-1.1992 2.6841-0.92417 4.4566-2.2483 5.8047-3.834 1.348-1.5857 2.273-3.4333 2.9551-4.8125 0.65525-1.3249 1.0931-2.2124 1.6797-3.0996zm115.22 59.627c-0.88716 0.58655-1.7746 1.0244-3.0996 1.6797-1.3792 0.68208-3.2268 1.607-4.8125 2.9551-1.5857 1.348-2.9098 3.1206-3.834 5.8047s-1.4487 6.279-1.1992 9.625 1.2733 6.4418 2.3594 9.2383c1.0861 2.7965 2.2349 5.2945 3.2773 7.2422 1.0424 1.9476 1.9791 3.3445 1.9922 4.3555 0.0131 1.011-0.89758 1.6359-1.7402 2.0606-0.84266 0.42469-1.6179 0.64889-2.5293 0.79883-0.91141 0.15-1.9589 0.2248-3.3574 0.125-1.3986-0.0998-3.1455-0.37429-4.2949-1.2363-1.1494-0.86203-1.6996-2.3089-2.1367-3.5703-0.4371-1.2614-0.76014-2.3336-1.0723-3.1699-0.31213-0.83637-0.61255-1.4359-1.3359-1.4609-0.72339-0.02506-1.8721 0.52312-2.9707 1.1348-1.0986 0.61164-2.1462 1.2856-2.8457 2.1094-0.69947 0.82372-1.0505 1.798-1.2754 2.7344-0.22487 0.93637-0.32358 1.8359-0.74804 2.0488-0.42445 0.21289-1.1732-0.26227-1.8477-0.88672-0.67447-0.62445-1.2736-1.3987-1.9356-2.248-0.66199-0.84934-1.3844-1.7709-1.6094-2.8594-0.2249-1.0885 0.0494-2.3332-0.25-3.0566-0.29938-0.72342-1.173-0.92372-1.8594-0.88672-0.6864 0.03704-1.1858 0.31205-1.5605 0.67383-0.37479 0.36177-0.62488 0.81046-1.2363 1.5469-0.61145 0.73643-1.5863 1.7621-2.6719 2.3613-1.0856 0.5992-2.2842 0.77441-3.2207 0.72461-0.93651-0.04977-1.611-0.32469-2.5723-0.69922s-2.2092-0.84886-3.5449-1.2109c-1.3357-0.36206-2.7593-0.61326-3.8203-0.41406s-1.7605 0.84879-2.3848 1.4355c-0.62423 0.58676-1.1741 1.1115-1.6113 1.748-0.4372 0.63658-0.75951 1.3826-0.75977 1.709-2.6e-4 0.32643 0.32449 0.22624 1.498 0.03906 1.1736-0.18718 3.1944-0.46026 5.1172-0.47266s3.7444 0.23628 5.9922 0.58594c2.2477 0.34966 4.9192 0.79829 7.291 1.6348 2.3718 0.83648 4.4436 2.0605 6.291 3.7207 1.8475 1.6602 3.4709 3.7576 4.8691 5.7051s2.5715 3.7457 4.2012 5.4004 3.7142 3.1641 6.0625 4.1289c2.3483 0.9648 4.9556 1.3824 8.1152 0.58593 3.1596-0.79649 6.8657-2.8062 9.0254-4.0703 0.94835-0.55511 1.5662-0.95001 2.0449-1.2734z',transform:'rotate(0 0 0)'},{d:'m51.299-0.056641c0.0202 0.32034 0.19102 0.65816 0.59375 1.0312 1.2544 1.162 4.5607 2.6487 7.2148 3.9395s4.6579 2.3843 6.1895 3.3301 2.5917 1.7446 3.3848 2.3359c0.79304 0.59136 1.3185 0.97541 1.5234 0.22656 0.20491-0.74885 0.08852-2.6298 0.15625-4.2363s0.31965-2.9379 0.82422-3.9824c0.45249-0.93672 1.0904-1.6464 0.4668-2.6445zm147.96 129.2c-0.66459-0.0625-1.2389 0.38134-1.9414 0.72071-1.0445 0.50457-2.3759 0.75651-3.9824 0.82421-1.6065 0.0677-3.4875-0.0487-4.2363 0.15625-0.74885 0.20491-0.3648 0.73039 0.22656 1.5234 0.59138 0.79304 1.3902 1.8532 2.3359 3.3848 0.94576 1.5315 2.0393 3.5353 3.3301 6.1894 1.2908 2.6542 2.7774 5.9605 3.9394 7.2148 0.37309 0.40273 0.71091 0.57355 1.0312 0.59375v-20.354c-0.24953-0.15591-0.48159-0.23309-0.70312-0.25391z',transform:'rotate(0 0 0)'},{d:'m-0.070312-0.066406v9.0176c0.60693-0.17801 1.3408-0.35706 2.4473-0.49805 3.205-0.40839 8.9592-0.46701 16.676 1.0293 7.7166 1.4963 17.402 4.5479 26.59 9.1445s17.878 10.738 24.207 16.855 10.299 12.209 13.795 19.338c3.4957 7.1287 6.516 15.294 8.2266 22.51s2.11 13.48 2.3027 17.488c0.19276 4.008 0.17792 5.7564 0.10938 7.2617-0.0675 1.4822-0.18335 2.7235 0.13867 3.7695l-0.01953 0.0195c0.0081 3e-3 0.01726 3e-3 0.02539 6e-3 0.0026 8e-3 0.0032 0.0173 0.0059 0.0254l0.01953-0.0195c1.046 0.32202 2.2873 0.20612 3.7695 0.13867 1.5053-0.0686 3.2537-0.0834 7.2617 0.10938 4.008 0.19276 10.272 0.59221 17.488 2.3027s15.381 4.7308 22.51 8.2266 13.221 7.4656 19.338 13.795c6.1171 6.3293 12.259 15.019 16.855 24.207 4.5967 9.1876 7.6482 18.873 9.1445 26.59 1.4963 7.7166 1.4377 13.471 1.0293 16.676-0.14099 1.1064-0.32003 1.8403-0.49805 2.4473h9.0176v-12.656c-0.0646-2.6067-0.11012-5.0724-0.19922-6.6953-0.20254-3.69-0.64394-3.2489-2.4277-7.5566-1.7838-4.3077-4.9087-13.363-9.0488-21.635-4.1402-8.2714-9.294-15.759-15.332-22.326-6.038-6.5676-12.96-12.216-20.463-16.807-7.5034-4.5903-15.59-8.1208-24.152-10.416-8.5626-2.2952-17.603-3.3551-22.123-3.8848-2.7474-0.32196-3.7456-0.44562-4.1719-0.54492-0.0993-0.42628-0.22296-1.4245-0.54492-4.1719-0.52975-4.5202-1.5896-13.56-3.8848-22.123-2.2952-8.5627-5.8257-16.649-10.416-24.152-4.5903-7.5034-10.239-14.425-16.807-20.463s-14.055-11.192-22.326-15.332c-8.2714-4.1402-17.327-7.265-21.635-9.0488-4.3077-1.7838-3.8667-2.2252-7.5566-2.4277-1.623-0.089082-4.0886-0.13461-6.6953-0.19922z',transform:'rotate(0 0 0)'},{d:'m7.0273 8.2051c-1.8879-0.008779-3.4485 0.094902-4.6504 0.24805-0.85125 0.10847-1.4467 0.24123-1.9687 0.37695-0.20999 0.6493-0.31567 1.2277-0.42969 1.8496v8.4922c0.88706 0.15315 2.1316 0.17594 3.7852 0.20703 3.3966 0.06387 8.4909 0.17807 12.775 0.70703 4.2845 0.52896 7.7566 1.4718 12.412 3.123s10.493 4.0111 16.189 7.3086c5.6965 3.2975 11.25 7.5314 16.117 12.414 4.8667 4.8827 9.0474 10.414 12.203 16.131 3.1557 5.7173 5.2873 11.621 6.6797 16.365s2.044 8.3283 2.4219 12.027 0.48196 7.5141 0.25 11.434-0.79956 7.9443-1.2285 10.48c-0.42895 2.5362-0.71978 3.5825-0.75976 4.3301-0.03999 0.74758 0.17179 1.1951 0.5293 1.7812 0.3575 0.58616 0.85702 1.308 1.1113 1.6816 0.07546 0.11086 0.13061 0.18447 0.19141 0.21875 0.09365 0.0927 0.18676 0.18516 0.2793 0.2793 0.05381 0.0359 0.1083 0.0743 0.16016 0.10937 0.02468 0.0174 0.03513 0.0308 0.06445 0.0508 0.37362 0.25431 1.0955 0.75383 1.6816 1.1113 0.58617 0.3575 1.0337 0.5693 1.7812 0.5293s1.7939-0.33082 4.3301-0.75977 6.561-0.99656 10.48-1.2285c3.9195-0.23196 7.7346-0.12788 11.434 0.25 3.699 0.37787 7.2834 1.0295 12.027 2.4219 4.7439 1.3924 10.648 3.524 16.365 6.6797 5.7173 3.1557 11.248 7.3364 16.131 12.203 4.8827 4.8667 9.1166 10.421 12.414 16.117 3.2975 5.6965 5.6574 11.534 7.3086 16.189 1.6512 4.6555 2.5941 8.1276 3.123 12.412 0.52896 4.2845 0.64313 9.3788 0.70703 12.775 0.0311 1.6536 0.0539 2.8981 0.20703 3.7852h8.4922c0.62194-0.11401 1.2003-0.2197 1.8496-0.42969 0.13573-0.52206 0.26848-1.1175 0.37695-1.9688 0.15314-1.2019 0.25705-2.7625 0.24805-4.6504-0.0146-3.1465-0.34216-7.2025-1.2774-12.025-1.4963-7.7166-4.5479-17.402-9.1445-26.59-4.5967-9.1876-10.738-17.878-16.855-24.207-6.1171-6.3293-12.209-10.299-19.338-13.795-7.1287-3.4957-15.294-6.516-22.51-8.2266-7.2162-1.7105-13.48-2.11-17.488-2.3027-4.008-0.19278-5.7564-0.17798-7.2617-0.10938-1.4822 0.0675-2.7235 0.18335-3.7695-0.13867l-0.01953 0.0176c-0.0026 4e-3 -0.0072 8e-3 -0.0098 0.0117l-0.03906-0.0234 0.01758-0.0195c-0.32202-1.046-0.20617-2.2873-0.13867-3.7695 0.06855-1.5054 0.08338-3.2537-0.10938-7.2617-0.19273-4.0081-0.59218-10.272-2.3027-17.488s-4.7308-15.381-8.2266-22.51c-3.4957-7.1287-7.4656-13.221-13.795-19.338s-15.019-12.259-24.207-16.855-18.873-7.6482-26.59-9.1445c-4.8229-0.93519-8.8789-1.2627-12.025-1.2773z',transform:'rotate(0 0 0)'},{d:'m0 28.352v171.65h171.84c-0.0123-0.39781-0.026-0.79949-0.0234-1.1719 0.0147-2.4528 0.043-7.9038-0.37695-12.691-0.41993-4.7876-1.3147-7.2315-2.9277-12.973-1.7028-6.0606-4.4279-12.308-9.1172-18.699-4.6893-6.3915-12.818-14.209-19.602-18.75-6.7833-4.5414-15.096-7.058-21.469-8.8438-6.3728-1.7858-10.713-1.8676-15.486-1.752-4.7729 0.11564-9.9736 0.43052-15.602 2.8496-5.6279 2.4191-11.856 6.4989-15.518 11.77-3.662 5.2706-4.7526 11.725-4.1289 17.463 0.6237 5.738 2.9618 10.753 6.2949 14.744 3.3331 3.9915 7.6581 6.9552 10.654 8.5742s4.6616 1.8916 6.5078 2.0234c1.8462 0.13184 3.8744 0.1224 5.3926-0.0371 1.5182-0.15952 2.5252-0.46833 3.3594-0.71875 0.83411-0.25042 1.4952-0.44098 2.5469-0.86523 1.0517-0.42424 2.4939-1.0812 2.8105-1.6875 0.31662-0.60634-0.49292-1.1631-1.291-1.5547-0.79809-0.39159-1.5842-0.61869-2.4219-0.9336s-1.7272-0.71829-2.6152-1.1211c-0.67273-0.46592-1.3434-0.93085-2.127-1.2754s-1.6768-0.56789-1.8477-1.6211c-0.1708-1.0532 0.37872-2.9275 0.80469-4.7363 0.42597-1.8088 0.72155-3.5268 0.80664-5.8379 0.0851-2.3111-0.0394-5.2097-0.33789-7.3789-0.2985-2.1692-0.77052-3.6098-1.2949-4.8633s-1.1026-2.3188-2.0078-3.7031c-0.90527-1.3844-2.1373-3.088-3.1973-4.459-1.0599-1.371-1.9472-2.4098-2.5352-3.1152-0.58797-0.7054-0.87728-1.0787-0.12305-1.5723s2.5502-1.1068 4.4746-1.625c1.9244-0.51822 3.9777-0.941 6.2637-0.78906 2.2859 0.15193 4.8052 0.87749 7.4277 2.8555s5.3494 5.2092 6.8418 7.0879 1.751 2.4045 2.666 2.1914c0.915-0.2131 2.4846-1.1649 4.0625-1.8945 1.5778-0.72962 3.1636-1.2365 4.4531-1.918 1.2895-0.68148 2.2832-1.5371 2.5312-0.78515 0.24801 0.75196-0.2485 3.109-0.56836 5.5605s-0.46271 4.9896-0.1543 6.1504c0.30842 1.1608 1.0646 0.93768 2.9043 1.1387 1.8396 0.20101 4.7624 0.82644 7.3887 1.8223s4.9562 2.3606 7.2246 4.1582c2.2685 1.7976 4.4747 4.0272 6.0957 6.3027 1.621 2.2755 2.6568 4.5963 3.3457 6.541 0.68882 1.9447 1.0301 3.5126 1.2676 4.6504 0.2374 1.1378 0.37034 1.8434-0.0723 2.0527-0.44256 0.20928-1.4594-0.0807-2.332-0.33203-0.87263-0.25138-1.5996-0.46301-2.4219-0.66992s-1.7393-0.40941-2.9551-0.58203c-1.2157-0.1726-2.7257-0.31558-4.4219-0.084-1.6961 0.2316-3.5715 0.83733-5.2695 1.4492-1.6981 0.61189-3.2137 1.2282-4.3672 2.5039-1.1535 1.2757-1.8548 2.9981-2.6309 5.0527-0.77611 2.0546-1.3229 3.6349-1.6875 4.9121s-0.45132 1.8525-1.6816 2.207c-1.2303 0.35453-2.5706 0.1897-4.3965-0.35351-1.8258-0.54321-3.6497-1.404-4.8164-2.959-1.1667-1.555-1.6729-3.8007-2.0039-4.6113s-0.48719-0.18553-1.2637 0.42774-2.1747 1.2132-3.7754 2.0469-3.3964 1.8987-5.4394 2.7695c-2.0431 0.87082-4.3245 1.5444-6.9551 1.9648-2.6306 0.42045-5.6028 0.58522-8.3145 0.26367s-5.1561-1.13-7.4238-2.3809c-2.2678-1.2509-4.3551-2.9414-7.2246-5.5977s-6.5192-6.2778-9.0391-10.729c-2.5199-4.4507-3.9096-9.7291-4.6875-13.523s-0.9456-6.1038-0.99805-8.4356c-0.04548-2.0237-0.01081-4.0352-0.07617-5.5996-0.06644 0.33945-0.15995 0.66831-0.30078 0.98047-0.59174 1.3117-1.996 2.3489-3.918 4.0762-1.922 1.7273-4.3531 4.1376-5.9648 5.7539-1.6118 1.6163-2.3972 2.4335-3.1562 3.2207-0.75909 0.78721-1.4879 1.5399-1.332 2.2617 0.15582 0.72186 1.196 1.408 2.2539 2.3691 1.0579 0.96117 2.1321 2.198 2.7812 3.627 0.64915 1.429 0.87382 3.0503 0.63672 4.8047-0.2371 1.7544-0.93566 3.6385-2.2031 5.25-1.2675 1.6115-3.1017 2.945-5.1562 3.5762-2.0546 0.63114-4.3255 0.55643-5.9043 0.23632-1.5788-0.32011-2.4616-0.88496-3.4766-0.85546-1.0149 0.0295-2.16 0.65453-3.1309 1.5332-0.97085 0.87866-1.7609 2.0054-2.9941 2.9434-1.2333 0.9379-2.9019 1.6792-4.6895 1.6543s-3.685-0.81733-4.9805-1.4746c-1.2955-0.65727-1.9847-1.1756-2.4082-1.5234-0.23118-0.18986-0.41056-0.3983-0.65039-0.79297-0.39468-0.23983-0.60311-0.41921-0.79297-0.65039-0.34781-0.42351-0.86616-1.1127-1.5234-2.4082-0.65727-1.2955-1.4497-3.1929-1.4746-4.9805s0.71639-3.4562 1.6543-4.6895c0.93791-1.2333 2.0647-2.0233 2.9434-2.9941 0.87867-0.97085 1.5037-2.1159 1.5332-3.1309 0.02954-1.0149-0.53536-1.8978-0.85547-3.4766-0.32011-1.5788-0.39481-3.8497 0.23633-5.9043 0.63113-2.0546 1.9647-3.8888 3.5762-5.1562 1.6115-1.2675 3.4957-1.966 5.25-2.2031s3.3757-0.0124 4.8047 0.63672c1.429 0.64915 2.6658 1.7234 3.627 2.7812 0.96117 1.0579 1.6473 2.0981 2.3691 2.2539 0.72186 0.15583 1.4745-0.57294 2.2617-1.332 0.78721-0.75908 1.6044-1.5445 3.2207-3.1562s4.0266-4.0428 5.7539-5.9648c1.7273-1.922 2.7645-3.3262 4.0762-3.918 0.46729-0.21082 0.97739-0.30362 1.502-0.36719-1.6188-0.10974-3.9238-0.052-6.2148-0.10351-2.3317-0.0524-4.6412-0.22013-8.4355-0.99805-3.7943-0.77792-9.0727-2.1676-13.523-4.6875s-8.0723-6.1696-10.729-9.0391c-2.6563-2.8695-4.3468-4.9568-5.5977-7.2246-1.2509-2.2678-2.0593-4.7122-2.3809-7.4238s-0.15678-5.6839 0.26367-8.3144c0.42045-2.6306 1.094-4.912 1.9648-6.9551 0.87082-2.0431 1.9359-3.8388 2.7695-5.4395 0.83365-1.6006 1.4336-2.9989 2.0469-3.7754 0.61327-0.77648 1.2383-0.93266 0.42773-1.2637-0.81059-0.33101-3.0563-0.83722-4.6113-2.0039-1.555-1.1667-2.4158-2.9905-2.959-4.8164-0.54321-1.8259-0.70804-3.1662-0.35352-4.3965s0.92982-1.317 2.207-1.6816c1.2772-0.36459 2.8575-0.9114 4.9121-1.6875 2.0546-0.7761 3.777-1.4774 5.0527-2.6309s1.892-2.6691 2.5039-4.3672c0.61189-1.6981 1.2176-3.5734 1.4492-5.2695 0.23161-1.6961 0.08863-3.2061-0.08398-4.4219-0.17261-1.2157-0.37512-2.1328-0.58203-2.9551s-0.41854-1.5492-0.66992-2.4219c-0.25138-0.87263-0.54131-1.8895-0.33203-2.332 0.20928-0.44257 0.91493-0.30971 2.0527-0.07227 1.1378 0.23744 2.7057 0.57873 4.6504 1.2676s4.2655 1.7247 6.541 3.3457c2.2755 1.621 4.5052 3.8272 6.3027 6.0957 1.7975 2.2685 3.1624 4.5983 4.1582 7.2246 0.99582 2.6263 1.6213 5.549 1.8223 7.3887s-0.0221 2.5959 1.1387 2.9043c1.1608 0.30841 3.6988 0.16556 6.1504-0.1543 2.4516-0.31986 4.8086-0.81637 5.5605-0.56836 0.75196 0.24801-0.10367 1.2417-0.78516 2.5312-0.68149 1.2895-1.1884 2.8753-1.918 4.4531-0.72962 1.5779-1.6814 3.1475-1.8945 4.0625-0.21311 0.91501 0.31268 1.1736 2.1914 2.666s5.1099 4.2193 7.0879 6.8418c1.978 2.6225 2.7035 5.1418 2.8555 7.4277 0.15193 2.2859-0.27084 4.3393-0.78906 6.2637-0.51822 1.9244-1.1314 3.7204-1.625 4.4746-0.4936 0.75423-0.86686 0.46493-1.5723-0.12304-0.7054-0.58798-1.7443-1.4752-3.1152-2.5352-1.3709-1.06-3.0746-2.292-4.459-3.1973-1.3844-0.90526-2.4497-1.4834-3.7031-2.0078-1.2534-0.5244-2.694-0.99642-4.8633-1.2949-2.1692-0.29849-5.0678-0.42299-7.3789-0.33789-2.3111 0.0851-4.0291 0.38067-5.8379 0.80664-1.8088 0.42597-3.6831 0.97549-4.7363 0.80469-1.0532-0.17081-1.2766-1.0641-1.6211-1.8477s-0.80948-1.4542-1.2754-2.127c-0.4028-0.88807-0.80618-1.7776-1.1211-2.6152-0.31491-0.83766-0.54201-1.6238-0.93359-2.4219s-0.94834-1.6076-1.5547-1.291c-0.60635 0.31663-1.2633 1.7589-1.6875 2.8105-0.42424 1.0517-0.61481 1.7128-0.86523 2.5469-0.25042 0.83413-0.55923 1.8412-0.71875 3.3594-0.15952 1.5181-0.16894 3.5463-0.03711 5.3926 0.13182 1.8462 0.4044 3.5116 2.0234 6.5078s4.5827 7.3212 8.5742 10.654c3.9915 3.3331 9.0061 5.6712 14.744 6.2949 5.738 0.6237 12.192-0.46696 17.463-4.1289 5.2706-3.6619 9.3504-9.8896 11.77-15.518 2.4191-5.6279 2.734-10.829 2.8496-15.602 0.11564-4.7729 0.03378-9.1135-1.752-15.486-1.7857-6.3728-4.3024-14.685-8.8438-21.469-4.5414-6.7833-12.358-14.912-18.75-19.602-6.3915-4.6893-12.639-7.4144-18.699-9.1172-5.7411-1.613-8.1851-2.5078-12.973-2.9277-4.7876-0.41992-10.239-0.39168-12.691-0.37695-0.43322 0.00261-0.90137-0.013007-1.3633-0.027344zm14.342 157.59c-9.5612 9.3711-4.7806 4.6856 0 0z',transform:'rotate(0 0 0)'},{d:'m-0.015625 19.172v9.1797c0.46705 0.01448 0.94073 0.02998 1.3789 0.02734 2.4528-0.01473 7.9038-0.04297 12.691 0.37695 4.7876 0.41993 7.2315 1.3147 12.973 2.9277 6.0607 1.7028 12.308 4.4279 18.699 9.1172 6.3915 4.6893 14.209 12.818 18.75 19.602 4.5414 6.7833 7.058 15.096 8.8438 21.469 1.7857 6.3728 1.8676 10.713 1.752 15.486-0.11564 4.7729-0.43052 9.9736-2.8496 15.602-2.4191 5.6279-6.4989 11.856-11.77 15.518-5.2706 3.662-11.725 4.7526-17.463 4.1289-5.738-0.6237-10.753-2.9618-14.744-6.2949-3.9915-3.3331-6.9552-7.6581-8.5742-10.654s-1.8916-4.6616-2.0234-6.5078c-0.13183-1.8462-0.12241-3.8744 0.03711-5.3926 0.15952-1.5182 0.46833-2.5252 0.71875-3.3594 0.25042-0.83411 0.44099-1.4952 0.86523-2.5469 0.42424-1.0517 1.0812-2.4939 1.6875-2.8105 0.60635-0.31662 1.1631 0.49293 1.5547 1.291s0.61868 1.5842 0.93359 2.4219c0.31491 0.83766 0.71829 1.7272 1.1211 2.6152 0.46592 0.67273 0.93085 1.3434 1.2754 2.127s0.5679 1.6768 1.6211 1.8477c1.0532 0.1708 2.9275-0.37872 4.7363-0.80469 1.8088-0.42597 3.5268-0.72155 5.8379-0.80664 2.3111-0.0851 5.2097 0.0394 7.3789 0.33789 2.1692 0.2985 3.6098 0.77052 4.8633 1.2949 1.2534 0.5244 2.3188 1.1026 3.7031 2.0078 1.3844 0.90527 3.088 2.1373 4.459 3.1973 1.3709 1.0599 2.4098 1.9472 3.1152 2.5352 0.7054 0.58797 1.0787 0.87727 1.5723 0.12304 0.4936-0.75423 1.1068-2.5502 1.625-4.4746 0.51822-1.9244 0.941-3.9777 0.78906-6.2637-0.15193-2.2859-0.87749-4.8052-2.8555-7.4277-1.978-2.6225-5.2092-5.3494-7.0879-6.8418s-2.4045-1.751-2.1914-2.666c0.21311-0.91501 1.1649-2.4846 1.8945-4.0625 0.72962-1.5779 1.2365-3.1636 1.918-4.4531 0.68149-1.2895 1.5371-2.2832 0.78516-2.5312-0.75196-0.24801-3.109 0.2485-5.5605 0.56836-2.4515 0.31986-4.9896 0.46271-6.1504 0.1543-1.1608-0.30841-0.93766-1.0646-1.1387-2.9043s-0.82644-4.7624-1.8223-7.3887c-0.99582-2.6263-2.3607-4.9562-4.1582-7.2246-1.7975-2.2685-4.0272-4.4747-6.3027-6.0957-2.2755-1.621-4.5963-2.6569-6.541-3.3457s-3.5126-1.0301-4.6504-1.2676c-1.1378-0.23744-1.8435-0.3703-2.0527 0.07227-0.20928 0.44256 0.08065 1.4594 0.33203 2.332 0.25138 0.87263 0.46301 1.5996 0.66992 2.4219s0.40942 1.7393 0.58203 2.9551c0.17261 1.2157 0.31559 2.7257 0.08398 4.4219-0.2316 1.6961-0.83733 3.5715-1.4492 5.2695-0.61189 1.6981-1.2282 3.2137-2.5039 4.3672s-2.9981 1.8548-5.0527 2.6309c-2.0546 0.7761-3.6349 1.3229-4.9121 1.6875-1.2772 0.36459-1.8525 0.45132-2.207 1.6816s-0.18969 2.5706 0.35352 4.3965c0.54321 1.8259 1.404 3.6497 2.959 4.8164 1.555 1.1667 3.8007 1.6729 4.6113 2.0039s0.18554 0.4872-0.42773 1.2637c-0.61327 0.77648-1.2132 2.1747-2.0469 3.7754-0.83365 1.6006-1.8987 3.3964-2.7695 5.4395-0.87082 2.0431-1.5444 4.3245-1.9648 6.9551-0.42045 2.6306-0.58522 5.6028-0.26367 8.3144s1.13 5.1561 2.3809 7.4238c1.2509 2.2678 2.9414 4.3551 5.5977 7.2246 2.6563 2.8695 6.2778 6.5192 10.729 9.0391s9.7291 3.9096 13.523 4.6875c3.7943 0.77792 6.1038 0.9456 8.4355 0.99805 2.3317 0.0524 4.6863-0.0105 6.3086 0.10742 1.6223 0.11796 2.5134 0.4162 5.041-0.47656 0.84886-0.29982 1.8926-0.74565 3.043-1.3008-0.55513 1.1504-1.001 2.1941-1.3008 3.043-0.89276 2.5277-0.59452 3.4188-0.47656 5.041 0.11792 1.6223 0.05502 3.9769 0.10742 6.3086 0.05245 2.3317 0.22013 4.6412 0.99805 8.4356s2.1676 9.0727 4.6875 13.523c2.5199 4.4507 6.1696 8.0722 9.0391 10.729s4.9568 4.3468 7.2246 5.5977c2.2678 1.2509 4.7122 2.0593 7.4238 2.3809s5.6839 0.15678 8.3145-0.26367c2.6306-0.42045 4.912-1.094 6.9551-1.9648 2.0431-0.87082 3.8388-1.9359 5.4394-2.7695s2.9989-1.4336 3.7754-2.0469 0.93266-1.2383 1.2637-0.42774 0.83722 3.0564 2.0039 4.6113c1.1667 1.555 2.9906 2.4158 4.8164 2.959 1.8259 0.54321 3.1662 0.70804 4.3965 0.35351 1.2303-0.35452 1.317-0.92982 1.6816-2.207s0.91139-2.8575 1.6875-4.9121c0.7761-2.0546 1.4774-3.777 2.6309-5.0527 1.1535-1.2757 2.6691-1.892 4.3672-2.5039 1.698-0.61189 3.5734-1.2176 5.2695-1.4492 1.6961-0.23159 3.2061-0.0886 4.4219 0.084 1.2157 0.17262 2.1328 0.37512 2.9551 0.58203s1.5492 0.41854 2.4219 0.66992c0.87263 0.25133 1.8895 0.54131 2.332 0.33203 0.4426-0.20928 0.3097-0.91492 0.0723-2.0527-0.23745-1.1378-0.57874-2.7057-1.2676-4.6504-0.68886-1.9447-1.7247-4.2655-3.3457-6.541-1.621-2.2755-3.8272-4.5052-6.0957-6.3027-2.2684-1.7976-4.5984-3.1624-7.2246-4.1582s-5.549-1.6212-7.3887-1.8223c-1.8396-0.201-2.5959 0.0221-2.9043-1.1387-0.30841-1.1608-0.16556-3.6988 0.1543-6.1504s0.81637-4.8086 0.56836-5.5605c-0.24801-0.75197-1.2417 0.10367-2.5312 0.78515-1.2895 0.68149-2.8753 1.1884-4.4531 1.918-1.5779 0.72962-3.1475 1.6814-4.0625 1.8945-0.91501 0.21311-1.1736-0.31267-2.666-2.1914s-4.2193-5.1099-6.8418-7.0879-5.1418-2.7035-7.4277-2.8555c-2.2859-0.15194-4.3393 0.27084-6.2637 0.78906-1.9244 0.51822-3.7204 1.1314-4.4746 1.625s-0.46492 0.86687 0.12305 1.5723c0.58798 0.70541 1.4752 1.7443 2.5352 3.1152 1.06 1.3709 2.292 3.0746 3.1973 4.459 0.90526 1.3844 1.4834 2.4497 2.0078 3.7031s0.99642 2.694 1.2949 4.8633c0.29849 2.1692 0.42299 5.0678 0.33789 7.3789-0.08509 2.3111-0.38067 4.0291-0.80664 5.8379-0.42597 1.8088-0.97549 3.6831-0.80469 4.7363 0.17081 1.0532 1.0641 1.2766 1.8477 1.6211s1.4542 0.80947 2.127 1.2754c0.88807 0.4028 1.7776 0.80618 2.6152 1.1211s1.6238 0.54201 2.4219 0.9336c0.79809 0.39158 1.6076 0.94835 1.291 1.5547-0.31663 0.60635-1.7589 1.2633-2.8105 1.6875-1.0517 0.42425-1.7128 0.61481-2.5469 0.86523-0.83413 0.25042-1.8412 0.55923-3.3594 0.71875-1.5181 0.15951-3.5463 0.16894-5.3926 0.0371-1.8462-0.13183-3.5116-0.40441-6.5078-2.0234s-7.3212-4.5827-10.654-8.5742c-3.3331-3.9915-5.6712-9.0061-6.2949-14.744-0.6237-5.738 0.46696-12.192 4.1289-17.463 3.6619-5.2706 9.8896-9.3504 15.518-11.77 5.6279-2.4191 10.829-2.734 15.602-2.8496 4.7729-0.11565 9.1135-0.0338 15.486 1.752 6.3728 1.7857 14.685 4.3024 21.469 8.8438 6.7833 4.5414 14.912 12.358 19.602 18.75 4.6893 6.3915 7.4144 12.639 9.1172 18.699 1.613 5.7411 2.5078 8.1851 2.9277 12.973 0.41995 4.7876 0.39165 10.239 0.37695 12.691-3e-3 0.43817 0.0128 0.91186 0.0273 1.3789h9.1797c-0.0806-0.81929-0.18273-2.4873-0.20703-3.7793-0.0639-3.3966-0.17807-8.4909-0.70703-12.775-0.52896-4.2845-1.4718-7.7566-3.123-12.412-1.6512-4.6555-4.0111-10.493-7.3086-16.189-3.2975-5.6965-7.5314-11.25-12.414-16.117-4.8826-4.8667-10.414-9.0474-16.131-12.203-5.7173-3.1557-11.621-5.2873-16.365-6.6797s-8.3286-2.044-12.027-2.4219c-2.7743-0.28341-5.6138-0.4122-8.5137-0.36133-0.96664 0.017-1.94 0.0533-2.9199 0.11133-3.9195 0.23195-7.9443 0.79956-10.48 1.2285s-3.5825 0.71977-4.3301 0.75977c-0.74758 0.04-1.1951-0.1718-1.7812-0.5293-0.58616-0.35751-1.308-0.85703-1.6816-1.1113-0.19828-0.13497-0.26568-0.21964-0.17578-0.38867-0.16903 0.0899-0.2537 0.0225-0.38867-0.17578-0.2543-0.37362-0.75382-1.0955-1.1113-1.6816-0.3575-0.58617-0.56929-1.0337-0.5293-1.7812s0.33081-1.7939 0.75976-4.3301c0.42895-2.5362 0.99656-6.561 1.2285-10.48s0.12787-7.7346-0.25-11.434c-0.37788-3.6987-1.0295-7.2834-2.4219-12.027s-3.524-10.648-6.6797-16.365c-3.1557-5.7173-7.3364-11.248-12.203-16.131-4.8667-4.8827-10.421-9.1166-16.117-12.414-5.6965-3.2975-11.534-5.6574-16.189-7.3086s-8.1276-2.5941-12.412-3.123c-4.2845-0.52896-9.3788-0.64316-12.775-0.70703-1.292-0.024293-2.96-0.12646-3.7793-0.20703z',transform:'rotate(0 0 0)'},{d:'m14.623 127.52c0.95886 1.0072 1.9882 2.0495 3.1523 3.1094-1.1485-1.0496-2.1988-2.1078-3.1523-3.1094zm3.1523 3.1094c0.32598 0.2968 0.65842 0.5909 1 0.88476-0.33958-0.29317-0.67593-0.58861-1-0.88476zm12.029-3.1094c0.49296 0.35664 1.0005 0.6972 1.5195 1.0234-0.51879-0.32606-1.0268-0.66699-1.5195-1.0234zm2.1289 1.3828c0.328 0.19476 0.65653 0.38828 0.99414 0.57031-0.33765-0.18202-0.66611-0.37555-0.99414-0.57031zm1.7324 0.94726c0.319 0.15985 0.63987 0.3167 0.9668 0.46485-0.32701-0.14814-0.64772-0.30501-0.9668-0.46485zm1.7383 0.79688c0.33482 0.13951 0.67311 0.27153 1.0156 0.39844-0.34234-0.12681-0.68098-0.25905-1.0156-0.39844zm1.7949 0.67578c0.36331 0.12221 0.73217 0.23415 1.1035 0.3418-0.37132-0.10761-0.74022-0.21964-1.1035-0.3418zm-18.016 0.53711c0.26046 0.21865 0.52196 0.43559 0.79102 0.65039-0.2681-0.21465-0.53164-0.43193-0.79102-0.65039zm19.885 0.02148c0.40582 0.1049 0.81964 0.19425 1.2344 0.28125-0.4146-0.08695-0.82867-0.17642-1.2344-0.28125zm1.9434 0.43164c0.65002 0.11852 1.3082 0.21816 1.9785 0.29102-0.67023-0.07285-1.3285-0.17253-1.9785-0.29102zm-20.311 0.75977c0.20535 0.15615 0.40915 0.31207 0.61914 0.46484-0.20984-0.15291-0.41412-0.3086-0.61914-0.46484zm57.17 0.38672c-0.25476 0.19648-0.51064 0.3909-0.75977 0.59375 0.24882-0.20324 0.50532-0.39687 0.75977-0.59375zm-55.527 0.79101c0.14215 0.09569 0.27973 0.19537 0.42383 0.28907-0.1441-0.09375-0.28178-0.19337-0.42383-0.28907zm53.881 0.5586c-0.30084 0.2623-0.59521 0.5289-0.88476 0.80078 0.28894-0.27202 0.58457-0.53825 0.88476-0.80078zm-1.8789 1.7656c-0.04333 0.04461-0.087868 0.08797-0.13086 0.13281 0.0429-0.04484 0.087621-0.08819 0.13086-0.13281zm-1.3379 1.4824c-0.067329 0.08043-0.13305 0.16111-0.19922 0.24219 0.066054-0.08104 0.13201-0.16179 0.19922-0.24219zm-12.326 1.4512c-1.1504 0.55513-2.1941 1.001-3.043 1.3008-2.5277 0.89276-3.4188 0.59452-5.041 0.47656-0.028334-0.00206-0.064973-0.00196-0.09375-0.00391-0.52457 0.06357-1.0347 0.15637-1.502 0.36719-1.3117 0.59174-2.3489 1.996-4.0762 3.918-1.7273 1.922-4.1376 4.3531-5.7539 5.9648s-2.4335 2.3972-3.2207 3.1562c-0.78721 0.75909-1.5399 1.4879-2.2617 1.332-0.72186-0.15582-1.408-1.196-2.3691-2.2539-0.96117-1.0579-2.1979-2.1321-3.627-2.7812-1.429-0.64912-3.0503-0.87382-4.8047-0.63672s-3.6385 0.93566-5.25 2.2031c-1.6115 1.2675-2.945 3.1017-3.5762 5.1562-0.63113 2.0546-0.55644 4.3255-0.23633 5.9043 0.32011 1.5788 0.88501 2.4616 0.85547 3.4766-0.02954 1.0149-0.65454 2.16-1.5332 3.1309-0.87867 0.97085-2.0055 1.7609-2.9434 2.9941-0.93791 1.2333-1.6792 2.9019-1.6543 4.6895s0.81734 3.685 1.4746 4.9805c0.65727 1.2955 1.1756 1.9847 1.5234 2.4082 0.18986 0.23118 0.39829 0.41056 0.79297 0.65039 0.23983 0.39467 0.41921 0.60311 0.65039 0.79297 0.42351 0.34781 1.1127 0.86617 2.4082 1.5234 1.2955 0.65728 3.1929 1.4497 4.9805 1.4746 1.7875 0.02489 3.4562-0.7164 4.6895-1.6543 1.2333-0.93791 2.0233-2.0647 2.9941-2.9434 0.97085-0.87867 2.1159-1.5037 3.1309-1.5332 1.0149-0.0295 1.8978 0.53535 3.4766 0.85546 1.5788 0.32011 3.8497 0.39482 5.9043-0.23632 2.0546-0.63113 3.8888-1.9647 5.1562-3.5762 1.2675-1.6115 1.966-3.4956 2.2031-5.25 0.2371-1.7543 0.01243-3.3757-0.63672-4.8047-0.64915-1.429-1.7234-2.6658-2.7812-3.627-1.0579-0.96117-2.0981-1.6473-2.2539-2.3691-0.15583-0.72186 0.57294-1.4745 1.332-2.2617 0.75908-0.78721 1.5445-1.6044 3.1562-3.2207 1.6118-1.6164 4.0428-4.0266 5.9648-5.7539 1.922-1.7273 3.3262-2.7645 3.918-4.0762 0.14058-0.31158 0.23436-0.63973 0.30078-0.97851-0.009963-0.23883-0.01563-0.49605-0.03125-0.71094-0.11796-1.6223-0.4162-2.5134 0.47656-5.041 0.29982-0.84886 0.74565-1.8926 1.3008-3.043zm-8.1777 1.7734c-0.79503-0.05389-1.7498-0.06885-2.7949-0.07422 1.0405 0.00591 2.0016 0.02044 2.7949 0.07422zm6.4316 7.0312c0.06477 1.563 0.030793 3.5687 0.076172 5.5879-0.045366-2.0186-0.011503-4.025-0.076172-5.5879zm14.945 23.631c0.41153 0.49283 0.83834 0.96921 1.2754 1.4297-0.43746-0.46094-0.86381-0.9368-1.2754-1.4297zm1.5625 1.7168c0.34448 0.35384 0.69071 0.70369 1.0449 1.0371-0.35361-0.33304-0.70114-0.68395-1.0449-1.0371zm1.6641 1.5938c0.23413 0.21023 0.4673 0.42577 0.70312 0.62695-0.23616-0.20162-0.46871-0.41633-0.70312-0.62695zm1.6699 1.418c0.12562 0.10027 0.25154 0.2051 0.37695 0.30273-0.12521-0.09759-0.25153-0.20252-0.37695-0.30273zm1.4238 1.0879c0.097133 0.07064 0.1944 0.14587 0.29102 0.21484-0.096341-0.06888-0.19416-0.1443-0.29102-0.21484zm2.3223 15.195c0.52993 0.2365 1.0721 0.44277 1.623 0.63281-0.55052-0.18988-1.0919-0.4001-1.623-0.63281z',transform:'rotate(0 0 0)'}],colorScheme:[['#fff','#333','#333','#fff','#fff','#fff','#fff','#333','#333','#fff','#fff'],['#fff','#7F7C7C','#fff','#7F7C7C','#fff','#7F7C7C','#fff','#7F7C7C','#7F7C7C','#fff','#fff'],['#ff8080','#06f','#d7f4ee','#ffd42a','#ffd42a','#59f','#ff8080','#59f','#ff8080','#ffd42a','#59f'],['#333','#fff','#fff','#333','#333','#fff','#333','#333','#fff','#7F7C7C','#7F7C7C']],rotations:[90,180,90,180,0,-90,0,-90,90,180,90,180,0,-90,0,-90]},{paths:[{d:'m37.939 0.25195v37.199h8.7598v-26.463h38.986l-8.7324-10.584 12.973-0.027344v-0.054688h-43.227v-0.070312zm68.164 37.199 1.9375 3.0449-7.6016 15.666 4.6738 11.619 8.7422-19.668 0.4668-0.83203v-1.0703h16.898l-9.9922 26.582-3.793 10.094-4.8125 12.803 10.156 4.5137 3.6621-1.6269 7.5605-3.3613-11.125-4.4766 4.6387-11.641 4.1719-10.471 8.8672-22.258-2.7383-0.1582h15.654v-8.7598h-47.105zm56.387 0v8.7598h27.033v39.914l10.539-8.6934 0.0234 12.006h0.10351v-43.227h0.0703v-8.7598zm-124.55 8.7598v47.898l1.2266-0.78125 11.385 5.5254 2.4668 1.1973 0.57422 0.27734 0.3125-0.125 12.398-4.9883-18.396-8.1758-0.75-0.41992v-0.087891h-0.45703v-17.24l26.09 9.8066 10.08 3.7891 13.309 5.002 3.9746-8.9434-4.9609-11.162-3.9648 9.8516-12.15-4.8418-10.457-4.166h-2e-3l-21.76-8.6699-0.1582 2.7383v-16.484zm108.71 53.896-0.11719 0.0469-0.11914 0.0488 0.4961 0.19922c0.27213 0.10948 0.81055 0.32647 1.1973 0.48243 0.61256 0.24704 0.73816 0.29525 0.72266 0.28125-2e-3 -2e-3 -0.49354-0.241-1.0918-0.53125zm-69.119 0.0957-11.223 4.9883 11.125 4.4766-4.8711 12.227-4.1738 10.475-8.6328 21.668 2.7383 0.1582h-15.654v8.7598h46.557l0.12305-0.25391-0.91016-1.4316 7.543-15.541v-2e-3l-4.9609-12.326-8.6348 19.43-0.4668 0.83203v0.5332h-17l9.7715-25.998 8.8262-23.48zm68.875 0-12.398 4.9883 18.396 8.1758 0.83203 0.46679v-0.0117h0.47656v17.83l-25.959-9.7578-10.094-3.793-13.426-5.0469-4.0762 9.1719 1.1641 2.6211 3.8027 8.5527 4.0606-10.092 12.27 4.8887 10.473 4.1719 21.627 8.6172 0.1582-2.7383v15.654h8.7598v-47.186l-0.95313 0.60547-12.486-6.0625-4e-3 -2e-3zm-135.62 14.604-10.666 8.7988v30.59h-0.070313v8.7598h37.77v-8.7598h-27.033zm142.93 48.148v27h-39.379l8.6211 10.451-12.469 0.0254v0.18945h43.227v0.0703h8.7598v-37.736z',transform:'rotate(0 0 0)'},{d:'m153.61 0.25195v0.070312h-28.715l-8.4707 10.666h37.186v51.707l-0.1582-2.7383-21.76 8.6699-4.1719 10.471 26.09-9.8066v17.24h-0.45703v0.08789l-0.75 0.41992-18.396 8.1758-7.5605 3.3613-3.6621 1.6269-10.156 4.5137 5.0312 13.385 10.094 3.793-4.8711-12.227 11.125-4.4766 12.398-4.9883 0.24609-0.0996-0.56445-0.27344 16.283-5.4355v-94.143zm-43.227 0.070312v0.013672l6.8516-0.013672zm-110.33 37.129v8.7598h0.070313v30.801l10.666 8.4707v-39.271h51.707l-2.7383 0.1582 8.8672 22.258h2e-3l10.457 4.166-9.9922-26.582h16.898v1.0703l0.4668 0.83203 13.703 30.832 3.9746 8.9434 13.309-5.002 3.793-10.094-12.15 4.8418-3.9648-9.8535-4.6738-11.619-0.1875 0.38477-1.666-4.9883-1.7207-4.2773h-0.06055v-1.0566l-2.332-6.9844 1.3262-1.7891h-57.984zm72.744 41.646 4.6387 11.641-11.125 4.4766-12.711 5.1133 1.2422 0.60352-16.895 5.6406-0.10156-0.0762v93.666h38.574l8.1055-10.207h-37.92v-51.707l0.1582 2.7383 21.627-8.6172 4.1738-10.475-25.959 9.7578v-17.83h0.47656v0.0117l0.83203-0.46679 18.396-8.1758 11.223-4.9883 10.156-4.5137-4.8125-12.803zm127.34 31.871 0.0254 12.562-10.631-8.4414v39.105h-51.707l2.7383-0.1582-8.6328-21.668-10.473-4.1719 9.7715 25.998h-17v-0.5332l-0.46679-0.83203-8.6348-19.43-1.3242-2.9766-2.4785-5.5762-1.1641-2.6211-4.0762-9.1719-13.426 5.0469-3.7949 10.096 12.27-4.8887 4.0605 10.092 4.9609 12.328 0.0606-0.12696 0.54688 1.6367 2.584 6.4238h-0.0332v0.5332h-0.22852l2.7715 8.3008-0.33985 0.45899h94.752v-8.7598h-0.0703v-43.227z',transform:'rotate(0 0 0)'},{d:'m124.9 0.30664-47.949 0.097656 24.393 29.566zm-23.557 29.664-6.873 9.2695 5.7793 17.307 7.7891-16.051zm-101.41 46.898 0.095703 46.805 28.861-23.809zm28.957 22.996 9.0469 6.707 16.895-5.6406-15.668-7.6035zm171.17-22.434-28.428 23.451 28.52 22.648zm-28.428 23.451-8.9121-6.6074-16.641 5.5547 15.432 7.4922zm-71.428 44.719-7.6035 15.668 6.5352 10.273 6.709-9.0469zm-1.0684 25.941-22.994 28.957 46.805-0.0937z',transform:'rotate(0 0 0)'},{d:'m189.37 0.095703v0.1582h-27v10.77h27v26.936h10.736v-37.863zm-189.43 0.15625v10.67h0.16016v26.834h10.809v-26.834h27.035v-10.67h-37.844zm0.10937 161.83v38.092h10.736v-0.16015h27v-10.834h-27v-27.098zm189.39 0.86914v26.469h-27.221v10.582h27.221v0.15625h10.824v-37.207z',transform:'rotate(0 0 0)'},{d:'m153.47 46.125v0.08594h-15.654l2.7383 0.1582-8.8672 22.258 21.76-8.6699 0.1582 2.7383v-16.57zm-106.77 0.08594v16.484l0.1582-2.7383 21.76 8.6699-8.8672-22.258 2.7383-0.1582h-15.654zm22.385 0 9.9922 26.582 11.324 4.5117 1.0273-0.16992 3.7637-9.3516-8.7422-19.67-0.4668-0.83203v-1.0703zm45.238 0v1.0703l-0.4668 0.83203-8.7422 19.668 3.9648 9.8535 12.15-4.8418 9.9922-26.582zm-67.623 23.08v17.24h0.45703v0.08789l0.75 0.41992 18.396 8.1758 11.125-4.4766-4.6387-11.641zm106.91 0-26.09 9.8066-4.6387 11.641 11.125 4.4766 18.396-8.1758 0.75-0.41992v-0.08789h0.45703zm-87.303 35.9-18.396 8.1758-0.83203 0.46679v-0.0117h-0.47656v17.83l25.959-9.7578 4.8711-12.227zm67.699 0-11.125 4.4766 4.8711 12.227 25.959 9.7578v-17.83h-0.47656v0.0117l-0.83203-0.46679zm-42.877 18.117-12.27 4.8887-9.7715 25.998h17v-0.5332l0.4668-0.83203 8.6348-19.43zm18.055 0-4.0606 10.092 8.6348 19.43 0.46679 0.83203v0.5332h17l-9.7715-25.998zm-40.797 9.0606-21.627 8.6172-0.1582-2.7383v15.967h0.23633v-0.0195h15.654l-2.7383-0.15823zm63.539 0 8.6328 21.668-2.7383 0.1582h15.891v-15.947l-0.1582 2.7383z',transform:'rotate(0 0 0)'},{d:'m10.904 10.922v26.529h27.035v-26.529zm151.46 0.10156v26.477h0.125v-0.04883h26.875v-26.428zm-124.55 151.9v0.0332h-27.033v26.229h27v4.5664h0.05664v-30.828zm124.65 0.0332v26.469h26.969v-26.469h-26.945z',transform:'rotate(0 0 0)'},{d:'m46.699 10.988v26.463h49.1l5.5469-7.4805-15.66-18.982zm54.646 18.982 4.7578 7.4805h47.367v0.048828h0.13477v-26.512h-37.186zm61.02 16.154v48.27l0.35743-0.11914 8.9121 6.6074 17.889-14.758v-39.914h-27.033v-0.085938zm9.2695 54.758-9.168 5.834v47.186h-0.01v0.29297h27.066v-39.105zm-160.85-54.672v39.271l18.111 14.383 8.9219-5.6758v-47.979zm18.111 53.654-18.111 14.941v39.389h27.033v-47.717zm64.621 62.836-0.12305 0.25391h-46.557v-0.0332h-0.23633v27.033h37.92l14.621-18.412zm5.625 8.8418 15.189 18.412h39.379v-27h-48.199z',transform:'rotate(0 0 0)'},{d:'m91.428 77.135-1.0273 0.16992 0.82617 0.33008zm8.7246 1.8105-3.9746 8.9434-13.309-5.002 4.8125 12.803-10.156 4.5137 10.156 4.5137-5.0312 13.385 13.426-5.0469 4.0762 9.1719 4.0762-9.1719 13.426 5.0469-5.0312-13.385 10.156-4.5137-10.156-4.5137 4.8125-12.803-13.309 5.002z',transform:'rotate(0 0 0)'}],colorScheme:[['#b0cdee','#ecdba3','#fff','#c6c0c0','#fff','#fff','#fff','#536c53'],['#b0cdee','#c6c0c0','#ecdba3','#c6c0c0','#fff','#fff','#fff','#fff','#536c53'],['#c6c0c0','#ecdba3','#536c53','#b0cdee','#fff','#fff','#fff','#536c53'],['#d45500','#fd5','#536c53','#536c53','#fff','#fff','#fff','#536c53']],rotations:[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{paths:[{d:'m200.02 199.96-54.229-125.64-145.75-74.331 54.23 125.58z',transform:'rotate(0 0 0)'},{d:'m0.039062-0.060547 145.75 74.383 54.24-74.33zm54.238 125.64-54.24 74.33 199.99 0.05273z',transform:'rotate(0 0 0)'},{d:'m0.00904-0.060735 0.10438 0.05323h199.88zm199.99 0.05323-54.238 74.331 54.229 125.64-199.98-0.0532v0.0915h199.99v-200.01zm-199.99 199.92v-0.0114l-8e-3 0.0114zm0-0.0114 54.23-74.32-54.23-125.58zm0-199.9 145.75 74.331-145.64-74.331z',transform:'rotate(0 0 0)'}],colorScheme:[['#fff','#ecdba7','#b5dbcb'],//['#8f1b1b', '#dfc200','#b5dbdb'],
['#c6bdbe','#fff','#b5dbdb']],rotations:[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]},{paths:[{d:"m0 0v43.234 78.262 78.504h0.041016v-78.479l34.334 20.814 30.543-5.0117-5.8379 32.547 18.201 30.121-15.096-0.08789-17.555 0.0957h109.32c0.61613-1.2381 1.5554-2.5941 2.0215-4.168 0.62869-2.1229 0.39239-4.6384-0.51172-6.918s-2.4765-4.325-3.9297-5.2676c-1.4531-0.9426-2.7908-0.78401-4.4414 0.04102-1.6506 0.82507-3.6167 2.319-6.25 3.459-2.6333 1.1399-3.7689 1.0087-6.127 1.166-2.3581 0.15731-3.3541-0.81498-4.0234-1.5234-0.6693-0.70845-0.88671-1.2498-1.1875-2.6797-0.38048-1.8088 1.5488-3.0552 2.7676-5.375 1.2188-2.3198 1.926-4.6792 1.9258-6.6445-1.8e-4 -1.9654-0.70707-3.5386-1.7676-4.3633-1.0605-0.82469-2.477-1.4865-4.3633-0.77929-1.8863 0.70717-4.2463 1.2846-6.4863 3.0137-2.2401 1.7291-3.7784 3.4452-5.9004 5.0957-2.122 1.6505-2.1637 2.2369-3.9316 3.1406s-4.0986 2.043-5.1211 2.0039-2.2348-0.17293-2.1562-1.1172c0.0787-0.94426-0.30441-0.86217 0.875-2.8672 1.1794-2.005 2.751-4.675 3.8125-7.1914 1.0615-2.5164 1.6134-4.8784 1.6133-6.1738-1.3e-4 -1.2954-0.55153-1.53-2.0449-1.7266-1.4934-0.19657-2.0144-1.1888-3.9004-1.3066-1.8859-0.11787-2.9705-0.11235-3.7969-0.82031-0.82638-0.70796-1.2255-2.0432-1.3828-3.1055s0.17716-2.5998 0.28711-4.457c0.10997-1.8573 0.9128-2.6182 1.3301-4.7383 0.66743-1.453-0.54812-1.9338-1.6094-2.5234-1.0613-0.58958-1.3848-0.62073-2.6816-1.3281-1.2969-0.70739-0.8659-1.2583-4.4023-1.4941-2.0915-0.1395-4.4779-1.3244-6.9141-1.2852s-4.1645 0.28919-4.834-0.26172c-0.66947-0.55092-1.0259-0.73348 0.23242-2.1094 1.2583-1.3759 3.3792-3.0264 6.0918-4.127 2.7126-1.1006 6.0149-1.6495 9.1992-1.8066 3.1843-0.15717 6.2454 0.0782 8.252-0.19727 2.0066-0.2755 2.9498-1.0614 4.1289-3.3809 1.1791-2.3194 2.6056-6.2012 2.7578-7.9941 0.15215-1.793-0.94966-1.5575-2.7969-1.0859-1.8472 0.4716-4.442 1.1794-6.918 1.5332-2.4759 0.35379-4.8333 0.35371-6.3672-0.27539s-2.2423-1.8858-1.9668-3.1445c0.27547-1.2587 1.5333-2.5159 3.6562-4.3242s5.1925-5.1656 7.748-7.6426 4.5936-4.0704 6.4414-6.7832c1.8478-2.7129 2.4212-5.5428 2.5781-8.0977 0.15688-2.5548-1.1028-3.919-2.6348-4.4688-1.5319-0.54979-2.3407-0.28816-5.0527 1.7949-2.7121 2.0831-6.3297 5.0718-9.002 7.7832-2.6723 2.7114-4.4029 5.1499-6.2891 7.1934-1.8862 2.0434-3.9314 3.6965-5.6211 4.4434-1.6897 0.74682-3.0253 0.59012-3.8516-0.31445-0.8263-0.90456-1.1414-2.5558-0.43359-5.4258 0.70783-2.87 1.6883-7.0422 1.9238-9.5176 0.23555-2.4754-0.69003-2.8415-2.3008-2.8809-1.6108-0.03936-2.3267 0.58237-4.2129 1.5254-1.8862 0.94302-4.1127 2.2936-4.7812 3.4727-0.66854 1.1791-0.61227 1.9363-0.14062 3.7441 0.47165 1.8079 0.9424 4.1675 0.43164 7.1543s-2.0046 6.6065-3.2617 9.1602c-1.2571 2.5537-3.6154 4.5488-4.5586 5.1387-0.94317 0.58977-0.72368-1.8917-0.9707-3.5527-0.33041-1.8278-0.70694-2.9165-1.3359-5.9043-0.62899-2.9878-2.1773-5.7068-2.8848-7.7109-0.70742-2.0042-1.4952-2.7122-2.1621-2.8691-0.66689-0.15693-1.2177 0.23613-2.3574 0.90429-1.1397 0.66819-2.1187 0.94361-3.7695 1.1797s-3.3891-0.23506-4.4512-1.2969c-1.062-1.0618-1.7797-2.5438-2.3301-4.5488-0.55038-2.005-1.518-3.8663-2.5391-4.8086-1.0211-0.94228-1.6147-0.6795-3.5684-0.38086-2.2199 0.33935-2.8329-0.28611-4.9941 0.53906-2.1613 0.82517-5.4563 2.1001-7.1855 3.6719s-2.8934 3.0223-3.5625 3.377c-0.66908 0.3546 0.075061-0.96938 0.23242-2.3066 0.15736-1.3373 0.56052-2.0171 1.1504-3.5898 0.58987-1.5727 0.69966-2.5366 2.1152-4.4238 1.4156-1.8872 2.2179-3.4433 4.1445-5.252 1.9266-1.8086 3.8077-3.4492 4.9082-5.8867 1.1005-2.4375 1.3348-5.0874 0.90234-7.1309-0.43242-2.0434-1.6998-3.5653-3.3105-3.4082-1.6108 0.15713-3.5674 0.07646-5.6895 1.334-2.122 1.2575-3.665 2.3546-5 3.2969s-2.4694 1.2344-3.0586 1.9414-2.0513 2.4978-2.8379 2.459c-0.78655-0.038737-0.48779 1.3495-1.5195-2.7754-0.40985-1.6386-0.51479-2.8948-0.35742-5.5684 0.15737-2.6736 0.19361-4.9046 1.334-7.5391 1.1404-2.6344 2.6328-4.8328 3.7344-6.3672 1.1016-1.5344 1.8095-2.3983 1.416-3.459-0.3935-1.0607-1.889-2.3195-4.4043-3.4199-2.5153-1.1005-6.0528-2.0447-9.5898-2.3984-1.0338-0.1034-2.0657-0.15078-3.0898-0.1543-1.0103-0.003471-2.0126 0.036794-3.002 0.10938v-42.975a199.82 199.82 0 0 1 199.82 199.74h0.14258v-123.87a76.132 76.132 0 0 1-53.834-22.299 76.132 76.132 0 0 1-22.299-53.834h-123.87zm144.03 5.4434c0.0199 0.47317 0.04344 0.94498 0.08594 1.4219-0.0424-0.47556-0.06614-0.95014-0.08594-1.4219zm39.16 5.1836c0.12789 0.08048 0.24454 0.16834 0.34961 0.26172-0.10536-0.09375-0.22127-0.18096-0.34961-0.26172zm-35.15 6.3145c0.28812 0.21739 0.59042 0.41039 0.89453 0.58984-0.3037-0.17931-0.60689-0.37263-0.89453-0.58984zm1.1777 0.74609c0.21763 0.11991 0.43016 0.23121 0.64258 0.33203-0.21115-0.10026-0.42632-0.21292-0.64258-0.33203zm7.4199 0.46289c-0.17809 0.05119-0.35397 0.09615-0.53125 0.14258 0.17956-0.04698 0.35084-0.09071 0.53125-0.14258zm-6.4922 0.001953c0.1392 0.06191 0.25656 0.1087 0.38867 0.16211-0.12824-0.05195-0.25379-0.10218-0.38867-0.16211zm4.7305 0.42188c-0.19409 0.03801-0.39102 0.08158-0.57813 0.11133 0.18806-0.02989 0.38302-0.0731 0.57813-0.11133zm-0.89649 0.1582c-0.37682 0.05098-0.74308 0.090189-1.0723 0.099609 0.33001-0.0094 0.69444-0.048449 1.0723-0.099609zm34.951 1.9062c0.0457 0.014 0.0899 0.034964 0.13477 0.052734-0.045-0.01782-0.0889-0.038714-0.13477-0.052734zm0.44922 0.21094c0.0514 0.03189 0.1027 0.06481 0.15235 0.10156-0.0499-0.03695-0.10061-0.06954-0.15235-0.10156zm0.42774 0.3418c0.0411 0.04099 0.0838 0.07866 0.12304 0.12305-0.0394-0.04469-0.0817-0.08181-0.12304-0.12305zm-6.0059 2.209c-0.26712 0.34958-0.52601 0.755-0.79297 1.1895 0.26827-0.43664 0.52493-0.83842 0.79297-1.1895zm6.9805 1.4277c-5e-3 0.06179-0.01323 0.12819-0.01953 0.19141 6e-3 -0.06355 0.01433-0.1293 0.01953-0.19141zm-8.2988 0.63086c-0.17604 0.29802-0.37779 0.63595-0.58008 0.97266 0.21485-0.35733 0.39445-0.65869 0.58008-0.97266zm8.0273 1.1211c-0.11279 0.54026-0.24537 1.0973-0.42187 1.6797 0.17646-0.58218 0.3092-1.1397 0.42187-1.6797zm-13.664 12.564c-0.46992 1.3152-0.95395 2.4783-1.2852 3.4043 0.33121-0.92605 0.81524-2.089 1.2852-3.4043zm-14.783 3.4141c0.0921 0.08066 0.19486 0.16168 0.28906 0.24023-0.0959-0.07994-0.19537-0.15809-0.28906-0.24023zm1.1465 0.89844c0.11529 0.08218 0.23333 0.17005 0.35547 0.25195-0.12429-0.08328-0.23827-0.16838-0.35547-0.25195zm11.121 1.5547c-0.17152 0.11701-0.36557 0.21699-0.57226 0.30859 0.20659-0.091599 0.40079-0.19153 0.57226-0.30859zm-0.75 0.37891c-0.15835 0.06334-0.32161 0.12334-0.49414 0.17773 0.17236-0.05434 0.33595-0.11444 0.49414-0.17773zm-6.1816 0.375c0.31633 0.10268 0.63097 0.17969 0.94532 0.24414-0.31394-0.0643-0.62944-0.14175-0.94532-0.24414zm1.2324 0.29297c0.22338 0.03767 0.44457 0.067747 0.66406 0.085937-0.21938-0.01815-0.44081-0.048347-0.66406-0.085937zm1.6016 0.10156c-0.20461 0.0098-0.41231 0.012446-0.62305 0.003906 0.21113 0.008601 0.41805 0.005894 0.62305-0.003906zm13.143 2.0957c0.013 0.18508 0.03222 0.35604 0.04883 0.53906-0.01631-0.17997-0.03603-0.3571-0.04883-0.53906zm0.21679 1.9258c0.0314 0.20453 0.05881 0.41079 0.09571 0.60352-0.0367-0.19152-0.06441-0.40032-0.09571-0.60352zm0.16797 0.95508c0.0852 0.38881 0.17681 0.75625 0.28711 1.0645-0.10996-0.30727-0.20208-0.67697-0.28711-1.0645zm1.4024 2.5449c0.20979 0.14832 0.45093 0.27695 0.69531 0.40039-0.24642-0.12432-0.48392-0.25108-0.69531-0.40039zm6.5664 3.0508c0.22771 0.07112 0.44261 0.13731 0.66992 0.20508-0.22358-0.0667-0.44597-0.13513-0.66992-0.20508zm2.2305 0.66797c0.58093 0.1703 1.1343 0.33578 1.5996 0.5-0.46497-0.16409-1.0191-0.32975-1.5996-0.5zm-81.725 9.1309c0.0756 0.06367 0.15104 0.12761 0.22656 0.19141a174.39 174.39 0 0 0-0.22656-0.19141zm12.68 11.789c0.11468 0.11771 0.2294 0.23549 0.34375 0.35352a174.39 174.39 0 0 0-0.34375-0.35352zm49.039 109.31c2e-3 0.0344 0.00286 0.0691 0.00586 0.10351a174.39 174.39 0 0 0-0.00586-0.10351z",transform:'rotate(0 0 0)'},{d:"m-0.11719 0v200h0.11719v-58.885a62.239 58.82 0 0 1 40.736 14.439c1.1727 0.93967 2.2984 1.9314 3.375 2.9707a62.239 58.82 0 0 1 0.95117 0.92773c0.46551 0.47509 0.91175 0.9661 1.3555 1.459a62.239 58.82 0 0 1 15.768 38.992l15.096 0.08789-18.201-30.121 5.8379-32.547-30.543 5.0117-34.375-20.84v-95.889a174.39 174.39 0 0 1 174.39 174.39h25.49a200 200 0 0 0-200-200z",transform:'rotate(0 0 0)'},{d:"m134.66 0a65.343 65.343 0 0 0 19.139 46.205 65.343 65.343 0 0 0 46.205 19.139v-6.2285c-0.21747-0.02375-0.65997-0.15134-0.83984-0.17383-1.7289-0.21609-1.5988-0.33351-3.6035-1.041-2.0047-0.7075-5.4212-1.4141-7.3281-2.6133s-3.5152-1.2183-4.1836-3.0859c-0.6684-1.8677-0.86846-5.4631-0.6914-7.7832 0.71905-2.2784 1.0413-3.9685 2.2012-6.4453s2.692-4.9883 3.8125-7.7012 1.593-5.3919 1.416-6.9434-1.1988-2.7694-2.3379-2.7695-2.2804 0.62772-3.6953 1.8262c-1.4149 1.1985-2.0657 2.968-4.0508 5.9551-1.3955 2.9871-2.3367 5.7814-3.1816 8.7285-0.82941 2.8928-2.0458 5.3457-2.3203 6.6816-0.30806 1.4989-2.012 1.833-3.8398 2.2656-1.903 0.45048-4.3153-0.03278-6.4043-1.4551-2.3392-1.2972-3.3579-2.3435-5.127-4.2305-1.769-1.887-2.673-3.3011-3.3809-4.9922-0.70786-1.6911-1.1808-4.5517-0.45312-6.1836 0.72771-1.6319 2.1303-2.7055 4.666-3.9043 2.5357-1.1988 4.8681-1.9785 7.6992-2.8633 2.8312-0.88477 5.0302-1.7889 7.3106-3.0078s4.6382-2.7503 6.1328-4.1074c1.4946-1.3571 2.3596-1.9468 2.3789-3.0078s-0.92505-1.8872-2.418-2.1621c-1.4929-0.27489-3.7732-0.58809-6.9961 0.41406-3.2228 1.0022-6.094 2.1405-9.6113 3.791s-4.3838 2.3988-6.8398 3.3027c-2.456 0.90393-5.3249 1.4946-6.6816 1.1016-1.3568-0.39308-4.3843-1.65-5.3672-3.8516-0.98284-2.2016-1.5733-3.8118-2.0254-6.8984-0.42494-2.9011-0.09731-6.0189-0.59179-7.9609h-8.9922zm-134.66 25.607v17.627c2.0051-0.14901 4.0653-0.16382 6.1328 0.042969 3.537 0.35376 7.0746 1.298 9.5898 2.3984 2.5153 1.1005 4.0108 2.3592 4.4043 3.4199 0.3935 1.0607-0.31439 1.9246-1.416 3.459-1.1016 1.5344-2.594 3.7328-3.7344 6.3672-1.1404 2.6344-1.1766 4.8655-1.334 7.5391-0.15737 2.6736-0.05243 3.9298 0.35742 5.5684 1.0317 4.1248 0.73298 2.7366 1.5195 2.7754 0.78655 0.03878 2.2487-1.7519 2.8379-2.459s1.7236-0.99916 3.0586-1.9414 2.878-2.0394 5-3.2969c2.122-1.2575 4.0787-1.1769 5.6895-1.334 1.6108-0.15713 2.8781 1.3648 3.3105 3.4082 0.43242 2.0434 0.19815 4.6934-0.90234 7.1309-1.1005 2.4375-2.9816 4.0781-4.9082 5.8867-1.9266 1.8086-2.729 3.3647-4.1445 5.252-1.4156 1.8872-1.5254 2.8511-2.1152 4.4238-0.58987 1.5727-0.99303 2.2526-1.1504 3.5898-0.15736 1.3373-0.9015 2.6612-0.23242 2.3066 0.66908-0.35461 1.8333-1.8052 3.5625-3.377s5.0243-2.8467 7.1855-3.6719c2.1613-0.82517 2.7742-0.19972 4.9941-0.53906 1.9537-0.29864 2.5472-0.56142 3.5684 0.38086 1.0211 0.94228 1.9887 2.8036 2.5391 4.8086 0.55038 2.005 1.2681 3.487 2.3301 4.5488 1.062 1.0618 2.8003 1.533 4.4512 1.2969s2.6298-0.5115 3.7695-1.1797c1.1397-0.66817 1.6905-1.0612 2.3574-0.90429 0.66689 0.15693 1.4547 0.86494 2.1621 2.8691 0.70743 2.0042 2.2558 4.7232 2.8848 7.7109 0.629 2.9878 1.0055 4.0766 1.3359 5.9043 0.24703 1.661 0.02753 4.1425 0.9707 3.5527 0.94318-0.58984 3.3015-2.585 4.5586-5.1387 1.2571-2.5537 2.751-6.1733 3.2617-9.1602s0.04001-5.3464-0.43164-7.1543c-0.47165-1.8079-0.52791-2.5651 0.14062-3.7441 0.66854-1.1791 2.8951-2.5296 4.7812-3.4727 1.8862-0.94302 2.6021-1.5647 4.2129-1.5254 1.6108 0.039361 2.5363 0.40547 2.3008 2.8809-0.23556 2.4754-1.216 6.6476-1.9238 9.5176-0.70783 2.87-0.3927 4.5212 0.43359 5.4258 0.8263 0.90457 2.1619 1.0613 3.8516 0.31445 1.6897-0.74681 3.7349-2.3999 5.6211-4.4434 1.8862-2.0435 3.6168-4.4819 6.2891-7.1934 2.6723-2.7114 6.2899-5.7001 9.002-7.7832 2.712-2.0831 3.5208-2.3447 5.0527-1.7949 1.5319 0.54979 2.7916 1.9139 2.6348 4.4688-0.15695 2.5548-0.73032 5.3848-2.5781 8.0977-1.8478 2.7129-3.8858 4.3062-6.4414 6.7832s-5.6251 5.8342-7.748 7.6426-3.3808 3.0655-3.6562 4.3242c-0.27547 1.2587 0.43287 2.5154 1.9668 3.1445s3.8912 0.62918 6.3672 0.27539c2.476-0.35379 5.0708-1.0616 6.918-1.5332 1.8472-0.47161 2.949-0.70703 2.7969 1.0859-0.15221 1.793-1.5787 5.6747-2.7578 7.9941-1.1791 2.3195-2.1224 3.1054-4.1289 3.3809-2.0066 0.27551-5.0676 0.0401-8.252 0.19727-3.1843 0.15718-6.4866 0.70606-9.1992 1.8066-2.7126 1.1006-4.8335 2.751-6.0918 4.127-1.2583 1.3759-0.90189 1.5585-0.23242 2.1094 0.66947 0.55091 2.3978 0.30099 4.834 0.26172 2.4362-0.0393 4.8226 1.1456 6.9141 1.2852 3.5364 0.23587 3.1055 0.78675 4.4023 1.4941 1.2969 0.7074 1.6204 0.73855 2.6816 1.3281 1.0613 0.58959 2.2768 1.0705 1.6094 2.5234-0.41728 2.1201-1.2201 2.881-1.3301 4.7383-0.10996 1.8572-0.44446 3.3947-0.28711 4.457s0.55644 2.3975 1.3828 3.1055c0.82639 0.70796 1.9109 0.70244 3.7969 0.82031 1.8859 0.11788 2.407 1.1101 3.9004 1.3066 1.4934 0.19657 2.0448 0.43112 2.0449 1.7266 1.4e-4 1.2954-0.55178 3.6574-1.6133 6.1738-1.0615 2.5164-2.6331 5.1864-3.8125 7.1914-1.1794 2.005-0.79635 1.9229-0.875 2.8672-0.0786 0.94426 1.1338 1.0781 2.1562 1.1172 1.0225 0.0391 3.3532-1.1002 5.1211-2.0039s1.8096-1.4901 3.9316-3.1406c2.122-1.6505 3.6603-3.3666 5.9004-5.0957 2.24-1.7291 4.6-2.3065 6.4863-3.0137 1.8863-0.70717 3.3028-0.0454 4.3633 0.77929 1.0605 0.8247 1.7674 2.3979 1.7676 4.3633 1.7e-4 1.9654-0.70704 4.3247-1.9258 6.6445-1.2187 2.3198-3.148 3.5662-2.7676 5.375 0.30079 1.4299 0.5182 1.9712 1.1875 2.6797 0.6693 0.70846 1.6653 1.6808 4.0234 1.5234 2.3581-0.15731 3.4937-0.0261 6.127-1.166 2.6333-1.14 4.5994-2.6339 6.25-3.459s2.9883-0.98362 4.4414-0.04102c1.4532 0.94255 3.0256 2.988 3.9297 5.2676s1.1404 4.7951 0.51172 6.918c-0.4661 1.5739-1.4054 2.9299-2.0215 4.168h20.439c2.8e-4 -96.314-78.078-174.39-174.39-174.39zm46.25 13.23c2.1125-0.03908 7.2651 1.3881 13.008 3.4004 5.7427 2.0123 12.073 4.6102 18.553 8.3359 6.4799 3.7257 13.109 8.5776 16.035 11.408 2.9259 2.8306 2.1472 3.6404 0.53125 3.8867-1.616 0.24636-4.0697-0.07135-8.1211 0.71875-4.0514 0.7901-9.7012 2.6892-14.039 4.5762-4.3379 1.8869-7.3635 3.7625-9.6973 5.2129-2.3338 1.4504-3.9739 2.4745-4.877 2.3477-0.90302-0.12683-1.0639-1.4049-1.3516-3.957-0.2877-2.5521-0.70128-6.3749-1.3691-9.8027-0.66786-3.4279-1.5891-6.4569-2.6992-9.4824-1.1101-3.0256-2.4097-6.0472-3.4785-8.3125-1.0688-2.2654-1.9062-3.7744-2.791-5.2812-0.88478-1.5068-1.8156-3.0117 0.29688-3.0508zm91.02 67.912c0.25943-5e-3 0.58285 0.13535 0.99414 0.4668 1.6452 1.3258 4.6843 5.7263 7.7969 10.955 3.1126 5.2288 6.2986 11.283 8.877 18.299s4.5474 14.993 4.9746 19.041-0.68856 4.1704-2.0859 3.3223c-1.3974-0.84814-3.0754-2.6679-6.6894-4.6621-3.6141-1.9942-9.1655-4.1632-13.703-5.5-4.5377-1.3368-8.0607-1.8411-10.781-2.2266-2.7206-0.3855-4.6369-0.65133-5.248-1.3281-0.61112-0.6768 0.0847-1.7605 1.502-3.9024 1.4172-2.1418 3.5545-5.3391 5.2422-8.3965 1.6877-3.0574 2.9252-5.9712 4.0156-9.0039 1.0904-3.0327 2.0318-6.1842 2.666-8.6074 0.6342-2.4232 0.96149-4.1184 1.25-5.8418 0.21638-1.2926 0.41116-2.6013 1.1894-2.6152z",transform:'rotate(0 0 0)'},{d:"m143.65 0c0.49448 1.942 0.16807 5.0597 0.59301 7.9607 0.45213 3.0867 1.0428 4.6968 2.0256 6.8984s4.0088 3.4587 5.3656 3.8518 4.2257-0.19668 6.6817-1.1006c2.456-0.90393 3.323-1.6522 6.8402-3.3027s6.3889-2.7898 9.6118-3.792c3.2229-1.0022 5.5024-0.68844 6.9954-0.41355 1.4929 0.27489 2.4376 1.1003 2.4182 2.1614-0.0193 1.061-0.88379 1.6509-2.3784 3.008-1.4946 1.3571-3.8524 2.8885-6.1328 4.1074s-4.4794 2.123-7.3106 3.0078c-2.8312 0.88477-5.1628 1.6651-7.6985 2.8639-2.5357 1.1988-3.9388 2.2728-4.6665 3.9047-0.7277 1.6319-0.25436 4.4914 0.4535 6.1824 0.70786 1.6911 1.6116 3.1057 3.3806 4.9927 1.769 1.887 2.7868 2.9338 5.126 4.231 2.089 1.4223 4.5023 1.9048 6.4053 1.4543 1.8278-0.43267 3.5316-0.76731 3.8397-2.2662 0.27456-1.3359 1.4909-3.7886 2.3203-6.6814 0.84497-2.9471 1.7855-5.7411 3.181-8.7282 1.9851-2.9871 2.6363-4.7559 4.0512-5.9543 1.4149-1.1985 2.5555-1.827 3.6946-1.8269s2.1609 1.2186 2.3379 2.77-0.29549 4.2299-1.416 6.9428-2.6512 5.2234-3.8111 7.7003-1.4828 4.1679-2.2019 6.4463c-0.17706 2.3201 0.0222 5.915 0.6906 7.7827 0.6684 1.8677 2.2765 1.8865 4.1834 3.0857s5.3244 1.9067 7.3292 2.6142c2.0047 0.7075 1.8744 0.82492 3.6033 1.041 0.18863 0.02358 0.67909 0.16849 0.88169 0.18172l-0.04169-59.123zm-8.5082 114.48c-0.94151 3.1506-1.8844 6.3012-2.8288 9.4522-1.2365 2.9146-2.4741 5.8284-3.7137 8.7439-2.1361 3.1995-4.2722 6.3971-6.411 9.5967-0.69567 1.084-1.3918 2.1668-2.0908 3.2519 1.9204 0.26756 3.8357 0.53475 5.7515 0.80231 3.5254 0.50345 7.0494 1.007 10.572 1.5107 5.5529 2.1697 11.104 4.3395 16.655 6.5095 1.6786 1.8182 3.3558 3.6365 5.0316 5.455 1.1181-0.12137 2.2349-0.24262 3.3502-0.36373-1.9685-7.9762-3.9383-15.952-5.9096-23.928-3.1855-6.0558-6.372-12.111-9.5605-18.166-3.0369-4.4019-6.0745-8.8026-9.1143-13.204-0.25009 1.7512-0.50154 3.5021-0.75442 5.2533-0.32416 1.6956-0.64973 3.3914-0.97671 5.0873zm-86.625-68.066c1.2999 3.0204 2.5988 6.0417 3.8968 9.0643 0.92222 3.0288 1.8432 6.0576 2.7636 9.089 0.41523 3.8246 0.82919 7.6477 1.2424 11.474 0.16221 1.2778 0.32322 2.555 0.48355 3.8357 1.6444-1.0272 3.2848-2.0516 4.9257-3.0759 3.0267-1.8764 6.0524-3.7518 9.0771-5.6263 5.651-1.8998 11.301-3.7986 16.95-5.6964 2.4542 0.31708 4.9074 0.63515 7.3596 0.95423 0.7796-0.81067 1.5582-1.6203 2.3358-2.429-6.6285-4.8536-13.258-9.7061-19.889-14.558-6.3294-2.5997-12.659-5.1982-18.991-7.796-5.154-1.4268-10.308-2.8522-15.464-4.2771 0.93207 1.5035 1.8629 3.0076 2.7929 4.5129 0.83962 1.5084 1.6782 3.0178 2.5159 4.5282z",transform:'rotate(0 0 0)'},{d:"m-0.11719 158.74v41.377h0.11719v-0.11719h44.631c-0.01267-0.0793-0.01956-0.1532-0.03516-0.23633-0.29506-1.5723-1.0424-3.8522-1.7305-5.8574-0.68809-2.0052-1.3159-3.7334-1.9844-5.6602-0.66844-1.9267-1.376-4.0493-2.2402-4.5605-0.8642-0.51123-1.8857 0.59085-2.9863 1.6719s-2.2801 2.141-4.3438 2.9668-5.0115 1.417-8.1172 0.90625-6.3689-2.123-8.4922-4.7969c-2.1233-2.6739-3.1058-6.4056-3.1055-9.6894s0.98359-6.1114 1.9473-7.8809 1.9066-2.4769 1.9258-3.125c0.01922-0.64808-0.8858-1.2384-3.8926-2.1621-2.8787-0.88435-7.6671-2.0634-11.693-2.8359zm123.98-158.74a76.132 76.132 0 0 0 22.299 53.834 76.132 76.132 0 0 0 53.834 22.299v-10.789a65.343 65.343 0 0 1-46.205-19.139 65.343 65.343 0 0 1-19.139-46.205z",transform:'rotate(0 0 0)'},{d:"m0 141.12-0.11719 17.625c4.0263 0.77255 8.8147 1.9516 11.693 2.8359 3.0068 0.9237 3.9118 1.514 3.8926 2.1621-0.01922 0.64809-0.9621 1.3555-1.9258 3.125s-1.947 4.597-1.9473 7.8809 0.98213 7.0156 3.1055 9.6894c2.1233 2.6739 5.3865 4.2861 8.4922 4.7969s6.0536-0.0804 8.1172-0.90625c2.0636-0.82583 3.2432-1.8858 4.3438-2.9668s2.1221-2.1831 2.9863-1.6719c0.8642 0.51122 1.5718 2.6338 2.2402 4.5605 0.66844 1.9267 1.2963 3.6549 1.9844 5.6602 0.68809 2.0052 1.4354 4.2851 1.7305 5.8574 0.0156 0.0831 0.02248 0.15704 0.03516 0.23633l17.555-0.0957a62.239 58.82 0 0 0-15.768-38.992c-0.44372-0.49289-0.88996-0.9839-1.3555-1.459a62.239 58.82 0 0 0-0.95117-0.92773c-1.0766-1.0394-2.2023-2.031-3.375-2.9707a62.239 58.82 0 0 0-40.736-14.439z",transform:'rotate(0 0 0)'}],colorScheme:[["#ececec","#537870","#799682","#bb9e62","#7fa1bc","#bb9e62"]],rotations:[-90,0,-90,0,180,90,180,90,-90,0,-90,0,180,90,180,90]},/*{
			paths: [
				{
					d:"m101.01 0v100l86.602-50zm0 100v100l86.602-50z",
					transform: 'rotate(0 0 0)'
				},{
					d:"m101 100.01-86.602 49.999v-100z",
					transform: 'rotate(0 0 0)'
				},{
					d:"m101.01 0-86.604 50 86.604 50zm0 100 86.602 50v-100zl-86.604 50 86.604 50z",
					transform: 'rotate(0 0 0)'
				}
			],
			colorScheme: [
				['#80b3ff','#3771c8','#b7e9af'],
			],
			rotations: [0, 60, 120, 60,0, 60, 120, 60,0, 60, 120, 60,0, 60, 120, 60,0, 60, 120, 60,0, 60, 120, 60,0, 60, 120, 60,0, 60, 120, 60],
			type: "hexagonal"
		},*/{paths:[{d:'m101.01 0-86.604 50v100l86.604 50 86.602-50v-100z',transform:'rotate(0 0 0)'},{d:'m187.63 50a100 100 0 0 0-86.588 49.953 100 100 0 0 0 0.0293 2e-3 100 100 0 0 0 86.559-49.941z',transform:'rotate(0 0 0)'},{d:'m14.49 50.004a100 100 0 0 0 86.492 49.947 100 100 0 0 0-86.492-49.947z',transform:'rotate(0 0 0)'},{d:'m101.01 100a100 100 0 0 0 0 100 100 100 0 0 0 0-100z',transform:'rotate(0 0 0)'},{d:'m101.01 0c-17.863 30.94-17.863 69.06 0 100 17.863-30.94 17.863-69.06 0-100z',transform:'rotate(0 0 0)'},{d:'m101.07 100.04-0.0293 2e-3c17.873 30.918 50.876 49.958 86.588 49.953v-0.0137c-17.87-30.904-50.86-49.938-86.559-49.941z',transform:'rotate(0 0 0)'},{d:'m100.98 100.04c-35.676 0.0285-68.635 19.061-86.492 49.947 35.676-0.0285 68.635-19.061 86.492-49.947',transform:'rotate(0 0 0)'}],colorScheme:[['#b8e986','#3771c8','#5fd38d','#3771c8','#fd5','#5fd38d','#fd5'],['#ff7f2a','#3771c8','#5fd38d','#3771c8','#fd5','#5fd38d','#fd5'],['#ededed','#3771c8','#5fd38d','#3771c8','#fd5','#5fd38d','#fd5'],['#333','#adcdf3','#adcdf3','#adcdf3','#adcdf3','#adcdf3','#adcdf3']],rotations:[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],type:"hexagonal"}],selectedTile:0,selectedSample:0,selectedPath:0,selectedColor:0,currentColors:['#efffe8','#59f',"#d8ba31","#4cb3a0","#d40000"],colors:["#C4A45F","#FAC944","#8F7264","#8CBBAD","#F0BBAD","#ECDAA7","#000000","#333333","#7F7C7C","#C6BEBE","#EDEDED","#FFFFFF","#0000FF","#218ACE","#7DB6EF","#ABCEF2","#9EBBC0","#B6DBDB","#9DAAE0","#7F39A8","#AA72AF","#8E271C","#BC444A","#EC588C","#F0BBAD","#FECCCB","#D76233","#C47C41","#F70F0F","#FF0000","#594730","#B2906B","#8F7264","#CC9656","#F8E71C","#FEF374","#FAC944","#FAC960","#FBE700","#EDCF76","#ECDAA7","#385035","#04BE94","#B8E986","#7ED321","#417505","#90A369","#86A580","#9A8D59"]};var store=Object(__WEBPACK_IMPORTED_MODULE_4_redux__["c" /* createStore */])(__WEBPACK_IMPORTED_MODULE_7__reducers_index__["a" /* default */],initialState//window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);var Root=function Root(_ref){var store=_ref.store;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux__["a" /* Provider */],{store:store},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["a" /* HashRouter */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_app_App__["a" /* default */],null)));};Root.propTypes={store:__WEBPACK_IMPORTED_MODULE_5_prop_types__["PropTypes"].object.isRequired};/*const printState = ()=>{console.log(store.getState())}
printState();
store.subscribe(printState);
*/__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Root,{store:store}),document.getElementById('root'));/*ReactDOM.render(
	<Provider store={store}>
    <App />
	</Provider>,
    document.getElementById('root')
);*/Object(__WEBPACK_IMPORTED_MODULE_2__registerServiceWorker__["a" /* default */])();/*
ReactDOM.render(
    <HashRouter>
        <App />
    </HashRouter>,
    document.getElementById('root')
);*/

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.8.6
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var k=__webpack_require__(13),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.concurrent_mode"):60111,y=n?Symbol.for("react.forward_ref"):60112,z=n?Symbol.for("react.suspense"):60113,aa=n?Symbol.for("react.memo"):
60115,ba=n?Symbol.for("react.lazy"):60116,A="function"===typeof Symbol&&Symbol.iterator;function ca(a,b,d,c,e,g,h,f){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[d,c,e,g,h,f],m=0;a=Error(b.replace(/%s/g,function(){return l[m++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
function B(a){for(var b=arguments.length-1,d="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)d+="&args[]="+encodeURIComponent(arguments[c+1]);ca(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",d)}var C={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},D={};
function E(a,b,d){this.props=a;this.context=b;this.refs=D;this.updater=d||C}E.prototype.isReactComponent={};E.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?B("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,d){this.props=a;this.context=b;this.refs=D;this.updater=d||C}var H=G.prototype=new F;
H.constructor=G;k(H,E.prototype);H.isPureReactComponent=!0;var I={current:null},J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,d){var c=void 0,e={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=b[c]);var f=arguments.length-2;if(1===f)e.children=d;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];e.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===e[c]&&(e[c]=f[c]);return{$$typeof:p,type:a,key:g,ref:h,props:e,_owner:J.current}}
function da(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,d,c){if(P.length){var e=P.pop();e.result=a;e.keyPrefix=b;e.func=d;e.context=c;e.count=0;return e}return{result:a,keyPrefix:b,func:d,context:c,count:0}}
function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
function S(a,b,d,c){var e=typeof a;if("undefined"===e||"boolean"===e)a=null;var g=!1;if(null===a)g=!0;else switch(e){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return d(c,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){e=a[h];var f=b+T(e,h);g+=S(e,f,d,c)}else if(null===a||"object"!==typeof a?f=null:(f=A&&a[A]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),h=
0;!(e=a.next()).done;)e=e.value,f=b+T(e,h++),g+=S(e,f,d,c);else"object"===e&&(d=""+a,B("31","[object Object]"===d?"object with keys {"+Object.keys(a).join(", ")+"}":d,""));return g}function U(a,b,d){return null==a?0:S(a,"",b,d)}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ea(a,b){a.func.call(a.context,b,a.count++)}
function fa(a,b,d){var c=a.result,e=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,c,d,function(a){return a}):null!=a&&(N(a)&&(a=da(a,e+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+d)),c.push(a))}function V(a,b,d,c,e){var g="";null!=d&&(g=(""+d).replace(O,"$&/")+"/");b=Q(b,g,c,e);U(a,fa,b);R(b)}function W(){var a=I.current;null===a?B("321"):void 0;return a}
var X={Children:{map:function(a,b,d){if(null==a)return a;var c=[];V(a,c,null,b,d);return c},forEach:function(a,b,d){if(null==a)return a;b=Q(null,null,b,d);U(a,ea,b);R(b)},count:function(a){return U(a,function(){return null},null)},toArray:function(a){var b=[];V(a,b,null,function(a){return a});return b},only:function(a){N(a)?void 0:B("143");return a}},createRef:function(){return{current:null}},Component:E,PureComponent:G,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:y,render:a}},lazy:function(a){return{$$typeof:ba,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:aa,type:a,compare:void 0===b?null:b}},useCallback:function(a,b){return W().useCallback(a,b)},useContext:function(a,b){return W().useContext(a,b)},useEffect:function(a,b){return W().useEffect(a,b)},useImperativeHandle:function(a,
b,d){return W().useImperativeHandle(a,b,d)},useDebugValue:function(){},useLayoutEffect:function(a,b){return W().useLayoutEffect(a,b)},useMemo:function(a,b){return W().useMemo(a,b)},useReducer:function(a,b,d){return W().useReducer(a,b,d)},useRef:function(a){return W().useRef(a)},useState:function(a){return W().useState(a)},Fragment:r,StrictMode:t,Suspense:z,createElement:M,cloneElement:function(a,b,d){null===a||void 0===a?B("267",a):void 0;var c=void 0,e=k({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=
b){void 0!==b.ref&&(h=b.ref,f=J.current);void 0!==b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)e.children=d;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];e.children=l}return{$$typeof:p,type:a.type,key:g,ref:h,props:e,_owner:f}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.8.6",
unstable_ConcurrentMode:x,unstable_Profiler:u,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentDispatcher:I,ReactCurrentOwner:J,assign:k}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.8.6
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(13),r=__webpack_require__(54);function ba(a,b,c,d,e,f,g,h){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[c,d,e,f,g,h],k=0;a=Error(b.replace(/%s/g,function(){return l[k++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
function x(a){for(var b=arguments.length-1,c="https://reactjs.org/docs/error-decoder.html?invariant="+a,d=0;d<b;d++)c+="&args[]="+encodeURIComponent(arguments[d+1]);ba(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}aa?void 0:x("227");function ca(a,b,c,d,e,f,g,h,l){var k=Array.prototype.slice.call(arguments,3);try{b.apply(c,k)}catch(m){this.onError(m)}}
var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,l){da=!1;ea=null;ca.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,l){ja.apply(this,arguments);if(da){if(da){var k=ea;da=!1;ea=null}else x("198"),k=void 0;fa||(fa=!0,ha=k)}}var la=null,ma={};
function na(){if(la)for(var a in ma){var b=ma[a],c=la.indexOf(a);-1<c?void 0:x("96",a);if(!oa[c]){b.extractEvents?void 0:x("97",a);oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;pa.hasOwnProperty(h)?x("99",h):void 0;pa[h]=f;var l=f.phasedRegistrationNames;if(l){for(e in l)l.hasOwnProperty(e)&&qa(l[e],g,h);e=!0}else f.registrationName?(qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:x("98",d,a)}}}}
function qa(a,b,c){ra[a]?x("100",a):void 0;ra[a]=b;sa[a]=b.eventTypes[c].dependencies}var oa=[],pa={},ra={},sa={},ta=null,ua=null,va=null;function wa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=va(c);ka(d,b,void 0,a);a.currentTarget=null}function xa(a,b){null==b?x("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
function ya(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var za=null;function Aa(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)wa(a,b[d],c[d]);else b&&wa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}
var Ba={injectEventPluginOrder:function(a){la?x("101"):void 0;la=Array.prototype.slice.call(a);na()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];ma.hasOwnProperty(c)&&ma[c]===d||(ma[c]?x("102",c):void 0,ma[c]=d,b=!0)}b&&na()}};
function Ca(a,b){var c=a.stateNode;if(!c)return null;var d=ta(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?x("231",b,typeof c):void 0;
return c}function Da(a){null!==a&&(za=xa(za,a));a=za;za=null;if(a&&(ya(a,Aa),za?x("95"):void 0,fa))throw a=ha,fa=!1,ha=null,a;}var Ea=Math.random().toString(36).slice(2),Fa="__reactInternalInstance$"+Ea,Ga="__reactEventHandlers$"+Ea;function Ha(a){if(a[Fa])return a[Fa];for(;!a[Fa];)if(a.parentNode)a=a.parentNode;else return null;a=a[Fa];return 5===a.tag||6===a.tag?a:null}function Ia(a){a=a[Fa];return!a||5!==a.tag&&6!==a.tag?null:a}
function Ja(a){if(5===a.tag||6===a.tag)return a.stateNode;x("33")}function Ka(a){return a[Ga]||null}function La(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Ma(a,b,c){if(b=Ca(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a)}
function Na(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=La(b);for(b=c.length;0<b--;)Ma(c[b],"captured",a);for(b=0;b<c.length;b++)Ma(c[b],"bubbled",a)}}function Oa(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Ca(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a))}function Pa(a){a&&a.dispatchConfig.registrationName&&Oa(a._targetInst,null,a)}
function Qa(a){ya(a,Na)}var Ra=!("undefined"===typeof window||!window.document||!window.document.createElement);function Sa(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Ta={animationend:Sa("Animation","AnimationEnd"),animationiteration:Sa("Animation","AnimationIteration"),animationstart:Sa("Animation","AnimationStart"),transitionend:Sa("Transition","TransitionEnd")},Ua={},Va={};
Ra&&(Va=document.createElement("div").style,"AnimationEvent"in window||(delete Ta.animationend.animation,delete Ta.animationiteration.animation,delete Ta.animationstart.animation),"TransitionEvent"in window||delete Ta.transitionend.transition);function Wa(a){if(Ua[a])return Ua[a];if(!Ta[a])return a;var b=Ta[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Va)return Ua[a]=b[c];return a}
var Xa=Wa("animationend"),Ya=Wa("animationiteration"),Za=Wa("animationstart"),$a=Wa("transitionend"),ab="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bb=null,cb=null,db=null;
function eb(){if(db)return db;var a,b=cb,c=b.length,d,e="value"in bb?bb.value:bb.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return db=e.slice(a,1<d?1-d:void 0)}function fb(){return!0}function gb(){return!1}
function y(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?fb:gb;this.isPropagationStopped=gb;return this}
n(y.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=fb)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=fb)},persist:function(){this.isPersistent=fb},isPersistent:gb,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=gb;this._dispatchInstances=this._dispatchListeners=null}});y.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
y.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;hb(c);return c};hb(y);function ib(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function jb(a){a instanceof this?void 0:x("279");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}
function hb(a){a.eventPool=[];a.getPooled=ib;a.release=jb}var kb=y.extend({data:null}),lb=y.extend({data:null}),mb=[9,13,27,32],nb=Ra&&"CompositionEvent"in window,ob=null;Ra&&"documentMode"in document&&(ob=document.documentMode);
var pb=Ra&&"TextEvent"in window&&!ob,qb=Ra&&(!nb||ob&&8<ob&&11>=ob),rb=String.fromCharCode(32),sb={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},tb=!1;
function ub(a,b){switch(a){case "keyup":return-1!==mb.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function vb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var wb=!1;function xb(a,b){switch(a){case "compositionend":return vb(b);case "keypress":if(32!==b.which)return null;tb=!0;return rb;case "textInput":return a=b.data,a===rb&&tb?null:a;default:return null}}
function yb(a,b){if(wb)return"compositionend"===a||!nb&&ub(a,b)?(a=eb(),db=cb=bb=null,wb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return qb&&"ko"!==b.locale?null:b.data;default:return null}}
var zb={eventTypes:sb,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(nb)b:{switch(a){case "compositionstart":e=sb.compositionStart;break b;case "compositionend":e=sb.compositionEnd;break b;case "compositionupdate":e=sb.compositionUpdate;break b}e=void 0}else wb?ub(a,c)&&(e=sb.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=sb.compositionStart);e?(qb&&"ko"!==c.locale&&(wb||e!==sb.compositionStart?e===sb.compositionEnd&&wb&&(f=eb()):(bb=d,cb="value"in bb?bb.value:bb.textContent,wb=
!0)),e=kb.getPooled(e,b,c,d),f?e.data=f:(f=vb(c),null!==f&&(e.data=f)),Qa(e),f=e):f=null;(a=pb?xb(a,c):yb(a,c))?(b=lb.getPooled(sb.beforeInput,b,c,d),b.data=a,Qa(b)):b=null;return null===f?b:null===b?f:[f,b]}},Ab=null,Bb=null,Cb=null;function Db(a){if(a=ua(a)){"function"!==typeof Ab?x("280"):void 0;var b=ta(a.stateNode);Ab(a.stateNode,a.type,b)}}function Eb(a){Bb?Cb?Cb.push(a):Cb=[a]:Bb=a}function Fb(){if(Bb){var a=Bb,b=Cb;Cb=Bb=null;Db(a);if(b)for(a=0;a<b.length;a++)Db(b[a])}}
function Gb(a,b){return a(b)}function Hb(a,b,c){return a(b,c)}function Ib(){}var Jb=!1;function Kb(a,b){if(Jb)return a(b);Jb=!0;try{return Gb(a,b)}finally{if(Jb=!1,null!==Bb||null!==Cb)Ib(),Fb()}}var Lb={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Mb(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Lb[a.type]:"textarea"===b?!0:!1}
function Nb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function Ob(a){if(!Ra)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function Pb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function Qb(a){var b=Pb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function Rb(a){a._valueTracker||(a._valueTracker=Qb(a))}function Sb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=Pb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}var Tb=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Tb.hasOwnProperty("ReactCurrentDispatcher")||(Tb.ReactCurrentDispatcher={current:null});
var Ub=/^(.*)[\\\/]/,z="function"===typeof Symbol&&Symbol.for,Vb=z?Symbol.for("react.element"):60103,Wb=z?Symbol.for("react.portal"):60106,Xb=z?Symbol.for("react.fragment"):60107,Yb=z?Symbol.for("react.strict_mode"):60108,Zb=z?Symbol.for("react.profiler"):60114,$b=z?Symbol.for("react.provider"):60109,ac=z?Symbol.for("react.context"):60110,bc=z?Symbol.for("react.concurrent_mode"):60111,cc=z?Symbol.for("react.forward_ref"):60112,dc=z?Symbol.for("react.suspense"):60113,ec=z?Symbol.for("react.memo"):
60115,fc=z?Symbol.for("react.lazy"):60116,gc="function"===typeof Symbol&&Symbol.iterator;function hc(a){if(null===a||"object"!==typeof a)return null;a=gc&&a[gc]||a["@@iterator"];return"function"===typeof a?a:null}
function ic(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case bc:return"ConcurrentMode";case Xb:return"Fragment";case Wb:return"Portal";case Zb:return"Profiler";case Yb:return"StrictMode";case dc:return"Suspense"}if("object"===typeof a)switch(a.$$typeof){case ac:return"Context.Consumer";case $b:return"Context.Provider";case cc:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+
")":"ForwardRef");case ec:return ic(a.type);case fc:if(a=1===a._status?a._result:null)return ic(a)}return null}function jc(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=ic(a.type);c=null;d&&(c=ic(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ub,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
var kc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,lc=Object.prototype.hasOwnProperty,mc={},nc={};
function oc(a){if(lc.call(nc,a))return!0;if(lc.call(mc,a))return!1;if(kc.test(a))return nc[a]=!0;mc[a]=!0;return!1}function pc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function qc(a,b,c,d){if(null===b||"undefined"===typeof b||pc(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function C(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var D={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){D[a]=new C(a,0,!1,a,null)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];D[b]=new C(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){D[a]=new C(a,2,!1,a.toLowerCase(),null)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){D[a]=new C(a,2,!1,a,null)});"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){D[a]=new C(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){D[a]=new C(a,3,!0,a,null)});
["capture","download"].forEach(function(a){D[a]=new C(a,4,!1,a,null)});["cols","rows","size","span"].forEach(function(a){D[a]=new C(a,6,!1,a,null)});["rowSpan","start"].forEach(function(a){D[a]=new C(a,5,!1,a.toLowerCase(),null)});var rc=/[\-:]([a-z])/g;function sc(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(rc,
sc);D[b]=new C(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(rc,sc);D[b]=new C(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(rc,sc);D[b]=new C(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});["tabIndex","crossOrigin"].forEach(function(a){D[a]=new C(a,1,!1,a.toLowerCase(),null)});
function tc(a,b,c,d){var e=D.hasOwnProperty(b)?D[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(qc(b,c,e,d)&&(c=null),d||null===e?oc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function uc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function vc(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function wc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=uc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function xc(a,b){b=b.checked;null!=b&&tc(a,"checked",b,!1)}
function yc(a,b){xc(a,b);var c=uc(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?zc(a,b.type,c):b.hasOwnProperty("defaultValue")&&zc(a,b.type,uc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Ac(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function zc(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}var Bc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Cc(a,b,c){a=y.getPooled(Bc.change,a,b,c);a.type="change";Eb(c);Qa(a);return a}var Dc=null,Ec=null;function Fc(a){Da(a)}
function Gc(a){var b=Ja(a);if(Sb(b))return a}function Hc(a,b){if("change"===a)return b}var Ic=!1;Ra&&(Ic=Ob("input")&&(!document.documentMode||9<document.documentMode));function Jc(){Dc&&(Dc.detachEvent("onpropertychange",Kc),Ec=Dc=null)}function Kc(a){"value"===a.propertyName&&Gc(Ec)&&(a=Cc(Ec,a,Nb(a)),Kb(Fc,a))}function Lc(a,b,c){"focus"===a?(Jc(),Dc=b,Ec=c,Dc.attachEvent("onpropertychange",Kc)):"blur"===a&&Jc()}function Mc(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Gc(Ec)}
function Nc(a,b){if("click"===a)return Gc(b)}function Oc(a,b){if("input"===a||"change"===a)return Gc(b)}
var Pc={eventTypes:Bc,_isInputEventSupported:Ic,extractEvents:function(a,b,c,d){var e=b?Ja(b):window,f=void 0,g=void 0,h=e.nodeName&&e.nodeName.toLowerCase();"select"===h||"input"===h&&"file"===e.type?f=Hc:Mb(e)?Ic?f=Oc:(f=Mc,g=Lc):(h=e.nodeName)&&"input"===h.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=Nc);if(f&&(f=f(a,b)))return Cc(f,c,d);g&&g(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&zc(e,"number",e.value)}},Qc=y.extend({view:null,detail:null}),Rc={Alt:"altKey",
Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Sc(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Rc[a])?!!b[a]:!1}function Tc(){return Sc}
var Uc=0,Vc=0,Wc=!1,Xc=!1,Yc=Qc.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Tc,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Uc;Uc=a.screenX;return Wc?"mousemove"===a.type?a.screenX-b:0:(Wc=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Vc;Vc=a.screenY;return Xc?"mousemove"===a.type?a.screenY-b:0:(Xc=!0,0)}}),Zc=Yc.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),$c={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},ad={eventTypes:$c,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Ha(b):null):f=null;if(f===b)return null;var g=void 0,h=void 0,l=void 0,k=void 0;if("mouseout"===a||"mouseover"===a)g=Yc,h=$c.mouseLeave,l=$c.mouseEnter,k="mouse";
else if("pointerout"===a||"pointerover"===a)g=Zc,h=$c.pointerLeave,l=$c.pointerEnter,k="pointer";var m=null==f?e:Ja(f);e=null==b?e:Ja(b);a=g.getPooled(h,f,c,d);a.type=k+"leave";a.target=m;a.relatedTarget=e;c=g.getPooled(l,b,c,d);c.type=k+"enter";c.target=e;c.relatedTarget=m;d=b;if(f&&d)a:{b=f;e=d;k=0;for(g=b;g;g=La(g))k++;g=0;for(l=e;l;l=La(l))g++;for(;0<k-g;)b=La(b),k--;for(;0<g-k;)e=La(e),g--;for(;k--;){if(b===e||b===e.alternate)break a;b=La(b);e=La(e)}b=null}else b=null;e=b;for(b=[];f&&f!==e;){k=
f.alternate;if(null!==k&&k===e)break;b.push(f);f=La(f)}for(f=[];d&&d!==e;){k=d.alternate;if(null!==k&&k===e)break;f.push(d);d=La(d)}for(d=0;d<b.length;d++)Oa(b[d],"bubbled",a);for(d=f.length;0<d--;)Oa(f[d],"captured",c);return[a,c]}};function bd(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var cd=Object.prototype.hasOwnProperty;
function dd(a,b){if(bd(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!cd.call(b,c[d])||!bd(a[c[d]],b[c[d]]))return!1;return!0}function ed(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function fd(a){2!==ed(a)?x("188"):void 0}
function gd(a){var b=a.alternate;if(!b)return b=ed(a),3===b?x("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c.return,f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return fd(e),a;if(g===d)return fd(e),b;g=g.sibling}x("188")}if(c.return!==d.return)c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:x("189")}}c.alternate!==d?x("190"):void 0}3!==c.tag?x("188"):void 0;return c.stateNode.current===c?a:b}function hd(a){a=gd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
var id=y.extend({animationName:null,elapsedTime:null,pseudoElement:null}),jd=y.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),kd=Qc.extend({relatedTarget:null});function ld(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var md={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},nd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},od=Qc.extend({key:function(a){if(a.key){var b=md[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=ld(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?nd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Tc,charCode:function(a){return"keypress"===
a.type?ld(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?ld(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),pd=Yc.extend({dataTransfer:null}),qd=Qc.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Tc}),rd=y.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),sd=Yc.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),td=[["abort","abort"],[Xa,"animationEnd"],[Ya,"animationIteration"],[Za,"animationStart"],["canplay","canPlay"],["canplaythrough","canPlayThrough"],["drag","drag"],["dragenter","dragEnter"],["dragexit","dragExit"],["dragleave","dragLeave"],["dragover","dragOver"],["durationchange","durationChange"],["emptied","emptied"],["encrypted","encrypted"],
["ended","ended"],["error","error"],["gotpointercapture","gotPointerCapture"],["load","load"],["loadeddata","loadedData"],["loadedmetadata","loadedMetadata"],["loadstart","loadStart"],["lostpointercapture","lostPointerCapture"],["mousemove","mouseMove"],["mouseout","mouseOut"],["mouseover","mouseOver"],["playing","playing"],["pointermove","pointerMove"],["pointerout","pointerOut"],["pointerover","pointerOver"],["progress","progress"],["scroll","scroll"],["seeking","seeking"],["stalled","stalled"],
["suspend","suspend"],["timeupdate","timeUpdate"],["toggle","toggle"],["touchmove","touchMove"],[$a,"transitionEnd"],["waiting","waiting"],["wheel","wheel"]],ud={},vd={};function wd(a,b){var c=a[0];a=a[1];var d="on"+(a[0].toUpperCase()+a.slice(1));b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};ud[a]=b;vd[c]=b}
[["blur","blur"],["cancel","cancel"],["click","click"],["close","close"],["contextmenu","contextMenu"],["copy","copy"],["cut","cut"],["auxclick","auxClick"],["dblclick","doubleClick"],["dragend","dragEnd"],["dragstart","dragStart"],["drop","drop"],["focus","focus"],["input","input"],["invalid","invalid"],["keydown","keyDown"],["keypress","keyPress"],["keyup","keyUp"],["mousedown","mouseDown"],["mouseup","mouseUp"],["paste","paste"],["pause","pause"],["play","play"],["pointercancel","pointerCancel"],
["pointerdown","pointerDown"],["pointerup","pointerUp"],["ratechange","rateChange"],["reset","reset"],["seeked","seeked"],["submit","submit"],["touchcancel","touchCancel"],["touchend","touchEnd"],["touchstart","touchStart"],["volumechange","volumeChange"]].forEach(function(a){wd(a,!0)});td.forEach(function(a){wd(a,!1)});
var xd={eventTypes:ud,isInteractiveTopLevelEventType:function(a){a=vd[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=vd[a];if(!e)return null;switch(a){case "keypress":if(0===ld(c))return null;case "keydown":case "keyup":a=od;break;case "blur":case "focus":a=kd;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=Yc;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
pd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=qd;break;case Xa:case Ya:case Za:a=id;break;case $a:a=rd;break;case "scroll":a=Qc;break;case "wheel":a=sd;break;case "copy":case "cut":case "paste":a=jd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=Zc;break;default:a=y}b=a.getPooled(e,b,c,d);Qa(b);return b}},yd=xd.isInteractiveTopLevelEventType,
zd=[];function Ad(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d;for(d=c;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo;if(!d)break;a.ancestors.push(c);c=Ha(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=Nb(a.nativeEvent);d=a.topLevelType;for(var f=a.nativeEvent,g=null,h=0;h<oa.length;h++){var l=oa[h];l&&(l=l.extractEvents(d,b,f,e))&&(g=xa(g,l))}Da(g)}}var Bd=!0;
function E(a,b){if(!b)return null;var c=(yd(a)?Cd:Dd).bind(null,a);b.addEventListener(a,c,!1)}function Ed(a,b){if(!b)return null;var c=(yd(a)?Cd:Dd).bind(null,a);b.addEventListener(a,c,!0)}function Cd(a,b){Hb(Dd,a,b)}
function Dd(a,b){if(Bd){var c=Nb(b);c=Ha(c);null===c||"number"!==typeof c.tag||2===ed(c)||(c=null);if(zd.length){var d=zd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{Kb(Ad,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>zd.length&&zd.push(a)}}}var Fd={},Gd=0,Hd="_reactListenersID"+(""+Math.random()).slice(2);
function Id(a){Object.prototype.hasOwnProperty.call(a,Hd)||(a[Hd]=Gd++,Fd[a[Hd]]={});return Fd[a[Hd]]}function Jd(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function Kd(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Ld(a,b){var c=Kd(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Kd(c)}}function Md(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?Md(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}
function Nd(){for(var a=window,b=Jd();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=Jd(a.document)}return b}function Od(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
function Pd(){var a=Nd();if(Od(a)){if("selectionStart"in a)var b={start:a.selectionStart,end:a.selectionEnd};else a:{b=(b=a.ownerDocument)&&b.defaultView||window;var c=b.getSelection&&b.getSelection();if(c&&0!==c.rangeCount){b=c.anchorNode;var d=c.anchorOffset,e=c.focusNode;c=c.focusOffset;try{b.nodeType,e.nodeType}catch(A){b=null;break a}var f=0,g=-1,h=-1,l=0,k=0,m=a,p=null;b:for(;;){for(var t;;){m!==b||0!==d&&3!==m.nodeType||(g=f+d);m!==e||0!==c&&3!==m.nodeType||(h=f+c);3===m.nodeType&&(f+=m.nodeValue.length);
if(null===(t=m.firstChild))break;p=m;m=t}for(;;){if(m===a)break b;p===b&&++l===d&&(g=f);p===e&&++k===c&&(h=f);if(null!==(t=m.nextSibling))break;m=p;p=m.parentNode}m=t}b=-1===g||-1===h?null:{start:g,end:h}}else b=null}b=b||{start:0,end:0}}else b=null;return{focusedElem:a,selectionRange:b}}
function Qd(a){var b=Nd(),c=a.focusedElem,d=a.selectionRange;if(b!==c&&c&&c.ownerDocument&&Md(c.ownerDocument.documentElement,c)){if(null!==d&&Od(c))if(b=d.start,a=d.end,void 0===a&&(a=b),"selectionStart"in c)c.selectionStart=b,c.selectionEnd=Math.min(a,c.value.length);else if(a=(b=c.ownerDocument||document)&&b.defaultView||window,a.getSelection){a=a.getSelection();var e=c.textContent.length,f=Math.min(d.start,e);d=void 0===d.end?f:Math.min(d.end,e);!a.extend&&f>d&&(e=d,d=f,f=e);e=Ld(c,f);var g=Ld(c,
d);e&&g&&(1!==a.rangeCount||a.anchorNode!==e.node||a.anchorOffset!==e.offset||a.focusNode!==g.node||a.focusOffset!==g.offset)&&(b=b.createRange(),b.setStart(e.node,e.offset),a.removeAllRanges(),f>d?(a.addRange(b),a.extend(g.node,g.offset)):(b.setEnd(g.node,g.offset),a.addRange(b)))}b=[];for(a=c;a=a.parentNode;)1===a.nodeType&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});"function"===typeof c.focus&&c.focus();for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,a.element.scrollTop=a.top}}
var Rd=Ra&&"documentMode"in document&&11>=document.documentMode,Sd={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},Td=null,Ud=null,Vd=null,Wd=!1;
function Xd(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(Wd||null==Td||Td!==Jd(c))return null;c=Td;"selectionStart"in c&&Od(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return Vd&&dd(Vd,c)?null:(Vd=c,a=y.getPooled(Sd.select,Ud,a,b),a.type="select",a.target=Td,Qa(a),a)}
var Yd={eventTypes:Sd,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Id(e);f=sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Ja(b):window;switch(a){case "focus":if(Mb(e)||"true"===e.contentEditable)Td=e,Ud=b,Vd=null;break;case "blur":Vd=Ud=Td=null;break;case "mousedown":Wd=!0;break;case "contextmenu":case "mouseup":case "dragend":return Wd=!1,Xd(c,d);case "selectionchange":if(Rd)break;
case "keydown":case "keyup":return Xd(c,d)}return null}};Ba.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ta=Ka;ua=Ia;va=Ja;Ba.injectEventPluginsByName({SimpleEventPlugin:xd,EnterLeaveEventPlugin:ad,ChangeEventPlugin:Pc,SelectEventPlugin:Yd,BeforeInputEventPlugin:zb});function Zd(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}
function $d(a,b){a=n({children:void 0},b);if(b=Zd(b.children))a.children=b;return a}function ae(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+uc(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function be(a,b){null!=b.dangerouslySetInnerHTML?x("91"):void 0;return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function ce(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?x("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:x("93"),b=b[0]),c=b),null==c&&(c=""));a._wrapperState={initialValue:uc(c)}}
function de(a,b){var c=uc(b.value),d=uc(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function ee(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var fe={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function ge(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function he(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?ge(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var ie=void 0,je=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==fe.svg||"innerHTML"in a)a.innerHTML=b;else{ie=ie||document.createElement("div");ie.innerHTML="<svg>"+b+"</svg>";for(b=ie.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function ke(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var le={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},me=["Webkit","ms","Moz","O"];Object.keys(le).forEach(function(a){me.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);le[b]=le[a]})});function ne(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||le.hasOwnProperty(a)&&le[a]?(""+b).trim():b+"px"}
function oe(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ne(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var pe=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function qe(a,b){b&&(pe[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?x("137",a,""):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?x("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:x("61")),null!=b.style&&"object"!==typeof b.style?x("62",""):void 0)}
function re(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}
function se(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Id(a);b=sa[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.hasOwnProperty(e)||!c[e]){switch(e){case "scroll":Ed("scroll",a);break;case "focus":case "blur":Ed("focus",a);Ed("blur",a);c.blur=!0;c.focus=!0;break;case "cancel":case "close":Ob(e)&&Ed(e,a);break;case "invalid":case "submit":case "reset":break;default:-1===ab.indexOf(e)&&E(e,a)}c[e]=!0}}}function te(){}var ue=null,ve=null;
function we(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}function xe(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}
var ye="function"===typeof setTimeout?setTimeout:void 0,ze="function"===typeof clearTimeout?clearTimeout:void 0,Ae=r.unstable_scheduleCallback,Be=r.unstable_cancelCallback;
function Ce(a,b,c,d,e){a[Ga]=e;"input"===c&&"radio"===e.type&&null!=e.name&&xc(a,e);re(c,d);d=re(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?oe(a,h):"dangerouslySetInnerHTML"===g?je(a,h):"children"===g?ke(a,h):tc(a,g,h,d)}switch(c){case "input":yc(a,e);break;case "textarea":de(a,e);break;case "select":b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?ae(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?ae(a,!!e.multiple,e.defaultValue,
!0):ae(a,!!e.multiple,e.multiple?[]:"",!1))}}function De(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}function Ee(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}new Set;var Fe=[],Ge=-1;function F(a){0>Ge||(a.current=Fe[Ge],Fe[Ge]=null,Ge--)}function G(a,b){Ge++;Fe[Ge]=a.current;a.current=b}var He={},H={current:He},I={current:!1},Ie=He;
function Je(a,b){var c=a.type.contextTypes;if(!c)return He;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function J(a){a=a.childContextTypes;return null!==a&&void 0!==a}function Ke(a){F(I,a);F(H,a)}function Le(a){F(I,a);F(H,a)}
function Me(a,b,c){H.current!==He?x("168"):void 0;G(H,b,a);G(I,c,a)}function Ne(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)e in a?void 0:x("108",ic(b)||"Unknown",e);return n({},c,d)}function Oe(a){var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||He;Ie=H.current;G(H,b,a);G(I,I.current,a);return!0}
function Pe(a,b,c){var d=a.stateNode;d?void 0:x("169");c?(b=Ne(a,b,Ie),d.__reactInternalMemoizedMergedChildContext=b,F(I,a),F(H,a),G(H,b,a)):F(I,a);G(I,c,a)}var Qe=null,Re=null;function Se(a){return function(b){try{return a(b)}catch(c){}}}
function Te(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Qe=Se(function(a){return b.onCommitFiberRoot(c,a)});Re=Se(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}
function Ue(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.contextDependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function K(a,b,c,d){return new Ue(a,b,c,d)}
function Ve(a){a=a.prototype;return!(!a||!a.isReactComponent)}function We(a){if("function"===typeof a)return Ve(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===cc)return 11;if(a===ec)return 14}return 2}
function Xe(a,b){var c=a.alternate;null===c?(c=K(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;c.contextDependencies=a.contextDependencies;c.sibling=a.sibling;
c.index=a.index;c.ref=a.ref;return c}
function Ye(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)Ve(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case Xb:return Ze(c.children,e,f,b);case bc:return $e(c,e|3,f,b);case Yb:return $e(c,e|2,f,b);case Zb:return a=K(12,c,b,e|4),a.elementType=Zb,a.type=Zb,a.expirationTime=f,a;case dc:return a=K(13,c,b,e),a.elementType=dc,a.type=dc,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case $b:g=10;break a;case ac:g=9;break a;case cc:g=11;break a;case ec:g=
14;break a;case fc:g=16;d=null;break a}x("130",null==a?a:typeof a,"")}b=K(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Ze(a,b,c,d){a=K(7,a,d,b);a.expirationTime=c;return a}function $e(a,b,c,d){a=K(8,a,d,b);b=0===(b&1)?Yb:bc;a.elementType=b;a.type=b;a.expirationTime=c;return a}function af(a,b,c){a=K(6,a,null,b);a.expirationTime=c;return a}
function bf(a,b,c){b=K(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}function cf(a,b){a.didError=!1;var c=a.earliestPendingTime;0===c?a.earliestPendingTime=a.latestPendingTime=b:c<b?a.earliestPendingTime=b:a.latestPendingTime>b&&(a.latestPendingTime=b);df(b,a)}
function ef(a,b){a.didError=!1;if(0===b)a.earliestPendingTime=0,a.latestPendingTime=0,a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=0;else{b<a.latestPingedTime&&(a.latestPingedTime=0);var c=a.latestPendingTime;0!==c&&(c>b?a.earliestPendingTime=a.latestPendingTime=0:a.earliestPendingTime>b&&(a.earliestPendingTime=a.latestPendingTime));c=a.earliestSuspendedTime;0===c?cf(a,b):b<a.latestSuspendedTime?(a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=0,cf(a,b)):
b>c&&cf(a,b)}df(0,a)}function ff(a,b){a.didError=!1;a.latestPingedTime>=b&&(a.latestPingedTime=0);var c=a.earliestPendingTime,d=a.latestPendingTime;c===b?a.earliestPendingTime=d===b?a.latestPendingTime=0:d:d===b&&(a.latestPendingTime=c);c=a.earliestSuspendedTime;d=a.latestSuspendedTime;0===c?a.earliestSuspendedTime=a.latestSuspendedTime=b:c<b?a.earliestSuspendedTime=b:d>b&&(a.latestSuspendedTime=b);df(b,a)}
function gf(a,b){var c=a.earliestPendingTime;a=a.earliestSuspendedTime;c>b&&(b=c);a>b&&(b=a);return b}function df(a,b){var c=b.earliestSuspendedTime,d=b.latestSuspendedTime,e=b.earliestPendingTime,f=b.latestPingedTime;e=0!==e?e:f;0===e&&(0===a||d<a)&&(e=d);a=e;0!==a&&c>a&&(a=c);b.nextExpirationTimeToWorkOn=e;b.expirationTime=a}function L(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}
function hf(a){var b=a._result;switch(a._status){case 1:return b;case 2:throw b;case 0:throw b;default:a._status=0;b=a._ctor;b=b();b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)});switch(a._status){case 1:return a._result;case 2:throw a._result;}a._result=b;throw b;}}var jf=(new aa.Component).refs;
function kf(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;d=a.updateQueue;null!==d&&0===a.expirationTime&&(d.baseState=c)}
var tf={isMounted:function(a){return(a=a._reactInternalFiber)?2===ed(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=lf();d=mf(d,a);var e=nf(d);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);of();pf(a,e);qf(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=lf();d=mf(d,a);var e=nf(d);e.tag=rf;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);of();pf(a,e);qf(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=lf();c=mf(c,a);var d=nf(c);d.tag=
sf;void 0!==b&&null!==b&&(d.callback=b);of();pf(a,d);qf(a,c)}};function uf(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!dd(c,d)||!dd(e,f):!0}
function vf(a,b,c){var d=!1,e=He;var f=b.contextType;"object"===typeof f&&null!==f?f=M(f):(e=J(b)?Ie:H.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Je(a,e):He);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=tf;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function wf(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&tf.enqueueReplaceState(b,b.state,null)}
function xf(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=jf;var f=b.contextType;"object"===typeof f&&null!==f?e.context=M(f):(f=J(b)?Ie:H.current,e.context=Je(a,f));f=a.updateQueue;null!==f&&(yf(a,f,c,e,d),e.state=a.memoizedState);f=b.getDerivedStateFromProps;"function"===typeof f&&(kf(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==
typeof e.componentWillMount||(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&tf.enqueueReplaceState(e,e.state,null),f=a.updateQueue,null!==f&&(yf(a,f,c,e,d),e.state=a.memoizedState));"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var zf=Array.isArray;
function Af(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(1!==c.tag?x("309"):void 0,d=c.stateNode);d?void 0:x("147",a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===jf&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?x("284"):void 0;c._owner?void 0:x("290",a)}return a}
function Bf(a,b){"textarea"!==a.type&&x("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function Cf(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=Xe(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=af(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function l(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props,d),d.ref=Af(a,b,c),d.return=a,d;d=Ye(c.type,c.key,c.props,null,a.mode,d);d.ref=Af(a,b,c);d.return=a;return d}function k(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=bf(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Ze(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=af(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Vb:return c=Ye(b.type,b.key,b.props,null,a.mode,c),c.ref=Af(a,null,b),c.return=a,c;case Wb:return b=bf(b,a.mode,c),b.return=a,b}if(zf(b)||
hc(b))return b=Ze(b,a.mode,c,null),b.return=a,b;Bf(a,b)}return null}function t(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Vb:return c.key===e?c.type===Xb?m(a,b,c.props.children,d,e):l(a,b,c,d):null;case Wb:return c.key===e?k(a,b,c,d):null}if(zf(c)||hc(c))return null!==e?null:m(a,b,c,d,null);Bf(a,c)}return null}function A(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Vb:return a=a.get(null===d.key?c:d.key)||null,d.type===Xb?m(b,a,d.props.children,e,d.key):l(b,a,d,e);case Wb:return a=a.get(null===d.key?c:d.key)||null,k(b,a,d,e)}if(zf(d)||hc(d))return a=a.get(c)||null,m(b,a,d,e,null);Bf(b,d)}return null}function v(e,g,h,k){for(var l=null,m=null,q=g,u=g=0,B=null;null!==q&&u<h.length;u++){q.index>u?(B=q,q=null):B=q.sibling;var w=t(e,q,h[u],k);if(null===w){null===q&&(q=B);break}a&&
q&&null===w.alternate&&b(e,q);g=f(w,g,u);null===m?l=w:m.sibling=w;m=w;q=B}if(u===h.length)return c(e,q),l;if(null===q){for(;u<h.length;u++)if(q=p(e,h[u],k))g=f(q,g,u),null===m?l=q:m.sibling=q,m=q;return l}for(q=d(e,q);u<h.length;u++)if(B=A(q,e,u,h[u],k))a&&null!==B.alternate&&q.delete(null===B.key?u:B.key),g=f(B,g,u),null===m?l=B:m.sibling=B,m=B;a&&q.forEach(function(a){return b(e,a)});return l}function R(e,g,h,k){var l=hc(h);"function"!==typeof l?x("150"):void 0;h=l.call(h);null==h?x("151"):void 0;
for(var m=l=null,q=g,u=g=0,B=null,w=h.next();null!==q&&!w.done;u++,w=h.next()){q.index>u?(B=q,q=null):B=q.sibling;var v=t(e,q,w.value,k);if(null===v){q||(q=B);break}a&&q&&null===v.alternate&&b(e,q);g=f(v,g,u);null===m?l=v:m.sibling=v;m=v;q=B}if(w.done)return c(e,q),l;if(null===q){for(;!w.done;u++,w=h.next())w=p(e,w.value,k),null!==w&&(g=f(w,g,u),null===m?l=w:m.sibling=w,m=w);return l}for(q=d(e,q);!w.done;u++,w=h.next())w=A(q,e,u,w.value,k),null!==w&&(a&&null!==w.alternate&&q.delete(null===w.key?u:
w.key),g=f(w,g,u),null===m?l=w:m.sibling=w,m=w);a&&q.forEach(function(a){return b(e,a)});return l}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===Xb&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Vb:a:{l=f.key;for(k=d;null!==k;){if(k.key===l)if(7===k.tag?f.type===Xb:k.elementType===f.type){c(a,k.sibling);d=e(k,f.type===Xb?f.props.children:f.props,h);d.ref=Af(a,k,f);d.return=a;a=d;break a}else{c(a,k);break}else b(a,k);k=
k.sibling}f.type===Xb?(d=Ze(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ye(f.type,f.key,f.props,null,a.mode,h),h.ref=Af(a,d,f),h.return=a,a=h)}return g(a);case Wb:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=bf(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=
""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=a,a=d):(c(a,d),d=af(f,a.mode,h),d.return=a,a=d),g(a);if(zf(f))return v(a,d,f,h);if(hc(f))return R(a,d,f,h);l&&Bf(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:h=a.type,x("152",h.displayName||h.name||"Component")}return c(a,d)}}var Df=Cf(!0),Ef=Cf(!1),Ff={},N={current:Ff},Gf={current:Ff},Hf={current:Ff};function If(a){a===Ff?x("174"):void 0;return a}
function Jf(a,b){G(Hf,b,a);G(Gf,a,a);G(N,Ff,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:he(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=he(b,c)}F(N,a);G(N,b,a)}function Kf(a){F(N,a);F(Gf,a);F(Hf,a)}function Lf(a){If(Hf.current);var b=If(N.current);var c=he(b,a.type);b!==c&&(G(Gf,a,a),G(N,c,a))}function Mf(a){Gf.current===a&&(F(N,a),F(Gf,a))}
var Nf=0,Of=2,Pf=4,Qf=8,Rf=16,Sf=32,Tf=64,Uf=128,Vf=Tb.ReactCurrentDispatcher,Wf=0,Xf=null,O=null,P=null,Yf=null,Q=null,Zf=null,$f=0,ag=null,bg=0,cg=!1,dg=null,eg=0;function fg(){x("321")}function gg(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!bd(a[c],b[c]))return!1;return!0}
function hg(a,b,c,d,e,f){Wf=f;Xf=b;P=null!==a?a.memoizedState:null;Vf.current=null===P?ig:jg;b=c(d,e);if(cg){do cg=!1,eg+=1,P=null!==a?a.memoizedState:null,Zf=Yf,ag=Q=O=null,Vf.current=jg,b=c(d,e);while(cg);dg=null;eg=0}Vf.current=kg;a=Xf;a.memoizedState=Yf;a.expirationTime=$f;a.updateQueue=ag;a.effectTag|=bg;a=null!==O&&null!==O.next;Wf=0;Zf=Q=Yf=P=O=Xf=null;$f=0;ag=null;bg=0;a?x("300"):void 0;return b}function lg(){Vf.current=kg;Wf=0;Zf=Q=Yf=P=O=Xf=null;$f=0;ag=null;bg=0;cg=!1;dg=null;eg=0}
function mg(){var a={memoizedState:null,baseState:null,queue:null,baseUpdate:null,next:null};null===Q?Yf=Q=a:Q=Q.next=a;return Q}function ng(){if(null!==Zf)Q=Zf,Zf=Q.next,O=P,P=null!==O?O.next:null;else{null===P?x("310"):void 0;O=P;var a={memoizedState:O.memoizedState,baseState:O.baseState,queue:O.queue,baseUpdate:O.baseUpdate,next:null};Q=null===Q?Yf=a:Q.next=a;P=O.next}return Q}function og(a,b){return"function"===typeof b?b(a):b}
function pg(a){var b=ng(),c=b.queue;null===c?x("311"):void 0;c.lastRenderedReducer=a;if(0<eg){var d=c.dispatch;if(null!==dg){var e=dg.get(c);if(void 0!==e){dg.delete(c);var f=b.memoizedState;do f=a(f,e.action),e=e.next;while(null!==e);bd(f,b.memoizedState)||(qg=!0);b.memoizedState=f;b.baseUpdate===c.last&&(b.baseState=f);c.lastRenderedState=f;return[f,d]}}return[b.memoizedState,d]}d=c.last;var g=b.baseUpdate;f=b.baseState;null!==g?(null!==d&&(d.next=null),d=g.next):d=null!==d?d.next:null;if(null!==
d){var h=e=null,l=d,k=!1;do{var m=l.expirationTime;m<Wf?(k||(k=!0,h=g,e=f),m>$f&&($f=m)):f=l.eagerReducer===a?l.eagerState:a(f,l.action);g=l;l=l.next}while(null!==l&&l!==d);k||(h=g,e=f);bd(f,b.memoizedState)||(qg=!0);b.memoizedState=f;b.baseUpdate=h;b.baseState=e;c.lastRenderedState=f}return[b.memoizedState,c.dispatch]}
function rg(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};null===ag?(ag={lastEffect:null},ag.lastEffect=a.next=a):(b=ag.lastEffect,null===b?ag.lastEffect=a.next=a:(c=b.next,b.next=a,a.next=c,ag.lastEffect=a));return a}function sg(a,b,c,d){var e=mg();bg|=a;e.memoizedState=rg(b,c,void 0,void 0===d?null:d)}
function tg(a,b,c,d){var e=ng();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&gg(d,g.deps)){rg(Nf,c,f,d);return}}bg|=a;e.memoizedState=rg(b,c,f,d)}function ug(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function vg(){}
function wg(a,b,c){25>eg?void 0:x("301");var d=a.alternate;if(a===Xf||null!==d&&d===Xf)if(cg=!0,a={expirationTime:Wf,action:c,eagerReducer:null,eagerState:null,next:null},null===dg&&(dg=new Map),c=dg.get(b),void 0===c)dg.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a}else{of();var e=lf();e=mf(e,a);var f={expirationTime:e,action:c,eagerReducer:null,eagerState:null,next:null},g=b.last;if(null===g)f.next=f;else{var h=g.next;null!==h&&(f.next=h);g.next=f}b.last=f;if(0===a.expirationTime&&(null===
d||0===d.expirationTime)&&(d=b.lastRenderedReducer,null!==d))try{var l=b.lastRenderedState,k=d(l,c);f.eagerReducer=d;f.eagerState=k;if(bd(k,l))return}catch(m){}finally{}qf(a,e)}}
var kg={readContext:M,useCallback:fg,useContext:fg,useEffect:fg,useImperativeHandle:fg,useLayoutEffect:fg,useMemo:fg,useReducer:fg,useRef:fg,useState:fg,useDebugValue:fg},ig={readContext:M,useCallback:function(a,b){mg().memoizedState=[a,void 0===b?null:b];return a},useContext:M,useEffect:function(a,b){return sg(516,Uf|Tf,a,b)},useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return sg(4,Pf|Sf,ug.bind(null,b,a),c)},useLayoutEffect:function(a,b){return sg(4,Pf|Sf,a,b)},
useMemo:function(a,b){var c=mg();b=void 0===b?null:b;a=a();c.memoizedState=[a,b];return a},useReducer:function(a,b,c){var d=mg();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={last:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=wg.bind(null,Xf,a);return[d.memoizedState,a]},useRef:function(a){var b=mg();a={current:a};return b.memoizedState=a},useState:function(a){var b=mg();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={last:null,dispatch:null,
lastRenderedReducer:og,lastRenderedState:a};a=a.dispatch=wg.bind(null,Xf,a);return[b.memoizedState,a]},useDebugValue:vg},jg={readContext:M,useCallback:function(a,b){var c=ng();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&gg(b,d[1]))return d[0];c.memoizedState=[a,b];return a},useContext:M,useEffect:function(a,b){return tg(516,Uf|Tf,a,b)},useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return tg(4,Pf|Sf,ug.bind(null,b,a),c)},useLayoutEffect:function(a,
b){return tg(4,Pf|Sf,a,b)},useMemo:function(a,b){var c=ng();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&gg(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a},useReducer:pg,useRef:function(){return ng().memoizedState},useState:function(a){return pg(og,a)},useDebugValue:vg},xg=null,yg=null,zg=!1;
function Ag(a,b){var c=K(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function Bg(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Cg(a){if(zg){var b=yg;if(b){var c=b;if(!Bg(a,b)){b=De(c);if(!b||!Bg(a,b)){a.effectTag|=2;zg=!1;xg=a;return}Ag(xg,c)}xg=a;yg=Ee(b)}else a.effectTag|=2,zg=!1,xg=a}}function Dg(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&18!==a.tag;)a=a.return;xg=a}function Eg(a){if(a!==xg)return!1;if(!zg)return Dg(a),zg=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!xe(b,a.memoizedProps))for(b=yg;b;)Ag(a,b),b=De(b);Dg(a);yg=xg?De(a.stateNode):null;return!0}function Fg(){yg=xg=null;zg=!1}
var Gg=Tb.ReactCurrentOwner,qg=!1;function S(a,b,c,d){b.child=null===a?Ef(b,null,c,d):Df(b,a.child,c,d)}function Hg(a,b,c,d,e){c=c.render;var f=b.ref;Ig(b,e);d=hg(a,b,c,d,f,e);if(null!==a&&!qg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),Jg(a,b,e);b.effectTag|=1;S(a,b,d,e);return b.child}
function Kg(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!Ve(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,Lg(a,b,g,d,e,f);a=Ye(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:dd,c(e,d)&&a.ref===b.ref))return Jg(a,b,f);b.effectTag|=1;a=Xe(g,d,f);a.ref=b.ref;a.return=b;return b.child=a}
function Lg(a,b,c,d,e,f){return null!==a&&dd(a.memoizedProps,d)&&a.ref===b.ref&&(qg=!1,e<f)?Jg(a,b,f):Mg(a,b,c,d,f)}function Ng(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function Mg(a,b,c,d,e){var f=J(c)?Ie:H.current;f=Je(b,f);Ig(b,e);c=hg(a,b,c,d,f,e);if(null!==a&&!qg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),Jg(a,b,e);b.effectTag|=1;S(a,b,c,e);return b.child}
function Og(a,b,c,d,e){if(J(c)){var f=!0;Oe(b)}else f=!1;Ig(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),vf(b,c,d,e),xf(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var l=g.context,k=c.contextType;"object"===typeof k&&null!==k?k=M(k):(k=J(c)?Ie:H.current,k=Je(b,k));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||l!==k)&&wf(b,g,d,k);Pg=!1;var t=b.memoizedState;l=g.state=t;var A=b.updateQueue;null!==A&&(yf(b,A,d,g,e),l=b.memoizedState);h!==d||t!==l||I.current||Pg?("function"===typeof m&&(kf(b,c,m,d),l=b.memoizedState),(h=Pg||uf(b,c,h,d,t,l,k))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&
g.UNSAFE_componentWillMount()),"function"===typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=l),g.props=d,g.state=l,g.context=k,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,h=b.memoizedProps,g.props=b.type===b.elementType?h:L(b.type,h),l=g.context,k=c.contextType,"object"===typeof k&&null!==k?k=M(k):(k=J(c)?Ie:H.current,k=Je(b,k)),m=c.getDerivedStateFromProps,(p="function"===
typeof m||"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||l!==k)&&wf(b,g,d,k),Pg=!1,l=b.memoizedState,t=g.state=l,A=b.updateQueue,null!==A&&(yf(b,A,d,g,e),t=b.memoizedState),h!==d||l!==t||I.current||Pg?("function"===typeof m&&(kf(b,c,m,d),t=b.memoizedState),(m=Pg||uf(b,c,h,d,l,t,k))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===
typeof g.componentWillUpdate&&g.componentWillUpdate(d,t,k),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,t,k)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=
t),g.props=d,g.state=t,g.context=k,d=m):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=256),d=!1);return Qg(a,b,c,d,f,e)}
function Qg(a,b,c,d,e,f){Ng(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Pe(b,c,!1),Jg(a,b,f);d=b.stateNode;Gg.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Df(b,a.child,null,f),b.child=Df(b,null,h,f)):S(a,b,h,f);b.memoizedState=d.state;e&&Pe(b,c,!0);return b.child}function Rg(a){var b=a.stateNode;b.pendingContext?Me(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Me(a,b.context,!1);Jf(a,b.containerInfo)}
function Sg(a,b,c){var d=b.mode,e=b.pendingProps,f=b.memoizedState;if(0===(b.effectTag&64)){f=null;var g=!1}else f={timedOutAt:null!==f?f.timedOutAt:0},g=!0,b.effectTag&=-65;if(null===a)if(g){var h=e.fallback;a=Ze(null,d,0,null);0===(b.mode&1)&&(a.child=null!==b.memoizedState?b.child.child:b.child);d=Ze(h,d,c,null);a.sibling=d;c=a;c.return=d.return=b}else c=d=Ef(b,null,e.children,c);else null!==a.memoizedState?(d=a.child,h=d.sibling,g?(c=e.fallback,e=Xe(d,d.pendingProps,0),0===(b.mode&1)&&(g=null!==
b.memoizedState?b.child.child:b.child,g!==d.child&&(e.child=g)),d=e.sibling=Xe(h,c,h.expirationTime),c=e,e.childExpirationTime=0,c.return=d.return=b):c=d=Df(b,d.child,e.children,c)):(h=a.child,g?(g=e.fallback,e=Ze(null,d,0,null),e.child=h,0===(b.mode&1)&&(e.child=null!==b.memoizedState?b.child.child:b.child),d=e.sibling=Ze(g,d,c,null),d.effectTag|=2,c=e,e.childExpirationTime=0,c.return=d.return=b):d=c=Df(b,h,e.children,c)),b.stateNode=a.stateNode;b.memoizedState=f;b.child=c;return d}
function Jg(a,b,c){null!==a&&(b.contextDependencies=a.contextDependencies);if(b.childExpirationTime<c)return null;null!==a&&b.child!==a.child?x("153"):void 0;if(null!==b.child){a=b.child;c=Xe(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Xe(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}
function Tg(a,b,c){var d=b.expirationTime;if(null!==a)if(a.memoizedProps!==b.pendingProps||I.current)qg=!0;else{if(d<c){qg=!1;switch(b.tag){case 3:Rg(b);Fg();break;case 5:Lf(b);break;case 1:J(b.type)&&Oe(b);break;case 4:Jf(b,b.stateNode.containerInfo);break;case 10:Ug(b,b.memoizedProps.value);break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;if(0!==d&&d>=c)return Sg(a,b,c);b=Jg(a,b,c);return null!==b?b.sibling:null}}return Jg(a,b,c)}}else qg=!1;b.expirationTime=0;switch(b.tag){case 2:d=
b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;var e=Je(b,H.current);Ig(b,c);e=hg(null,b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;lg();if(J(d)){var f=!0;Oe(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;var g=d.getDerivedStateFromProps;"function"===typeof g&&kf(b,d,g,a);e.updater=tf;b.stateNode=e;e._reactInternalFiber=b;xf(b,d,a,c);b=Qg(null,b,d,!0,f,
c)}else b.tag=0,S(null,b,e,c),b=b.child;return b;case 16:e=b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);f=b.pendingProps;a=hf(e);b.type=a;e=b.tag=We(a);f=L(a,f);g=void 0;switch(e){case 0:g=Mg(null,b,a,f,c);break;case 1:g=Og(null,b,a,f,c);break;case 11:g=Hg(null,b,a,f,c);break;case 14:g=Kg(null,b,a,L(a.type,f),d,c);break;default:x("306",a,"")}return g;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:L(d,e),Mg(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,
e=b.elementType===d?e:L(d,e),Og(a,b,d,e,c);case 3:Rg(b);d=b.updateQueue;null===d?x("282"):void 0;e=b.memoizedState;e=null!==e?e.element:null;yf(b,d,b.pendingProps,null,c);d=b.memoizedState.element;if(d===e)Fg(),b=Jg(a,b,c);else{e=b.stateNode;if(e=(null===a||null===a.child)&&e.hydrate)yg=Ee(b.stateNode.containerInfo),xg=b,e=zg=!0;e?(b.effectTag|=2,b.child=Ef(b,null,d,c)):(S(a,b,d,c),Fg());b=b.child}return b;case 5:return Lf(b),null===a&&Cg(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,
g=e.children,xe(d,e)?g=null:null!==f&&xe(d,f)&&(b.effectTag|=16),Ng(a,b),1!==c&&b.mode&1&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(S(a,b,g,c),b=b.child),b;case 6:return null===a&&Cg(b),null;case 13:return Sg(a,b,c);case 4:return Jf(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Df(b,null,d,c):S(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:L(d,e),Hg(a,b,d,e,c);case 7:return S(a,b,b.pendingProps,c),b.child;case 8:return S(a,b,b.pendingProps.children,
c),b.child;case 12:return S(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;Ug(b,f);if(null!==g){var h=g.value;f=bd(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0;if(0===f){if(g.children===e.children&&!I.current){b=Jg(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var l=h.contextDependencies;if(null!==l){g=h.child;for(var k=l.first;null!==k;){if(k.context===d&&0!==
(k.observedBits&f)){1===h.tag&&(k=nf(c),k.tag=sf,pf(h,k));h.expirationTime<c&&(h.expirationTime=c);k=h.alternate;null!==k&&k.expirationTime<c&&(k.expirationTime=c);k=c;for(var m=h.return;null!==m;){var p=m.alternate;if(m.childExpirationTime<k)m.childExpirationTime=k,null!==p&&p.childExpirationTime<k&&(p.childExpirationTime=k);else if(null!==p&&p.childExpirationTime<k)p.childExpirationTime=k;else break;m=m.return}l.expirationTime<c&&(l.expirationTime=c);break}k=k.next}}else g=10===h.tag?h.type===b.type?
null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=g}}S(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,Ig(b,c),e=M(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,S(a,b,d,c),b.child;case 14:return e=b.type,f=L(e,b.pendingProps),f=L(e.type,f),Kg(a,b,e,f,d,c);case 15:return Lg(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===
d?e:L(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,J(d)?(a=!0,Oe(b)):a=!1,Ig(b,c),vf(b,d,e,c),xf(b,d,e,c),Qg(null,b,d,!0,a,c)}x("156")}var Vg={current:null},Wg=null,Xg=null,Yg=null;function Ug(a,b){var c=a.type._context;G(Vg,c._currentValue,a);c._currentValue=b}function Zg(a){var b=Vg.current;F(Vg,a);a.type._context._currentValue=b}function Ig(a,b){Wg=a;Yg=Xg=null;var c=a.contextDependencies;null!==c&&c.expirationTime>=b&&(qg=!0);a.contextDependencies=null}
function M(a,b){if(Yg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)Yg=a,b=1073741823;b={context:a,observedBits:b,next:null};null===Xg?(null===Wg?x("308"):void 0,Xg=b,Wg.contextDependencies={first:b,expirationTime:0}):Xg=Xg.next=b}return a._currentValue}var $g=0,rf=1,sf=2,ah=3,Pg=!1;function bh(a){return{baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function ch(a){return{baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function nf(a){return{expirationTime:a,tag:$g,payload:null,callback:null,next:null,nextEffect:null}}function dh(a,b){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b)}
function pf(a,b){var c=a.alternate;if(null===c){var d=a.updateQueue;var e=null;null===d&&(d=a.updateQueue=bh(a.memoizedState))}else d=a.updateQueue,e=c.updateQueue,null===d?null===e?(d=a.updateQueue=bh(a.memoizedState),e=c.updateQueue=bh(c.memoizedState)):d=a.updateQueue=ch(e):null===e&&(e=c.updateQueue=ch(d));null===e||d===e?dh(d,b):null===d.lastUpdate||null===e.lastUpdate?(dh(d,b),dh(e,b)):(dh(d,b),e.lastUpdate=b)}
function eh(a,b){var c=a.updateQueue;c=null===c?a.updateQueue=bh(a.memoizedState):fh(a,c);null===c.lastCapturedUpdate?c.firstCapturedUpdate=c.lastCapturedUpdate=b:(c.lastCapturedUpdate.next=b,c.lastCapturedUpdate=b)}function fh(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=ch(b));return b}
function gh(a,b,c,d,e,f){switch(c.tag){case rf:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case ah:a.effectTag=a.effectTag&-2049|64;case $g:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return n({},d,e);case sf:Pg=!0}return d}
function yf(a,b,c,d,e){Pg=!1;b=fh(a,b);for(var f=b.baseState,g=null,h=0,l=b.firstUpdate,k=f;null!==l;){var m=l.expirationTime;m<e?(null===g&&(g=l,f=k),h<m&&(h=m)):(k=gh(a,b,l,k,c,d),null!==l.callback&&(a.effectTag|=32,l.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=l:(b.lastEffect.nextEffect=l,b.lastEffect=l)));l=l.next}m=null;for(l=b.firstCapturedUpdate;null!==l;){var p=l.expirationTime;p<e?(null===m&&(m=l,null===g&&(f=k)),h<p&&(h=p)):(k=gh(a,b,l,k,c,d),null!==l.callback&&(a.effectTag|=
32,l.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=l:(b.lastCapturedEffect.nextEffect=l,b.lastCapturedEffect=l)));l=l.next}null===g&&(b.lastUpdate=null);null===m?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===m&&(f=k);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=m;a.expirationTime=h;a.memoizedState=k}
function hh(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);ih(b.firstEffect,c);b.firstEffect=b.lastEffect=null;ih(b.firstCapturedEffect,c);b.firstCapturedEffect=b.lastCapturedEffect=null}function ih(a,b){for(;null!==a;){var c=a.callback;if(null!==c){a.callback=null;var d=b;"function"!==typeof c?x("191",c):void 0;c.call(d)}a=a.nextEffect}}
function jh(a,b){return{value:a,source:b,stack:jc(b)}}function kh(a){a.effectTag|=4}var lh=void 0,mh=void 0,nh=void 0,oh=void 0;lh=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};mh=function(){};
nh=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;If(N.current);a=null;switch(c){case "input":f=vc(g,f);d=vc(g,d);a=[];break;case "option":f=$d(g,f);d=$d(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=be(g,f);d=be(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=te)}qe(c,d);g=c=void 0;var h=null;for(c in f)if(!d.hasOwnProperty(c)&&f.hasOwnProperty(c)&&null!=f[c])if("style"===
c){var l=f[c];for(g in l)l.hasOwnProperty(g)&&(h||(h={}),h[g]="")}else"dangerouslySetInnerHTML"!==c&&"children"!==c&&"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&"autoFocus"!==c&&(ra.hasOwnProperty(c)?a||(a=[]):(a=a||[]).push(c,null));for(c in d){var k=d[c];l=null!=f?f[c]:void 0;if(d.hasOwnProperty(c)&&k!==l&&(null!=k||null!=l))if("style"===c)if(l){for(g in l)!l.hasOwnProperty(g)||k&&k.hasOwnProperty(g)||(h||(h={}),h[g]="");for(g in k)k.hasOwnProperty(g)&&l[g]!==k[g]&&(h||
(h={}),h[g]=k[g])}else h||(a||(a=[]),a.push(c,h)),h=k;else"dangerouslySetInnerHTML"===c?(k=k?k.__html:void 0,l=l?l.__html:void 0,null!=k&&l!==k&&(a=a||[]).push(c,""+k)):"children"===c?l===k||"string"!==typeof k&&"number"!==typeof k||(a=a||[]).push(c,""+k):"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&(ra.hasOwnProperty(c)?(null!=k&&se(e,c),a||l===k||(a=[])):(a=a||[]).push(c,k))}h&&(a=a||[]).push("style",h);e=a;(b.updateQueue=e)&&kh(b)}};oh=function(a,b,c,d){c!==d&&kh(b)};
var ph="function"===typeof WeakSet?WeakSet:Set;function qh(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=jc(c));null!==c&&ic(c.type);b=b.value;null!==a&&1===a.tag&&ic(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function rh(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){sh(a,c)}else b.current=null}
function th(a,b,c){c=c.updateQueue;c=null!==c?c.lastEffect:null;if(null!==c){var d=c=c.next;do{if((d.tag&a)!==Nf){var e=d.destroy;d.destroy=void 0;void 0!==e&&e()}(d.tag&b)!==Nf&&(e=d.create,d.destroy=e());d=d.next}while(d!==c)}}
function uh(a,b){for(var c=a;;){if(5===c.tag){var d=c.stateNode;if(b)d.style.display="none";else{d=c.stateNode;var e=c.memoizedProps.style;e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null;d.style.display=ne("display",e)}}else if(6===c.tag)c.stateNode.nodeValue=b?"":c.memoizedProps;else if(13===c.tag&&null!==c.memoizedState){d=c.child.sibling;d.return=c;c=d;continue}else if(null!==c.child){c.child.return=c;c=c.child;continue}if(c===a)break;for(;null===c.sibling;){if(null===c.return||
c.return===a)return;c=c.return}c.sibling.return=c.return;c=c.sibling}}
function vh(a){"function"===typeof Re&&Re(a);switch(a.tag){case 0:case 11:case 14:case 15:var b=a.updateQueue;if(null!==b&&(b=b.lastEffect,null!==b)){var c=b=b.next;do{var d=c.destroy;if(void 0!==d){var e=a;try{d()}catch(f){sh(e,f)}}c=c.next}while(c!==b)}break;case 1:rh(a);b=a.stateNode;if("function"===typeof b.componentWillUnmount)try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(f){sh(a,f)}break;case 5:rh(a);break;case 4:wh(a)}}
function xh(a){return 5===a.tag||3===a.tag||4===a.tag}
function yh(a){a:{for(var b=a.return;null!==b;){if(xh(b)){var c=b;break a}b=b.return}x("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:x("161")}c.effectTag&16&&(ke(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||xh(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&
2)continue b;if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)if(c)if(d){var f=b,g=e.stateNode,h=c;8===f.nodeType?f.parentNode.insertBefore(g,h):f.insertBefore(g,h)}else b.insertBefore(e.stateNode,c);else d?(g=b,h=e.stateNode,8===g.nodeType?(f=g.parentNode,f.insertBefore(h,g)):(f=g,f.appendChild(h)),g=g._reactRootContainer,null!==g&&void 0!==g||null!==f.onclick||(f.onclick=te)):b.appendChild(e.stateNode);
else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function wh(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b.return;a:for(;;){null===c?x("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c.return}c=!0}if(5===b.tag||6===b.tag){a:for(var f=b,g=f;;)if(vh(g),null!==g.child&&4!==g.tag)g.child.return=g,g=g.child;else{if(g===f)break;for(;null===g.sibling;){if(null===g.return||g.return===f)break a;g=g.return}g.sibling.return=g.return;g=g.sibling}e?
(f=d,g=b.stateNode,8===f.nodeType?f.parentNode.removeChild(g):f.removeChild(g)):d.removeChild(b.stateNode)}else if(4===b.tag){if(null!==b.child){d=b.stateNode.containerInfo;e=!0;b.child.return=b;b=b.child;continue}}else if(vh(b),null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return;b=b.return;4===b.tag&&(c=!1)}b.sibling.return=b.return;b=b.sibling}}
function zh(a,b){switch(b.tag){case 0:case 11:case 14:case 15:th(Pf,Qf,b);break;case 1:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&Ce(c,f,e,a,d,b)}break;case 6:null===b.stateNode?x("162"):void 0;b.stateNode.nodeValue=b.memoizedProps;break;case 3:break;case 12:break;case 13:c=b.memoizedState;d=void 0;a=b;null===c?d=!1:(d=!0,a=b.child,0===c.timedOutAt&&(c.timedOutAt=lf()));null!==a&&uh(a,d);c=
b.updateQueue;if(null!==c){b.updateQueue=null;var g=b.stateNode;null===g&&(g=b.stateNode=new ph);c.forEach(function(a){var c=Ah.bind(null,b,a);g.has(a)||(g.add(a),a.then(c,c))})}break;case 17:break;default:x("163")}}var Bh="function"===typeof WeakMap?WeakMap:Map;function Ch(a,b,c){c=nf(c);c.tag=ah;c.payload={element:null};var d=b.value;c.callback=function(){Dh(d);qh(a,b)};return c}
function Eh(a,b,c){c=nf(c);c.tag=ah;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===Fh?Fh=new Set([this]):Fh.add(this));var c=b.value,e=b.stack;qh(a,b);this.componentDidCatch(c,{componentStack:null!==e?e:""})});return c}
function Gh(a){switch(a.tag){case 1:J(a.type)&&Ke(a);var b=a.effectTag;return b&2048?(a.effectTag=b&-2049|64,a):null;case 3:return Kf(a),Le(a),b=a.effectTag,0!==(b&64)?x("285"):void 0,a.effectTag=b&-2049|64,a;case 5:return Mf(a),null;case 13:return b=a.effectTag,b&2048?(a.effectTag=b&-2049|64,a):null;case 18:return null;case 4:return Kf(a),null;case 10:return Zg(a),null;default:return null}}
var Hh=Tb.ReactCurrentDispatcher,Ih=Tb.ReactCurrentOwner,Jh=1073741822,Kh=!1,T=null,Lh=null,U=0,Mh=-1,Nh=!1,V=null,Oh=!1,Ph=null,Qh=null,Rh=null,Fh=null;function Sh(){if(null!==T)for(var a=T.return;null!==a;){var b=a;switch(b.tag){case 1:var c=b.type.childContextTypes;null!==c&&void 0!==c&&Ke(b);break;case 3:Kf(b);Le(b);break;case 5:Mf(b);break;case 4:Kf(b);break;case 10:Zg(b)}a=a.return}Lh=null;U=0;Mh=-1;Nh=!1;T=null}
function Th(){for(;null!==V;){var a=V.effectTag;a&16&&ke(V.stateNode,"");if(a&128){var b=V.alternate;null!==b&&(b=b.ref,null!==b&&("function"===typeof b?b(null):b.current=null))}switch(a&14){case 2:yh(V);V.effectTag&=-3;break;case 6:yh(V);V.effectTag&=-3;zh(V.alternate,V);break;case 4:zh(V.alternate,V);break;case 8:a=V,wh(a),a.return=null,a.child=null,a.memoizedState=null,a.updateQueue=null,a=a.alternate,null!==a&&(a.return=null,a.child=null,a.memoizedState=null,a.updateQueue=null)}V=V.nextEffect}}
function Uh(){for(;null!==V;){if(V.effectTag&256)a:{var a=V.alternate,b=V;switch(b.tag){case 0:case 11:case 15:th(Of,Nf,b);break a;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:L(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}break a;case 3:case 5:case 6:case 4:case 17:break a;default:x("163")}}V=V.nextEffect}}
function Vh(a,b){for(;null!==V;){var c=V.effectTag;if(c&36){var d=V.alternate,e=V,f=b;switch(e.tag){case 0:case 11:case 15:th(Rf,Sf,e);break;case 1:var g=e.stateNode;if(e.effectTag&4)if(null===d)g.componentDidMount();else{var h=e.elementType===e.type?d.memoizedProps:L(e.type,d.memoizedProps);g.componentDidUpdate(h,d.memoizedState,g.__reactInternalSnapshotBeforeUpdate)}d=e.updateQueue;null!==d&&hh(e,d,g,f);break;case 3:d=e.updateQueue;if(null!==d){g=null;if(null!==e.child)switch(e.child.tag){case 5:g=
e.child.stateNode;break;case 1:g=e.child.stateNode}hh(e,d,g,f)}break;case 5:f=e.stateNode;null===d&&e.effectTag&4&&we(e.type,e.memoizedProps)&&f.focus();break;case 6:break;case 4:break;case 12:break;case 13:break;case 17:break;default:x("163")}}c&128&&(e=V.ref,null!==e&&(f=V.stateNode,"function"===typeof e?e(f):e.current=f));c&512&&(Ph=a);V=V.nextEffect}}
function Wh(a,b){Rh=Qh=Ph=null;var c=W;W=!0;do{if(b.effectTag&512){var d=!1,e=void 0;try{var f=b;th(Uf,Nf,f);th(Nf,Tf,f)}catch(g){d=!0,e=g}d&&sh(b,e)}b=b.nextEffect}while(null!==b);W=c;c=a.expirationTime;0!==c&&Xh(a,c);X||W||Yh(1073741823,!1)}function of(){null!==Qh&&Be(Qh);null!==Rh&&Rh()}
function Zh(a,b){Oh=Kh=!0;a.current===b?x("177"):void 0;var c=a.pendingCommitExpirationTime;0===c?x("261"):void 0;a.pendingCommitExpirationTime=0;var d=b.expirationTime,e=b.childExpirationTime;ef(a,e>d?e:d);Ih.current=null;d=void 0;1<b.effectTag?null!==b.lastEffect?(b.lastEffect.nextEffect=b,d=b.firstEffect):d=b:d=b.firstEffect;ue=Bd;ve=Pd();Bd=!1;for(V=d;null!==V;){e=!1;var f=void 0;try{Uh()}catch(h){e=!0,f=h}e&&(null===V?x("178"):void 0,sh(V,f),null!==V&&(V=V.nextEffect))}for(V=d;null!==V;){e=!1;
f=void 0;try{Th()}catch(h){e=!0,f=h}e&&(null===V?x("178"):void 0,sh(V,f),null!==V&&(V=V.nextEffect))}Qd(ve);ve=null;Bd=!!ue;ue=null;a.current=b;for(V=d;null!==V;){e=!1;f=void 0;try{Vh(a,c)}catch(h){e=!0,f=h}e&&(null===V?x("178"):void 0,sh(V,f),null!==V&&(V=V.nextEffect))}if(null!==d&&null!==Ph){var g=Wh.bind(null,a,d);Qh=r.unstable_runWithPriority(r.unstable_NormalPriority,function(){return Ae(g)});Rh=g}Kh=Oh=!1;"function"===typeof Qe&&Qe(b.stateNode);c=b.expirationTime;b=b.childExpirationTime;b=
b>c?b:c;0===b&&(Fh=null);$h(a,b)}
function ai(a){for(;;){var b=a.alternate,c=a.return,d=a.sibling;if(0===(a.effectTag&1024)){T=a;a:{var e=b;b=a;var f=U;var g=b.pendingProps;switch(b.tag){case 2:break;case 16:break;case 15:case 0:break;case 1:J(b.type)&&Ke(b);break;case 3:Kf(b);Le(b);g=b.stateNode;g.pendingContext&&(g.context=g.pendingContext,g.pendingContext=null);if(null===e||null===e.child)Eg(b),b.effectTag&=-3;mh(b);break;case 5:Mf(b);var h=If(Hf.current);f=b.type;if(null!==e&&null!=b.stateNode)nh(e,b,f,g,h),e.ref!==b.ref&&(b.effectTag|=
128);else if(g){var l=If(N.current);if(Eg(b)){g=b;e=g.stateNode;var k=g.type,m=g.memoizedProps,p=h;e[Fa]=g;e[Ga]=m;f=void 0;h=k;switch(h){case "iframe":case "object":E("load",e);break;case "video":case "audio":for(k=0;k<ab.length;k++)E(ab[k],e);break;case "source":E("error",e);break;case "img":case "image":case "link":E("error",e);E("load",e);break;case "form":E("reset",e);E("submit",e);break;case "details":E("toggle",e);break;case "input":wc(e,m);E("invalid",e);se(p,"onChange");break;case "select":e._wrapperState=
{wasMultiple:!!m.multiple};E("invalid",e);se(p,"onChange");break;case "textarea":ce(e,m),E("invalid",e),se(p,"onChange")}qe(h,m);k=null;for(f in m)m.hasOwnProperty(f)&&(l=m[f],"children"===f?"string"===typeof l?e.textContent!==l&&(k=["children",l]):"number"===typeof l&&e.textContent!==""+l&&(k=["children",""+l]):ra.hasOwnProperty(f)&&null!=l&&se(p,f));switch(h){case "input":Rb(e);Ac(e,m,!0);break;case "textarea":Rb(e);ee(e,m);break;case "select":case "option":break;default:"function"===typeof m.onClick&&
(e.onclick=te)}f=k;g.updateQueue=f;g=null!==f?!0:!1;g&&kh(b)}else{m=b;p=f;e=g;k=9===h.nodeType?h:h.ownerDocument;l===fe.html&&(l=ge(p));l===fe.html?"script"===p?(e=k.createElement("div"),e.innerHTML="<script>\x3c/script>",k=e.removeChild(e.firstChild)):"string"===typeof e.is?k=k.createElement(p,{is:e.is}):(k=k.createElement(p),"select"===p&&(p=k,e.multiple?p.multiple=!0:e.size&&(p.size=e.size))):k=k.createElementNS(l,p);e=k;e[Fa]=m;e[Ga]=g;lh(e,b,!1,!1);p=e;k=f;m=g;var t=h,A=re(k,m);switch(k){case "iframe":case "object":E("load",
p);h=m;break;case "video":case "audio":for(h=0;h<ab.length;h++)E(ab[h],p);h=m;break;case "source":E("error",p);h=m;break;case "img":case "image":case "link":E("error",p);E("load",p);h=m;break;case "form":E("reset",p);E("submit",p);h=m;break;case "details":E("toggle",p);h=m;break;case "input":wc(p,m);h=vc(p,m);E("invalid",p);se(t,"onChange");break;case "option":h=$d(p,m);break;case "select":p._wrapperState={wasMultiple:!!m.multiple};h=n({},m,{value:void 0});E("invalid",p);se(t,"onChange");break;case "textarea":ce(p,
m);h=be(p,m);E("invalid",p);se(t,"onChange");break;default:h=m}qe(k,h);l=void 0;var v=k,R=p,u=h;for(l in u)if(u.hasOwnProperty(l)){var q=u[l];"style"===l?oe(R,q):"dangerouslySetInnerHTML"===l?(q=q?q.__html:void 0,null!=q&&je(R,q)):"children"===l?"string"===typeof q?("textarea"!==v||""!==q)&&ke(R,q):"number"===typeof q&&ke(R,""+q):"suppressContentEditableWarning"!==l&&"suppressHydrationWarning"!==l&&"autoFocus"!==l&&(ra.hasOwnProperty(l)?null!=q&&se(t,l):null!=q&&tc(R,l,q,A))}switch(k){case "input":Rb(p);
Ac(p,m,!1);break;case "textarea":Rb(p);ee(p,m);break;case "option":null!=m.value&&p.setAttribute("value",""+uc(m.value));break;case "select":h=p;h.multiple=!!m.multiple;p=m.value;null!=p?ae(h,!!m.multiple,p,!1):null!=m.defaultValue&&ae(h,!!m.multiple,m.defaultValue,!0);break;default:"function"===typeof h.onClick&&(p.onclick=te)}(g=we(f,g))&&kh(b);b.stateNode=e}null!==b.ref&&(b.effectTag|=128)}else null===b.stateNode?x("166"):void 0;break;case 6:e&&null!=b.stateNode?oh(e,b,e.memoizedProps,g):("string"!==
typeof g&&(null===b.stateNode?x("166"):void 0),e=If(Hf.current),If(N.current),Eg(b)?(g=b,f=g.stateNode,e=g.memoizedProps,f[Fa]=g,(g=f.nodeValue!==e)&&kh(b)):(f=b,g=(9===e.nodeType?e:e.ownerDocument).createTextNode(g),g[Fa]=b,f.stateNode=g));break;case 11:break;case 13:g=b.memoizedState;if(0!==(b.effectTag&64)){b.expirationTime=f;T=b;break a}g=null!==g;f=null!==e&&null!==e.memoizedState;null!==e&&!g&&f&&(e=e.child.sibling,null!==e&&(h=b.firstEffect,null!==h?(b.firstEffect=e,e.nextEffect=h):(b.firstEffect=
b.lastEffect=e,e.nextEffect=null),e.effectTag=8));if(g||f)b.effectTag|=4;break;case 7:break;case 8:break;case 12:break;case 4:Kf(b);mh(b);break;case 10:Zg(b);break;case 9:break;case 14:break;case 17:J(b.type)&&Ke(b);break;case 18:break;default:x("156")}T=null}b=a;if(1===U||1!==b.childExpirationTime){g=0;for(f=b.child;null!==f;)e=f.expirationTime,h=f.childExpirationTime,e>g&&(g=e),h>g&&(g=h),f=f.sibling;b.childExpirationTime=g}if(null!==T)return T;null!==c&&0===(c.effectTag&1024)&&(null===c.firstEffect&&
(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a))}else{a=Gh(a,U);if(null!==a)return a.effectTag&=1023,a;null!==c&&(c.firstEffect=c.lastEffect=null,c.effectTag|=1024)}if(null!==d)return d;if(null!==c)a=c;else break}return null}
function bi(a){var b=Tg(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=ai(a));Ih.current=null;return b}
function ci(a,b){Kh?x("243"):void 0;of();Kh=!0;var c=Hh.current;Hh.current=kg;var d=a.nextExpirationTimeToWorkOn;if(d!==U||a!==Lh||null===T)Sh(),Lh=a,U=d,T=Xe(Lh.current,null,U),a.pendingCommitExpirationTime=0;var e=!1;do{try{if(b)for(;null!==T&&!di();)T=bi(T);else for(;null!==T;)T=bi(T)}catch(u){if(Yg=Xg=Wg=null,lg(),null===T)e=!0,Dh(u);else{null===T?x("271"):void 0;var f=T,g=f.return;if(null===g)e=!0,Dh(u);else{a:{var h=a,l=g,k=f,m=u;g=U;k.effectTag|=1024;k.firstEffect=k.lastEffect=null;if(null!==
m&&"object"===typeof m&&"function"===typeof m.then){var p=m;m=l;var t=-1,A=-1;do{if(13===m.tag){var v=m.alternate;if(null!==v&&(v=v.memoizedState,null!==v)){A=10*(1073741822-v.timedOutAt);break}v=m.pendingProps.maxDuration;if("number"===typeof v)if(0>=v)t=0;else if(-1===t||v<t)t=v}m=m.return}while(null!==m);m=l;do{if(v=13===m.tag)v=void 0===m.memoizedProps.fallback?!1:null===m.memoizedState;if(v){l=m.updateQueue;null===l?(l=new Set,l.add(p),m.updateQueue=l):l.add(p);if(0===(m.mode&1)){m.effectTag|=
64;k.effectTag&=-1957;1===k.tag&&(null===k.alternate?k.tag=17:(g=nf(1073741823),g.tag=sf,pf(k,g)));k.expirationTime=1073741823;break a}k=h;l=g;var R=k.pingCache;null===R?(R=k.pingCache=new Bh,v=new Set,R.set(p,v)):(v=R.get(p),void 0===v&&(v=new Set,R.set(p,v)));v.has(l)||(v.add(l),k=ei.bind(null,k,p,l),p.then(k,k));-1===t?h=1073741823:(-1===A&&(A=10*(1073741822-gf(h,g))-5E3),h=A+t);0<=h&&Mh<h&&(Mh=h);m.effectTag|=2048;m.expirationTime=g;break a}m=m.return}while(null!==m);m=Error((ic(k.type)||"A React component")+
" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+jc(k))}Nh=!0;m=jh(m,k);h=l;do{switch(h.tag){case 3:h.effectTag|=2048;h.expirationTime=g;g=Ch(h,m,g);eh(h,g);break a;case 1:if(t=m,A=h.type,k=h.stateNode,0===(h.effectTag&64)&&("function"===typeof A.getDerivedStateFromError||null!==k&&"function"===typeof k.componentDidCatch&&(null===Fh||!Fh.has(k)))){h.effectTag|=2048;
h.expirationTime=g;g=Eh(h,t,g);eh(h,g);break a}}h=h.return}while(null!==h)}T=ai(f);continue}}}break}while(1);Kh=!1;Hh.current=c;Yg=Xg=Wg=null;lg();if(e)Lh=null,a.finishedWork=null;else if(null!==T)a.finishedWork=null;else{c=a.current.alternate;null===c?x("281"):void 0;Lh=null;if(Nh){e=a.latestPendingTime;f=a.latestSuspendedTime;g=a.latestPingedTime;if(0!==e&&e<d||0!==f&&f<d||0!==g&&g<d){ff(a,d);fi(a,c,d,a.expirationTime,-1);return}if(!a.didError&&b){a.didError=!0;d=a.nextExpirationTimeToWorkOn=d;
b=a.expirationTime=1073741823;fi(a,c,d,b,-1);return}}b&&-1!==Mh?(ff(a,d),b=10*(1073741822-gf(a,d)),b<Mh&&(Mh=b),b=10*(1073741822-lf()),b=Mh-b,fi(a,c,d,a.expirationTime,0>b?0:b)):(a.pendingCommitExpirationTime=d,a.finishedWork=c)}}
function sh(a,b){for(var c=a.return;null!==c;){switch(c.tag){case 1:var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===Fh||!Fh.has(d))){a=jh(b,a);a=Eh(c,a,1073741823);pf(c,a);qf(c,1073741823);return}break;case 3:a=jh(b,a);a=Ch(c,a,1073741823);pf(c,a);qf(c,1073741823);return}c=c.return}3===a.tag&&(c=jh(b,a),c=Ch(a,c,1073741823),pf(a,c),qf(a,1073741823))}
function mf(a,b){var c=r.unstable_getCurrentPriorityLevel(),d=void 0;if(0===(b.mode&1))d=1073741823;else if(Kh&&!Oh)d=U;else{switch(c){case r.unstable_ImmediatePriority:d=1073741823;break;case r.unstable_UserBlockingPriority:d=1073741822-10*(((1073741822-a+15)/10|0)+1);break;case r.unstable_NormalPriority:d=1073741822-25*(((1073741822-a+500)/25|0)+1);break;case r.unstable_LowPriority:case r.unstable_IdlePriority:d=1;break;default:x("313")}null!==Lh&&d===U&&--d}c===r.unstable_UserBlockingPriority&&
(0===gi||d<gi)&&(gi=d);return d}function ei(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);if(null!==Lh&&U===c)Lh=null;else if(b=a.earliestSuspendedTime,d=a.latestSuspendedTime,0!==b&&c<=b&&c>=d){a.didError=!1;b=a.latestPingedTime;if(0===b||b>c)a.latestPingedTime=c;df(c,a);c=a.expirationTime;0!==c&&Xh(a,c)}}function Ah(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=lf();b=mf(b,a);a=hi(a,b);null!==a&&(cf(a,b),b=a.expirationTime,0!==b&&Xh(a,b))}
function hi(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}return e}
function qf(a,b){a=hi(a,b);null!==a&&(!Kh&&0!==U&&b>U&&Sh(),cf(a,b),Kh&&!Oh&&Lh===a||Xh(a,a.expirationTime),ii>ji&&(ii=0,x("185")))}function ki(a,b,c,d,e){return r.unstable_runWithPriority(r.unstable_ImmediatePriority,function(){return a(b,c,d,e)})}var li=null,Y=null,mi=0,ni=void 0,W=!1,oi=null,Z=0,gi=0,pi=!1,qi=null,X=!1,ri=!1,si=null,ti=r.unstable_now(),ui=1073741822-(ti/10|0),vi=ui,ji=50,ii=0,wi=null;function xi(){ui=1073741822-((r.unstable_now()-ti)/10|0)}
function yi(a,b){if(0!==mi){if(b<mi)return;null!==ni&&r.unstable_cancelCallback(ni)}mi=b;a=r.unstable_now()-ti;ni=r.unstable_scheduleCallback(zi,{timeout:10*(1073741822-b)-a})}function fi(a,b,c,d,e){a.expirationTime=d;0!==e||di()?0<e&&(a.timeoutHandle=ye(Ai.bind(null,a,b,c),e)):(a.pendingCommitExpirationTime=c,a.finishedWork=b)}function Ai(a,b,c){a.pendingCommitExpirationTime=c;a.finishedWork=b;xi();vi=ui;Bi(a,c)}function $h(a,b){a.expirationTime=b;a.finishedWork=null}
function lf(){if(W)return vi;Ci();if(0===Z||1===Z)xi(),vi=ui;return vi}function Xh(a,b){null===a.nextScheduledRoot?(a.expirationTime=b,null===Y?(li=Y=a,a.nextScheduledRoot=a):(Y=Y.nextScheduledRoot=a,Y.nextScheduledRoot=li)):b>a.expirationTime&&(a.expirationTime=b);W||(X?ri&&(oi=a,Z=1073741823,Di(a,1073741823,!1)):1073741823===b?Yh(1073741823,!1):yi(a,b))}
function Ci(){var a=0,b=null;if(null!==Y)for(var c=Y,d=li;null!==d;){var e=d.expirationTime;if(0===e){null===c||null===Y?x("244"):void 0;if(d===d.nextScheduledRoot){li=Y=d.nextScheduledRoot=null;break}else if(d===li)li=e=d.nextScheduledRoot,Y.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===Y){Y=c;Y.nextScheduledRoot=li;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{e>a&&(a=e,b=d);if(d===Y)break;if(1073741823===
a)break;c=d;d=d.nextScheduledRoot}}oi=b;Z=a}var Ei=!1;function di(){return Ei?!0:r.unstable_shouldYield()?Ei=!0:!1}function zi(){try{if(!di()&&null!==li){xi();var a=li;do{var b=a.expirationTime;0!==b&&ui<=b&&(a.nextExpirationTimeToWorkOn=ui);a=a.nextScheduledRoot}while(a!==li)}Yh(0,!0)}finally{Ei=!1}}
function Yh(a,b){Ci();if(b)for(xi(),vi=ui;null!==oi&&0!==Z&&a<=Z&&!(Ei&&ui>Z);)Di(oi,Z,ui>Z),Ci(),xi(),vi=ui;else for(;null!==oi&&0!==Z&&a<=Z;)Di(oi,Z,!1),Ci();b&&(mi=0,ni=null);0!==Z&&yi(oi,Z);ii=0;wi=null;if(null!==si)for(a=si,si=null,b=0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(d){pi||(pi=!0,qi=d)}}if(pi)throw a=qi,qi=null,pi=!1,a;}function Bi(a,b){W?x("253"):void 0;oi=a;Z=b;Di(a,b,!1);Yh(1073741823,!1)}
function Di(a,b,c){W?x("245"):void 0;W=!0;if(c){var d=a.finishedWork;null!==d?Fi(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,-1!==d&&(a.timeoutHandle=-1,ze(d)),ci(a,c),d=a.finishedWork,null!==d&&(di()?a.finishedWork=d:Fi(a,d,b)))}else d=a.finishedWork,null!==d?Fi(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,-1!==d&&(a.timeoutHandle=-1,ze(d)),ci(a,c),d=a.finishedWork,null!==d&&Fi(a,d,b));W=!1}
function Fi(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime>=c&&(null===si?si=[d]:si.push(d),d._defer)){a.finishedWork=b;a.expirationTime=0;return}a.finishedWork=null;a===wi?ii++:(wi=a,ii=0);r.unstable_runWithPriority(r.unstable_ImmediatePriority,function(){Zh(a,b)})}function Dh(a){null===oi?x("246"):void 0;oi.expirationTime=0;pi||(pi=!0,qi=a)}function Gi(a,b){var c=X;X=!0;try{return a(b)}finally{(X=c)||W||Yh(1073741823,!1)}}
function Hi(a,b){if(X&&!ri){ri=!0;try{return a(b)}finally{ri=!1}}return a(b)}function Ii(a,b,c){X||W||0===gi||(Yh(gi,!1),gi=0);var d=X;X=!0;try{return r.unstable_runWithPriority(r.unstable_UserBlockingPriority,function(){return a(b,c)})}finally{(X=d)||W||Yh(1073741823,!1)}}
function Ji(a,b,c,d,e){var f=b.current;a:if(c){c=c._reactInternalFiber;b:{2===ed(c)&&1===c.tag?void 0:x("170");var g=c;do{switch(g.tag){case 3:g=g.stateNode.context;break b;case 1:if(J(g.type)){g=g.stateNode.__reactInternalMemoizedMergedChildContext;break b}}g=g.return}while(null!==g);x("171");g=void 0}if(1===c.tag){var h=c.type;if(J(h)){c=Ne(c,h,g);break a}}c=g}else c=He;null===b.context?b.context=c:b.pendingContext=c;b=e;e=nf(d);e.payload={element:a};b=void 0===b?null:b;null!==b&&(e.callback=b);
of();pf(f,e);qf(f,d);return d}function Ki(a,b,c,d){var e=b.current,f=lf();e=mf(f,e);return Ji(a,b,c,e,d)}function Li(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function Mi(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Wb,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
Ab=function(a,b,c){switch(b){case "input":yc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Ka(d);e?void 0:x("90");Sb(d);yc(d,e)}}}break;case "textarea":de(a,c);break;case "select":b=c.value,null!=b&&ae(a,!!c.multiple,b,!1)}};
function Ni(a){var b=1073741822-25*(((1073741822-lf()+500)/25|0)+1);b>=Jh&&(b=Jh-1);this._expirationTime=Jh=b;this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}Ni.prototype.render=function(a){this._defer?void 0:x("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new Oi;Ji(a,b,null,c,d._onCommit);return d};
Ni.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
Ni.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:x("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?x("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;Bi(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
null,this._defer=!1};Ni.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function Oi(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}Oi.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
Oi.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?x("191",c):void 0;c()}}};
function Pi(a,b,c){b=K(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,pingCache:null,earliestPendingTime:0,latestPendingTime:0,earliestSuspendedTime:0,latestSuspendedTime:0,latestPingedTime:0,didError:!1,pendingCommitExpirationTime:0,finishedWork:null,timeoutHandle:-1,context:null,pendingContext:null,hydrate:c,nextExpirationTimeToWorkOn:0,expirationTime:0,firstBatch:null,nextScheduledRoot:null};this._internalRoot=b.stateNode=a}
Pi.prototype.render=function(a,b){var c=this._internalRoot,d=new Oi;b=void 0===b?null:b;null!==b&&d.then(b);Ki(a,c,null,d._onCommit);return d};Pi.prototype.unmount=function(a){var b=this._internalRoot,c=new Oi;a=void 0===a?null:a;null!==a&&c.then(a);Ki(null,b,null,c._onCommit);return c};Pi.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new Oi;c=void 0===c?null:c;null!==c&&e.then(c);Ki(b,d,a,e._onCommit);return e};
Pi.prototype.createBatch=function(){var a=new Ni(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime>=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function Qi(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Gb=Gi;Hb=Ii;Ib=function(){W||0===gi||(Yh(gi,!1),gi=0)};
function Ri(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new Pi(a,!1,b)}
function Si(a,b,c,d,e){var f=c._reactRootContainer;if(f){if("function"===typeof e){var g=e;e=function(){var a=Li(f._internalRoot);g.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=Ri(c,d);if("function"===typeof e){var h=e;e=function(){var a=Li(f._internalRoot);h.call(a)}}Hi(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return Li(f._internalRoot)}
function Ti(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;Qi(b)?void 0:x("200");return Mi(a,b,null,c)}
var Vi={createPortal:Ti,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?x("188"):x("268",Object.keys(a)));a=hd(b);a=null===a?null:a.stateNode;return a},hydrate:function(a,b,c){Qi(b)?void 0:x("200");return Si(null,a,b,!0,c)},render:function(a,b,c){Qi(b)?void 0:x("200");return Si(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){Qi(c)?void 0:x("200");null==a||void 0===a._reactInternalFiber?
x("38"):void 0;return Si(a,b,c,!1,d)},unmountComponentAtNode:function(a){Qi(a)?void 0:x("40");return a._reactRootContainer?(Hi(function(){Si(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return Ti.apply(void 0,arguments)},unstable_batchedUpdates:Gi,unstable_interactiveUpdates:Ii,flushSync:function(a,b){W?x("187"):void 0;var c=X;X=!0;try{return ki(a,b)}finally{X=c,Yh(1073741823,!1)}},unstable_createRoot:Ui,unstable_flushControlled:function(a){var b=
X;X=!0;try{ki(a)}finally{(X=b)||W||Yh(1073741823,!1)}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{Events:[Ia,Ja,Ka,Ba.injectEventPluginsByName,pa,Qa,function(a){ya(a,Pa)},Eb,Fb,Dd,Da]}};function Ui(a,b){Qi(a)?void 0:x("299","unstable_createRoot");return new Pi(a,!0,null!=b&&!0===b.hydrate)}
(function(a){var b=a.findFiberByHostInstance;return Te(n({},a,{overrideProps:null,currentDispatcherRef:Tb.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hd(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))})({findFiberByHostInstance:Ha,bundleType:0,version:"16.8.6",rendererPackageName:"react-dom"});var Wi={default:Vi},Xi=Wi&&Vi||Wi;module.exports=Xi.default||Xi;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(55);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** @license React v0.13.6
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});var d=null,e=!1,g=3,k=-1,l=-1,m=!1,n=!1;function p(){if(!m){var a=d.expirationTime;n?q():n=!0;r(t,a)}}
function u(){var a=d,b=d.next;if(d===b)d=null;else{var c=d.previous;d=c.next=b;b.previous=c}a.next=a.previous=null;c=a.callback;b=a.expirationTime;a=a.priorityLevel;var f=g,Q=l;g=a;l=b;try{var h=c()}finally{g=f,l=Q}if("function"===typeof h)if(h={callback:h,priorityLevel:a,expirationTime:b,next:null,previous:null},null===d)d=h.next=h.previous=h;else{c=null;a=d;do{if(a.expirationTime>=b){c=a;break}a=a.next}while(a!==d);null===c?c=d:c===d&&(d=h,p());b=c.previous;b.next=c.previous=h;h.next=c;h.previous=
b}}function v(){if(-1===k&&null!==d&&1===d.priorityLevel){m=!0;try{do u();while(null!==d&&1===d.priorityLevel)}finally{m=!1,null!==d?p():n=!1}}}function t(a){m=!0;var b=e;e=a;try{if(a)for(;null!==d;){var c=exports.unstable_now();if(d.expirationTime<=c){do u();while(null!==d&&d.expirationTime<=c)}else break}else if(null!==d){do u();while(null!==d&&!w())}}finally{m=!1,e=b,null!==d?p():n=!1,v()}}
var x=Date,y="function"===typeof setTimeout?setTimeout:void 0,z="function"===typeof clearTimeout?clearTimeout:void 0,A="function"===typeof requestAnimationFrame?requestAnimationFrame:void 0,B="function"===typeof cancelAnimationFrame?cancelAnimationFrame:void 0,C,D;function E(a){C=A(function(b){z(D);a(b)});D=y(function(){B(C);a(exports.unstable_now())},100)}
if("object"===typeof performance&&"function"===typeof performance.now){var F=performance;exports.unstable_now=function(){return F.now()}}else exports.unstable_now=function(){return x.now()};var r,q,w,G=null;"undefined"!==typeof window?G=window:"undefined"!==typeof global&&(G=global);
if(G&&G._schedMock){var H=G._schedMock;r=H[0];q=H[1];w=H[2];exports.unstable_now=H[3]}else if("undefined"===typeof window||"function"!==typeof MessageChannel){var I=null,J=function(a){if(null!==I)try{I(a)}finally{I=null}};r=function(a){null!==I?setTimeout(r,0,a):(I=a,setTimeout(J,0,!1))};q=function(){I=null};w=function(){return!1}}else{"undefined"!==typeof console&&("function"!==typeof A&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"),
"function"!==typeof B&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"));var K=null,L=!1,M=-1,N=!1,O=!1,P=0,R=33,S=33;w=function(){return P<=exports.unstable_now()};var T=new MessageChannel,U=T.port2;T.port1.onmessage=function(){L=!1;var a=K,b=M;K=null;M=-1;var c=exports.unstable_now(),f=!1;if(0>=P-c)if(-1!==b&&b<=c)f=!0;else{N||(N=!0,E(V));K=a;M=b;return}if(null!==a){O=!0;try{a(f)}finally{O=!1}}};
var V=function(a){if(null!==K){E(V);var b=a-P+S;b<S&&R<S?(8>b&&(b=8),S=b<R?R:b):R=b;P=a+S;L||(L=!0,U.postMessage(void 0))}else N=!1};r=function(a,b){K=a;M=b;O||0>b?U.postMessage(void 0):N||(N=!0,E(V))};q=function(){K=null;L=!1;M=-1}}exports.unstable_ImmediatePriority=1;exports.unstable_UserBlockingPriority=2;exports.unstable_NormalPriority=3;exports.unstable_IdlePriority=5;exports.unstable_LowPriority=4;
exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=g,f=k;g=a;k=exports.unstable_now();try{return b()}finally{g=c,k=f,v()}};exports.unstable_next=function(a){switch(g){case 1:case 2:case 3:var b=3;break;default:b=g}var c=g,f=k;g=b;k=exports.unstable_now();try{return a()}finally{g=c,k=f,v()}};
exports.unstable_scheduleCallback=function(a,b){var c=-1!==k?k:exports.unstable_now();if("object"===typeof b&&null!==b&&"number"===typeof b.timeout)b=c+b.timeout;else switch(g){case 1:b=c+-1;break;case 2:b=c+250;break;case 5:b=c+1073741823;break;case 4:b=c+1E4;break;default:b=c+5E3}a={callback:a,priorityLevel:g,expirationTime:b,next:null,previous:null};if(null===d)d=a.next=a.previous=a,p();else{c=null;var f=d;do{if(f.expirationTime>b){c=f;break}f=f.next}while(f!==d);null===c?c=d:c===d&&(d=a,p());
b=c.previous;b.next=c.previous=a;a.next=c;a.previous=b}return a};exports.unstable_cancelCallback=function(a){var b=a.next;if(null!==b){if(b===a)d=null;else{a===d&&(d=b);var c=a.previous;c.next=b;b.previous=c}a.next=a.previous=null}};exports.unstable_wrapCallback=function(a){var b=g;return function(){var c=g,f=k;g=b;k=exports.unstable_now();try{return a.apply(this,arguments)}finally{g=c,k=f,v()}}};exports.unstable_getCurrentPriorityLevel=function(){return g};
exports.unstable_shouldYield=function(){return!e&&(null!==d&&d.expirationTime<l||w())};exports.unstable_continueExecution=function(){null!==d&&p()};exports.unstable_pauseExecution=function(){};exports.unstable_getFirstCallbackNode=function(){return d};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12)))

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl=""+'/service-worker.js';if(isLocalhost){// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);// Add some additional logging to localhost, pointing developers to the
// service worker/PWA documentation.
navigator.serviceWorker.ready.then(function(){console.log('This web app is being served cache-first by a service '+'worker. To learn more, visit https://goo.gl/SC7cgQ');});}else{// Is not local host. Just register service worker
registerValidSW(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Context__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_Subscription__ = __webpack_require__(17);







var Provider =
/*#__PURE__*/
function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Provider, _Component);

  function Provider(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    var store = props.store;
    _this.notifySubscribers = _this.notifySubscribers.bind(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this));
    var subscription = new __WEBPACK_IMPORTED_MODULE_5__utils_Subscription__["a" /* default */](store);
    subscription.onStateChange = _this.notifySubscribers;
    _this.state = {
      store: store,
      subscription: subscription
    };
    _this.previousState = store.getState();
    return _this;
  }

  var _proto = Provider.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this._isMounted = true;
    this.state.subscription.trySubscribe();

    if (this.previousState !== this.props.store.getState()) {
      this.state.subscription.notifyNestedSubs();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.unsubscribe) this.unsubscribe();
    this.state.subscription.tryUnsubscribe();
    this._isMounted = false;
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.store !== prevProps.store) {
      this.state.subscription.tryUnsubscribe();
      var subscription = new __WEBPACK_IMPORTED_MODULE_5__utils_Subscription__["a" /* default */](this.props.store);
      subscription.onStateChange = this.notifySubscribers;
      this.setState({
        store: this.props.store,
        subscription: subscription
      });
    }
  };

  _proto.notifySubscribers = function notifySubscribers() {
    this.state.subscription.notifyNestedSubs();
  };

  _proto.render = function render() {
    var Context = this.props.context || __WEBPACK_IMPORTED_MODULE_4__Context__["a" /* ReactReduxContext */];
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Context.Provider, {
      value: this.state
    }, this.props.children);
  };

  return Provider;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

Provider.propTypes = {
  store: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    subscribe: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
    dispatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
    getState: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired
  }),
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (Provider);

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(61);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var ReactIs = __webpack_require__(26);
var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};

var MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};

var TYPE_STATICS = {};
TYPE_STATICS[ReactIs.ForwardRef] = FORWARD_REF_STATICS;

function getStatics(component) {
    if (ReactIs.isMemo(component)) {
        return MEMO_STATICS;
    }
    return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        var targetStatics = getStatics(targetComponent);
        var sourceStatics = getStatics(sourceComponent);

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.8.6
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.memo"):
60115,r=b?Symbol.for("react.lazy"):60116;function t(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case r:case q:case d:return u}}}function v(a){return t(a)===m}exports.typeOf=t;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;
exports.Fragment=e;exports.Lazy=r;exports.Memo=q;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||"object"===typeof a&&null!==a&&(a.$$typeof===r||a.$$typeof===q||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n)};exports.isAsyncMode=function(a){return v(a)||t(a)===l};exports.isConcurrentMode=v;exports.isContextConsumer=function(a){return t(a)===k};
exports.isContextProvider=function(a){return t(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return t(a)===n};exports.isFragment=function(a){return t(a)===e};exports.isLazy=function(a){return t(a)===r};exports.isMemo=function(a){return t(a)===q};exports.isPortal=function(a){return t(a)===d};exports.isProfiler=function(a){return t(a)===g};exports.isStrictMode=function(a){return t(a)===f};
exports.isSuspense=function(a){return t(a)===p};


/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeProps__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectorFactory__ = __webpack_require__(72);








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? __WEBPACK_IMPORTED_MODULE_6__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? __WEBPACK_IMPORTED_MODULE_7__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areMergedPropsE,
        extraOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(28);


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["a" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(68);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(12), __webpack_require__(67)(module)))

/***/ }),
/* 67 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPlainObject;
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(28);

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_verifyPlainObject__ = __webpack_require__(29);


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verifySubselectors__ = __webpack_require__(73);


function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(30);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export useDispatch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__useStore__ = __webpack_require__(31);

/**
 * A hook to access the redux `dispatch` function. Note that in most cases where you
 * might want to use this hook it is recommended to use `useActions` instead to bind
 * action creators to the `dispatch` function.
 *
 * @returns {any|function} redux store's `dispatch` function
 *
 * @example
 *
 * import React, { useCallback } from 'react'
 * import { useReduxDispatch } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const dispatch = useDispatch()
 *   const increaseCounter = useCallback(() => dispatch({ type: 'increase-counter' }), [])
 *   return (
 *     <div>
 *       <span>{value}</span>
 *       <button onClick={increaseCounter}>Increase counter</button>
 *     </div>
 *   )
 * }
 */

function useDispatch() {
  var store = Object(__WEBPACK_IMPORTED_MODULE_0__useStore__["a" /* useStore */])();
  return store.dispatch;
}

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export useSelector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__useReduxContext__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(17);



 // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser. We need useLayoutEffect to ensure the store
// subscription callback always has the selector from the latest render commit
// available, otherwise a store update may happen between render and the effect,
// which may cause missed updates; we also must ensure the store subscription
// is created synchronously, otherwise a store update may occur before the
// subscription is created and an inconsistent state may be observed

var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react__["useLayoutEffect"] : __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"];

var refEquality = function refEquality(a, b) {
  return a === b;
};
/**
 * A hook to access the redux store's state. This hook takes a selector function
 * as an argument. The selector is called with the store state.
 *
 * This hook takes an optional equality comparison function as the second parameter
 * that allows you to customize the way the selected state is compared to determine
 * whether the component needs to be re-rendered.
 *
 * @param {Function} selector the selector function
 * @param {Function=} equalityFn the function that will be used to determine equality
 *
 * @returns {any} the selected state
 *
 * @example
 *
 * import React from 'react'
 * import { useSelector } from 'react-redux'
 *
 * export const CounterComponent = () => {
 *   const counter = useSelector(state => state.counter)
 *   return <div>{counter}</div>
 * }
 */


function useSelector(selector, equalityFn) {
  if (equalityFn === void 0) {
    equalityFn = refEquality;
  }

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(selector, "You must pass a selector to useSelectors");

  var _useReduxContext = Object(__WEBPACK_IMPORTED_MODULE_2__useReduxContext__["a" /* useReduxContext */])(),
      store = _useReduxContext.store,
      contextSub = _useReduxContext.subscription;

  var _useReducer = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(function (s) {
    return s + 1;
  }, 0),
      forceRender = _useReducer[1];

  var subscription = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](store, contextSub);
  }, [store, contextSub]);
  var latestSubscriptionCallbackError = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();
  var latestSelector = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();
  var latestSelectedState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();
  var selectedState;

  try {
    if (selector !== latestSelector.current || latestSubscriptionCallbackError.current) {
      selectedState = selector(store.getState());
    } else {
      selectedState = latestSelectedState.current;
    }
  } catch (err) {
    var errorMessage = "An error occured while selecting the store state: " + err.message + ".";

    if (latestSubscriptionCallbackError.current) {
      errorMessage += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\nOriginal stack trace:";
    }

    throw new Error(errorMessage);
  }

  useIsomorphicLayoutEffect(function () {
    latestSelector.current = selector;
    latestSelectedState.current = selectedState;
    latestSubscriptionCallbackError.current = undefined;
  });
  useIsomorphicLayoutEffect(function () {
    function checkForUpdates() {
      try {
        var newSelectedState = latestSelector.current(store.getState());

        if (equalityFn(newSelectedState, latestSelectedState.current)) {
          return;
        }

        latestSelectedState.current = newSelectedState;
      } catch (err) {
        // we ignore all errors here, since when the component
        // is re-rendered, the selectors are called again, and
        // will throw again, if neither props nor store state
        // changed
        latestSubscriptionCallbackError.current = err;
      }

      forceRender({});
    }

    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    return function () {
      return subscription.tryUnsubscribe();
    };
  }, [store, subscription]);
  return selectedState;
}

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_dom__);
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_react_dom__, "unstable_batchedUpdates")) __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_react_dom__["unstable_batchedUpdates"]; });
/* eslint-disable import/no-unresolved */


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gallery_Gallery__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__home_Home__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bussinesDevelopment_BussinesDevelopment__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sites_Rionegro__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__sites_Dosquebradas__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__header_Header__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__App_css__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__App_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mosaic_visibleDesignApp__ = __webpack_require__(131);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import DesignApp from '../designApp/DesignApp'
/*const App = () => (
  <div>
    <VisibleDesignApp/>
  </div>
)*/var App=function(_Component){_inherits(App,_Component);function App(props){_classCallCheck(this,App);var _this=_possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).call(this,props));_this.toggle=_this.toggle.bind(_this);_this.state={isOpen:false};return _this;}_createClass(App,[{key:'toggle',value:function toggle(){this.setState({isOpen:!this.state.isOpen});}},{key:'render',value:function render(){var tiles='tiles.json';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__header_Header__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'0',exact:true,path:'/',component:__WEBPACK_IMPORTED_MODULE_3__home_Home__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'1',exact:true,path:'/galeria',component:__WEBPACK_IMPORTED_MODULE_2__gallery_Gallery__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'2',exact:true,path:'/mosaicos',component:__WEBPACK_IMPORTED_MODULE_9__mosaic_visibleDesignApp__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'3',exact:true,path:'/trayectoria',component:__WEBPACK_IMPORTED_MODULE_4__bussinesDevelopment_BussinesDevelopment__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'4',exact:true,path:'/rionegro',component:__WEBPACK_IMPORTED_MODULE_5__sites_Rionegro__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{key:'5',exact:true,path:'/dosquebradas',component:__WEBPACK_IMPORTED_MODULE_6__sites_Dosquebradas__["a" /* default */]})));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(20);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (BrowserRouter);

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (warning);


/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
  if (condition) {
    return;
  }

  if (isProduction) {
    throw new Error(prefix);
  } else {
    throw new Error(prefix + ": " + (message || ''));
  }
}

/* harmony default export */ __webpack_exports__["a"] = (invariant);


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(20);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (HashRouter);

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(85);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(21);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(33);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  "aria-current": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* unused harmony default export */ var _unused_webpack_default_export = (NavLink);

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(89);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(91);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(37);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["f" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(93);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(21);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["e" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(95);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(22);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__ = __webpack_require__(37);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__["a" /* default */]);

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(22);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(99);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(35);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gallery_css__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gallery_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__gallery_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Modal__ = __webpack_require__(103);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Gallery=function(_React$Component){_inherits(Gallery,_React$Component);function Gallery(props){_classCallCheck(this,Gallery);var _this=_possibleConstructorReturn(this,(Gallery.__proto__||Object.getPrototypeOf(Gallery)).call(this,props));_this.state={filteredTiles:TILES,modal:false,modalTile:TILES[0],modalImg:null,modalDescription:null,searchReference:'',searchBackground:'',backgroundColors:["Blanco","Gris","Rojo","Trani","Verde"],tags:["Interior","Exterior","Grano","Clasica"]};_this.filterByReference=_this.filterByReference.bind(_this);_this.filterByBackground=_this.filterByBackground.bind(_this);_this.toogleModal=_this.toogleModal.bind(_this);return _this;}_createClass(Gallery,[{key:'render',value:function render(){var _this2=this;var _state=this.state,modal=_state.modal,modalImg=_state.modalImg,modalDescription=_state.modalDescription;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'responsive'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Modal__["a" /* default */],{src:modalImg,display:modal,description:modalDescription,clickOnModal:this.toogleModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gallery'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'filters'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{inline:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'reference',className:'mr-sm-2'},'Referencia'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:'reference',type:'text',placeholder:'referencia',onChange:this.filterByReference}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'selectColor',className:'mr-sm-2'},'Color de Fondo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{type:'select',name:'select',id:'selectColor',onChange:this.filterByBackground},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:99},'Todos'),this.state.backgroundColors.map(function(color,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:index},color);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'grid'},this.state.filteredTiles.map(function(tile,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,className:'cell'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"images/tiles/thumbs/"+tile.reference+".png",onClick:function onClick(e){return _this2.toogleModal(tile.reference,e);},alt:tile.reference}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'reference'},"Referencia: "+tile.reference));}))));}},{key:'filterByReference',value:function filterByReference(event){var filteredTiles=TILES.filter(function(tile){return tile.reference==event.target.value;});this.setState({filteredTiles:filteredTiles.length>0?filteredTiles:TILES});}},{key:'filterByBackground',value:function filterByBackground(event){var filteredTiles=TILES.filter(function(tile){return tile.background==event.target.value;});this.setState({filteredTiles:filteredTiles.length>0?filteredTiles:TILES});}},{key:'toogleModal',value:function toogleModal(reference){var self=this;this.setState({modal:!self.state.modal,modalImg:"images/tiles/"+reference+".png",modalDescription:reference});}}]);return Gallery;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/*
<div>Etiquetas: {tile.tags.map((tag) =>(<span>{tag}</span>))}</div>
 */var TILES=[{"reference":"1002","background":"Verde","tags":["interior","grano"],"grain":[{"name":"trani","size":""},{"name":"negro","size":""}]},{"reference":"1009","background":"Blanco","tags":["interior","grano"],"grain":[{"name":"negro","size":"3"},{"name":"gris","size":"3"},{"name":"perla","size":"3"}]},{"reference":"1010","background":"Blanco","tags":["interior","grano"],"grain":[{"name":"","size":""}]},{"reference":"1012","background":"Blanco","tags":["interior","grano"],"grain":[{"name":"","size":""}]},{"reference":"1013","background":"Gris","tags":["interior","grano"],"grain":[{"name":"","size":""}]},{"reference":"1019","background":"Trani","tags":["interior","grano"],"grain":[{"name":"","size":""}]},{"reference":"1023","background":"Verde","tags":["interior","grano"],"grain":[{"name":"","size":""}]},{"reference":"1026","background":"Rojo","tags":["interior","grano"],"grain":[{"name":"","size":""}]},{"reference":"1032","background":"Trani","tags":["interior","grano"],"grain":[{"name":"","size":""}]},{"reference":"1037","background":"Blanco","tags":["interior","grano"],"grain":[{"name":"","size":""}]},{"reference":"1038","background":"Blanco","tags":["interior","grano"],"grain":[{"name":"","size":""}]},{"reference":"1041","background":"Blanco","tags":["interior","grano"],"grain":[{"name":"","size":""}]},{"reference":"1044","background":"Gris","tags":["interior","grano"],"grain":[{"name":"","size":""}]},{"reference":"1046","background":"Verde","tags":["interior","grano"],"grain":[{"name":"","size":""}]},{"reference":"1050","background":"Blanco","tags":["interior","grano"],"grain":[{"name":"","size":""}]},{"reference":"1051","background":"Trani","tags":["interior","grano"],"grain":[{"name":"","size":""}]},{"reference":"1054","background":"Trani","tags":["interior","grano"],"grain":[{"name":"","size":""}]},{"reference":"1060","background":"Blanco","tags":["interior","grano"],"grain":[{"name":"","size":""}]},{"reference":"1061","background":"Verde","tags":["interior","grano"],"grain":[{"name":"","size":""}]},{"reference":"1067","background":"Trani","tags":["interior","grano"],"grain":[{"name":"","size":""}]},{"reference":"1075","background":"Blanco","tags":["interior","grano"],"grain":[{"name":"","size":""}]},{"reference":"1080","background":"Blanco","tags":["interior","grano"],"grain":[{"name":"","size":""}]},{"reference":"1082","background":"Blanco","tags":["interior","grano"],"grain":[{"name":"","size":""}]},{"reference":"1083","background":"Gris","tags":["interior","grano"],"grain":[{"name":"","size":""}]},{"reference":"1102","background":"Trani","tags":["interior","grano"],"grain":[{"name":"1014","size":""}]},{"reference":"9000","background":"Trani","tags":["interior","grano"],"grain":[{"name":"","size":""}]},{"reference":"9999","background":"Blanco","tags":["interior","grano"],"grain":[{"name":"","size":""}]},{"reference":"2001","background":"Otro","tags":["exterior","grano"],"grain":[{"name":"","size":""}]},{"reference":"2002","background":"Trani","tags":["exterior","grano"],"grain":[{"name":"","size":""}]},{"reference":"2003","background":"Trani","tags":["exterior","grano"],"grain":[{"name":"","size":""}]},{"reference":"2101","background":"Trani","tags":["exterior","grano"],"grain":[{"name":"","size":""}]},{"reference":"A0001","background":"","tags":["interior","clasica"],"grain":[{"name":"","size":""}]},{"reference":"A0002","background":"","tags":["interior","clasica"],"grain":[{"name":"","size":""}]},{"reference":"A0003","background":"","tags":["interior","clasica"],"grain":[{"name":"","size":""}]},{"reference":"A0004","background":"","tags":["interior","clasica"],"grain":[{"name":"","size":""}]},{"reference":"A0005","background":"","tags":["interior","clasica"],"grain":[{"name":"","size":""}]},{"reference":"A0006","background":"","tags":["interior","clasica"],"grain":[{"name":"","size":""}]},{"reference":"A0007","background":"","tags":["interior","clasica"],"grain":[{"name":"","size":""}]},{"reference":"A0008","background":"","tags":["interior","clasica"],"grain":[{"name":"","size":""}]},{"reference":"A0009","background":"","tags":["interior","clasica"],"grain":[{"name":"","size":""}]}];/* harmony default export */ __webpack_exports__["a"] = (Gallery);

/***/ }),
/* 102 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modal_css__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__modal_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Modal=function(_React$Component){_inherits(Modal,_React$Component);function Modal(props){_classCallCheck(this,Modal);var _this=_possibleConstructorReturn(this,(Modal.__proto__||Object.getPrototypeOf(Modal)).call(this,props));_this.click=_this.click.bind(_this);return _this;}_createClass(Modal,[{key:'click',value:function click(alt){this.props.clickOnModal(alt);}},{key:'render',value:function render(){var _this2=this;var _props=this.props,alt=_props.alt,src=_props.src,display=_props.display,clickOnModal=_props.clickOnModal;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'myModal',className:'modal',style:{display:display==true?"block":"none"},onClick:function onClick(e){return _this2.click(alt);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'close'},'\xD7'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'modal-content',id:'img01',src:src}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'caption'},alt));}}]);return Modal;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Modal);

/***/ }),
/* 104 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slider_Slider__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__card_Card__ = __webpack_require__(39);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Home=function(_React$Component){_inherits(Home,_React$Component);function Home(props){_classCallCheck(this,Home);return _possibleConstructorReturn(this,(Home.__proto__||Object.getPrototypeOf(Home)).call(this,props));}_createClass(Home,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__slider_Slider__["a" /* default */],{translateValue:400}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__card_Card__["a" /* default */],{title:'Productos'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Baldosa Lisa Tradicional.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Baldosa en Grano.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Baldosa en Grano para Exteriores.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Baldosa en Grano con Retal de Marmol.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Z\xF3calo Lineal.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Z\xF3calo en Media Ca\xF1a.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Lavaderos en Granito.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Bases de Marmol.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__card_Card__["a" /* default */],{title:'Servicios'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Pulida de Pisos en Grano y Marmol.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Brillada de Pisos en Grano y Marmol.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Instaci\xF3n de Pisos.')))));}}]);return Home;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Home);

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Slide=function(_Component){_inherits(Slide,_Component);function Slide(props){_classCallCheck(this,Slide);return _possibleConstructorReturn(this,(Slide.__proto__||Object.getPrototypeOf(Slide)).call(this,props));}_createClass(Slide,[{key:'render',value:function render(){var _props=this.props,image=_props.image,visible=_props.visible,description=_props.description,url=_props.url;var slideStyle={width:1200,height:500,display:visible};var imageStyle={width:1200,height:400,backgroundImage:'url(images/tiles/thumbs/'+image+'.png)',backgroundSize:'cover',backgroundRepeat:'no-repeat',backgroundPosition:'100% 100%',display:visible};var descriptionStyle={fontSize:"2rem",textDecoration:"none",textAlign:"center",color:"#f18904"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:url},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:slideStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:descriptionStyle},description),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:imageStyle})));}}]);return Slide;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Slide);

/***/ }),
/* 107 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 108 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slider_Slider__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__card_Card__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bussines_css__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bussines_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__bussines_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BussinesDevelopment=function(_React$Component){_inherits(BussinesDevelopment,_React$Component);function BussinesDevelopment(){_classCallCheck(this,BussinesDevelopment);return _possibleConstructorReturn(this,(BussinesDevelopment.__proto__||Object.getPrototypeOf(BussinesDevelopment)).apply(this,arguments));}_createClass(BussinesDevelopment,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bussines'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__slider_Slider__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__card_Card__["a" /* default */],{title:'Nuestra Historia'},'Nuestra empresa fue creada en 1990 en el municipio de Rionegro - Antioquia con la pretenci\xF3n de fabricar productos y prestar sevicios relacionados con pisos, pero nuestro compromiso nos permitieron no s\xF3lo aumentar la variedad de baldosas y z\xF3calos, sino tambi\xE9n incluir la comercializaci\xF3n de lavaderos y bases en marmol. Pero todo no termin\xF3 con la ampliaci\xF3n de nuestro cat\xE1logo, ya que por nuestro inter\xE9s de continuar creciendo y la demanda de productos y empresas como la nuestra, abrimos una sede en Santa Rosa de Cabal donde continuamos con nuestra pol\xEDtica de calidad y excelente precio.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__card_Card__["a" /* default */],{title:'Obras ejecutadas'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,' Estos son algunos de nuestros trabajos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'works'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'work'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'En Antioquia'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,' Hogar Infantil, Los Lagos '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,' Parque Educativo  San Vicente Ferrer '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,' Casa Usuarios Campesinos, La Ceja'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,' Corporaci\xF3n Semillas de Fe'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,' Cl\xEDnica Somer'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,' Hospital San Juan de Dios'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,' Escuela Baldomero San\xEDn Cano'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,' Colegio La Industrial'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,' COREDI, Rionegro'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,' COREDI, Marinilla'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,' Plaza de Mercado, El Pe\xF1ol'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,' Coliseo Ca\xF1as Gordas'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,' Instituciones Educativas en Granada'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,' Entre otros'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'work'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'En Risaralda'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Reconversi\xF3n Ley \u2013 \xC9xito, Eje Cafetero'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Baldosas del Norte Ltda'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Consorcio Hospital Victoria'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Entre otros'))))));}}]);return BussinesDevelopment;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (BussinesDevelopment);

/***/ }),
/* 110 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mapContainer_MapContainer__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Site__ = __webpack_require__(42);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Rionegro=function(_React$Component){_inherits(Rionegro,_React$Component);function Rionegro(props){_classCallCheck(this,Rionegro);return _possibleConstructorReturn(this,(Rionegro.__proto__||Object.getPrototypeOf(Rionegro)).call(this,props));}_createClass(Rionegro,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Site__["a" /* default */],{dep:'Antioquia',mun:'Rionegro',dir:'Kil\xF3metro 33 Autopista Medell\xEDn - Bogot\xE1, Vereda La Playa',tel:'312 245 4575'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__mapContainer_MapContainer__["a" /* default */],{lat:6.203354,lng:-75.38215622,zoom:16.95}));}}]);return Rionegro;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Rionegro);

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(113), __webpack_require__(117), __webpack_require__(118), __webpack_require__(121), __webpack_require__(122), __webpack_require__(124), __webpack_require__(0), __webpack_require__(1), __webpack_require__(7), __webpack_require__(10), __webpack_require__(123)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./GoogleApiComponent'), require('./components/Marker'), require('./components/InfoWindow'), require('./components/HeatMap'), require('./components/Polygon'), require('./components/Polyline'), require('react'), require('prop-types'), require('react-dom'), require('./lib/String'), require('./lib/cancelablePromise'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.GoogleApiComponent, global.Marker, global.InfoWindow, global.HeatMap, global.Polygon, global.Polyline, global.react, global.propTypes, global.reactDom, global.String, global.cancelablePromise);
    global.index = mod.exports;
  }
})(this, function (exports, _GoogleApiComponent, _Marker, _InfoWindow, _HeatMap, _Polygon, _Polyline, _react, _propTypes, _reactDom, _String, _cancelablePromise) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Map = exports.Polyline = exports.Polygon = exports.HeatMap = exports.InfoWindow = exports.Marker = exports.GoogleApiWrapper = undefined;
  Object.defineProperty(exports, 'GoogleApiWrapper', {
    enumerable: true,
    get: function () {
      return _GoogleApiComponent.wrapper;
    }
  });
  Object.defineProperty(exports, 'Marker', {
    enumerable: true,
    get: function () {
      return _Marker.Marker;
    }
  });
  Object.defineProperty(exports, 'InfoWindow', {
    enumerable: true,
    get: function () {
      return _InfoWindow.InfoWindow;
    }
  });
  Object.defineProperty(exports, 'HeatMap', {
    enumerable: true,
    get: function () {
      return _HeatMap.HeatMap;
    }
  });
  Object.defineProperty(exports, 'Polygon', {
    enumerable: true,
    get: function () {
      return _Polygon.Polygon;
    }
  });
  Object.defineProperty(exports, 'Polyline', {
    enumerable: true,
    get: function () {
      return _Polyline.Polyline;
    }
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _reactDom2 = _interopRequireDefault(_reactDom);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var mapStyles = {
    container: {
      position: 'absolute',
      width: '100%',
      height: '100%'
    },
    map: {
      position: 'absolute',
      left: 0,
      right: 0,
      bottom: 0,
      top: 0
    }
  };

  var evtNames = ['ready', 'click', 'dragend', 'recenter', 'bounds_changed', 'center_changed', 'dblclick', 'dragstart', 'heading_change', 'idle', 'maptypeid_changed', 'mousemove', 'mouseout', 'mouseover', 'projection_changed', 'resize', 'rightclick', 'tilesloaded', 'tilt_changed', 'zoom_changed'];

  var Map = exports.Map = function (_React$Component) {
    _inherits(Map, _React$Component);

    function Map(props) {
      _classCallCheck(this, Map);

      var _this = _possibleConstructorReturn(this, (Map.__proto__ || Object.getPrototypeOf(Map)).call(this, props));

      if (!props.hasOwnProperty('google')) {
        throw new Error('You must include a `google` prop');
      }

      _this.listeners = {};
      _this.state = {
        currentLocation: {
          lat: _this.props.initialCenter.lat,
          lng: _this.props.initialCenter.lng
        }
      };
      return _this;
    }

    _createClass(Map, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;

        if (this.props.centerAroundCurrentLocation) {
          if (navigator && navigator.geolocation) {
            this.geoPromise = (0, _cancelablePromise.makeCancelable)(new Promise(function (resolve, reject) {
              navigator.geolocation.getCurrentPosition(resolve, reject);
            }));

            this.geoPromise.promise.then(function (pos) {
              var coords = pos.coords;
              _this2.setState({
                currentLocation: {
                  lat: coords.latitude,
                  lng: coords.longitude
                }
              });
            }).catch(function (e) {
              return e;
            });
          }
        }
        this.loadMap();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps, prevState) {
        if (prevProps.google !== this.props.google) {
          this.loadMap();
        }
        if (this.props.visible !== prevProps.visible) {
          this.restyleMap();
        }
        if (this.props.zoom !== prevProps.zoom) {
          this.map.setZoom(this.props.zoom);
        }
        if (this.props.center !== prevProps.center) {
          this.setState({
            currentLocation: this.props.center
          });
        }
        if (prevState.currentLocation !== this.state.currentLocation) {
          this.recenterMap();
        }
        if (this.props.bounds !== prevProps.bounds) {
          this.map.fitBounds(this.props.bounds);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        var _this3 = this;

        var google = this.props.google;

        if (this.geoPromise) {
          this.geoPromise.cancel();
        }
        Object.keys(this.listeners).forEach(function (e) {
          google.maps.event.removeListener(_this3.listeners[e]);
        });
      }
    }, {
      key: 'loadMap',
      value: function loadMap() {
        var _this4 = this;

        if (this.props && this.props.google) {
          var google = this.props.google;

          var maps = google.maps;

          var mapRef = this.refs.map;
          var node = _reactDom2.default.findDOMNode(mapRef);
          var curr = this.state.currentLocation;
          var center = new maps.LatLng(curr.lat, curr.lng);

          var mapTypeIds = this.props.google.maps.MapTypeId || {};
          var mapTypeFromProps = String(this.props.mapType).toUpperCase();

          var mapConfig = Object.assign({}, {
            mapTypeId: mapTypeIds[mapTypeFromProps],
            center: center,
            zoom: this.props.zoom,
            maxZoom: this.props.maxZoom,
            minZoom: this.props.minZoom,
            clickableIcons: !!this.props.clickableIcons,
            disableDefaultUI: this.props.disableDefaultUI,
            zoomControl: this.props.zoomControl,
            mapTypeControl: this.props.mapTypeControl,
            scaleControl: this.props.scaleControl,
            streetViewControl: this.props.streetViewControl,
            panControl: this.props.panControl,
            rotateControl: this.props.rotateControl,
            fullscreenControl: this.props.fullscreenControl,
            scrollwheel: this.props.scrollwheel,
            draggable: this.props.draggable,
            keyboardShortcuts: this.props.keyboardShortcuts,
            disableDoubleClickZoom: this.props.disableDoubleClickZoom,
            noClear: this.props.noClear,
            styles: this.props.styles,
            gestureHandling: this.props.gestureHandling
          });

          Object.keys(mapConfig).forEach(function (key) {
            // Allow to configure mapConfig with 'false'
            if (mapConfig[key] === null) {
              delete mapConfig[key];
            }
          });

          this.map = new maps.Map(node, mapConfig);

          evtNames.forEach(function (e) {
            _this4.listeners[e] = _this4.map.addListener(e, _this4.handleEvent(e));
          });
          maps.event.trigger(this.map, 'ready');
          this.forceUpdate();
        }
      }
    }, {
      key: 'handleEvent',
      value: function handleEvent(evtName) {
        var _this5 = this;

        var timeout = void 0;
        var handlerName = 'on' + (0, _String.camelize)(evtName);

        return function (e) {
          if (timeout) {
            clearTimeout(timeout);
            timeout = null;
          }
          timeout = setTimeout(function () {
            if (_this5.props[handlerName]) {
              _this5.props[handlerName](_this5.props, _this5.map, e);
            }
          }, 0);
        };
      }
    }, {
      key: 'recenterMap',
      value: function recenterMap() {
        var map = this.map;

        var google = this.props.google;


        if (!google) return;
        var maps = google.maps;

        if (map) {
          var center = this.state.currentLocation;
          if (!(center instanceof google.maps.LatLng)) {
            center = new google.maps.LatLng(center.lat, center.lng);
          }
          // map.panTo(center)
          map.setCenter(center);
          maps.event.trigger(map, 'recenter');
        }
      }
    }, {
      key: 'restyleMap',
      value: function restyleMap() {
        if (this.map) {
          var google = this.props.google;

          google.maps.event.trigger(this.map, 'resize');
        }
      }
    }, {
      key: 'renderChildren',
      value: function renderChildren() {
        var _this6 = this;

        var children = this.props.children;


        if (!children) return;

        return _react2.default.Children.map(children, function (c) {
          if (!c) return;
          return _react2.default.cloneElement(c, {
            map: _this6.map,
            google: _this6.props.google,
            mapCenter: _this6.state.currentLocation
          });
        });
      }
    }, {
      key: 'render',
      value: function render() {
        var style = Object.assign({}, mapStyles.map, this.props.style, {
          display: this.props.visible ? 'inherit' : 'none'
        });

        var containerStyles = Object.assign({}, mapStyles.container, this.props.containerStyle);

        return _react2.default.createElement(
          'div',
          { style: containerStyles, className: this.props.className },
          _react2.default.createElement(
            'div',
            { style: style, ref: 'map' },
            'Loading map...'
          ),
          this.renderChildren()
        );
      }
    }]);

    return Map;
  }(_react2.default.Component);

  Map.propTypes = {
    google: _propTypes2.default.object,
    zoom: _propTypes2.default.number,
    centerAroundCurrentLocation: _propTypes2.default.bool,
    center: _propTypes2.default.object,
    initialCenter: _propTypes2.default.object,
    className: _propTypes2.default.string,
    style: _propTypes2.default.object,
    containerStyle: _propTypes2.default.object,
    visible: _propTypes2.default.bool,
    mapType: _propTypes2.default.string,
    maxZoom: _propTypes2.default.number,
    minZoom: _propTypes2.default.number,
    clickableIcons: _propTypes2.default.bool,
    disableDefaultUI: _propTypes2.default.bool,
    zoomControl: _propTypes2.default.bool,
    mapTypeControl: _propTypes2.default.bool,
    scaleControl: _propTypes2.default.bool,
    streetViewControl: _propTypes2.default.bool,
    panControl: _propTypes2.default.bool,
    rotateControl: _propTypes2.default.bool,
    fullscreenControl: _propTypes2.default.bool,
    scrollwheel: _propTypes2.default.bool,
    draggable: _propTypes2.default.bool,
    keyboardShortcuts: _propTypes2.default.bool,
    disableDoubleClickZoom: _propTypes2.default.bool,
    noClear: _propTypes2.default.bool,
    styles: _propTypes2.default.array,
    gestureHandling: _propTypes2.default.string,
    bounds: _propTypes2.default.object
  };

  evtNames.forEach(function (e) {
    return Map.propTypes[(0, _String.camelize)(e)] = _propTypes2.default.func;
  });

  Map.defaultProps = {
    zoom: 14,
    initialCenter: {
      lat: 37.774929,
      lng: -122.419416
    },
    center: {},
    centerAroundCurrentLocation: false,
    style: {},
    containerStyle: {},
    visible: true
  };

  exports.default = Map;
});

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(7), __webpack_require__(114), __webpack_require__(116)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('react-dom'), require('./lib/ScriptCache'), require('./lib/GoogleApi'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.reactDom, global.ScriptCache, global.GoogleApi);
    global.GoogleApiComponent = mod.exports;
  }
})(this, function (exports, _react, _reactDom, _ScriptCache, _GoogleApi) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.wrapper = undefined;

  var _react2 = _interopRequireDefault(_react);

  var _reactDom2 = _interopRequireDefault(_reactDom);

  var _GoogleApi2 = _interopRequireDefault(_GoogleApi);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var defaultMapConfig = {};

  var serialize = function serialize(obj) {
    return JSON.stringify(obj);
  };
  var isSame = function isSame(obj1, obj2) {
    return obj1 === obj2 || serialize(obj1) === serialize(obj2);
  };

  var defaultCreateCache = function defaultCreateCache(options) {
    options = options || {};
    var apiKey = options.apiKey;
    var libraries = options.libraries || ['places'];
    var version = options.version || '3';
    var language = options.language || 'en';
    var url = options.url;
    var client = options.client;

    return (0, _ScriptCache.ScriptCache)({
      google: (0, _GoogleApi2.default)({
        apiKey: apiKey,
        language: language,
        libraries: libraries,
        version: version,
        url: url,
        client: client
      })
    });
  };

  var DefaultLoadingContainer = function DefaultLoadingContainer(props) {
    return _react2.default.createElement(
      'div',
      null,
      'Loading...'
    );
  };

  var wrapper = exports.wrapper = function wrapper(input) {
    return function (WrappedComponent) {
      var Wrapper = function (_React$Component) {
        _inherits(Wrapper, _React$Component);

        function Wrapper(props, context) {
          _classCallCheck(this, Wrapper);

          // Build options from input
          var _this = _possibleConstructorReturn(this, (Wrapper.__proto__ || Object.getPrototypeOf(Wrapper)).call(this, props, context));

          var options = typeof input === 'function' ? input(props) : input;

          // Initialize required Google scripts and other configured options
          _this.initialize(options);

          _this.state = {
            loaded: false,
            map: null,
            google: null,
            options: options
          };
          return _this;
        }

        _createClass(Wrapper, [{
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(props) {
            // Do not update input if it's not dynamic
            if (typeof input !== 'function') {
              return;
            }

            // Get options to compare
            var prevOptions = this.state.options;
            var options = typeof input === 'function' ? input(props) : input;

            // Ignore when options are not changed
            if (isSame(options, prevOptions)) {
              return;
            }

            // Initialize with new options
            this.initialize(options);

            // Save new options in component state,
            // and remove information about previous API handlers
            this.setState({
              options: options,
              loaded: false,
              google: null
            });
          }
        }, {
          key: 'initialize',
          value: function initialize(options) {
            // Avoid race condition: remove previous 'load' listener
            if (this.unregisterLoadHandler) {
              this.unregisterLoadHandler();
              this.unregisterLoadHandler = null;
            }

            // Load cache factory
            var createCache = options.createCache || defaultCreateCache;

            // Build script
            this.scriptCache = createCache(options);
            this.unregisterLoadHandler = this.scriptCache.google.onLoad(this.onLoad.bind(this));

            // Store information about loading container
            this.LoadingContainer = options.LoadingContainer || DefaultLoadingContainer;
          }
        }, {
          key: 'onLoad',
          value: function onLoad(err, tag) {
            this._gapi = window.google;

            this.setState({ loaded: true, google: this._gapi });
          }
        }, {
          key: 'render',
          value: function render() {
            var LoadingContainer = this.LoadingContainer;

            if (!this.state.loaded) {
              return _react2.default.createElement(LoadingContainer, null);
            }

            var props = Object.assign({}, this.props, {
              loaded: this.state.loaded,
              google: window.google
            });

            return _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(WrappedComponent, props),
              _react2.default.createElement('div', { ref: 'map' })
            );
          }
        }]);

        return Wrapper;
      }(_react2.default.Component);

      return Wrapper;
    };
  };

  exports.default = wrapper;
});

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(115)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require('./windowOrGlobal'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.windowOrGlobal);
        global.ScriptCache = mod.exports;
    }
})(this, function (exports, window) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var counter = 0;
    var scriptMap = typeof window !== 'undefined' && window._scriptMap || new Map();
    var ScriptCache = exports.ScriptCache = function (global) {
        global._scriptMap = global._scriptMap || scriptMap;
        return function ScriptCache(scripts) {
            var Cache = {};

            Cache._onLoad = function (key) {
                return function (cb) {
                    var registered = true;

                    function unregister() {
                        registered = false;
                    }

                    var stored = scriptMap.get(key);

                    if (stored) {
                        stored.promise.then(function () {
                            if (registered) {
                                stored.error ? cb(stored.error) : cb(null, stored);
                            }

                            return stored;
                        });
                    } else {
                        // TODO:
                    }

                    return unregister;
                };
            };

            Cache._scriptTag = function (key, src) {
                if (!scriptMap.has(key)) {
                    // Server side rendering environments don't always have access to the `document` global.
                    // In these cases, we're not going to be able to return a script tag, so just return null.
                    if (typeof document === 'undefined') return null;

                    var tag = document.createElement('script');
                    var promise = new Promise(function (resolve, reject) {
                        var resolved = false,
                            errored = false,
                            body = document.getElementsByTagName('body')[0];

                        tag.type = 'text/javascript';
                        tag.async = false; // Load in order

                        var cbName = 'loaderCB' + counter++ + Date.now();
                        var cb = void 0;

                        var handleResult = function handleResult(state) {
                            return function (evt) {
                                var stored = scriptMap.get(key);
                                if (state === 'loaded') {
                                    stored.resolved = true;
                                    resolve(src);
                                    // stored.handlers.forEach(h => h.call(null, stored))
                                    // stored.handlers = []
                                } else if (state === 'error') {
                                    stored.errored = true;
                                    // stored.handlers.forEach(h => h.call(null, stored))
                                    // stored.handlers = [];
                                    reject(evt);
                                }
                                stored.loaded = true;

                                cleanup();
                            };
                        };

                        var cleanup = function cleanup() {
                            if (global[cbName] && typeof global[cbName] === 'function') {
                                global[cbName] = null;
                                delete global[cbName];
                            }
                        };

                        tag.onload = handleResult('loaded');
                        tag.onerror = handleResult('error');
                        tag.onreadystatechange = function () {
                            handleResult(tag.readyState);
                        };

                        // Pick off callback, if there is one
                        if (src.match(/callback=CALLBACK_NAME/)) {
                            src = src.replace(/(callback=)[^\&]+/, '$1' + cbName);
                            cb = window[cbName] = tag.onload;
                        } else {
                            tag.addEventListener('load', tag.onload);
                        }
                        tag.addEventListener('error', tag.onerror);

                        tag.src = src;
                        body.appendChild(tag);

                        return tag;
                    });
                    var initialState = {
                        loaded: false,
                        error: false,
                        promise: promise,
                        tag: tag
                    };
                    scriptMap.set(key, initialState);
                }
                return scriptMap.get(key);
            };

            // let scriptTags = document.querySelectorAll('script')
            //
            // NodeList.prototype.filter = Array.prototype.filter;
            // NodeList.prototype.map = Array.prototype.map;
            // const initialScripts = scriptTags
            //   .filter(s => !!s.src)
            //   .map(s => s.src.split('?')[0])
            //   .reduce((memo, script) => {
            //     memo[script] = script;
            //     return memo;
            //   }, {});

            Object.keys(scripts).forEach(function (key) {
                var script = scripts[key];

                var tag = window._scriptMap.has(key) ? window._scriptMap.get(key).tag : Cache._scriptTag(key, script);

                Cache[key] = {
                    tag: tag,
                    onLoad: Cache._onLoad(key)
                };
            });

            return Cache;
        };
    }(window);

    exports.default = ScriptCache;
});

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod);
    global.windowOrGlobal = mod.exports;
  }
})(this, function (module) {
  'use strict';

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };

  module.exports = (typeof self === 'undefined' ? 'undefined' : _typeof(self)) === 'object' && self.self === self && self || (typeof global === 'undefined' ? 'undefined' : _typeof(global)) === 'object' && global.global === global && global || undefined;
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12)))

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.GoogleApi = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var GoogleApi = exports.GoogleApi = function GoogleApi(opts) {
    opts = opts || {};

    if (!opts.hasOwnProperty('apiKey')) {
      throw new Error('You must pass an apiKey to use GoogleApi');
    }

    var apiKey = opts.apiKey;
    var libraries = opts.libraries || ['places'];
    var client = opts.client;
    var URL = opts.url || 'https://maps.googleapis.com/maps/api/js';

    var googleVersion = opts.version || '3.31';

    var script = null;
    var google = typeof window !== 'undefined' && window.google || null;
    var loading = false;
    var channel = null;
    var language = opts.language;
    var region = opts.region || null;

    var onLoadEvents = [];

    var url = function url() {
      var url = URL;
      var params = {
        key: apiKey,
        callback: 'CALLBACK_NAME',
        libraries: libraries.join(','),
        client: client,
        v: googleVersion,
        channel: channel,
        language: language,
        region: region
      };

      var paramStr = Object.keys(params).filter(function (k) {
        return !!params[k];
      }).map(function (k) {
        return k + '=' + params[k];
      }).join('&');

      return url + '?' + paramStr;
    };

    return url();
  };

  exports.default = GoogleApi;
});

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(10)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('../lib/String'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.String);
    global.Marker = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _String) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Marker = undefined;

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var evtNames = ['click', 'dblclick', 'dragend', 'mousedown', 'mouseout', 'mouseover', 'mouseup', 'recenter'];

  var wrappedPromise = function wrappedPromise() {
    var wrappedPromise = {},
        promise = new Promise(function (resolve, reject) {
      wrappedPromise.resolve = resolve;
      wrappedPromise.reject = reject;
    });
    wrappedPromise.then = promise.then.bind(promise);
    wrappedPromise.catch = promise.catch.bind(promise);
    wrappedPromise.promise = promise;

    return wrappedPromise;
  };

  var Marker = exports.Marker = function (_React$Component) {
    _inherits(Marker, _React$Component);

    function Marker() {
      _classCallCheck(this, Marker);

      return _possibleConstructorReturn(this, (Marker.__proto__ || Object.getPrototypeOf(Marker)).apply(this, arguments));
    }

    _createClass(Marker, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.markerPromise = wrappedPromise();
        this.renderMarker();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (this.props.map !== prevProps.map || this.props.position !== prevProps.position || this.props.icon !== prevProps.icon) {
          if (this.marker) {
            this.marker.setMap(null);
          }
          this.renderMarker();
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.marker) {
          this.marker.setMap(null);
        }
      }
    }, {
      key: 'renderMarker',
      value: function renderMarker() {
        var _this2 = this;

        var _props = this.props,
            map = _props.map,
            google = _props.google,
            position = _props.position,
            mapCenter = _props.mapCenter,
            icon = _props.icon,
            label = _props.label,
            draggable = _props.draggable,
            title = _props.title,
            props = _objectWithoutProperties(_props, ['map', 'google', 'position', 'mapCenter', 'icon', 'label', 'draggable', 'title']);

        if (!google) {
          return null;
        }

        var pos = position || mapCenter;
        if (!(pos instanceof google.maps.LatLng)) {
          pos = new google.maps.LatLng(pos.lat, pos.lng);
        }

        var pref = _extends({
          map: map,
          position: pos,
          icon: icon,
          label: label,
          title: title,
          draggable: draggable
        }, props);
        this.marker = new google.maps.Marker(pref);

        evtNames.forEach(function (e) {
          _this2.marker.addListener(e, _this2.handleEvent(e));
        });

        this.markerPromise.resolve(this.marker);
      }
    }, {
      key: 'getMarker',
      value: function getMarker() {
        return this.markerPromise;
      }
    }, {
      key: 'handleEvent',
      value: function handleEvent(evt) {
        var _this3 = this;

        return function (e) {
          var evtName = 'on' + (0, _String.camelize)(evt);
          if (_this3.props[evtName]) {
            _this3.props[evtName](_this3.props, _this3.marker, e);
          }
        };
      }
    }, {
      key: 'render',
      value: function render() {
        return null;
      }
    }]);

    return Marker;
  }(_react2.default.Component);

  Marker.propTypes = {
    position: _propTypes2.default.object,
    map: _propTypes2.default.object
  };

  evtNames.forEach(function (e) {
    return Marker.propTypes[e] = _propTypes2.default.func;
  });

  Marker.defaultProps = {
    name: 'Marker'
  };

  exports.default = Marker;
});

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(7), __webpack_require__(119)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('react-dom'), require('react-dom/server'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.reactDom, global.server);
    global.InfoWindow = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _reactDom, _server) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.InfoWindow = undefined;

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _reactDom2 = _interopRequireDefault(_reactDom);

  var _server2 = _interopRequireDefault(_server);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var InfoWindow = exports.InfoWindow = function (_React$Component) {
    _inherits(InfoWindow, _React$Component);

    function InfoWindow() {
      _classCallCheck(this, InfoWindow);

      return _possibleConstructorReturn(this, (InfoWindow.__proto__ || Object.getPrototypeOf(InfoWindow)).apply(this, arguments));
    }

    _createClass(InfoWindow, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.renderInfoWindow();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        var _props = this.props,
            google = _props.google,
            map = _props.map;


        if (!google || !map) {
          return;
        }

        if (map !== prevProps.map) {
          this.renderInfoWindow();
        }

        if (this.props.position !== prevProps.position) {
          this.updatePosition();
        }

        if (this.props.children !== prevProps.children) {
          this.updateContent();
        }

        if (this.props.visible !== prevProps.visible || this.props.marker !== prevProps.marker || this.props.position !== prevProps.position) {
          this.props.visible ? this.openWindow() : this.closeWindow();
        }
      }
    }, {
      key: 'renderInfoWindow',
      value: function renderInfoWindow() {
        var _props2 = this.props,
            map = _props2.map,
            google = _props2.google,
            mapCenter = _props2.mapCenter,
            props = _objectWithoutProperties(_props2, ['map', 'google', 'mapCenter']);

        if (!google || !google.maps) {
          return;
        }

        var iw = this.infowindow = new google.maps.InfoWindow(_extends({
          content: ''
        }, props));

        google.maps.event.addListener(iw, 'closeclick', this.onClose.bind(this));
        google.maps.event.addListener(iw, 'domready', this.onOpen.bind(this));
      }
    }, {
      key: 'onOpen',
      value: function onOpen() {
        if (this.props.onOpen) {
          this.props.onOpen();
        }
      }
    }, {
      key: 'onClose',
      value: function onClose() {
        if (this.props.onClose) {
          this.props.onClose();
        }
      }
    }, {
      key: 'openWindow',
      value: function openWindow() {
        this.infowindow.open(this.props.map, this.props.marker);
      }
    }, {
      key: 'updatePosition',
      value: function updatePosition() {
        var pos = this.props.position;
        if (!(pos instanceof google.maps.LatLng)) {
          pos = pos && new google.maps.LatLng(pos.lat, pos.lng);
        }
        this.infowindow.setPosition(pos);
      }
    }, {
      key: 'updateContent',
      value: function updateContent() {
        var content = this.renderChildren();
        this.infowindow.setContent(content);
      }
    }, {
      key: 'closeWindow',
      value: function closeWindow() {
        this.infowindow.close();
      }
    }, {
      key: 'renderChildren',
      value: function renderChildren() {
        var children = this.props.children;

        return _server2.default.renderToString(children);
      }
    }, {
      key: 'render',
      value: function render() {
        return null;
      }
    }]);

    return InfoWindow;
  }(_react2.default.Component);

  InfoWindow.propTypes = {
    children: _propTypes2.default.element.isRequired,
    map: _propTypes2.default.object,
    marker: _propTypes2.default.object,
    position: _propTypes2.default.object,
    visible: _propTypes2.default.bool,

    // callbacks
    onClose: _propTypes2.default.func,
    onOpen: _propTypes2.default.func
  };

  InfoWindow.defaultProps = {
    visible: false
  };

  exports.default = InfoWindow;
});

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(120);
} else {
  module.exports = require('./cjs/react-dom-server.browser.development.js');
}


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.8.6
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var p=__webpack_require__(13),q=__webpack_require__(0);function aa(a,b,d,c,f,e,h,g){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var D=[d,c,f,e,h,g],B=0;a=Error(b.replace(/%s/g,function(){return D[B++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
function r(a){for(var b=arguments.length-1,d="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)d+="&args[]="+encodeURIComponent(arguments[c+1]);aa(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",d)}
var v="function"===typeof Symbol&&Symbol.for,ba=v?Symbol.for("react.portal"):60106,x=v?Symbol.for("react.fragment"):60107,ca=v?Symbol.for("react.strict_mode"):60108,da=v?Symbol.for("react.profiler"):60114,z=v?Symbol.for("react.provider"):60109,ea=v?Symbol.for("react.context"):60110,fa=v?Symbol.for("react.concurrent_mode"):60111,ha=v?Symbol.for("react.forward_ref"):60112,A=v?Symbol.for("react.suspense"):60113,ia=v?Symbol.for("react.memo"):60115,ja=v?Symbol.for("react.lazy"):60116;
function C(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case fa:return"ConcurrentMode";case x:return"Fragment";case ba:return"Portal";case da:return"Profiler";case ca:return"StrictMode";case A:return"Suspense"}if("object"===typeof a)switch(a.$$typeof){case ea:return"Context.Consumer";case z:return"Context.Provider";case ha:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case ia:return C(a.type);case ja:if(a=1===a._status?a._result:null)return C(a)}return null}var E=q.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;E.hasOwnProperty("ReactCurrentDispatcher")||(E.ReactCurrentDispatcher={current:null});var ka={};function F(a,b){for(var d=a._threadCount|0;d<=b;d++)a[d]=a._currentValue2,a._threadCount=d+1}
function la(a,b,d){var c=a.contextType;if("object"===typeof c&&null!==c)return F(c,d),c[d];if(a=a.contextTypes){d={};for(var f in a)d[f]=b[f];b=d}else b=ka;return b}for(var G=new Uint16Array(16),H=0;15>H;H++)G[H]=H+1;G[15]=0;
var ma=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,na=Object.prototype.hasOwnProperty,oa={},pa={};
function qa(a){if(na.call(pa,a))return!0;if(na.call(oa,a))return!1;if(ma.test(a))return pa[a]=!0;oa[a]=!0;return!1}function ra(a,b,d,c){if(null!==d&&0===d.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(c)return!1;if(null!==d)return!d.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function sa(a,b,d,c){if(null===b||"undefined"===typeof b||ra(a,b,d,c))return!0;if(c)return!1;if(null!==d)switch(d.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function I(a,b,d,c,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=c;this.attributeNamespace=f;this.mustUseProperty=d;this.propertyName=a;this.type=b}var J={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){J[a]=new I(a,0,!1,a,null)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];J[b]=new I(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){J[a]=new I(a,2,!1,a.toLowerCase(),null)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){J[a]=new I(a,2,!1,a,null)});"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){J[a]=new I(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){J[a]=new I(a,3,!0,a,null)});
["capture","download"].forEach(function(a){J[a]=new I(a,4,!1,a,null)});["cols","rows","size","span"].forEach(function(a){J[a]=new I(a,6,!1,a,null)});["rowSpan","start"].forEach(function(a){J[a]=new I(a,5,!1,a.toLowerCase(),null)});var K=/[\-:]([a-z])/g;function L(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(K,
L);J[b]=new I(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(K,L);J[b]=new I(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(K,L);J[b]=new I(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});["tabIndex","crossOrigin"].forEach(function(a){J[a]=new I(a,1,!1,a.toLowerCase(),null)});var ta=/["'&<>]/;
function M(a){if("boolean"===typeof a||"number"===typeof a)return""+a;a=""+a;var b=ta.exec(a);if(b){var d="",c,f=0;for(c=b.index;c<a.length;c++){switch(a.charCodeAt(c)){case 34:b="&quot;";break;case 38:b="&amp;";break;case 39:b="&#x27;";break;case 60:b="&lt;";break;case 62:b="&gt;";break;default:continue}f!==c&&(d+=a.substring(f,c));f=c+1;d+=b}a=f!==c?d+a.substring(f,c):d}return a}var N=null,O=null,P=null,Q=!1,S=!1,T=null,U=0;function V(){null===N?r("321"):void 0;return N}
function ua(){0<U&&r("312");return{memoizedState:null,queue:null,next:null}}function W(){null===P?null===O?(Q=!1,O=P=ua()):(Q=!0,P=O):null===P.next?(Q=!1,P=P.next=ua()):(Q=!0,P=P.next);return P}function va(a,b,d,c){for(;S;)S=!1,U+=1,P=null,d=a(b,c);O=N=null;U=0;P=T=null;return d}function wa(a,b){return"function"===typeof b?b(a):b}
function xa(a,b,d){N=V();P=W();if(Q){var c=P.queue;b=c.dispatch;if(null!==T&&(d=T.get(c),void 0!==d)){T.delete(c);c=P.memoizedState;do c=a(c,d.action),d=d.next;while(null!==d);P.memoizedState=c;return[c,b]}return[P.memoizedState,b]}a=a===wa?"function"===typeof b?b():b:void 0!==d?d(b):b;P.memoizedState=a;a=P.queue={last:null,dispatch:null};a=a.dispatch=ya.bind(null,N,a);return[P.memoizedState,a]}
function ya(a,b,d){25>U?void 0:r("301");if(a===N)if(S=!0,a={action:d,next:null},null===T&&(T=new Map),d=T.get(b),void 0===d)T.set(b,a);else{for(b=d;null!==b.next;)b=b.next;b.next=a}}function za(){}
var X=0,Aa={readContext:function(a){var b=X;F(a,b);return a[b]},useContext:function(a){V();var b=X;F(a,b);return a[b]},useMemo:function(a,b){N=V();P=W();b=void 0===b?null:b;if(null!==P){var d=P.memoizedState;if(null!==d&&null!==b){a:{var c=d[1];if(null===c)c=!1;else{for(var f=0;f<c.length&&f<b.length;f++){var e=b[f],h=c[f];if((e!==h||0===e&&1/e!==1/h)&&(e===e||h===h)){c=!1;break a}}c=!0}}if(c)return d[0]}}a=a();P.memoizedState=[a,b];return a},useReducer:xa,useRef:function(a){N=V();P=W();var b=P.memoizedState;
return null===b?(a={current:a},P.memoizedState=a):b},useState:function(a){return xa(wa,a)},useLayoutEffect:function(){},useCallback:function(a){return a},useImperativeHandle:za,useEffect:za,useDebugValue:za},Ba={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};function Ca(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}
var Da={area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0},Ea=p({menuitem:!0},Da),Y={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,
gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Fa=["Webkit","ms","Moz","O"];Object.keys(Y).forEach(function(a){Fa.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Y[b]=Y[a]})});
var Ga=/([A-Z])/g,Ha=/^ms-/,Z=q.Children.toArray,Ia=E.ReactCurrentDispatcher,Ja={listing:!0,pre:!0,textarea:!0},Ka=/^[a-zA-Z][a-zA-Z:_\.\-\d]*$/,La={},Ma={};function Na(a){if(void 0===a||null===a)return a;var b="";q.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}var Oa=Object.prototype.hasOwnProperty,Pa={children:null,dangerouslySetInnerHTML:null,suppressContentEditableWarning:null,suppressHydrationWarning:null};function Qa(a,b){void 0===a&&r("152",C(b)||"Component")}
function Ra(a,b,d){function c(c,f){var e=la(f,b,d),g=[],h=!1,l={isMounted:function(){return!1},enqueueForceUpdate:function(){if(null===g)return null},enqueueReplaceState:function(a,b){h=!0;g=[b]},enqueueSetState:function(a,b){if(null===g)return null;g.push(b)}},k=void 0;if(f.prototype&&f.prototype.isReactComponent){if(k=new f(c.props,e,l),"function"===typeof f.getDerivedStateFromProps){var t=f.getDerivedStateFromProps.call(null,c.props,k.state);null!=t&&(k.state=p({},k.state,t))}}else if(N={},k=f(c.props,
e,l),k=va(f,c.props,k,e),null==k||null==k.render){a=k;Qa(a,f);return}k.props=c.props;k.context=e;k.updater=l;l=k.state;void 0===l&&(k.state=l=null);if("function"===typeof k.UNSAFE_componentWillMount||"function"===typeof k.componentWillMount)if("function"===typeof k.componentWillMount&&"function"!==typeof f.getDerivedStateFromProps&&k.componentWillMount(),"function"===typeof k.UNSAFE_componentWillMount&&"function"!==typeof f.getDerivedStateFromProps&&k.UNSAFE_componentWillMount(),g.length){l=g;var m=
h;g=null;h=!1;if(m&&1===l.length)k.state=l[0];else{t=m?l[0]:k.state;var u=!0;for(m=m?1:0;m<l.length;m++){var w=l[m];w="function"===typeof w?w.call(k,t,c.props,e):w;null!=w&&(u?(u=!1,t=p({},t,w)):p(t,w))}k.state=t}}else g=null;a=k.render();Qa(a,f);c=void 0;if("function"===typeof k.getChildContext&&(e=f.childContextTypes,"object"===typeof e)){c=k.getChildContext();for(var R in c)R in e?void 0:r("108",C(f)||"Unknown",R)}c&&(b=p({},b,c))}for(;q.isValidElement(a);){var f=a,e=f.type;if("function"!==typeof e)break;
c(f,e)}return{child:a,context:b}}
var Sa=function(){function a(b,d){if(!(this instanceof a))throw new TypeError("Cannot call a class as a function");q.isValidElement(b)?b.type!==x?b=[b]:(b=b.props.children,b=q.isValidElement(b)?[b]:Z(b)):b=Z(b);b={type:null,domNamespace:Ba.html,children:b,childIndex:0,context:ka,footer:""};var c=G[0];if(0===c){var f=G;c=f.length;var e=2*c;65536>=e?void 0:r("304");var h=new Uint16Array(e);h.set(f);G=h;G[0]=c+1;for(f=c;f<e-1;f++)G[f]=f+1;G[e-1]=0}else G[0]=G[c];this.threadID=c;this.stack=[b];this.exhausted=
!1;this.currentSelectValue=null;this.previousWasTextNode=!1;this.makeStaticMarkup=d;this.suspenseDepth=0;this.contextIndex=-1;this.contextStack=[];this.contextValueStack=[]}a.prototype.destroy=function(){if(!this.exhausted){this.exhausted=!0;this.clearProviders();var a=this.threadID;G[a]=G[0];G[0]=a}};a.prototype.pushProvider=function(a){var b=++this.contextIndex,c=a.type._context,f=this.threadID;F(c,f);var e=c[f];this.contextStack[b]=c;this.contextValueStack[b]=e;c[f]=a.props.value};a.prototype.popProvider=
function(){var a=this.contextIndex,d=this.contextStack[a],c=this.contextValueStack[a];this.contextStack[a]=null;this.contextValueStack[a]=null;this.contextIndex--;d[this.threadID]=c};a.prototype.clearProviders=function(){for(var a=this.contextIndex;0<=a;a--)this.contextStack[a][this.threadID]=this.contextValueStack[a]};a.prototype.read=function(a){if(this.exhausted)return null;var b=X;X=this.threadID;var c=Ia.current;Ia.current=Aa;try{for(var f=[""],e=!1;f[0].length<a;){if(0===this.stack.length){this.exhausted=
!0;var h=this.threadID;G[h]=G[0];G[0]=h;break}var g=this.stack[this.stack.length-1];if(e||g.childIndex>=g.children.length){var D=g.footer;""!==D&&(this.previousWasTextNode=!1);this.stack.pop();if("select"===g.type)this.currentSelectValue=null;else if(null!=g.type&&null!=g.type.type&&g.type.type.$$typeof===z)this.popProvider(g.type);else if(g.type===A){this.suspenseDepth--;var B=f.pop();if(e){e=!1;var n=g.fallbackFrame;n?void 0:r("303");this.stack.push(n);continue}else f[this.suspenseDepth]+=B}f[this.suspenseDepth]+=
D}else{var l=g.children[g.childIndex++],k="";try{k+=this.render(l,g.context,g.domNamespace)}catch(t){throw t;}finally{}f.length<=this.suspenseDepth&&f.push("");f[this.suspenseDepth]+=k}}return f[0]}finally{Ia.current=c,X=b}};a.prototype.render=function(a,d,c){if("string"===typeof a||"number"===typeof a){c=""+a;if(""===c)return"";if(this.makeStaticMarkup)return M(c);if(this.previousWasTextNode)return"\x3c!-- --\x3e"+M(c);this.previousWasTextNode=!0;return M(c)}d=Ra(a,d,this.threadID);a=d.child;d=d.context;
if(null===a||!1===a)return"";if(!q.isValidElement(a)){if(null!=a&&null!=a.$$typeof){var b=a.$$typeof;b===ba?r("257"):void 0;r("258",b.toString())}a=Z(a);this.stack.push({type:null,domNamespace:c,children:a,childIndex:0,context:d,footer:""});return""}b=a.type;if("string"===typeof b)return this.renderDOM(a,d,c);switch(b){case ca:case fa:case da:case x:return a=Z(a.props.children),this.stack.push({type:null,domNamespace:c,children:a,childIndex:0,context:d,footer:""}),"";case A:r("294")}if("object"===
typeof b&&null!==b)switch(b.$$typeof){case ha:N={};var e=b.render(a.props,a.ref);e=va(b.render,a.props,e,a.ref);e=Z(e);this.stack.push({type:null,domNamespace:c,children:e,childIndex:0,context:d,footer:""});return"";case ia:return a=[q.createElement(b.type,p({ref:a.ref},a.props))],this.stack.push({type:null,domNamespace:c,children:a,childIndex:0,context:d,footer:""}),"";case z:return b=Z(a.props.children),c={type:a,domNamespace:c,children:b,childIndex:0,context:d,footer:""},this.pushProvider(a),this.stack.push(c),
"";case ea:b=a.type;e=a.props;var h=this.threadID;F(b,h);b=Z(e.children(b[h]));this.stack.push({type:a,domNamespace:c,children:b,childIndex:0,context:d,footer:""});return"";case ja:r("295")}r("130",null==b?b:typeof b,"")};a.prototype.renderDOM=function(a,d,c){var b=a.type.toLowerCase();c===Ba.html&&Ca(b);La.hasOwnProperty(b)||(Ka.test(b)?void 0:r("65",b),La[b]=!0);var e=a.props;if("input"===b)e=p({type:void 0},e,{defaultChecked:void 0,defaultValue:void 0,value:null!=e.value?e.value:e.defaultValue,
checked:null!=e.checked?e.checked:e.defaultChecked});else if("textarea"===b){var h=e.value;if(null==h){h=e.defaultValue;var g=e.children;null!=g&&(null!=h?r("92"):void 0,Array.isArray(g)&&(1>=g.length?void 0:r("93"),g=g[0]),h=""+g);null==h&&(h="")}e=p({},e,{value:void 0,children:""+h})}else if("select"===b)this.currentSelectValue=null!=e.value?e.value:e.defaultValue,e=p({},e,{value:void 0});else if("option"===b){g=this.currentSelectValue;var D=Na(e.children);if(null!=g){var B=null!=e.value?e.value+
"":D;h=!1;if(Array.isArray(g))for(var n=0;n<g.length;n++){if(""+g[n]===B){h=!0;break}}else h=""+g===B;e=p({selected:void 0,children:void 0},e,{selected:h,children:D})}}if(h=e)Ea[b]&&(null!=h.children||null!=h.dangerouslySetInnerHTML?r("137",b,""):void 0),null!=h.dangerouslySetInnerHTML&&(null!=h.children?r("60"):void 0,"object"===typeof h.dangerouslySetInnerHTML&&"__html"in h.dangerouslySetInnerHTML?void 0:r("61")),null!=h.style&&"object"!==typeof h.style?r("62",""):void 0;h=e;g=this.makeStaticMarkup;
D=1===this.stack.length;B="<"+a.type;for(y in h)if(Oa.call(h,y)){var l=h[y];if(null!=l){if("style"===y){n=void 0;var k="",t="";for(n in l)if(l.hasOwnProperty(n)){var m=0===n.indexOf("--"),u=l[n];if(null!=u){var w=n;if(Ma.hasOwnProperty(w))w=Ma[w];else{var R=w.replace(Ga,"-$1").toLowerCase().replace(Ha,"-ms-");w=Ma[w]=R}k+=t+w+":";t=n;m=null==u||"boolean"===typeof u||""===u?"":m||"number"!==typeof u||0===u||Y.hasOwnProperty(t)&&Y[t]?(""+u).trim():u+"px";k+=m;t=";"}}l=k||null}n=null;b:if(m=b,u=h,-1===
m.indexOf("-"))m="string"===typeof u.is;else switch(m){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":m=!1;break b;default:m=!0}if(m)Pa.hasOwnProperty(y)||(n=y,n=qa(n)&&null!=l?n+"="+('"'+M(l)+'"'):"");else{m=y;n=l;l=J.hasOwnProperty(m)?J[m]:null;if(u="style"!==m)u=null!==l?0===l.type:!(2<m.length)||"o"!==m[0]&&"O"!==m[0]||"n"!==m[1]&&"N"!==m[1]?!1:!0;u||sa(m,n,l,!1)?n="":null!==
l?(m=l.attributeName,l=l.type,n=3===l||4===l&&!0===n?m+'=""':m+"="+('"'+M(n)+'"')):n=qa(m)?m+"="+('"'+M(n)+'"'):""}n&&(B+=" "+n)}}g||D&&(B+=' data-reactroot=""');var y=B;h="";Da.hasOwnProperty(b)?y+="/>":(y+=">",h="</"+a.type+">");a:{g=e.dangerouslySetInnerHTML;if(null!=g){if(null!=g.__html){g=g.__html;break a}}else if(g=e.children,"string"===typeof g||"number"===typeof g){g=M(g);break a}g=null}null!=g?(e=[],Ja[b]&&"\n"===g.charAt(0)&&(y+="\n"),y+=g):e=Z(e.children);a=a.type;c=null==c||"http://www.w3.org/1999/xhtml"===
c?Ca(a):"http://www.w3.org/2000/svg"===c&&"foreignObject"===a?"http://www.w3.org/1999/xhtml":c;this.stack.push({domNamespace:c,type:b,children:e,childIndex:0,context:d,footer:h});this.previousWasTextNode=!1;return y};return a}(),Ta={renderToString:function(a){a=new Sa(a,!1);try{return a.read(Infinity)}finally{a.destroy()}},renderToStaticMarkup:function(a){a=new Sa(a,!0);try{return a.read(Infinity)}finally{a.destroy()}},renderToNodeStream:function(){r("207")},renderToStaticNodeStream:function(){r("208")},
version:"16.8.6"},Ua={default:Ta},Va=Ua&&Ta||Ua;module.exports=Va.default||Va;


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(10)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('../lib/String'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.String);
    global.HeatMap = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _String) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.HeatMap = undefined;

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var evtNames = ['click', 'mouseover', 'recenter'];

  var wrappedPromise = function wrappedPromise() {
    var wrappedPromise = {},
        promise = new Promise(function (resolve, reject) {
      wrappedPromise.resolve = resolve;
      wrappedPromise.reject = reject;
    });
    wrappedPromise.then = promise.then.bind(promise);
    wrappedPromise.catch = promise.catch.bind(promise);
    wrappedPromise.promise = promise;

    return wrappedPromise;
  };

  var HeatMap = exports.HeatMap = function (_React$Component) {
    _inherits(HeatMap, _React$Component);

    function HeatMap() {
      _classCallCheck(this, HeatMap);

      return _possibleConstructorReturn(this, (HeatMap.__proto__ || Object.getPrototypeOf(HeatMap)).apply(this, arguments));
    }

    _createClass(HeatMap, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.heatMapPromise = wrappedPromise();
        this.renderHeatMap();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (this.props.map !== prevProps.map || this.props.position !== prevProps.position) {
          if (this.heatMap) {
            this.heatMap.setMap(null);
            this.renderHeatMap();
          }
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.heatMap) {
          this.heatMap.setMap(null);
        }
      }
    }, {
      key: 'renderHeatMap',
      value: function renderHeatMap() {
        var _this2 = this;

        var _props = this.props,
            map = _props.map,
            google = _props.google,
            positions = _props.positions,
            mapCenter = _props.mapCenter,
            icon = _props.icon,
            gradient = _props.gradient,
            _props$radius = _props.radius,
            radius = _props$radius === undefined ? 20 : _props$radius,
            _props$opacity = _props.opacity,
            opacity = _props$opacity === undefined ? 0.2 : _props$opacity,
            props = _objectWithoutProperties(_props, ['map', 'google', 'positions', 'mapCenter', 'icon', 'gradient', 'radius', 'opacity']);

        if (!google) {
          return null;
        }

        var data = positions.map(function (pos) {
          return new google.maps.LatLng(pos.lat, pos.lng);
        });

        var pref = _extends({
          map: map,
          gradient: gradient,
          radius: radius,
          opacity: opacity,
          data: data
        }, props);

        this.heatMap = new google.maps.visualization.HeatmapLayer(pref);

        this.heatMap.set('radius', radius === undefined ? 20 : radius);

        this.heatMap.set('opacity', opacity === undefined ? 0.2 : opacity);

        evtNames.forEach(function (e) {
          _this2.heatMap.addListener(e, _this2.handleEvent(e));
        });

        this.heatMapPromise.resolve(this.heatMap);
      }
    }, {
      key: 'getHeatMap',
      value: function getHeatMap() {
        return this.heatMapPromise;
      }
    }, {
      key: 'handleEvent',
      value: function handleEvent(evt) {
        var _this3 = this;

        return function (e) {
          var evtName = 'on' + (0, _String.camelize)(evt);
          if (_this3.props[evtName]) {
            _this3.props[evtName](_this3.props, _this3.heatMap, e);
          }
        };
      }
    }, {
      key: 'render',
      value: function render() {
        return null;
      }
    }]);

    return HeatMap;
  }(_react2.default.Component);

  HeatMap.propTypes = {
    position: _propTypes2.default.object,
    map: _propTypes2.default.object,
    icon: _propTypes2.default.string
  };

  evtNames.forEach(function (e) {
    return HeatMap.propTypes[e] = _propTypes2.default.func;
  });

  HeatMap.defaultProps = {
    name: 'HeatMap'
  };

  exports.default = HeatMap;
});

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(41), __webpack_require__(10)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('../lib/arePathsEqual'), require('../lib/String'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.arePathsEqual, global.String);
    global.Polygon = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _arePathsEqual, _String) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Polygon = undefined;

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var evtNames = ['click', 'mouseout', 'mouseover'];

  var wrappedPromise = function wrappedPromise() {
    var wrappedPromise = {},
        promise = new Promise(function (resolve, reject) {
      wrappedPromise.resolve = resolve;
      wrappedPromise.reject = reject;
    });
    wrappedPromise.then = promise.then.bind(promise);
    wrappedPromise.catch = promise.catch.bind(promise);
    wrappedPromise.promise = promise;

    return wrappedPromise;
  };

  var Polygon = exports.Polygon = function (_React$Component) {
    _inherits(Polygon, _React$Component);

    function Polygon() {
      _classCallCheck(this, Polygon);

      return _possibleConstructorReturn(this, (Polygon.__proto__ || Object.getPrototypeOf(Polygon)).apply(this, arguments));
    }

    _createClass(Polygon, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.polygonPromise = wrappedPromise();
        this.renderPolygon();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (this.props.map !== prevProps.map || !(0, _arePathsEqual.arePathsEqual)(this.props.paths, prevProps.paths)) {
          if (this.polygon) {
            this.polygon.setMap(null);
          }
          this.renderPolygon();
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.polygon) {
          this.polygon.setMap(null);
        }
      }
    }, {
      key: 'renderPolygon',
      value: function renderPolygon() {
        var _this2 = this;

        var _props = this.props,
            map = _props.map,
            google = _props.google,
            paths = _props.paths,
            strokeColor = _props.strokeColor,
            strokeOpacity = _props.strokeOpacity,
            strokeWeight = _props.strokeWeight,
            fillColor = _props.fillColor,
            fillOpacity = _props.fillOpacity,
            props = _objectWithoutProperties(_props, ['map', 'google', 'paths', 'strokeColor', 'strokeOpacity', 'strokeWeight', 'fillColor', 'fillOpacity']);

        if (!google) {
          return null;
        }

        var params = _extends({
          map: map,
          paths: paths,
          strokeColor: strokeColor,
          strokeOpacity: strokeOpacity,
          strokeWeight: strokeWeight,
          fillColor: fillColor,
          fillOpacity: fillOpacity
        }, props);

        this.polygon = new google.maps.Polygon(params);

        evtNames.forEach(function (e) {
          _this2.polygon.addListener(e, _this2.handleEvent(e));
        });

        this.polygonPromise.resolve(this.polygon);
      }
    }, {
      key: 'getPolygon',
      value: function getPolygon() {
        return this.polygonPromise;
      }
    }, {
      key: 'handleEvent',
      value: function handleEvent(evt) {
        var _this3 = this;

        return function (e) {
          var evtName = 'on' + (0, _String.camelize)(evt);
          if (_this3.props[evtName]) {
            _this3.props[evtName](_this3.props, _this3.polygon, e);
          }
        };
      }
    }, {
      key: 'render',
      value: function render() {
        return null;
      }
    }]);

    return Polygon;
  }(_react2.default.Component);

  Polygon.propTypes = {
    paths: _propTypes2.default.array,
    strokeColor: _propTypes2.default.string,
    strokeOpacity: _propTypes2.default.number,
    strokeWeight: _propTypes2.default.number,
    fillColor: _propTypes2.default.string,
    fillOpacity: _propTypes2.default.number
  };

  evtNames.forEach(function (e) {
    return Polygon.propTypes[e] = _propTypes2.default.func;
  });

  Polygon.defaultProps = {
    name: 'Polygon'
  };

  exports.default = Polygon;
});

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.cancelablePromise = mod.exports;
  }
})(this, function (exports) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  // https://facebook.github.io/react/blog/2015/12/16/ismounted-antipattern.html

  var makeCancelable = exports.makeCancelable = function makeCancelable(promise) {
    var hasCanceled_ = false;

    var wrappedPromise = new Promise(function (resolve, reject) {
      promise.then(function (val) {
        return hasCanceled_ ? reject({ isCanceled: true }) : resolve(val);
      });
      promise.catch(function (error) {
        return hasCanceled_ ? reject({ isCanceled: true }) : reject(error);
      });
    });

    return {
      promise: wrappedPromise,
      cancel: function cancel() {
        hasCanceled_ = true;
      }
    };
  };
});

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(41), __webpack_require__(10)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('../lib/arePathsEqual'), require('../lib/String'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.arePathsEqual, global.String);
    global.Polyline = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _arePathsEqual, _String) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Polyline = undefined;

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var evtNames = ['click', 'mouseout', 'mouseover'];

  var wrappedPromise = function wrappedPromise() {
    var wrappedPromise = {},
        promise = new Promise(function (resolve, reject) {
      wrappedPromise.resolve = resolve;
      wrappedPromise.reject = reject;
    });
    wrappedPromise.then = promise.then.bind(promise);
    wrappedPromise.catch = promise.catch.bind(promise);
    wrappedPromise.promise = promise;

    return wrappedPromise;
  };

  var Polyline = exports.Polyline = function (_React$Component) {
    _inherits(Polyline, _React$Component);

    function Polyline() {
      _classCallCheck(this, Polyline);

      return _possibleConstructorReturn(this, (Polyline.__proto__ || Object.getPrototypeOf(Polyline)).apply(this, arguments));
    }

    _createClass(Polyline, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.polylinePromise = wrappedPromise();
        this.renderPolyline();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (this.props.map !== prevProps.map || !(0, _arePathsEqual.arePathsEqual)(this.props.path, prevProps.path)) {
          if (this.polyline) {
            this.polyline.setMap(null);
          }
          this.renderPolyline();
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.polyline) {
          this.polyline.setMap(null);
        }
      }
    }, {
      key: 'renderPolyline',
      value: function renderPolyline() {
        var _this2 = this;

        var _props = this.props,
            map = _props.map,
            google = _props.google,
            path = _props.path,
            strokeColor = _props.strokeColor,
            strokeOpacity = _props.strokeOpacity,
            strokeWeight = _props.strokeWeight,
            props = _objectWithoutProperties(_props, ['map', 'google', 'path', 'strokeColor', 'strokeOpacity', 'strokeWeight']);

        if (!google) {
          return null;
        }

        var params = _extends({
          map: map,
          path: path,
          strokeColor: strokeColor,
          strokeOpacity: strokeOpacity,
          strokeWeight: strokeWeight
        }, props);

        this.polyline = new google.maps.Polyline(params);

        evtNames.forEach(function (e) {
          _this2.polyline.addListener(e, _this2.handleEvent(e));
        });

        this.polylinePromise.resolve(this.polyline);
      }
    }, {
      key: 'getPolyline',
      value: function getPolyline() {
        return this.polylinePromise;
      }
    }, {
      key: 'handleEvent',
      value: function handleEvent(evt) {
        var _this3 = this;

        return function (e) {
          var evtName = 'on' + (0, _String.camelize)(evt);
          if (_this3.props[evtName]) {
            _this3.props[evtName](_this3.props, _this3.polyline, e);
          }
        };
      }
    }, {
      key: 'render',
      value: function render() {
        return null;
      }
    }]);

    return Polyline;
  }(_react2.default.Component);

  Polyline.propTypes = {
    path: _propTypes2.default.array,
    strokeColor: _propTypes2.default.string,
    strokeOpacity: _propTypes2.default.number,
    strokeWeight: _propTypes2.default.number
  };

  evtNames.forEach(function (e) {
    return Polyline.propTypes[e] = _propTypes2.default.func;
  });

  Polyline.defaultProps = {
    name: 'Polyline'
  };

  exports.default = Polyline;
});

/***/ }),
/* 125 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Site__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapContainer_MapContainer__ = __webpack_require__(40);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Dosquebradas=function(_React$Component){_inherits(Dosquebradas,_React$Component);function Dosquebradas(){_classCallCheck(this,Dosquebradas);return _possibleConstructorReturn(this,(Dosquebradas.__proto__||Object.getPrototypeOf(Dosquebradas)).apply(this,arguments));}_createClass(Dosquebradas,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Site__["a" /* default */],{dep:'Risaralda',mun:'Santa Rosa de Cabal',dir:'Kil\xF3metro 3, v\xEDa  Santa Rosa de Cabal - Dosquebradas, sector Alto de Boquer\xF3n.',tel:'314 670 0122'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__mapContainer_MapContainer__["a" /* default */],{lat:4.8583743,lng:-75.6370004,zoom:16.95}));}}]);return Dosquebradas;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Dosquebradas);

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__header_css__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__header_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__header_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__node_modules_font_awesome_css_font_awesome_min_css__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__node_modules_font_awesome_css_font_awesome_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__node_modules_font_awesome_css_font_awesome_min_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Header=function(_Component){_inherits(Header,_Component);function Header(props){_classCallCheck(this,Header);var _this=_possibleConstructorReturn(this,(Header.__proto__||Object.getPrototypeOf(Header)).call(this,props));_this.state={clicked:false};_this.myFunction=_this.myFunction.bind(_this);return _this;}_createClass(Header,[{key:'myFunction',value:function myFunction(){this.setState({clicked:!this.state.clicked});}},{key:'render',value:function render(){var clicked=this.state.clicked;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:clicked===true?"topnav responsive":"topnav"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:'/'},'Inicio'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:'galeria'},'Galer\xEDa'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:'mosaicos'},'Mosaicos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:'trayectoria'},'Nuestra Trayectoria'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:'mosaicos'},'Mosaicos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:'rionegro'},'Rionegro'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:'dosquebradas'},'Dosquebradas'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:'',className:'icon',onClick:this.myFunction},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-bars'})));}}]);return Header;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);//<Link to="/" className="logo"> <img alt="logo" src="./images/tiles/thumbs/1002.png"></img> </Link>
/* harmony default export */ __webpack_exports__["a"] = (Header);

/***/ }),
/* 128 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 129 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 130 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__designApp__ = __webpack_require__(132);
var mapStateToProps=function mapStateToProps(state,props){return{tiles:state.tiles,colorScheme:state.colorScheme,selectedTile:state.selectedTile,currentColors:state.currentColors,selectedPath:state.selectedPath,selectedColor:state.selectedColor,colors:state.colors};};var VisibleDesignApp=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,null)(__WEBPACK_IMPORTED_MODULE_2__designApp__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (VisibleDesignApp);

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__figure__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tile__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__visibleColorMenu__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__colorElement__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__visibleFigureMenu__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__visibleTileMenu__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__sampleMenu__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__visibleSampleMenu__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__visibleCurrentSample__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mosaic__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__designApp_css__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__designApp_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__designApp_css__);
var DesignApp=function DesignApp(_ref){var tiles=_ref.tiles,currentColors=_ref.currentColors,selectedTile=_ref.selectedTile,colors=_ref.colors;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'app-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__visibleTileMenu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__visibleSampleMenu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'modification-menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__visibleCurrentSample__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__visibleFigureMenu__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__visibleColorMenu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__mosaic__["a" /* default */],null));};/* harmony default export */ __webpack_exports__["a"] = (DesignApp);

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colorMenu__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_index__ = __webpack_require__(6);
var mapStateToProps=function mapStateToProps(state,props){return{colors:state.colors,selectedPath:state.selectedPath,selectedColor:state.selectedColor,currentColors:state.currentColors,selectedTile:state.selectedTile};};var mapDispatchToProps=function mapDispatchToProps(dispatch,props){return{onSelectColor:function onSelectColor(pathId,color,colorId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["c" /* changeColor */])(pathId,color));dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["e" /* selectColor */])(colorId));},onAddColor:function onAddColor(color){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["a" /* addColor */])(color));},onAddColorScheme:function onAddColorScheme(tileId,colors){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["b" /* addColorScheme */])(tileId,colors));dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_index__["g" /* selectSample */])(0));/*dispatch(selectTile(id));*/}};};var VisibleColorMenu=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_0__colorMenu__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (VisibleColorMenu);

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__colorElement__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__colorMenu_css__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__colorMenu_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__colorMenu_css__);
var ColorMenu=function ColorMenu(_ref){var colors=_ref.colors,selectedPath=_ref.selectedPath,selectedColor=_ref.selectedColor,onSelectColor=_ref.onSelectColor,onAddColorScheme=_ref.onAddColorScheme,onAddColor=_ref.onAddColor,currentColors=_ref.currentColors,selectedTile=_ref.selectedTile;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'seleccione'},'Seleccione el nuevo Color'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'color-menu'},colors.map(function(color,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__colorElement__["a" /* default */],{key:index,id:index,color:color,selected:index===selectedColor,selectedPath:selectedPath,onClick:onSelectColor});}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__colorElement__["a" /* default */],{color:'white',selected:false,selectedPath:selectedPath,onClick:onSelectColor})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return onAddColorScheme(selectedTile,currentColors);}},'Guardar colores'));};/* harmony default export */ __webpack_exports__["a"] = (ColorMenu);

/***/ }),
/* 135 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 136 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_index__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__figureMenu__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(4);
var mapStateToProps=function mapStateToProps(state,props){return{paths:state.tiles[state.selectedTile].paths,selectedPath:state.selectedPath,colors:state.currentColors//colors: state.tiles[state.selectedTile].colorScheme[state.selectedSample]
};};var mapDispatchToProps=function mapDispatchToProps(dispatch,props){return{onClick:function onClick(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__actions_index__["f" /* selectPath */])(id));}};};var VisibleColorMenu=Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__figureMenu__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (VisibleColorMenu);

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__figure__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__figureMenu_css__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__figureMenu_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__figureMenu_css__);
var FigureMenu=function FigureMenu(_ref){var paths=_ref.paths,selectedPath=_ref.selectedPath,colors=_ref.colors,onClick=_ref.onClick;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'figure-menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'seleccione'},'Seleccione la figura desea modificar'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'figure-container'},paths.map(function(path,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__figure__["a" /* default */],{id:index,key:index,d:path.d,width:100,height:100,strokeWidth:'2',stroke:'#000',independent:true,fill:colors[index],selected:index===selectedPath,onClick:onClick});})));};/* harmony default export */ __webpack_exports__["a"] = (FigureMenu);

/***/ }),
/* 139 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tileMenu__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_index__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(4);
var mapStateToProps=function mapStateToProps(state,props){return{tiles:state.tiles,selectedTile:state.selectedTile,selectedSample:state.selectedSample};};var mapDispatchToProps=function mapDispatchToProps(dispatch,props){return{onSelectTile:function onSelectTile(id,colors){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__actions_index__["h" /* selectTile */])(id),dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__actions_index__["d" /* changeColors */])(colors),dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__actions_index__["g" /* selectSample */])(0))));}};};var VisibleTileMenu=Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_0__tileMenu__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (VisibleTileMenu);

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tile__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__figure__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tileMenu_css__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tileMenu_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__tileMenu_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_index__ = __webpack_require__(6);
var TileMenu=function TileMenu(_ref){var tiles=_ref.tiles,selectedTile=_ref.selectedTile,selectedSample=_ref.selectedSample,_onSelectTile=_ref.onSelectTile;var defaultColorScheme=0;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'tile-menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'tile-container'},tiles.map(function(tile,tileIndex){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__tile__["a" /* default */],{selected:selectedTile===tileIndex,onSelectTile:function onSelectTile(){return _onSelectTile(tileIndex,tile.colorScheme[0]);}},tile.paths.map(function(path,pathIndex){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__figure__["a" /* default */],{id:pathIndex,key:pathIndex,transform:path.transform,d:path.d,fill:tile.colorScheme[defaultColorScheme][pathIndex]});}));})));};/* harmony default export */ __webpack_exports__["a"] = (TileMenu);

/***/ }),
/* 142 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_index__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sampleMenu__ = __webpack_require__(44);
var mapStateToProps=function mapStateToProps(state,props){return{tile:state.tiles[state.selectedTile],selectedTileIndex:state.selectedTile,selectedSample:state.selectedSample};};var mapDispatchToProps=function mapDispatchToProps(dispatch,props){return{onSelectedSample:function onSelectedSample(id,colors){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__actions_index__["g" /* selectSample */])(id));dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__actions_index__["d" /* changeColors */])(colors));}};};var VisibleSampleMenu=Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__sampleMenu__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (VisibleSampleMenu);

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__currentSample__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(4);
var mapStateToProps=function mapStateToProps(state,props){return{tile:state.tiles[state.selectedTile],colors:state.currentColors};};var VisibleCurrentSample=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,null)(__WEBPACK_IMPORTED_MODULE_0__currentSample__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (VisibleCurrentSample);

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tile__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__figure__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__currentSample_css__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__currentSample_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__currentSample_css__);
var CurrentSample=function CurrentSample(_ref){var tile=_ref.tile,colors=_ref.colors;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'current-sample'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__tile__["a" /* default */],{onSelectTile:function onSelectTile(){},width:'320',height:'320'},tile.paths.map(function(path,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__figure__["a" /* default */],{key:index,transform:path.transform,d:path.d,fill:colors[index]});})));};/* harmony default export */ __webpack_exports__["a"] = (CurrentSample);

/***/ }),
/* 146 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tile__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__figure__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mosaic_css__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mosaic_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__mosaic_css__);
/*const Mosaic = ( { tile, currentColors }) => {
	return (<div id="grid-container">
		{tile.rotations.map((r,i) => {
			return (<Tile width='100' height='100' onSelectTile={()=> {}}>
			{tile.paths.map(( path, pathIndex ) => {
				return (
					<Figure 
						id={pathIndex} 
						key={pathIndex} 
						transform={'rotate('+r+' '+'100 100)'} 
						d={path.d} 
						fill={currentColors[pathIndex]}
					/>
				)
			})}
			</Tile>)
		})}
	</div>)
}*/var Mosaic=function Mosaic(_ref){var tile=_ref.tile,currentColors=_ref.currentColors;var styledTile={border:'1px dotted #666666'};console.log(tile);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'grid-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{width:'400',height:'400',viewBox:'0 0 800 800'},tile.rotations.map(function(r,i){var type=tile.type;var transform=calcPosition(i,r,type);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{transform:transform},tile.paths.map(function(path,pathIndex){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{id:pathIndex,key:pathIndex,d:path.d,fill:currentColors[pathIndex]});}));})));};var calcPosition=function calcPosition(i,r){var type=arguments.length>2&&arguments[2]!==undefined?arguments[2]:"normal";var transform='';if(type==="normal")transform='translate('+(i%4*200+8)+','+(parseInt(i/4)*200+8)+')';else{var xInicial=-50;var yInicial=-80;var numElementosFila=6;var fila=parseInt(i/numElementosFila);var columna=i%numElementosFila;if(fila%2===0){transform='translate('+(xInicial+columna*176-90+8)+','+(yInicial+fila*150)+')';}else{transform='translate('+(xInicial+columna*176+6)+','+(yInicial+fila*150)+')';}}transform+=' rotate('+r+' 100 100)';return transform;};/*const drawTile(tile, r, i) => {
	const t = tile.rotations.map((r,i) => {
		return ({tile.paths.map(( path, pathIndex ) => <path 
				id={pathIndex} 
				key={pathIndex} 
				transform={'translate('+(i%4)*50+'0 0) rotate('+r+'0 100 100)'} 
				d={path.d} 
				fill={currentColors[pathIndex]}
				/>
			)
		)
	})
}*/var mapStateToProps=function mapStateToProps(state,props){return{tile:state.tiles[state.selectedTile],currentColors:state.currentColors};};var VisibleMosaic=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,null)(Mosaic);/* harmony default export */ __webpack_exports__["a"] = (VisibleMosaic);

/***/ }),
/* 148 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 149 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__colors__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selectedPath__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__selectedTile__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__currentColors__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectedSample__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__selectedColor__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tiles__ = __webpack_require__(157);
var appReducer=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* combineReducers */])({tiles:__WEBPACK_IMPORTED_MODULE_7__tiles__["a" /* default */],colors:__WEBPACK_IMPORTED_MODULE_1__colors__["a" /* default */],selectedPath:__WEBPACK_IMPORTED_MODULE_2__selectedPath__["a" /* default */],selectedTile:__WEBPACK_IMPORTED_MODULE_3__selectedTile__["a" /* default */],selectedSample:__WEBPACK_IMPORTED_MODULE_5__selectedSample__["a" /* default */],selectedColor:__WEBPACK_IMPORTED_MODULE_6__selectedColor__["a" /* default */],currentColors:__WEBPACK_IMPORTED_MODULE_4__currentColors__["a" /* default */]});/* harmony default export */ __webpack_exports__["a"] = (appReducer);

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(3);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var colors=function colors(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["a" /* ADD_COLOR */]:return[].concat(_toConsumableArray(state),[action.color]);default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (colors);

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(3);
var selectedPath=function selectedPath(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["f" /* SELECT_PATH */]:return action.id;default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (selectedPath);

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(3);
var selectedTile=function selectedTile(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["h" /* SELECT_TILE */]:return action.id;default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (selectedTile);

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(6);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var currentColors=function currentColors(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["c" /* CHANGE_COLOR */]:{var id=action.id,color=action.color;var newState=[].concat(_toConsumableArray(state));newState[id]=color;return newState;}case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["d" /* CHANGE_COLORS */]:{return action.colors;}default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (currentColors);

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(3);
var selectedSample=function selectedSample(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["g" /* SELECT_SAMPLE */]:{return action.id;}default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (selectedSample);

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_index__ = __webpack_require__(6);
var selectedColor=function selectedColor(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["e" /* SELECT_COLOR */]:return action.id;default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (selectedColor);

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(3);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var tiles=function tiles(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["b" /* ADD_COLOR_SCHEME */]:{var tileIndex=action.selectedTile;var selectedTile=state.slice(tileIndex,tileIndex+1)[0];var colorScheme=[].concat(_toConsumableArray(selectedTile.colorScheme),[action.colorScheme]);selectedTile.colorScheme=colorScheme;state.splice(tileIndex,1,selectedTile);return state;}default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (tiles);

/***/ }),
/* 158 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 159 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.11cfd7ae.js